// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.container {
  max-width: 1300px;
  width: 100%;
}

.cards-step-2 .body-card {
  color: #6e7889;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 4px;
}
.cards-step-2 iframe {
  width: 100%;
  height: 120px;
  border: none;
  background-color: transparent;
}
.cards-step-2 .UploadDocs .input-content {
  height: 78px;
}
.cards-step-2 .UploadDocs .input-content input {
  height: 78px;
}

.card__generic {
  border-radius: 10px;
  border: 1px solid #929fb0;
  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);
  width: 100%;
  padding: 16px;
}

.form-item__input,
.form-item .ant-input {
  padding: 12px 0;
  border: 0;
  border-bottom: 1px solid #404859;
  border-radius: 0;
}
.form-item__input::placeholder,
.form-item .ant-input::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.card-upload {
  border-radius: 10px;
  border: 1px solid #2a2f3c;
  padding: 12px 16px;
  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);
}
.card-upload .link {
  color: #6e7889;
  text-align: right;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
}
.card-upload p {
  margin: 10px 0;
}

.flex-btw {
  display: flex;
  justify-content: space-between;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-col {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}

.mt-20 {
  margin-top: 20px;
}
.mt-25 {
  margin-top: 25px;
}
.mt-30 {
  margin-top: 30px;
}
.mt-40 {
  margin-top: 40px;
}
.mt-50 {
  margin-top: 50px;
}
.mt-60 {
  margin-top: 60px;
}
.mt-12 {
  margin-top: 12px;
}
.mt-6 {
  margin-top: 6px;
}
.mt-5 {
  margin-top: 5px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-15 {
  margin-top: 15px;
}

.divider-top {
  border-top: 1px solid #afbdcc;
}

.input-transparent {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0;
}
.input-number {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  border: 1px solid #2a2f3c;
  background: #fff;
}
.input-number .ant-input-number-input-wrap {
  height: 45px;
}
.input-number .ant-input-number-input-wrap .ant-input-number-input {
  height: 45px;
}
.input-number .ant-input-prefix {
  color: #404859;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
}
.input-number input::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
}
.input-placeholder-bold::placeholder {
  color: #9bbceb;
  font-family: Inter;
  font-size: 16px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
}

.body-placeholder::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 600;
  line-height: normal;
}
.body-placeholder-w4::placeholder {
  font-weight: 400;
}

.fz-14 {
  font-size: 14px;
}

.fz-12 {
  font-size: 12px;
}

.children {
  padding-bottom: 20px;
}

/* http://meyerweb.com/eric/tools/css/reset/
   v2.0-modified | 20110126
   License: none (public domain)
*/
* {
  box-sizing: border-box;
}

html,
body,
#root {
  margin: 0;
  height: 100%;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* make sure to set some focus styles for accessibility */
:focus {
  outline: 0;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration {
  -webkit-appearance: none;
  -moz-appearance: none;
}

input[type=search] {
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: content-box;
}

textarea {
  overflow: auto;
  vertical-align: top;
  resize: vertical;
}

/**
   * Correct \`inline-block\` display not defined in IE 6/7/8/9 and Firefox 3.
   */
audio,
canvas,
video {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  max-width: 100%;
}

/**
   * Prevent modern browsers from displaying \`audio\` without controls.
   * Remove excess height in iOS 5 devices.
   */
audio:not([controls]) {
  display: none;
  height: 0;
}

/**
   * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.
   * Known issue: no IE 6 support.
   */
[hidden] {
  display: none;
}

/**
   * 1. Correct text resizing oddly in IE 6/7 when body \`font-size\` is set using
   *    \`em\` units.
   * 2. Prevent iOS text size adjust after orientation change, without disabling
   *    user zoom.
   */
html {
  font-size: 100%; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -ms-text-size-adjust: 100%; /* 2 */
}

/**
   * Address \`outline\` inconsistency between Chrome and other browsers.
   */
a:focus {
  outline: thin dotted;
}

/**
   * Improve readability when focused and also mouse hovered in all browsers.
   */
a:active,
a:hover {
  outline: 0;
}

/**
   * 1. Remove border when inside \`a\` element in IE 6/7/8/9 and Firefox 3.
   * 2. Improve image quality when scaled in IE 7.
   */
img {
  border: 0; /* 1 */
  -ms-interpolation-mode: bicubic; /* 2 */
}

/**
   * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.
   */
figure {
  margin: 0;
}

/**
   * Correct margin displayed oddly in IE 6/7.
   */
form {
  margin: 0;
}

/**
   * Define consistent border, margin, and padding.
   */
fieldset {
  border: 0px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

/**
   * 1. Correct color not being inherited in IE 6/7/8/9.
   * 2. Correct text not wrapping in Firefox 3.
   * 3. Correct alignment displayed oddly in IE 6/7.
   */
legend {
  border: 0; /* 1 */
  padding: 0;
  white-space: normal; /* 2 */
  *margin-left: -7px; /* 3 */
}

/**
   * 1. Correct font size not being inherited in all browsers.
   * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,
   *    and Chrome.
   * 3. Improve appearance and consistency in all browsers.
   */
button,
input,
select,
textarea {
  font-size: 100%; /* 1 */
  margin: 0; /* 2 */
  vertical-align: baseline; /* 3 */
  *vertical-align: middle; /* 3 */
}

/**
   * Address Firefox 3+ setting \`line-height\` on \`input\` using \`!important\` in
   * the UA stylesheet.
   */
button,
input {
  line-height: normal;
}

/**
   * Address inconsistent \`text-transform\` inheritance for \`button\` and \`select\`.
   * All other form control elements do not inherit \`text-transform\` values.
   * Correct \`button\` style inheritance in Chrome, Safari 5+, and IE 6+.
   * Correct \`select\` style inheritance in Firefox 4+ and Opera.
   */
button,
select {
  text-transform: none;
}

/**
   * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native \`audio\`
   *    and \`video\` controls.
   * 2. Correct inability to style clickable \`input\` types in iOS.
   * 3. Improve usability and consistency of cursor style between image-type
   *    \`input\` and others.
   * 4. Remove inner spacing in IE 7 without affecting normal text inputs.
   *    Known issue: inner spacing remains in IE 6.
   */
button,
html input[type=button],
input[type=reset],
input[type=submit] {
  -webkit-appearance: button; /* 2 */
  cursor: pointer; /* 3 */
  *overflow: visible; /* 4 */
}

/**
   * Re-set default cursor for disabled elements.
   */
button[disabled],
html input[disabled] {
  cursor: default;
}

/**
   * 1. Address box sizing set to content-box in IE 8/9.
   * 2. Remove excess padding in IE 8/9.
   * 3. Remove excess padding in IE 7.
   *    Known issue: excess padding remains in IE 6.
   */
input[type=checkbox],
input[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
  *height: 13px; /* 3 */
  *width: 13px; /* 3 */
}

/**
   * 1. Address \`appearance\` set to \`searchfield\` in Safari 5 and Chrome.
   * 2. Address \`box-sizing\` set to \`border-box\` in Safari 5 and Chrome
   *    (include \`-moz\` to future-proof).
   */
input[type=search] {
  -webkit-appearance: textfield; /* 1 */ /* 2 */
  box-sizing: content-box;
}

/**
   * Remove inner padding and search cancel button in Safari 5 and Chrome
   * on OS X.
   */
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
   * Remove inner padding and border in Firefox 3+.
   */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/**
   * 1. Remove default vertical scrollbar in IE 6/7/8/9.
   * 2. Improve readability and alignment in all browsers.
   */
textarea {
  overflow: auto; /* 1 */
  vertical-align: top; /* 2 */
}

/**
   * Remove most spacing between table cells.
   */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

html,
button,
input,
select,
textarea {
  color: #222;
}

::selection {
  background: #b3d4fc;
  text-shadow: none;
}

img {
  vertical-align: middle;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

textarea {
  resize: vertical;
}

.chromeframe {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.h1 {
  color: #404859;
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.h2 {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.h2-w8 {
  font-weight: 800;
}

.h3 {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 135%;
}

.h4 {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
}
.h4-cp {
  text-transform: capitalize;
}
.h4-w4 {
  font-weight: 400;
}
.h4-w5 {
  font-weight: 500;
}

.title-blue-bold {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #355c7d;
}

.body-regular {
  color: #404859;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.body-regular-italic {
  font-style: italic;
}
.body-regular-up {
  text-transform: uppercase;
}
.body-regular-bold, .body-regular-w6 {
  font-weight: 600;
}
.body-regular-w5 {
  font-weight: 500;
}

.placeholder {
  color: #929fb0;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.placeholder-w6 {
  font-weight: 600;
}

.button-txt-big {
  color: #f5faff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
}

.body-small {
  color: #404859;
  font-family: Inter;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.body-small-w4 {
  font-weight: 400;
}
.body-small-w6 {
  font-weight: 600;
}
.body-small-up {
  text-transform: uppercase;
}

.small-detail {
  color: #6e7889;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.body-card {
  color: #404859;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.body-card-bold-line {
  font-weight: 700;
  text-decoration-line: underline;
}
.body-card-w6 {
  font-weight: 600;
}
.body-card-w7 {
  font-weight: 700;
}
.body-card-w5 {
  font-weight: 500;
}

.blue-bold {
  color: #5e8eb7;
  cursor: pointer;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
}
.blue-bold img {
  height: 10px;
  margin-left: 5px;
}

.bold {
  font-weight: 600;
}

.bold-little {
  font-weight: 500;
}

.cursor {
  cursor: pointer;
}

.button {
  height: 32px;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.button-empty {
  background-color: transparent;
  padding: 0;
  border: none;
  box-shadow: none;
}
.button-empty span {
  color: #404859 !important;
  font-family: Inter;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.2px;
}
.button-modal-ok {
  width: 100%;
  border-radius: 6px;
  border: 1px solid #ffc857 !important;
  background: #ffc857 !important;
  height: 40px;
  color: #66564d !important;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.21px;
}
.button-modal-cancel {
  width: 100%;
  border-radius: 6px;
  border: 1px solid #ddaa42 !important;
  background: #fff9ee !important;
  height: 40px;
  color: #3c302a !important;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.21px;
}
.button-primary {
  width: 100%;
  height: 48px;
  flex-shrink: 0;
  border-radius: 6px;
  border: 1px solid #162e43;
  background: #162e43;
  border: none;
}
.button-primary:hover {
  border: none;
  color: #f5faff !important;
}
.button-secondary {
  width: 179px;
  border-radius: 6px;
  border: 1px solid #355c7d;
  color: #355c7d;
}
.button-secondary:hover {
  color: #355c7d !important;
  border: 1px solid #355c7d !important;
}
.button-grey {
  color: #6e7889 !important;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.18px;
  border-radius: 6px;
  border: 1px solid #eff3f5 !important;
  background: #eff3f5;
  width: 100%;
}
.button-transparent {
  padding: 0;
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: #48759a;
}
.button-transparent .anticon {
  color: #48759a;
}
.button-transparent:hover {
  color: #48759a !important;
}
.button-gray {
  padding: 0;
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: #afbdcc;
}
.button-gray .anticon {
  color: #afbdcc;
}
.button-gray:hover {
  color: #afbdcc !important;
}
.button-card {
  width: 100%;
  color: #000000;
  border: 1px solid #ccd3db;
}
.button-card:hover {
  color: #000000 !important;
  border: 1px solid #ccd3db !important;
}
.button-submit {
  border-radius: 6px;
  border: 1px solid #122536 !important;
  background: #122536 !important;
  color: #fff !important;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.18px;
  width: 100%;
}
.button-submit-delete {
  all: unset;
  border: none !important;
  background-color: transparent !important;
}
.button-submit-delete:hover {
  background: none !important;
  border-color: transparent !important;
}
.button-submit:disabled {
  background-color: #DFE4EB !important;
  border-color: #DFE4EB !important;
}
.button-submit:disabled span {
  color: #929FB0 !important;
}
.button-submit:disabled:hover {
  background-color: #DFE4EB !important;
  border-color: #DFE4EB !important;
}
.button-submit:disabled:hover span {
  color: #929FB0 !important;
}
.button-submit:not(.button-submit-delete):hover {
  background-color: #EBF6FF !important;
  border-color: #EBF6FF !important;
}
.button-submit:not(.button-submit-delete):hover span {
  color: #355D7D !important;
}
.button-link {
  width: 100%;
  background-color: transparent;
  border: none;
  box-shadow: none;
  font-weight: 400;
  color: #000000;
}
.button-link:hover {
  color: #000000 !important;
}
.button-link-REVIEW {
  color: #161616 !important;
}
.button-link-border {
  width: 100%;
  border-radius: 6px;
  border: 1px solid #162E43 !important;
  background: none;
  color: #3c302a !important;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.21px;
}
.button-link-border:disabled {
  background-color: #DFE4EB !important;
  border-color: #DFE4EB !important;
  color: #929FB0 !important;
}
.button-link-blue {
  color: #5E8EB7;
}
.button-link-blue span {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: underline;
}
.button-link-blue:hover {
  color: #5E8EB7 !important;
}
.button-blue {
  color: #5E8EB7;
}
.button-blue span {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.button-blue:hover {
  color: #5E8EB7 !important;
}
.button-open-modal {
  width: 100%;
}
.button-open-modal:hover {
  border-color: #ccd3db !important;
  color: #000000 !important;
}
.button-open-modal-REVIEW {
  border-color: #AC78B3;
  color: #161616;
}
.button-open-modal-REVIEW:hover {
  border-color: #AC78B3 !important;
  background-color: #693B6F !important;
  color: white !important;
}

.select-primary {
  width: 100%;
  height: 40px;
}
.select-primary .ant-select-selector {
  height: 40px !important;
  padding: 2px 11px !important;
  border-radius: 10px !important;
  border: 1px solid #5e8eb7 !important;
}
.select-primary .ant-select-selector .ant-select-selection-search-input {
  height: 40px !important;
}

.circle {
  background-color: #fff;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #2a2f3c;
  display: flex;
  justify-content: center;
  align-items: center;
}
.circle .upload {
  width: auto;
  height: 18px;
  object-fit: cover;
}

.circle-state-tooltip {
  padding: 6px 7px !important;
  opacity: 1 !important;
}
.circle-state-tooltip b {
  font-weight: 600;
}
.circle-state-tooltip span {
  margin-top: 10px;
}
.circle-state-tooltip-APPROVED {
  background-color: #549358 !important;
}
.circle-state-tooltip-DRAFT {
  background-color: #404859 !important;
}
.circle-state-tooltip-REQUEST_ERROR {
  background-color: #c94f4a !important;
}
.circle-state-tooltip-REVIEW {
  background-color: #855791 !important;
}

.DrodownBasic {
  height: 40px;
  padding: 1px 3px !important;
  display: flex;
  align-items: center;
  border: 1px solid #6E7889;
  width: 100%;
}
.DrodownBasic span {
  color: #6E7889;
  padding-left: 16px;
}
.DrodownBasic-blue {
  border: 1px solid #9BBCEB;
  border-radius: 10px;
}
.DrodownBasic-blue .ant-dropdown-menu {
  padding: 0px;
  width: 160px;
}
.DrodownBasic-blue .ant-dropdown-menu-item:hover {
  background-color: #EBF6FF !important;
}
.DrodownBasic-blue .ant-dropdown-menu-item:hover .ant-dropdown-menu-title-content {
  color: #355c7d;
  font-weight: 600;
}
.DrodownBasic-blue .ant-dropdown-menu-title-content {
  color: #5E8EB7;
  font-weight: 400;
}
.DrodownBasic-blue .ant-dropdown-menu-title-content:hover {
  color: #355c7d;
  font-weight: 600;
}

.checkbox-basic .ant-checkbox-wrapper {
  color: #244560;
}
.checkbox-basic .ant-checkbox-wrapper:hover .ant-checkbox-inner {
  border: 1px solid #5E8EB7 !important;
}
.checkbox-basic .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #5E8EB7 !important;
}
.checkbox-basic .ant-checkbox,
.checkbox-basic .ant-checkbox-input {
  border: none;
}
.checkbox-basic .ant-checkbox:hover .ant-checkbox-inner,
.checkbox-basic .ant-checkbox-input:hover .ant-checkbox-inner {
  border: 1px solid #5E8EB7 !important;
}
.checkbox-basic .ant-checkbox:hover .ant-checkbox-checked .ant-checkbox-inner,
.checkbox-basic .ant-checkbox-input:hover .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #5E8EB7 !important;
}
.checkbox-basic .ant-checkbox-inner {
  width: 18px;
  height: 18px;
  border: 1px solid #5E8EB7;
}
.checkbox-basic .ant-checkbox-disabled .ant-checkbox-inner {
  border-radius: 2px;
  background: #DFE4EB !important;
  border: 1px solid #DFE4EB;
}
.checkbox-basic .ant-checkbox-checked:hover .ant-checkbox-inner {
  background-color: #5E8EB7 !important;
}
.checkbox-basic .ant-checkbox-checked .ant-checkbox-inner {
  border-radius: 2px;
  background: #5E8EB7;
}

.Layout {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.Layout .content {
  width: 100%;
}
.Layout .BarLogin {
  padding: 16px;
  background-color: #eff3f5;
  width: 64px;
  height: 100vh;
  border-right: 1px solid #dfe4eb;
}
.Layout .BarLogin .logo {
  width: 32px;
}

.select-section-selected .ant-select-selector {
  background: #F5FAFF !important;
  border: 1px solid #5E8EB7 !important;
  padding-left: 10px !important;
}
.select-section-selected .ant-select-selector .ant-select-selection-item {
  color: #355C7D !important;
}
.select-section-selected .ant-select-selector .ant-select-selection-item-content {
  color: #5E8EB7 !important;
}
.select-section .ant-select {
  display: block;
  height: 40px;
  margin-top: 6px;
}
.select-section .ant-select .ant-select-selection-placeholder {
  margin-bottom: 0;
  color: #6E7889 !important;
}

.ant-select-dropdown div {
  color: #6E7889;
}
.ant-select-dropdown .anticon {
  display: none;
}
.ant-select-dropdown .circle {
  width: 14px !important;
  height: 14px !important;
  border-color: #CCD3DB;
}

.ant-select-outlined.ant-select-multiple .ant-select-selection-item {
  background: none;
  border: none;
}
.ant-select-outlined.ant-select-multiple .ant-select-selection-item span {
  color: rgb(53, 92, 125) !important;
}

.ant-select-item-option-selected .ant-select-item-option-content div {
  color: #48759A !important;
}

.task-item-list .circle-state-tooltip {
  padding: 6px 7px;
  opacity: 1;
}
.task-item-list .circle-state-tooltip b {
  font-weight: 600;
}
.task-item-list .circle-state-tooltip span {
  margin-top: 10px;
}
.task-item-list .circle-state-tooltip-APPROVED {
  background-color: #549358;
}
.task-item-list .circle-state-tooltip-DRAFT {
  background-color: #c0cad7;
}
.task-item-list .circle-state-tooltip-REQUEST_ERROR {
  background-color: #c94f4a;
}
.task-item-list .circle-state-tooltip-REVIEW {
  background-color: #855791;
}
.task-item-list .circles-tags {
  display: flex;
  align-items: end;
  gap: 20px;
  margin-top: 5px;
}
.task-item-list .circle {
  width: 16px;
  height: 16px;
}
.task-item-list .circle-APPROVED {
  background-color: #6eac72;
  border-color: #587e5b;
}
.task-item-list .circle-APPROVED:hover {
  background-color: #549358;
}
.task-item-list .circle-APPROVED-active {
  background-color: #549358;
}
.task-item-list .circle-REVIEW {
  background-color: #AC78B3;
  border-color: #AC78B3;
}
.task-item-list .circle-REVIEW:hover {
  background-color: #855791;
}
.task-item-list .circle-REVIEW-active {
  background-color: #855791;
}
.task-item-list .circle-REQUEST_ERROR {
  background-color: #FFD4CF;
  border-color: #c94f4a;
}
.task-item-list .circle-REQUEST_ERROR:hover {
  background-color: #c94f4a;
}
.task-item-list .circle-REQUEST_ERROR-active {
  background-color: #c94f4a;
}
.task-item-list .circle-DRAFT {
  background-color: #DFE4EB;
  border: 1px solid #CCD3DB;
}
.task-item-list .circle-DRAFT:hover {
  background-color: #cfd7e1;
}
.task-item-list .circle-DRAFT-active {
  background-color: #cfd7e1;
}
.task-item-list .circle-INCOMPLETE {
  background-color: #2a2f3c;
  border: 1px solid #2a2f3c;
}
.task-item-list .circle-INCOMPLETE:hover {
  background-color: #20232d;
}
.task-item-list .circle-INCOMPLETE-active {
  background-color: #20232d;
}

.LoanProgress {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
}
.LoanProgress .tab {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.LoanProgress .tab .popover-label {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.LoanProgress .tab .bar-status {
  cursor: pointer;
  width: 100%;
  width: calc(100% + 20px);
  height: 8px;
  border-radius: 16px;
  margin-top: 6px;
  background-color: #dfe4eb;
}
.LoanProgress .tab-complete .text-status {
  color: #141F15;
}
.LoanProgress .tab-complete .body-small {
  color: #2D7032;
}
.LoanProgress .tab-complete .bar-status {
  background-color: #4CA852;
}
.LoanProgress .tab-complete .bar-status-selected {
  background-color: #2D7032;
}
.LoanProgress .tab-complete .bar-status-selected:hover {
  background-color: #2D7032 !important;
}
.LoanProgress .tab-complete .bar-status:hover {
  background-color: #3F9545;
}
.LoanProgress .tab-complete .bar-status:hover .body-small {
  color: #2D7032;
}
.LoanProgress .tab-blocked .body-small {
  color: #8A130F;
}
.LoanProgress .tab-blocked .text-status {
  color: #610805;
}
.LoanProgress .tab-blocked .bar-status {
  background-color: #C13934;
}
.LoanProgress .tab-blocked .bar-status-selected {
  background-color: #8A130F;
}
.LoanProgress .tab-blocked .bar-status-selected:hover {
  background-color: #8A130F !important;
}
.LoanProgress .tab-blocked .bar-status:hover {
  background-color: #A31C17;
}
.LoanProgress .tab-blocked .bar-status:hover .body-small {
  color: #8A130F;
}
.LoanProgress .tab-error .body-small {
  color: #8A130F;
}
.LoanProgress .tab-error .text-status {
  color: #610805;
}
.LoanProgress .tab-error .bar-status {
  background-color: #FFDAD6;
}
.LoanProgress .tab-error .bar-status-selected {
  background-color: #8A130F;
}
.LoanProgress .tab-error .bar-status-selected:hover {
  background-color: #8A130F !important;
}
.LoanProgress .tab-error .bar-status:hover {
  background-color: #C13934;
}
.LoanProgress .tab-error .bar-status:hover .body-small {
  color: #8A130F;
}
.LoanProgress .tab-progress .text-status {
  color: #122536;
}
.LoanProgress .tab-progress .body-small {
  color: #404859;
}
.LoanProgress .tab-progress .bar-status {
  background-color: #5E8EB7;
}
.LoanProgress .tab-progress .bar-status-selected {
  background-color: #355C7D;
}
.LoanProgress .tab-progress .bar-status-selected:hover {
  background-color: #355C7D !important;
}
.LoanProgress .tab-progress .bar-status:hover {
  background-color: #48759A;
}
.LoanProgress .tab-progress .bar-status:hover .body-small {
  color: #404859;
}
.LoanProgress .tab-not-started .bar-status {
  background-color: white;
  border: 1px solid #404859;
}
.LoanProgress .tab-not-started .bar-status-selected {
  background-color: #404859;
}
.LoanProgress .tab-not-started .bar-status-selected:hover {
  background-color: #404859 !important;
}
.LoanProgress .tab-not-started .bar-status:hover {
  background-color: #929FB0;
}
.LoanProgress .tab-open-content {
  position: absolute;
  border: 1px solid #929FB0;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.1019607843);
  height: auto;
  min-height: 253px;
  width: 825px;
  background: white;
  top: 150px;
  border-radius: 10px;
  z-index: 99;
}
.LoanProgress .tab-open-content .content-bar-status {
  width: 823px;
  height: 68px;
  background: white;
  border-radius: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: start;
  gap: 8px;
  padding-left: 8px;
  padding-top: 3px;
}
.LoanProgress .tab-open-content .content-bar-status .tab .body-small {
  font-size: 12px !important;
}
.LoanProgress .tab-open-content .content-bar-status .tab-error span {
  color: #610805;
}
.LoanProgress .tab-open-content .content-bar-status .bar-status {
  width: -webkit-fill-available;
  height: 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.LoanProgress .tab-open-content .content-bar-status .bar-status .text-status {
  display: flex;
  align-items: center;
  gap: 3px;
}
.LoanProgress .tab-open-content .content-bar-status .bar-status .text-status span {
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
}
.LoanProgress .tab-open-content .content-bar-status .bar-status:hover span {
  display: none;
}
.LoanProgress .tab-open-content .content-bar-status .bar-status:hover .text-status {
  display: none;
}
.LoanProgress .tab-open-content .content-bar-status .tab {
  margin: 0 0;
}
.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(1) {
  width: 10%;
}
.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(2) {
  width: 22%;
}
.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(3) {
  width: 38%;
}
.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(4) {
  width: 14%;
}
.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(5) {
  width: 11%;
}
.LoanProgress .tab-open-content .content-phase-select {
  width: 823px;
  height: auto;
  min-height: 183px;
  border-radius: 10px;
  background: #F9FAFB;
  border-top: 1px solid #DFE4EB;
}
.LoanProgress .tab-open-content .content-phase-select-complete {
  background: #F8FFF8;
  border-top: 1px solid #C2F0C5;
}
.LoanProgress .tab-open-content .content-phase-select-complete .tag-state {
  background: #C2F0C5;
}
.LoanProgress .tab-open-content .content-phase-select-complete .tag-state b,
.LoanProgress .tab-open-content .content-phase-select-complete .tag-state span {
  color: #141F15;
}
.LoanProgress .tab-open-content .content-phase-select-complete .content-phase b {
  color: #1F4222;
}
.LoanProgress .tab-open-content .content-phase-select-complete .content-phase p {
  color: #1F4222 !important;
}
.LoanProgress .tab-open-content .content-phase-select-complete .content-phase-first b {
  color: #2D7032;
}
.LoanProgress .tab-open-content .content-phase-select-blocked {
  background: #FCF8F7;
  border-top: 1px solid #FFC6BF;
}
.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state {
  background: #FFD4CF;
}
.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state b,
.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state span {
  color: #610805;
}
.LoanProgress .tab-open-content .content-phase-select-blocked .content-phase b {
  color: #2A2F3C;
}
.LoanProgress .tab-open-content .content-phase-select-blocked .content-phase-first b {
  color: #610805;
}
.LoanProgress .tab-open-content .content-phase-select-error {
  background: #FCF8F7;
  border-top: 1px solid #FFC6BF;
}
.LoanProgress .tab-open-content .content-phase-select-error .tag-state {
  background: #FFD4CF;
}
.LoanProgress .tab-open-content .content-phase-select-error .tag-state b,
.LoanProgress .tab-open-content .content-phase-select-error .tag-state span {
  color: #610805;
}
.LoanProgress .tab-open-content .content-phase-select-error .content-phase b {
  color: #2A2F3C;
}
.LoanProgress .tab-open-content .content-phase-select-error .content-phase-first b {
  color: #610805;
}
.LoanProgress .tab-open-content .content-phase-select-progress {
  background: #F5FAFF;
  border-top: 1px solid #B6DCFC;
}
.LoanProgress .tab-open-content .content-phase-select-progress .tag-state {
  background: #B6DCFC;
}
.LoanProgress .tab-open-content .content-phase-select-progress .tag-state b,
.LoanProgress .tab-open-content .content-phase-select-progress .tag-state span {
  color: #122536;
}
.LoanProgress .tab-open-content .content-phase-select-progress .content-phase b {
  color: #2A2F3C;
}
.LoanProgress .tab-open-content .content-phase-select-progress .content-phase-first b {
  color: #244560;
}
.LoanProgress .tab-open-content .content-phase-select-not-started .tag-state {
  border: 1px solid #404859;
}
.LoanProgress .tab-open-content .content-phase-select .tag-state {
  height: 16px;
  width: max-content;
  display: flex;
  align-items: center;
  gap: 3.5px;
  border-radius: 10px;
  padding: 3px 7px;
  margin: 16px 23px;
}
.LoanProgress .tab-open-content .content-phase-select .tag-state b {
  font-size: 10px;
  font-weight: 600;
}
.LoanProgress .tab-open-content .content-phase-select .tag-state span {
  font-size: 10px;
  font-weight: 400;
}
.LoanProgress .tab-open-content .content-phase-select .divider {
  border: 0.7px solid #929FB0;
  height: auto;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase {
  margin: 0px 24px;
  padding-bottom: 23px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase b {
  font-size: 12px;
  font-weight: 600;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase p {
  font-size: 12px;
  font-weight: 400;
  color: #2A2F3C;
  margin-top: 6px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase-first {
  width: 270px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase-first b {
  font-size: 16px;
  font-weight: 600;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase-second {
  width: 240px;
  margin-left: 20px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 4px;
  width: max-content;
  border-radius: 4px;
  padding: 2px 3px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item span {
  font-family: Inter;
  font-size: 12px;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item b {
  font-family: Inter;
  font-weight: 500;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item .bold {
  font-weight: 600 !important;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item .circle {
  width: 12px;
  height: 12px;
  border: 1px solid #6E7889;
  border-radius: 50%;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED {
  background-color: #D5F7E2;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED span,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED b,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED strong {
  color: #2D7032;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR, .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED {
  background: #FFC6BF;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR span,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR b,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR strong, .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED span,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED b,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED strong {
  color: #610805;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW {
  background: #F7EDFC;
}
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW span,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW b,
.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW strong {
  color: #855791;
}

.borrowers {
  padding: 24px 25px;
}
.borrowers .dropdown-review-bold {
  color: #AC78B3 !important;
  height: 26px;
  display: unset;
  padding: 0 !important;
}
.borrowers .dropdown-review-bold span {
  font-weight: 600;
  text-decoration-line: underline;
}
.borrowers .top-container {
  box-sizing: content-box;
  width: 100%;
  margin-bottom: 33px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
}
.borrowers .top-container .title {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.borrowers .top-container .title > span {
  cursor: pointer;
  color: var(--blue60, #5E8EB7);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
}
.borrowers .badges-container {
  display: flex;
}
.borrowers-container {
  padding: 16px 0px;
}
.borrowers-container > * {
  margin-bottom: 16px;
}
.borrowers-container > *:last-child {
  margin-bottom: 0px;
}

.search-box {
  cursor: pointer;
  box-sizing: border-box;
  width: 384px;
  padding: 5px 18px 5px 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
  border: 1px solid var(--400-grey, #CCD3DB);
  background: var(--gray-100, #F9FAFB);
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}
.search-box > input {
  all: unset;
  width: 100%;
  margin-left: 8px;
}

.status-badge {
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  background: var(--300-grey, #DFE4EB);
  margin-right: 12px;
}
.status-badge .title {
  margin-right: 4px;
  color: var(--800-grey, #404859);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  white-space: nowrap;
}
.status-badge .count {
  color: var(--800-grey, #404859);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
}
.status-badge.selected {
  background: #355C7D;
}
.status-badge.selected .title, .status-badge.selected .count {
  color: #FFFFFF;
}

.borrower-list-item {
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 8px 24px 8px 16px;
  border-radius: 10px;
  border: 1px solid var(--600-grey, #929FB0);
  background: var(--white, #FFF);
}
.borrower-list-item > * {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.borrower-list-item > *.loan-status-badge-container {
  flex: 0.8 1;
}
.borrower-list-item > *.borrower-summary-container {
  flex: 0.5 1;
}
.borrower-list-item .loan-status-badge {
  display: inline-block;
  border-radius: 76px;
  border: 1px solid var(--blue60, #5E8EB7);
  padding: 4px 7px;
  color: var(--70, #48759A);
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.2px;
  text-transform: uppercase;
}
.borrower-list-item .borrower-summary .caption {
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  margin-bottom: 2px;
}
.borrower-list-item .borrower-summary .borrower-name {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
  text-transform: capitalize;
}
.borrower-list-item .entities-summary .caption {
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  margin-bottom: 2px;
}
.borrower-list-item .entities-summary .content {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  white-space: nowrap;
  display: flex;
  gap: 3px;
  align-items: center;
}
.borrower-list-item .task-summary {
  padding-left: 10px;
  display: flex;
  flex-direction: column;
}
.borrower-list-item .task-summary .caption {
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  margin-bottom: 2.5px;
}
.borrower-list-item .task-summary .task-item-container {
  display: flex;
  gap: 9px;
}
.borrower-list-item .task-summary .task-item-container .task-item {
  box-sizing: border-box;
  height: 15px;
  width: 15px;
  border-radius: 100px;
  margin-right: 8px;
  background-color: #DFE4EB;
  border: 1.5px solid #CCD3DB;
}
.borrower-list-item .task-summary .task-item-container .task-item.completed {
  background-color: #4CA852;
  border: unset;
}
.borrower-list-item .task-summary .task-item-container .task-item.review {
  background-color: #855791;
  border: unset;
}
.borrower-list-item .action-container {
  color: var(--blue60, #5E8EB7);
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
  align-self: flex-end;
}
.borrower-list-item:hover {
  border-radius: 10px;
  border: 1px solid var(--blue-40, #97BCF0);
  background: var(--10, #F5FAFF);
  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);
}
.borrower-list-item:hover .borrower-summary .caption {
  color: var(--70, #48759A);
}
.borrower-list-item:hover .borrower-summary .borrower-name {
  color: var(--90, #244560);
}
.borrower-list-item:hover .address-summary .caption {
  color: var(--70, #48759A);
}
.borrower-list-item:hover .address-summary .address {
  color: var(--blue-80, #355C7D);
}
.borrower-list-item:hover .task-summary .caption {
  color: var(--70, #48759A);
}
.borrower-list-item:hover .action-container {
  color: var(--70, #48759A);
  font-weight: 600;
}
.borrower-list-item:hover .action-container:hover {
  color: var(--90, #244560);
  font-weight: 700;
}

.right-scenes {
  position: fixed;
  background: rgba(42, 47, 60, 0.55);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  top: 0;
  left: 70px;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.right-scenes-content {
  position: relative;
  width: calc(100% - 70px); /* Ancho de la pantalla menos 70px */
  background-color: #fff;
  height: 100%;
  animation: slideIn 1s forwards;
}
@keyframes slideIn {
  from {
    transform: translateX(calc(-100% + 70px));
  }
  to {
    transform: translateX(0);
  }
}
.right-scenes .button-close-mask {
  width: 30%;
  height: 100%;
  background-color: rgba(255, 0, 0, 0);
  box-shadow: none;
  border: none;
}
.right-scenes .button-close-mask:hover, .right-scenes .button-close-mask:active, .right-scenes .button-close-mask:focus {
  background-color: rgba(255, 0, 0, 0);
  box-shadow: none;
  border: none;
}

.view-borrower-detail {
  padding: 50px 15px;
}
.view-borrower-detail-header .title {
  color: #404859;
  font-size: 32px;
  font-weight: 600;
  gap: 5px;
}
.view-borrower-detail-header .title button {
  height: 32px;
}
.view-borrower-detail-header .title button span {
  font-size: 32px;
}
.view-borrower-detail .button-r,
.view-borrower-detail .button-r:hover {
  width: 58px;
  height: 20px;
  border: 1px solid #bb8d2f;
  color: #bb8d2f;
  border-radius: 76px;
  padding: 0;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 12.1px;
  margin: 0 15px;
}
.view-borrower-detail .button-delete,
.view-borrower-detail .button-delete:hover {
  height: 20px;
  border: none;
  color: #c94f4a;
  padding: 0;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 12.1px;
  margin: 0 15px;
}
.view-borrower-detail .flex-2-col {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  width: 100%;
  gap: 30px;
}
.view-borrower-detail .flex-2-col .box {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 50%;
}
.view-borrower-detail .gap-3 {
  gap: 6px;
}
.view-borrower-detail .card-profile-generic {
  border: 1px solid #afbdcc;
  border-radius: 10px;
  padding: 15px;
  width: 100%;
}
.view-borrower-detail .card-profile-generic .card-title {
  font-family: Inter;
  font-size: 24px;
  font-weight: 400;
  line-height: 29.05px;
  text-align: left;
}
.view-borrower-detail .card-profile-generic .table {
  width: 100%;
  margin-top: 10px;
}
.view-borrower-detail .card-profile-generic .table-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 7px;
}
.view-borrower-detail .card-profile-generic .table-row .title {
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  text-align: left;
  color: #6e7889;
}
.view-borrower-detail .card-profile-generic .table-row .flex {
  display: flex;
  justify-content: space-between;
}
.view-borrower-detail .card-profile-generic .table-row .flex .col {
  width: 50%;
}
.view-borrower-detail .card-profile-generic .table-row .flex .col .italic {
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 16.94px;
  text-align: left;
  color: #929fb0;
}
.view-borrower-detail .card-profile-generic .avatar .ant-avatar-string {
  font-size: 25px;
}
.view-borrower-detail .card-profile-generic .avatar .ant-upload {
  width: 68px !important;
  height: 68px !important;
}
.view-borrower-detail .card-profile-generic .ant-upload-wrapper.ant-upload-picture-circle-wrapper {
  width: auto;
}
.view-borrower-detail .card-profile-generic .title-bold {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.94px;
  text-align: left;
  color: #404859;
}
.view-borrower-detail .card-profile-generic .title-bold .bold {
  font-weight: 600;
}
.view-borrower-detail .card-profile-generic .body-bold {
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.94px;
  text-align: right;
}
.view-borrower-detail .card-profile-generic .button-transparent,
.view-borrower-detail .card-profile-generic .button-transparent:hover {
  padding: 0;
  height: 20px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-align: left;
  color: #8a130f;
}
.view-borrower-detail .card-profile-generic .button-round {
  width: 75px;
  height: 20px;
  padding: 0;
  border-radius: 76px;
  border: 2px solid #404859;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
}
.view-borrower-detail .card-profile-generic .button-edit,
.view-borrower-detail .card-profile-generic .button-edit:hover {
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  text-align: left;
  color: #5e8eb7;
}
.view-borrower-detail .card-profile-generic .button-edit .edit,
.view-borrower-detail .card-profile-generic .button-edit:hover .edit {
  width: 10px;
  height: 10px;
  margin-right: 3px;
}
.view-borrower-detail .card-profile-generic .link {
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.94px;
  text-align: left;
  color: #5e8eb7;
  text-decoration: none;
}
.view-borrower-detail .card-profile-generic .link .arrow {
  width: 15px;
  margin-left: 5px;
}
.view-borrower-detail .card-profile-generic .text-footer {
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  text-align: left;
  color: #6e7889;
  margin-top: 14px;
}
.view-borrower-detail .card-profile-generic .text-footer span {
  color: #4e8aff;
}
.view-borrower-detail .card-report {
  position: relative;
}
.view-borrower-detail .card-report .button span {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  letter-spacing: 0.015em;
  text-align: center;
}
.view-borrower-detail .card-report .button-edit {
  position: absolute;
  top: 8px;
  right: 15px;
}
.view-borrower-detail .card-report .button-edit span {
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  text-align: left;
  color: #5e8eb7;
}
.view-borrower-detail .card-report-head {
  display: flex;
  justify-content: space-between;
}
.view-borrower-detail .card-report .date-expires {
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 16.94px;
  text-align: right;
  color: #6E7889;
}
.view-borrower-detail .card-report .upload-report-span {
  cursor: pointer;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.94px;
  text-align: right;
  color: #5E8EB7;
  text-decoration: underline;
}
.view-borrower-detail .card-report .credit-score-input input {
  text-align: end;
}

.loan-details {
  padding: 43px 40px;
  overflow: hidden;
}
.loan-details .loan-details-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #929FB0;
  margin-bottom: 22px;
}
.loan-details .loan-details-top-bar .loan-info {
  margin-bottom: 2px;
}
.loan-details .loan-details-top-bar .loan-info .loan-borrower-name {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-top-bar .loan-info .loan-address {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-top-bar .close-button-container {
  cursor: pointer;
  color: var(--800-grey, #404859);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-first-row {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #CCD3DB;
  margin-bottom: 16px;
}
.loan-details .loan-details-first-row .loan-progress {
  flex: 6 1;
}
.loan-details .loan-details-first-row .loan-progress .loan-info .loan-status {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.36px;
}
.loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.36px;
}
.loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date b {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.36px;
}
.loan-details .loan-details-first-row .loan-progress .loan-address {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section {
  margin-bottom: 20px;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container {
  display: flex;
  flex-direction: row;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container > * {
  flex: 1 1;
  margin-right: 8px;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container .loan-progress-item-caption {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
  margin-bottom: 6px;
  flex: 0.13 1;
}
.loan-details .loan-details-first-row .loan-progress .loan-values-summary {
  margin-bottom: 8px;
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
}
.loan-details .loan-details-first-row .loan-progress .loan-values-summary span {
  cursor: pointer;
  color: var(--blue60, #5E8EB7);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
}
.loan-details .loan-details-first-row .placeholder {
  flex: 3 1;
}
.loan-details .loan-details-first-row .borrower-card {
  flex: 1 1;
}
.loan-details .loan-details-main {
  display: flex;
}
.loan-details .loan-details-main > * {
  flex: 1 1;
  box-sizing: border-box;
}
.loan-details .loan-details-main .left-column {
  padding-right: 15px;
}
.loan-details .loan-details-main .left-column > * {
  margin-bottom: 16px;
}
.loan-details .loan-details-main .left-column > *:last-of-type {
  margin-bottom: 0px;
}
.loan-details .loan-details-main .left-column .loan-summary {
  display: flex;
  justify-content: space-between;
}
.loan-details .loan-details-main .left-column .loan-summary .closing {
  flex: 1 1;
  border-radius: 10px;
  border: 1px solid var(--500-grey, #AFBDCC);
  padding: 16px 20px;
  margin-right: 16px;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .label {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 18px;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar {
  width: 128px;
  border-radius: 10px;
  border: 1px solid var(--blue60, #5E8EB7);
  background: var(--10, #F5FAFF);
  margin-bottom: 8px;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled {
  border: 1px solid var(--600-grey, #929FB0);
  background: var(--200-grey, #EFF3F5);
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .date {
  color: var(--70, #48759A);
  border-bottom: 1px solid #929FB0;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .day {
  color: var(--300-grey, #DFE4EB);
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar .date {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 26px;
  border-bottom: 1px solid #5E8EB7;
  color: var(--70, #48759A);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 114.286% */
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar .day {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--blue-80, #355C7D);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .caption {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.loan-details .loan-details-main .left-column .loan-summary .closing .caption b {
  font-weight: 600;
  color: #404859;
}
.loan-details .loan-details-main .left-column .loan-summary .content-box {
  flex: 5 1;
}
.loan-details .loan-details-main .right-column {
  padding-left: 15px;
}
.loan-details .loan-details-main .right-column .borrower-tasks > .title {
  margin-bottom: 8px;
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-status-container {
  display: flex;
  margin-bottom: 16px;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 7px;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  margin-left: 16px;
  color: var(--700-grey, #6E7889);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div svg {
  position: relative;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-list {
  margin-bottom: 17px;
}
.loan-details .loan-details-main .right-column .action-button {
  border: 1px solid var(--100, #162E43);
  background: var(--100, #162E43);
  text-align: center;
  border-radius: 6px;
  padding: 14px 0px;
  margin-bottom: 30px;
  color: var(--10, #F5FAFF);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
}
.loan-details .loan-details-main .right-column .action-button:hover {
  background-color: #EBF6FF !important;
  border-color: #EBF6FF !important;
  color: #355D7D !important;
}
.loan-details .loan-details-main .right-column .loan-documents > .title {
  margin-bottom: 8px;
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}
.loan-details .loan-details-main .right-column .approve-loan {
  padding: 14px 0px;
  text-align: center;
  border-radius: 6px;
  border: 1px solid var(--300-grey, #DFE4EB);
  background: var(--300-grey, #DFE4EB);
  color: var(--600-grey, #929FB0);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
}

.loan-progress-item .caption {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  text-align: center;
  margin-bottom: 4px;
}
.loan-progress-item .loan-progress-bar {
  width: 100%;
  height: 6px;
  border-radius: 16px;
  background: var(--300-grey, #DFE4EB);
}

.content-box {
  border-radius: 10px;
  border: 1px solid var(--500-grey, #AFBDCC);
  padding: 16px 20px;
}
.content-box .label {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 10px;
}
.content-box .content {
  border-left: 1px solid #97BCF0;
  padding: 2px 0px;
  padding-left: 12px;
}
.content-box .content .item {
  margin-bottom: 8px;
}
.content-box .content .item:last-of-type {
  margin-bottom: 0px;
}
.content-box .content .item-row {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content-box .content .item-row .value i {
  color: var(--700-grey, #6E7889);
}
.content-box .content .item-row .value span {
  cursor: pointer;
  color: var(--blue60, #5E8EB7);
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.content-box .content .item-row.extra {
  margin-top: 8px;
  padding-left: 16px;
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
}
.content-box .content .item-row.extra .value {
  color: var(--700-grey, #6E7889);
}

.document-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 16px;
  border-radius: 10px;
  border: 1px solid var(--400-grey, #CCD3DB);
  background: var(--white, #FFF);
  margin-bottom: 12px;
}
.document-item-COMPLETE {
  border-radius: 10px;
  border: 1px solid var(--green-60, #4CA852);
  background: #FAFCFC;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
}
.document-item-COMPLETE .label {
  color: var(--green-90, #1F4222);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.document-item-COMPLETE svg:not(.trash) path {
  stroke: #1F4222;
}
.document-item-COMPLETE .status-badge {
  background: var(--30, #C2F0C5);
  color: var(--100, #141F15);
}
.document-item-VERIFY\\/UPDATE {
  border-radius: 10px;
  border: 1px solid var(--60, #C59ED5);
  background: var(--10, #FAF9FC);
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
}
.document-item-VERIFY\\/UPDATE .label {
  color: var(--90, #653B6F);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.document-item-VERIFY\\/UPDATE svg:not(.trash) path {
  stroke: var(--90, #653B6F);
}
.document-item-VERIFY\\/UPDATE .status-badge {
  background: #EAD6FF;
  color: var(--100, #141F15);
}
.document-item-UPLOAD {
  border-radius: 10px;
  border: 1px solid #C13934;
  background: #FAFCFC;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
}
.document-item-UPLOAD .label {
  color: #610805;
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.document-item-UPLOAD svg:not(.trash) path {
  stroke: #610805;
}
.document-item-UPLOAD .status-badge {
  background: #FFC6BF;
  color: var(--100, #141F15);
}
.document-item-DRAFT svg:not(.trash) path {
  stroke: #929FB0;
}
.document-item-DRAFT svg.trash path {
  stroke: #FFC6BF;
}
.document-item-DRAFT .label {
  color: var(--600-grey, #929FB0);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.document-item-DRAFT .status-badge {
  background: var(--30, #EFF3F5);
  color: var(--100, #404859);
}
.document-item svg {
  height: 16px;
  width: 16px;
  margin-right: 8px;
}
.document-item svg:last-of-type {
  margin-right: 0px;
}
.document-item .actions-container {
  display: flex;
  gap: 8px;
  width: 40px;
}
.document-item .actions-container .disabled {
  opacity: 0.3;
  cursor: auto;
}
.document-item .label {
  width: 20em;
  font-size: 22px;
  display: flex;
  align-items: center;
}
.document-item .label .expires-label {
  margin-left: 24px;
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  text-align: left;
}
.document-item .label .expires-label-error {
  color: #E56A5C !important;
}
.document-item .label .expires-label-approved {
  color: #3F9545 !important;
}
.document-item .feedback-actions-container {
  display: flex;
  align-items: start;
}
.document-item .feedback-actions-container .action-blocked-disabled {
  opacity: 0.3;
  cursor: auto;
}
.document-item .feedback-actions-container .action-blocked-blocked svg {
  fill: #FFC6BF;
}
.document-item .feedback-actions-container .action-blocked-blocked svg:not(.trash) path {
  stroke: #610805;
}
.document-item .content-right {
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: end;
  width: 50%;
}
.document-item .content-right .document-state {
  width: 200px;
  display: flex;
  justify-content: end;
}
.document-item .expand {
  flex: 0.2 1;
}

.borrower-card {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: var(--gray-100, #F9FAFB);
  height: 112px;
  padding: 7px 14px;
}
.borrower-card .borrower-summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 256px;
  position: relative;
  bottom: 8px;
}
.borrower-card .borrower-summary .photo-container {
  position: absolute;
  top: -8px;
  border-radius: 24px;
  background: lightgray 50%;
  margin-bottom: 4px;
}
.borrower-card .borrower-summary .borrower-caption {
  margin-top: 22px;
  color: var(--700-grey, #6E7889);
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
}
.borrower-card .borrower-summary .borrower-name {
  color: var(--900-grey, #2A2F3C);
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.borrower-card .contact-info-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 8px;
}
.borrower-card .buttons-container {
  width: 100%;
}
.borrower-card .buttons-container > *:first-child {
  margin-right: 8px;
}
.borrower-card .buttons-container .button-blue {
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--100, #122536);
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.15px;
  height: 24px;
  padding: 0px 6px;
  border-radius: 6px;
  border: 1px solid var(--100, #162E43);
  background: var(--100, #122536);
}
.borrower-card .buttons-container .button-blue:hover {
  color: var(--100, #122536) !important;
}
.borrower-card .buttons-container .button-blue.outlined {
  color: var(--100, #122536);
  background: #FFF;
}

.borrower-task-item {
  display: flex;
  flex-direction: column;
  padding: 11px 16px;
  border-radius: 10px;
  border: 1px solid var(--400-grey, #CCD3DB);
  background: var(--white, #FFF);
  margin-bottom: 12px;
}
.borrower-task-item .row-1 {
  display: flex;
  align-items: center;
}
.borrower-task-item .row-1 .actions-container {
  width: 40px;
  display: flex;
  gap: 8px;
}
.borrower-task-item .row-1 .actions-container img, .borrower-task-item .row-1 .actions-container svg {
  cursor: pointer;
}
.borrower-task-item .row-1 .label {
  margin-left: 10px;
  width: 20em;
}
.borrower-task-item .row-1 .feedback-actions-container {
  display: flex;
  width: 20px;
  max-width: 5em;
}
.borrower-task-item .row-1 .feedback-actions-container svg {
  cursor: pointer;
}
.borrower-task-item .row-1 .content-right {
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: end;
  width: 50%;
}
.borrower-task-item .row-1 .content-right .content-status {
  width: 150px;
  display: flex;
  justify-content: end;
}
.borrower-task-item .row-1 .expand {
  width: 20px;
}
.borrower-task-item svg {
  height: 16px;
  width: 16px;
  margin-right: 8px;
}
.borrower-task-item svg:last-of-type {
  margin-right: 0px;
}
.borrower-task-item svg:not(.trash) path {
  stroke: #2A2F3C;
}
.borrower-task-item .label {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.borrower-task-item .status-badge {
  background: var(--30, #404859);
}
.borrower-task-item .status-badge .title {
  color: var(--100, #FFFFFF);
}
.borrower-task-item.DRAFT svg:not(.trash) path {
  stroke: #404859;
}
.borrower-task-item.DRAFT .status-badge {
  border: 1px solid var(--60, #404859);
  background: var(--30, #FFFFFF);
}
.borrower-task-item.DRAFT .status-badge .title {
  color: var(--100, #404859);
}
.borrower-task-item.REVIEW {
  border: 1px solid var(--60, #C59ED5);
  background: var(--10, #FAF9FC);
}
.borrower-task-item.REVIEW .label {
  color: var(--90, #653B6F);
}
.borrower-task-item.REVIEW svg:not(.trash) path {
  stroke: #653B6F;
}
.borrower-task-item.REVIEW .status-badge {
  background: var(--30, #EAD6FF);
}
.borrower-task-item.REVIEW .status-badge .title {
  color: var(--100, #241226);
}
.borrower-task-item.REVIEW .liquidity-info .title {
  color: #653B6F !important;
}
.borrower-task-item.REVIEW .liquidity-info .max {
  color: #653B6F;
}
.borrower-task-item.REVIEW .box-message-state-review {
  margin-top: 10px;
  margin-left: 60px;
  margin-right: 28px;
  padding: 5px 8px;
  background-color: #FDFCFF;
  color: #855791;
  border: 1px solid #D7B8E5;
}
.borrower-task-item.REVIEW .box-message-state-review span {
  font-size: 12px;
  font-weight: 400;
}
.borrower-task-item.REVIEW .box-message-state-review b {
  font-size: 12px;
  font-weight: 700;
}
.borrower-task-item.REVIEW .box-message-state-review button {
  height: auto;
  padding: 0px;
}
.borrower-task-item.REVIEW .box-message-state-review button span {
  text-decoration: underline;
  color: #855791;
  font-size: 12px;
}
.borrower-task-item.REVIEW .box-message-state-review button svg {
  width: 12px;
  height: 12px;
}
.borrower-task-item.REVIEW .box-message-state-review button .anticon {
  margin-inline-start: 5px;
}
.borrower-task-item.REVIEW .box-message-state-review .button-bold span {
  font-weight: 600;
  text-decoration: none;
}
.borrower-task-item.REQUEST_ERROR {
  border: 1px solid var(--60, #C13934);
  background: var(--10, #FFFFFF);
}
.borrower-task-item.REQUEST_ERROR .label {
  color: var(--90, #610805);
}
.borrower-task-item.REQUEST_ERROR svg:not(.trash) path {
  stroke: #610805;
}
.borrower-task-item.REQUEST_ERROR .status-badge {
  background: var(--30, #FFC6BF);
}
.borrower-task-item.REQUEST_ERROR .status-badge .title {
  color: var(--100, #241226);
}
.borrower-task-item.APPROVED {
  border: 1px solid var(--60, #4CA852);
  background: var(--10, #FAFCFC);
}
.borrower-task-item.APPROVED .label {
  color: var(--90, #1F4222);
}
.borrower-task-item.APPROVED svg:not(.trash) path {
  stroke: #1F4222;
}
.borrower-task-item.APPROVED .status-badge {
  background: var(--30, #C2F0C5);
}
.borrower-task-item.APPROVED .status-badge .title {
  color: var(--100, #241226);
}
.borrower-task-item .liquidity-info {
  margin-top: 10px;
  margin-left: 55px;
}
.borrower-task-item .liquidity-info .label {
  font-weight: 500;
  font-size: 12px;
}
.borrower-task-item .liquidity-info .max {
  font-weight: 600;
  font-size: 12px;
}

.cont-modal {
  width: 100%;
}

.ModalTask {
  position: fixed;
  background: rgba(42, 47, 60, 0.55);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 300;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ModalTask .content-add {
  margin-top: 50px;
}
.ModalTask-content {
  width: 70%;
  background-color: #fff;
  height: 100%;
}
.ModalTask .button-close-mask {
  width: 30%;
  height: 100%;
  background-color: rgba(255, 0, 0, 0);
  box-shadow: none;
  border: none;
}
.ModalTask .button-close-mask:hover, .ModalTask .button-close-mask:active, .ModalTask .button-close-mask:focus {
  background-color: rgba(255, 0, 0, 0);
  box-shadow: none;
  border: none;
}
.ModalTask .content-modal {
  padding-bottom: 0;
}
.ModalTask .content-modal .modal-title {
  width: 100%;
  padding: 40px;
  padding-bottom: 0;
}
.ModalTask .content-modal .modal-title .flex-btw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #929fb0;
}
.ModalTask .content-modal .modal-title button,
.ModalTask .content-modal .modal-title button:hover,
.ModalTask .content-modal .modal-title button:active,
.ModalTask .content-modal .modal-title button:focus {
  background-color: transparent;
  border: none !important;
  padding: 0 !important;
  box-shadow: none !important;
  color: #404859 !important;
}
.ModalTask .content-modal .modal-title .body-card {
  color: #404859;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.24px;
}
.ModalTask .content-modal .modal-container {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: calc(100vh - 180px);
}
.ModalTask .content-modal .modal-container .dots {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 45%;
  left: 30px;
  gap: 9px;
}
.ModalTask .content-modal .modal-container .dots-button {
  padding: 0;
  border: 1.5px solid #6e7889;
  background: #fff;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.ModalTask .content-modal .modal-container .dots-button-success {
  border: 1px solid #6EAC72;
  background: #C5F0C8;
}
.ModalTask .content-modal .modal-container .dots-button-active {
  height: 25px;
  width: 25px;
  border: 2px dotted #ddaa42;
}
.ModalTask .content-modal .modal-container .dots-button-review-active {
  height: 25px;
  width: 25px;
  border: 2px dotted #ddaa42;
  background: #e3ddf0;
}
.ModalTask .content-modal .modal-container .modal-title {
  border-bottom: 0;
  align-items: flex-end;
}
.ModalTask .content-modal .modal-container .modal-title button {
  height: 18px;
  text-transform: uppercase;
  color: #8a5791 !important;
}
.ModalTask .content-modal .modal-container .modal-title button img {
  margin-top: -0.9px;
  margin-right: 3px;
}
.ModalTask .content-modal .modal-container .text {
  margin-top: 5px;
}
.ModalTask .content-modal .modal-container .text a {
  margin-left: 6px;
}
.ModalTask .content-modal .modal-container .text a:hover {
  color: #2a2f3c;
}
.ModalTask .content-modal .modal-container .modal-cards {
  width: 100%;
  height: 100%;
  padding-bottom: 20px;
  padding-top: 64px;
  overflow: auto;
  padding-right: 10px;
  max-width: 576px;
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.ModalTask .content-modal .modal-container .modal-cards--full {
  max-width: none;
  display: flex;
  justify-content: center;
}
.ModalTask .content-modal .modal-container .modal-cards-mx-w {
  max-width: 576px;
  width: 100%;
  padding-bottom: 20px;
}
.ModalTask .content-modal .modal-container .modal-cards .flex-btw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 12px;
}
.ModalTask .content-modal .modal-container .modal-cards .flex-btw .button {
  text-transform: uppercase;
  color: #404859;
  text-align: right;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  text-transform: uppercase;
}
.ModalTask .content-modal .modal-container .modal-cards .flex-btw .button .anticon {
  color: #404859;
}
.ModalTask .content-modal .modal-container .modal-cards .title {
  background: #e3ddf0;
  border-radius: 140px;
  display: flex;
  padding: 5px 12px 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.ModalTask .content-modal .modal-container .modal-cards .title .body-regular {
  color: #48244d;
}
.ModalTask .content-modal .modal-container .modal-cards .h2 {
  margin-top: 12px;
}
.ModalTask .content-modal .modal-container .modal-cards .h2-w8 {
  color: #ac78b3;
}
.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar {
  width: 8px;
  border-radius: 5px;
}
.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}
.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.ModalTask .modal-review-task__footer {
  border-top: 1px solid #dfe4eb;
  height: 180px;
}
.ModalTask .modal-review-task__footer .text-footer .placeholder {
  color: #6e7889;
}
.ModalTask .modal-review-task__footer .text-footer .placeholder span {
  color: #f5faff;
  font-weight: 600;
  background-color: #5e8eb7;
  padding: 0 5px;
  border-radius: 3px;
}
.ModalTask .modal-review-task__footer .footer-grey .h4 {
  color: #6e7889;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 170%;
}
.ModalTask .modal-review-task__footer .body-regular {
  color: #6e7889;
}
.ModalTask .modal-review-task__footer .footer_dost {
  align-items: center;
}
.ModalTask .modal-review-task__footer .footer_dost .body-regular {
  color: #404859;
}
.ModalTask .modal-review-task__footer .footer_dost .circles {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
}
.ModalTask .modal-review-task__footer .footer_dost .circles .circle {
  border-radius: 64px;
  border: 1px solid #404859;
  width: 20px;
  height: 20px;
}
.ModalTask .modal-review-task__footer .modal-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  padding-right: 15px;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards {
  width: 100%;
  height: 100%;
  max-width: 576px;
  padding: 14px 0;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .h4-w4 {
  color: #ac78b3;
  margin-bottom: 10px;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .h4-w4 .h4 {
  color: #6e7889;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle {
  border-radius: 100%;
  border: 1px solid #8a5791;
  background: #dfb8e5;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle-active {
  border: 1px solid #587e5b;
  background: #6eac72;
}
.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle-active img {
  display: none;
}

.ModalTask-content-right {
  width: 35%;
  background-color: #fff;
  height: 100%;
  border-left: 1px solid #ccd3db;
  overflow: scroll;
  padding: 60px 45px 25px 30px;
}
.ModalTask-content-right .w-md-editor .title {
  line-height: unset !important;
  font-size: unset !important;
  font-weight: unset !important;
}
.ModalTask-content-right .button-close {
  position: absolute;
  top: 10px;
  right: 10px;
  color: black;
}
.ModalTask-content-right .button-close:hover {
  color: black !important;
}

.modal-end-submit {
  border-radius: 10px;
  border: 1px solid var(--yellow-400, #ffd47d);
  background: var(--yellow-100, #fff9ee);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
  padding: 0;
  width: 556px !important;
  top: 202px !important;
}
.modal-end-submit .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #162e43 !important;
  border-color: #162e43 !important;
}
.modal-end-submit .coin {
  width: 49.334px;
  height: 34px;
}
.modal-end-submit .tag {
  width: 53px;
  height: 47.06px;
}
.modal-end-submit .ant-modal-content {
  background-color: transparent;
  padding: 32px;
}
.modal-end-submit .ant-modal-content .h2 {
  margin-top: 15px;
  margin-bottom: 5px;
}
.modal-end-submit .ant-modal-content .h4 {
  color: #66564d;
}
.modal-end-submit .ant-modal-content .divider {
  border-top: 1px solid #ddaa42;
  padding-top: 20px;
  margin-top: 26px;
}
.modal-end-submit .ant-modal-content .buttons {
  margin-top: 35px;
}
.modal-end-submit .ant-modal-content .button {
  margin-top: 16px;
  height: 40px !important;
}
.modal-end-submit .ant-modal-content .ant-modal-footer {
  display: none;
}
.modal-end-submit .anticon {
  color: #997120;
}
.modal-end-submit .ant-checkbox-wrapper {
  margin-top: 10px;
}
.modal-end-submit .ant-checkbox-wrapper span {
  color: #244560;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.18px;
}
.modal-end-submit--white {
  background: #fff;
  border-color: #fff;
}
.modal-end-submit--white .anticon {
  color: #6e7889;
}
.modal-end-submit--white .ant-modal-content .h2 {
  color: #162e43;
}
.modal-end-submit--white .ant-modal-content .h4 {
  color: #48759a;
}
.modal-end-submit--white .ant-modal-content .buttons .button-modal-ok {
  border: 1px solid #162e43 !important;
  background: #162e43 !important;
  color: #ffffff !important;
}
.modal-end-submit--white .ant-modal-content .buttons .button-modal-cancel {
  border: 1px solid #162e43 !important;
  background: #fff !important;
  color: #162e43 !important;
}
.modal-end-submit--white .ant-modal-content .buttons .button-modal-cancel-delete {
  font-weight: 600 !important;
  color: #122536 !important;
}
.modal-end-submit--white .ant-modal-content .buttons .button-modal-delete {
  border: 1px solid #A31C17 !important;
  background: #A31C17 !important;
  color: #F5FAFF !important;
  font-weight: 600 !important;
}

.QuestionBasic .body-regular {
  color: #6e7889;
}
.QuestionBasic .h3 {
  margin-bottom: 40px;
}
.QuestionBasic .options {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 18px;
  margin-top: 25px;
}
.QuestionBasic .options .content-left {
  display: flex;
  flex-direction: column;
}
.QuestionBasic .options .Button-option {
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid #ccd3db;
  background: #f9fafb;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
  min-height: 56px;
  height: auto;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 19px 24px;
}
.QuestionBasic .options .Button-option-text {
  color: #2a2f3c !important;
}
.QuestionBasic .options .Button-option .flex-btw {
  margin-bottom: 0 !important;
}
.QuestionBasic .options .Button-option .flex-start {
  display: none;
}
.QuestionBasic .options .Button-option-active {
  border-radius: 10px;
  border: 1px solid #9bbceb;
  background: #ebf6ff;
  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);
}
.QuestionBasic .options .Button-option-active .flex-start {
  display: flex;
  gap: 6px;
  align-items: flex-start;
}
.QuestionBasic .options .Button-option-active .flex-start img {
  margin-top: 3px;
}
.QuestionBasic .options .Button-option-active .flex-start .body-regular {
  max-width: 300px;
}
.QuestionBasic .options .Button-option-active-text {
  color: #355c7d !important;
}
.QuestionBasic .options .Button-option-active .body-regular {
  color: #5e8eb7;
}
.QuestionBasic .options .Button-option-active .sub-title {
  font-weight: 500;
}
.QuestionBasic .Button-option-active .ModalEndSubmit {
  width: 100%;
}
.QuestionBasic .Button-option-active .ModalEndSubmit .button {
  height: 36px;
}
.QuestionBasic .Button-option-active .ModalEndSubmit .button span {
  color: #f5faff !important;
}
.QuestionBasic .Button-option-active .Button-option-text {
  color: #355c7d !important;
}
.QuestionBasic .Button-option-active-description {
  color: #5E8EB7 !important;
  font-size: 14px;
  margin-top: 5px;
}
.QuestionBasic .list {
  list-style-type: disc;
  list-style: disc;
  padding-left: 25px;
  margin-top: 15px;
}
.QuestionBasic .list .h4 {
  color: #404859;
  line-height: 145%;
}

.spinner-container {
  position: relative;
  width: auto;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: end;
  overflow: hidden; /* Evita desbordamientos */
}

.spinner {
  position: relative;
}

.spinner div {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #c4cdd5;
  border-radius: 50%;
  animation: spin 1.2s linear infinite;
}

/* Colocación inicial de los 12 círculos */
.spinner div:nth-child(1) {
  transform: rotate(30deg) translate(40px);
}

.spinner div:nth-child(2) {
  transform: rotate(60deg) translate(40px);
}

.spinner div:nth-child(3) {
  transform: rotate(90deg) translate(40px);
}

.spinner div:nth-child(4) {
  transform: rotate(120deg) translate(40px);
}

.spinner div:nth-child(5) {
  transform: rotate(150deg) translate(40px);
}

.spinner div:nth-child(6) {
  transform: rotate(180deg) translate(40px);
}

.spinner div:nth-child(7) {
  transform: rotate(210deg) translate(40px);
}

.spinner div:nth-child(8) {
  transform: rotate(240deg) translate(40px);
}

.spinner div:nth-child(9) {
  transform: rotate(270deg) translate(40px);
}

.spinner div:nth-child(10) {
  transform: rotate(300deg) translate(40px);
}

.spinner div:nth-child(11) {
  transform: rotate(330deg) translate(40px);
}

.spinner div:nth-child(12) {
  transform: rotate(0deg) translate(40px);
}

/* Animación para cambiar el color de los círculos */
@keyframes spin {
  0%, 100% {
    background-color: #c4cdd5;
  }
  8.3% {
    background-color: #4e8de6;
  }
}
/* Cambia el retardo de cada círculo */
.spinner div:nth-child(1) {
  animation-delay: -1.1s;
}

.spinner div:nth-child(2) {
  animation-delay: -1s;
}

.spinner div:nth-child(3) {
  animation-delay: -0.9s;
}

.spinner div:nth-child(4) {
  animation-delay: -0.8s;
}

.spinner div:nth-child(5) {
  animation-delay: -0.7s;
}

.spinner div:nth-child(6) {
  animation-delay: -0.6s;
}

.spinner div:nth-child(7) {
  animation-delay: -0.5s;
}

.spinner div:nth-child(8) {
  animation-delay: -0.4s;
}

.spinner div:nth-child(9) {
  animation-delay: -0.3s;
}

.spinner div:nth-child(10) {
  animation-delay: -0.2s;
}

.spinner div:nth-child(11) {
  animation-delay: -0.1s;
}

.spinner div:nth-child(12) {
  animation-delay: 0s;
}

.ButtonTabsFilters {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}
.ButtonTabsFilters .tab {
  border-radius: 100px;
  background: #dfe4eb;
  color: #404859;
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  border: none;
  box-shadow: none;
  height: 24px;
}
.ButtonTabsFilters .tab .number {
  font-weight: 400;
  margin-left: 3px;
}
.ButtonTabsFilters .tab:hover {
  background: #5E8EB7 !important;
  color: white !important;
}
.ButtonTabsFilters .tab-active {
  background-color: #355c7d;
  color: #ffffff;
}
.ButtonTabsFilters .tab-active:hover {
  background-color: #355c7d;
  color: #ffffff !important;
}

.CardAlertError {
  border-radius: 10px;
  border: 1px solid #d7b8e5;
  background: #f7edfc;
  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);
  padding: 18px 24px;
}
.CardAlertError .h4-w5 {
  color: #241226;
  margin-bottom: 5px;
}
.CardAlertError .h4-w4 {
  color: #653b6f;
  margin-bottom: 30px;
}

.CardDetailInformationBank {
  border-radius: 10px;
  border: 1px solid #929fb0;
  background: #fff;
  padding: 20px 16px;
}
.CardDetailInformationBank .h4 {
  margin-bottom: 24px;
}
.CardDetailInformationBank .label {
  color: #6e7889;
  margin-bottom: 4px;
}
.CardDetailInformationBank .info {
  color: #929fb0;
  font-style: italic;
}
.CardDetailInformationBank .row {
  display: flex;
  justify-content: center;
  align-items: center;
}
.CardDetailInformationBank .row .column {
  width: 50%;
}
.CardDetailInformationBank .column {
  margin-bottom: 20px;
}
.CardDetailInformationBank .column-line {
  border-bottom: 1px solid #dfe4eb;
  padding-bottom: 16px;
}

.CardLoanTasks {
  width: 396px;
  height: 192px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #6e7889;
  background: #fafcfc;
  padding: 12px 19px;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.CardLoanTasks .state-name {
  color: #404859;
  font-family: Inter;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.CardLoanTasks .state-name-w6 {
  font-weight: 600;
}
.CardLoanTasks .withBorder {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #ccd3db;
  background: #fff;
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.CardLoanTasks .withOutBorder {
  width: 100%;
  border-radius: 10px;
  border: none;
  background: none;
  box-shadow: none;
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.CardLoanTasks__top__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}
.CardLoanTasks__top__head .flex-end {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  align-items: center;
}
.CardLoanTasks__top__head .flex-end .svg-grid {
  height: 12px;
  width: 12px;
  fill: none;
}
.CardLoanTasks__top__head .flex-end .quick-task path {
  stroke: #6e7889;
}
.CardLoanTasks__top__head .flex-end .quick-task path:first-child {
  fill: #6e7889;
}
.CardLoanTasks__top__head .flex-end .major-task path {
  stroke: #6e7889;
  fill: #6e7889;
}
.CardLoanTasks__top .h4 {
  margin-bottom: 4px;
}
.CardLoanTasks__top .text {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.CardLoanTasks__top .body-card-full {
  margin-left: 5px;
  padding: 0 5px;
  font-weight: 700;
  border-radius: 2px;
}
.CardLoanTasks .TaskProgress {
  margin-top: 10px;
}
.CardLoanTasks__bottom .body-small-up {
  color: #587e5b;
  margin-bottom: 8px;
}
.CardLoanTasks__bottom .flex-betwen .body-card {
  color: #587e5b;
}
.CardLoanTasks-buttons-actions {
  gap: 10px;
  display: flex;
  justify-content: space-between;
}
.CardLoanTasks-APPROVED {
  border-color: #6eac72;
}
.CardLoanTasks-APPROVED .state {
  border-radius: 76px;
  background: #c5f0c8;
  padding: 4px 8px 4px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.CardLoanTasks-APPROVED .state .check {
  margin-right: 2px;
}
.CardLoanTasks-APPROVED .state .state-name {
  color: #355137;
}
.CardLoanTasks-APPROVED .h4 {
  color: #466849;
}
.CardLoanTasks-APPROVED .body-card-full {
  background-color: #c5f0c8;
  color: #466849;
}
.CardLoanTasks-APPROVED .flex-end .svg-grid path {
  stroke: #6eac72;
}
.CardLoanTasks-APPROVED .flex-end .svg-grid path:first-child {
  fill: #6eac72;
}
.CardLoanTasks-APPROVED .flex-end .major-task path {
  stroke: #6eac72;
  fill: #6eac72;
}
.CardLoanTasks-APPROVED .flex-end .state-name {
  color: #6eac72;
}
.CardLoanTasks-APPROVED .button-card {
  border: 1px solid #6eac72;
  background: #fafcfc;
  color: #466849;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
}
.CardLoanTasks-REVIEW {
  border-color: #ac78b3;
  background: #FEFAFF;
}
.CardLoanTasks-REVIEW .body-card-full {
  color: #48244d;
  background: #e3ddf0;
}
.CardLoanTasks-REVIEW .body-card--green {
  background-color: #e3ddf0;
}
.CardLoanTasks-REVIEW .state-name {
  color: #8a5791;
}
.CardLoanTasks-REVIEW .CardLoanTasks__top__head .flex-end .major-task path {
  stroke: #ac78b3;
  fill: #ac78b3;
}
.CardLoanTasks-REVIEW .state {
  border-radius: 76px;
  background: #e3ddf0;
  padding: 4px 8px 4px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.CardLoanTasks-REVIEW .state .state-name {
  color: #48244d;
}
.CardLoanTasks-REVIEW .body-card {
  color: #48244d;
}
.CardLoanTasks-REVIEW .button-card {
  color: #693b6f;
  border-radius: 6px;
  border: 1px solid #ac78b3;
  background: #fdfcff;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.03);
}
.CardLoanTasks-DRAFT {
  border-color: #929fb0;
}
.CardLoanTasks-DRAFT .body-card-w5 {
  color: #48244d;
}
.CardLoanTasks-DRAFT .state {
  border-radius: 76px;
  background: #404859;
  padding: 4px 8px 4px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.CardLoanTasks-DRAFT .state .state-name {
  color: #f9fafb;
}
.CardLoanTasks-REQUEST_ERROR {
  border-color: #c94f4a;
}
.CardLoanTasks-REQUEST_ERROR .body-card-w5 {
  color: #ac3e3a;
}
.CardLoanTasks-REQUEST_ERROR .state {
  border-radius: 76px;
  background: #ffd4cf;
  padding: 4px 8px 4px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.CardLoanTasks-REQUEST_ERROR .state .state-name {
  color: #712220;
}
.CardLoanTasks-REQUEST_ERROR .h4,
.CardLoanTasks-REQUEST_ERROR .body-card {
  color: #712220;
}
.CardLoanTasks-REQUEST_ERROR .h4-text-2,
.CardLoanTasks-REQUEST_ERROR .body-card-text-2 {
  color: #ac3e3a;
}
.CardLoanTasks-REQUEST_ERROR .button-card {
  border-color: #c94f4a;
}
.CardLoanTasks-REQUEST_ERROR .flex-betwen .button,
.CardLoanTasks-REQUEST_ERROR .flex-betwen .button-link {
  color: #712220;
}
.CardLoanTasks-REQUEST_ERROR .flex-end .svg-grid path {
  stroke: #c94f4a;
}
.CardLoanTasks-REQUEST_ERROR .flex-end .svg-grid path:first-child {
  fill: #c94f4a;
}
.CardLoanTasks-REQUEST_ERROR .flex-end .major-task path {
  stroke: #c94f4a;
  fill: #c94f4a;
}
.CardLoanTasks-REQUEST_ERROR .flex-end .state-name {
  color: #c94f4a;
}
.CardLoanTasks-beginTask .ModalCardState {
  width: 100% !important;
}

.CardSomeoneElse {
  margin-top: 10px;
  width: 100%;
}
.CardSomeoneElse input {
  background-color: transparent;
  border: none !important;
  box-shadow: none !important;
  padding: 0;
  color: #48759a;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.CardSomeoneElse input::placeholder {
  color: #9bbceb;
  font-family: Inter;
  font-size: 16px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
}
.CardSomeoneElse .ant-form-item {
  width: 100%;
  margin-bottom: 15px;
}
.CardSomeoneElse .row {
  display: flex;
  justify-content: center;
  align-items: center;
}
.CardSomeoneElse .row .ant-form-item {
  width: 100%;
}

.card-upload-response {
  position: relative;
  border-radius: 10px;
  border: 1px solid #2A2F3C;
  padding: 10px 16px;
}
.card-upload-response .template {
  margin-bottom: 10px;
}
.card-upload-response .template .arrow-right {
  width: 14px;
  margin-left: 5px;
}
.card-upload-response .template button {
  padding: 0;
}
.card-upload-response .header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}
.card-upload-response .header .h4 {
  display: flex;
  align-items: center;
}
.card-upload-response .header .link {
  padding: 0;
  color: rgb(110, 120, 137);
  font-size: 12px;
}
.card-upload-response .header .link span {
  text-decoration: underline;
}
.card-upload-response .header .link:hover {
  color: rgb(110, 120, 137);
}
.card-upload-response .description {
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 12px;
}
.card-upload-response-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.card-upload-response-REVIEW .h4 {
  color: #161616 !important;
}
.card-upload-response-REVIEW .description {
  color: #161616 !important;
}
.card-upload-response-REVIEW .link {
  color: #161616 !important;
}
.card-upload-response-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.card-upload-response-APPROVED .h4 {
  color: #404859 !important;
}
.card-upload-response-APPROVED .description {
  color: #404859 !important;
}
.card-upload-response-APPROVED .link {
  color: #404859 !important;
}
.card-upload-response-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: #FFFFFF;
}
.card-upload-response-REQUEST_ERROR .h4 {
  color: #404859 !important;
}
.card-upload-response-REQUEST_ERROR .description {
  color: #404859 !important;
}
.card-upload-response-REQUEST_ERROR .link {
  color: #404859 !important;
}

.DrodownBlue {
  height: 20px;
  padding: 1px 3px !important;
  display: flex;
  align-items: center;
}
.DrodownBlue:hover {
  background-color: #5E8EB7 !important;
  color: white !important;
}
.DrodownBlue:hover span {
  text-decoration-line: none !important;
}
.DrodownBlue:disabled {
  background-color: white !important;
  color: #5E8EB7 !important;
}
.DrodownBlue:disabled span {
  text-decoration-line: underline !important;
}
.DrodownBlue-blue {
  border: 1px solid #9BBCEB;
  border-radius: 10px;
}
.DrodownBlue-blue .ant-dropdown-menu {
  padding: 0px;
}
.DrodownBlue-blue .ant-dropdown-menu-item:hover {
  background-color: #EBF6FF !important;
}
.DrodownBlue-blue .ant-dropdown-menu-item:hover .ant-dropdown-menu-title-content {
  color: #355c7d;
  font-weight: 600;
}
.DrodownBlue-blue .ant-dropdown-menu-title-content {
  color: #5E8EB7;
  font-weight: 400;
}
.DrodownBlue-blue .ant-dropdown-menu-title-content:hover {
  color: #355c7d;
  font-weight: 600;
}

.InputAmount {
  border-radius: 10px;
  border: 1px solid #929fb0;
  background: #fff;
  padding: 13px 16px;
}
.InputAmount .h4 {
  color: #404859;
}
.InputAmount .button-operation {
  padding: 0;
  height: 23px;
  border: 0;
  background: none;
  box-shadow: none;
}
.InputAmount .button-operation .anticon {
  color: #5e8eb7;
}
.InputAmount .button-operation .anticon-full {
  display: none;
}
.InputAmount .button-operation:hover .anticon {
  color: #5e8eb7;
  display: none;
}
.InputAmount .button-operation:hover .anticon-full {
  display: block;
  margin-left: 0;
}
.InputAmount .flex {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
.InputAmount .flex .h4 {
  color: #929fb0;
}
.InputAmount .flex span {
  color: #929fb0;
  font-family: Inter;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
}
.InputAmount .flex .text-bold {
  color: #5e8eb7;
  font-weight: 600;
  font-style: normal;
}

.InputBorderNone .input {
  color: #775614;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.InputBorderNone .body-placeholder-w4 {
  color: #775614;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.InputBorderNone .bold-lith {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
}
.InputBorderNone .bold-lith::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 145%;
}
.InputBorderNone .bold {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
}
.InputBorderNone .percentage-bottom {
  border: 0;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #afbdcc;
  padding-top: 1px;
  margin-bottom: 10px !important;
  width: 90% !important;
}
.InputBorderNone .percentage-bottom .body-regular span {
  font-size: 12px;
}
.InputBorderNone .ant-input-number-input {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
  padding: 5px 0px !important;
}
.InputBorderNone .ant-input-number-input .default {
  font-weight: 400;
  color: #404859;
}
.InputBorderNone .ant-input-number-input .warning {
  font-weight: 600;
  color: #775614;
}
.InputBorderNone .ant-input-number-input::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-style: italic !important;
  font-weight: 400;
}

.InputUploadedFile .file-ok {
  margin: 10px 0;
}
.InputUploadedFile .file-ok .file {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
  position: relative;
}
.InputUploadedFile .file-ok .file-content {
  height: 28px;
  border-radius: 10px;
  border: 1px solid #2a2f3c;
  background-color: #f9fafb;
  width: 100%;
  padding: 0 20px;
  padding-right: 12px;
}
.InputUploadedFile .file-ok .file-content-approved {
  border: 1px solid #92c295 !important;
  background: #f5faf7 !important;
}
.InputUploadedFile .file-ok .file-content-request_error {
  border: 1px solid #c94f4a !important;
  background: #fff4f3 !important;
}
.InputUploadedFile .file-ok .file-content-request_error .name,
.InputUploadedFile .file-ok .file-content-request_error .anticon {
  color: #712220 !important;
}
.InputUploadedFile .file-ok .file-content-review {
  border: 1px solid #AC78B3 !important;
  background: #e3ddf0 !important;
}
.InputUploadedFile .file-ok .file-content-review .name,
.InputUploadedFile .file-ok .file-content-review .anticon {
  color: #693B6F !important;
}
.InputUploadedFile .file-ok .file .file-name {
  width: 80%;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 7px;
}
.InputUploadedFile .file-ok .file .file-name .name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.InputUploadedFile .file-ok .file .file-name .anticon {
  font-size: 15px;
}
.InputUploadedFile .file-ok .file .content-buttons {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 7px;
}
.InputUploadedFile .file-ok .file .content-buttons .anticon {
  font-size: 15px;
}
.InputUploadedFile .file-ok .file .flex {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: 12px;
}
.InputUploadedFile .file-ok .file .flex:first-child {
  gap: 4px;
}
.InputUploadedFile .file-ok .file .upload {
  margin-bottom: 0;
}
.InputUploadedFile .file-ok .file .flex-btw {
  margin-bottom: 0;
  height: 100%;
  border-bottom: none;
}
.InputUploadedFile .file-ok .file .circle-input {
  background-color: #fff;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #2a2f3c;
  display: flex;
  position: absolute;
  left: 0;
  justify-content: center;
  align-items: center;
}
.InputUploadedFile .file-ok .file .circle-input .upload {
  width: auto;
  height: 18px;
  object-fit: cover;
}

.ProgressSteps {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
}
.ProgressSteps .tab {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.ProgressSteps .tab .bar-status {
  width: 100%;
  width: calc(100% + 20px);
  height: 6px;
  border-radius: 16px;
  margin-top: 6px;
  background-color: #dfe4eb;
}
.ProgressSteps .tab-complete .body-small {
  color: #587e5b;
}
.ProgressSteps .tab-complete .bar-status {
  background-color: #6eac72;
}
.ProgressSteps .tab-started:hover .bar-status {
  background-color: #404859;
}

.ant-popover-content .ant-popover-inner {
  padding: 0;
}
.ant-popover-content .popover-content {
  padding: 10px 8px;
  border-radius: 10px;
  width: 240px;
  position: relative;
}
.ant-popover-content .popover-content .body-small {
  color: #fafcfa;
}
.ant-popover-content .popover-content .body-small-w6 {
  margin-bottom: 6px;
}
.ant-popover-content .popover-content .divider {
  height: 1px;
  width: 100%;
  margin: 8px 0;
}
.ant-popover-content .popover-content .button {
  display: flex;
  gap: 4px;
  align-items: center;
}
.ant-popover-content .popover-content .flecha-darck,
.ant-popover-content .popover-content .flecha {
  display: none;
  width: 16px;
  height: 8px;
}
.ant-popover-content .popover-content .felx-between {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.ant-popover-content .popover-content .felx-between .flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ant-popover-content .popover-content .felx-between .flex img {
  margin-right: 5px;
}
.ant-popover-content .popover-content .felx-between .button {
  background-color: transparent;
  border: none;
  padding: 0;
  height: 20px;
  box-shadow: none;
}
.ant-popover-content .popover-content .felx-between .button .flecha {
  margin-left: 5px;
  width: 12px;
}
.ant-popover-content .popover-content .warning {
  display: none;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
}
.ant-popover-content .popover-content .warning svg {
  width: 10px;
  height: 11px;
  fill: none;
}
.ant-popover-content .popover-content .warning .body-small {
  margin-bottom: 0;
  color: #8f2f2c;
  text-decoration-line: underline;
}
.ant-popover-content .popover-content-complete, .ant-popover-content .popover-content-started {
  background-color: #587e5b;
}
.ant-popover-content .popover-content-complete .divider, .ant-popover-content .popover-content-started .divider {
  background-color: #fafcfa;
}
.ant-popover-content .popover-content-complete .flecha, .ant-popover-content .popover-content-started .flecha {
  display: block;
}
.ant-popover-content .popover-content-complete .button:hover, .ant-popover-content .popover-content-complete .button:active, .ant-popover-content .popover-content-complete .button:focus, .ant-popover-content .popover-content-started .button:hover, .ant-popover-content .popover-content-started .button:active, .ant-popover-content .popover-content-started .button:focus {
  color: #fafcfa;
}
.ant-popover-content .popover-content-complete::after, .ant-popover-content .popover-content-started::after {
  content: "*";
  font-size: 0;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 11px solid #587e5b;
  position: absolute;
  left: 46%;
  top: -10px;
  z-index: 3;
}
.ant-popover-content .popover-content-started {
  background-color: #404859;
  width: 270px;
}
.ant-popover-content .popover-content-started .warning {
  display: flex;
}
.ant-popover-content .popover-content-started .warning .body-small {
  color: #ffd4cf;
}
.ant-popover-content .popover-content-started .warning svg path {
  stroke: #ffd4cf;
}
.ant-popover-content .popover-content-started::after {
  content: "*";
  font-size: 0;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 11px solid #404859;
  position: absolute;
  left: 46%;
  top: -10px;
  z-index: 3;
}
.ant-popover-content .popover-content-not-started {
  background-color: #ccd3db;
  width: 270px;
}
.ant-popover-content .popover-content-not-started .body-small {
  color: #000000;
}
.ant-popover-content .popover-content-not-started .warning {
  display: flex;
}
.ant-popover-content .popover-content-not-started svg path {
  stroke: #8f2f2c;
}
.ant-popover-content .popover-content-not-started .button:hover, .ant-popover-content .popover-content-not-started .button:active, .ant-popover-content .popover-content-not-started .button:focus {
  color: #000000;
}
.ant-popover-content .popover-content-not-started .divider {
  background-color: #404859;
}
.ant-popover-content .popover-content-not-started .flecha-darck {
  display: block;
}
.ant-popover-content .popover-content-not-started::after {
  content: "*";
  font-size: 0;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 11px solid #ccd3db;
  position: absolute;
  left: 46%;
  top: -10px;
  z-index: 3;
}
.ant-popover-content .popover-content .green-all .body-small {
  color: #c5f0c8;
}

.TaskProgress .bar {
  width: 100%;
  background-color: #dfe4eb;
  height: 8px;
  border-radius: 8px;
  display: flex;
}
.TaskProgress .bar :first-child {
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
}
.TaskProgress .bar :last-child {
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
}
.TaskProgress .bar-percentage {
  height: 8px;
}
.TaskProgress .h4 {
  color: #404859 !important;
  text-transform: none;
}

.SelectPrimary .body-regular {
  color: #2a2f3c;
  font-weight: 500;
}
.SelectPrimary .ant-space-item {
  width: 100%;
}

.state-tag {
  width: max-content;
  border-radius: 76px;
  padding: 4px 8px 4px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.state-tag .check {
  margin-right: 2px;
}
.state-tag .state-name {
  font-weight: 600;
  font-family: Inter;
  line-height: 11px;
  letter-spacing: 0.02em;
  font-size: 10px;
}
.state-tag-APPROVED {
  border-color: #C2F0C5;
  background: #C2F0C5;
}
.state-tag-APPROVED .state-name {
  color: #404859 !important;
}
.state-tag-REVIEW {
  border-color: #e3ddf0;
  background: #e3ddf0;
}
.state-tag-REVIEW .state-name {
  color: #161616 !important;
}
.state-tag-REQUEST_ERROR {
  border-color: #FFD4CF;
  background: #FFD4CF;
}
.state-tag-REQUEST_ERROR .state-name {
  color: #404859 !important;
}
.state-tag-DRAFT .state-name {
  color: #2a2f3c !important;
}

.UploadDocs {
  position: relative;
}
.UploadDocs .modal-see-file {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: red;
}
.UploadDocs .button-upload {
  height: 78px;
  width: 100%;
  border: 1px dashed #6e7889;
}
.UploadDocs .button-upload p {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.UploadDocs .button-upload p span {
  font-size: 10px;
  color: #4e8aff;
}
.UploadDocs .circles {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}
.UploadDocs .circles .circle {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  border: 1px solid #404859;
}
.UploadDocs .circles .circle-review {
  background-color: #AC78B3;
  border-color: #AC78B3;
}
.UploadDocs .circles .circle-approved {
  background-color: #C2F0C5;
  border-color: #92c295;
}
.UploadDocs .ant-upload {
  width: 100%;
  margin-bottom: 12px;
}
.UploadDocs .button {
  border-radius: 6px;
  border: #122536;
  background: #122536;
  width: 100%;
  height: 32px;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.18px;
}
.UploadDocs .button-transparent {
  background-color: transparent;
  border: none !important;
  box-shadow: none !important;
}
.UploadDocs .body-small .blue {
  color: #4e8aff;
}
.UploadDocs .upload {
  width: 20px;
  height: 20px;
  margin-bottom: 7px;
}
.UploadDocs .empty-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.UploadDocs .empty-input .small-detail {
  margin-top: 4px;
}
.UploadDocs--container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
}
.UploadDocs .input-content {
  position: relative;
  height: 128px;
  width: 100%;
  border-radius: 10px;
  background: var(--colors-gradient);
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #6e7889;
}
.UploadDocs .input-content .white {
  background-color: #fff;
  height: 10px;
  width: 20px;
  position: absolute;
  left: 0px;
  top: 0px;
  border-top-left-radius: 5px;
  z-index: 200;
}
.UploadDocs .input-content input {
  height: 126px;
  width: 100%;
  border-radius: 10px;
  background-color: rgba(255, 0, 0, 0);
  font-size: 0 !important;
  position: absolute;
  z-index: 2;
  top: 0;
  cursor: pointer;
}
.UploadDocs .input-content .cont-img {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
.UploadDocs .input-content .cont-img img {
  width: 100px;
}
.UploadDocs .input-content-wh {
  background: var(--colors-white);
  box-shadow: -3px 1px 10px -7px var(--colors-black);
  margin: 30px 40px;
}
.UploadDocs .input-content .edit {
  position: absolute;
  bottom: 0;
  height: auto;
  width: 99px;
  border-radius: 0;
}
.UploadDocs .content-flex {
  align-items: flex-start;
  gap: 16px;
}
.UploadDocs .content-flex .input-content,
.UploadDocs .content-flex .file-ok {
  width: 50% !important;
}

.circle-tag .circle {
  width: 20px;
  height: 20px;
}
.circle-tag .circle-APPROVED {
  border-color: #92c295;
  background-color: #C2F0C5;
}
.circle-tag .circle-APPROVED:hover {
  background-color: #549358;
}
.circle-tag .circle-REVIEW {
  background-color: #AC78B3;
  border-color: #AC78B3;
}
.circle-tag .circle-REVIEW:hover {
  background-color: #855791;
}
.circle-tag .circle-REQUEST_ERROR {
  background-color: #FFD4CF;
  border-color: #c94f4a;
}
.circle-tag .circle-REQUEST_ERROR:hover {
  background-color: #c94f4a;
}

.MinimumLiquidity {
  padding-bottom: 30px;
}
.MinimumLiquidity .h4 {
  color: #404859 !important;
}
.MinimumLiquidity .divider-top {
  padding-top: 10px;
}
.MinimumLiquidity .h4-error {
  color: #712220 !important;
  margin-bottom: 7px;
}
.MinimumLiquidity .h2-w8 {
  color: #2a2f3c !important;
}

.CardStateAccount {
  border-radius: 10px;
  border: 1px solid #7b7b7b;
  padding: 12px 16px;
  position: relative;
}
.CardStateAccount .label {
  border-radius: 100px;
  min-width: 81px;
  width: auto;
  max-width: 95px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 4px;
  gap: 4px;
  margin-bottom: 8px;
  background: #969696;
}
.CardStateAccount .label .body-small {
  margin-bottom: 0;
}
.CardStateAccount_head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.CardStateAccount .box {
  width: 300px !important;
}
.CardStateAccount .box .body-card {
  margin-bottom: 6px;
}
.CardStateAccount .box .body-regular {
  margin-bottom: 16px;
}
.CardStateAccount .box .file-ok {
  margin-top: 0 !important;
}
.CardStateAccount .box-error .flex .button:last-child {
  display: none !important;
}
.CardStateAccount .box-success .flex .button:last-child {
  display: none !important;
}
.CardStateAccount .divider {
  border-top: 1px solid #afbdcc;
  margin-top: 20px;
}
.CardStateAccount--inReview {
  background: #fdfcff;
  border: 1px solid #ac78b3;
}
.CardStateAccount--inReview .label {
  background: #e3ddf0;
}
.CardStateAccount--inReview .label .body-small {
  color: #48244d;
}
.CardStateAccount--inReview .box .body-card {
  color: #48244d;
}
.CardStateAccount--inReview .box .body-card-dark {
  color: #2a2f3c;
}
.CardStateAccount--inReview .box .body-regular {
  color: #48244d;
}
.CardStateAccount--inReview .file-ok .file-content .name {
  color: #693b6f !important;
}
.CardStateAccount--inReview .file-ok .file-content .anticon {
  color: #693b6f !important;
}
.CardStateAccount--error {
  border: 1px solid #c94f4a;
}
.CardStateAccount--error .label {
  background: #ffd4cf;
}
.CardStateAccount--error .label img {
  margin-top: 1px;
}
.CardStateAccount--error .label .body-small {
  color: #712220;
}
.CardStateAccount--error .UploadDocs .input-content {
  border: 1px dashed #e67f73;
}
.CardStateAccount--error .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.CardStateAccount--error .row .box {
  width: 40%;
}
.CardStateAccount--error .row .box .body-card {
  margin-bottom: 4px;
}
.CardStateAccount--error .divider {
  margin-top: 20px;
  border-top: 1px solid #ffd4cf;
  padding-top: 8px;
}
.CardStateAccount--approved {
  border: 1px solid #3F9545;
}
.CardStateAccount--approved .label {
  background: #C5F0C8;
}
.CardStateAccount--approved .label img {
  margin-top: 1px;
}
.CardStateAccount--approved .label .body-small {
  color: #355137;
}
.CardStateAccount--approved .UploadDocs .input-content {
  border: 1px dashed #C5F0C8;
}
.CardStateAccount--approved .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.CardStateAccount--approved .row .box {
  width: 40%;
}
.CardStateAccount--approved .row .box .body-card {
  margin-bottom: 4px;
}
.CardStateAccount--approved .divider {
  margin-top: 20px;
  border-top: 1px solid #C5F0C8;
  padding-top: 8px;
}
.CardStateAccount--approved .file-ok .file-content {
  border: 1px solid #75C27A !important;
  background-color: #C5F0C8 !important;
}
.CardStateAccount--approved .file-ok .file-content .name {
  color: #355137 !important;
}
.CardStateAccount--approved .file-ok .file-content .anticon {
  color: #355137 !important;
}
.CardStateAccount .row-btw .box {
  width: 100%;
}
.CardStateAccount .section-upload .UploadDocs .file-content {
  height: 28px !important;
  border-radius: 10px;
  border: 1px solid #eff3f5 !important;
  background: #eff3f5 !important;
  padding-left: 12px !important;
}
.CardStateAccount .section-upload .UploadDocs .InputUploadedFile .file-ok .file .circle {
  display: none;
}

.SectionError {
  border-radius: 10px;
  border: 1px solid #c94f4a;
  padding: 12px 15px;
}
.SectionError .flex-end button {
  height: 30px;
}
.SectionError .description {
  overflow: hidden;
}
.SectionError .description .body-regular {
  display: -webkit-box; /* Utiliza el modelo de caja flexible de tipo webkit */
  -webkit-box-orient: vertical; /* Orientación vertical */
  -webkit-line-clamp: 2; /* Número máximo de líneas */
  overflow: hidden; /* Oculta el contenido que sobresale */
}
.SectionError .flex-btw {
  margin-bottom: 5px;
}
.SectionError .body-regular {
  color: #c94f4a;
}
.SectionError .body-regular-w6 {
  color: #712220;
}
.SectionError .button {
  color: #712220;
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
}
.SectionError .button span {
  text-decoration: underline;
}
.SectionError .button span:hover {
  color: #712220;
}
.SectionError .button .anticon {
  color: #712220;
  margin-top: 2px;
}

.SectionNewBank .h4,
.SectionNewBank .body-regular {
  margin-bottom: 8px;
  color: #2a2f3c;
  line-height: 145%;
}
.SectionNewBank .button {
  width: auto !important;
  font-size: 20px;
  font-weight: 600;
}
.SectionNewBank .button-block {
  width: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-add-account {
  border-radius: 10px;
  border: 1px solid #2a2f3c;
  padding: 16px;
  margin-top: 16px;
}
.card-add-account .ModalEndSubmit .button {
  margin-bottom: 5px;
}
.card-add-account .flex-btw {
  margin-bottom: 0 !important;
}
.card-add-account .flex-btw .box {
  height: 100%;
}
.card-add-account .UploadDocs .flex-btw {
  border: none;
}
.card-add-account .body-card {
  color: #404859 !important;
}
.card-add-account .box {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.card-add-account .box .h4 {
  color: #929fb0;
  font-style: italic;
  margin-bottom: 16px;
}
.card-add-account .box .ModalEndSubmit .button {
  display: none;
}
.card-add-account .button-submit {
  margin-bottom: 20px;
  border-radius: 6px;
}
.card-add-account .button-submit span {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.18px;
}
.card-add-account .top-InfoExpand {
  border-top: 1px solid #afbdcc;
}

.DscrQuestionsAgreements .Step3 .h2 {
  margin-top: 4px;
  margin-bottom: 10px;
}
.DscrQuestionsAgreements .Step3 .h2 .blue-bold {
  color: #5e8eb7;
  font-weight: 800;
  text-decoration-line: underline;
  color: #2A2F3C;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 800;
  line-height: 135%;
  text-decoration-line: unset;
}
.DscrQuestionsAgreements .Step3 .rent-input {
  border: none;
  width: auto;
  display: inline;
}
.DscrQuestionsAgreements .Step3 .rent-input.touched {
  color: #404859;
}
.DscrQuestionsAgreements .Step3 .month {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.DscrQuestionsAgreements .Step3 #rent-button {
  margin-top: 16px;
}
.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex {
  display: flex;
  width: 100%;
}
.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex .cont-files {
  width: 100%;
}
.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex .UploadDocs--container {
  gap: 20px;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  width: 100%;
}
.DscrQuestionsAgreements .InputAmount-edit {
  margin-bottom: 0px !important;
  border: none !important;
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.DscrQuestionsAgreements .InputAmount-edit .flex {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
.DscrQuestionsAgreements .InputAmount-edit .flex .text-bold {
  color: #5e8eb7;
  font-weight: 600;
  font-style: normal;
}
.DscrQuestionsAgreements .InputAmount-edit .flex .input-edit {
  all: unset;
  color: #6E7889;
  animation: none;
  cursor: pointer;
  font-style: italic;
  font-weight: 400;
  line-height: 19.36px;
  text-align: right;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.DscrQuestionsAgreements .InputAmount-edit .button-edit {
  all: unset;
  border: none;
  color: #5E8EB7;
  animation: none;
  cursor: pointer;
  margin-left: 10px;
}
.DscrQuestionsAgreements .InputAmount-edit .button-edit span {
  margin-left: 5px;
  font-weight: 500;
  color: #5E8EB7;
  font-family: Inter;
  font-style: normal;
}
.DscrQuestionsAgreements .InputAmount-edit .button-edit-disabled span {
  color: #6E7889 !important;
}

.CardLeaseAgreements {
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #929fb0;
}
.CardLeaseAgreements .flex-btw .flex {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 28px;
}
.CardLeaseAgreements .flex-btw .flex .circle {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  border: 1px solid #404859;
}
.CardLeaseAgreements .flex-btw .flex .circle--active {
  background-color: #404859;
}
.CardLeaseAgreements-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.CardLeaseAgreements-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.CardLeaseAgreements-APPROVED .h4 {
  color: #404859 !important;
}
.CardLeaseAgreements-APPROVED .description {
  color: #404859 !important;
}
.CardLeaseAgreements-APPROVED .link {
  color: #404859 !important;
}
.CardLeaseAgreements-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: #FFFFFF;
}
.CardLeaseAgreements-REQUEST_ERROR .h4 {
  color: #404859 !important;
}
.CardLeaseAgreements-REQUEST_ERROR .description {
  color: #404859 !important;
}
.CardLeaseAgreements-REQUEST_ERROR .link {
  color: #404859 !important;
}

.CardMarketRent {
  border-radius: 4px;
  border: 1px solid #929fb0;
  padding: 12px 16px;
}
.CardMarketRent .body-regular-italic {
  color: #929fb0;
}
.CardMarketRent .flex-btw {
  margin-bottom: 9px !important;
}
.CardMarketRent-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.CardMarketRent-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.CardMarketRent-APPROVED .h4 {
  color: #404859 !important;
}
.CardMarketRent-APPROVED .description {
  color: #404859 !important;
}
.CardMarketRent-APPROVED .link {
  color: #404859 !important;
}
.CardMarketRent-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: #FFFFFF;
}
.CardMarketRent-REQUEST_ERROR .h4 {
  color: #404859 !important;
}
.CardMarketRent-REQUEST_ERROR .description {
  color: #404859 !important;
}
.CardMarketRent-REQUEST_ERROR .link {
  color: #404859 !important;
}
.CardMarketRent .ant-form {
  all: unset;
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.CardMarketRent .ant-form .form-row {
  all: unset;
  display: flex;
  align-items: baseline;
  gap: 5px;
  max-height: 35px;
}
.CardMarketRent .ant-form .form-row .bold {
  font-weight: 600 !important;
  color: #404859 !important;
}
.CardMarketRent .ant-form .rent-container {
  display: flex;
  align-items: baseline;
  position: relative;
}
.CardMarketRent .ant-form .rent-input {
  width: auto;
  min-width: 56px;
  max-width: 58px;
  text-align: right;
  font-weight: 600;
  color: #404859;
  border: none;
  outline: none;
  background: transparent;
}
.CardMarketRent .ant-form .unit-input {
  width: 25px !important;
}

.CardTotalUnits {
  border: 1px solid #929fb0;
  padding: 12px 16px;
}
.CardTotalUnits .body-regular-italic {
  color: #929fb0;
}
.CardTotalUnits .flex-btw {
  margin-bottom: 16px !important;
}

.EntityGuarantorCreation .task-footer .dropdown-blue-bold {
  height: 26px;
  display: unset;
  padding: 0 !important;
}
.EntityGuarantorCreation .task-footer .dropdown-blue-bold span {
  font-weight: 600;
  text-decoration-line: underline;
}
.EntityGuarantorCreation .task-footer .dropdown-review-bold {
  color: #AC78B3 !important;
  height: 26px;
  display: unset;
  padding: 0 !important;
}
.EntityGuarantorCreation .task-footer .dropdown-review-bold span {
  font-weight: 600;
  text-decoration-line: underline;
}
.EntityGuarantorCreation .task-footer .owners-tags {
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.EntityGuarantorCreation .task-footer .owners-tags .circles-tags {
  display: flex;
  align-items: end;
  gap: 10px;
}
.EntityGuarantorCreation .task-footer .owners-tags .circle {
  width: 20px;
  height: 20px;
}
.EntityGuarantorCreation .task-footer .owners-tags .circle-step3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.main {
  position: relative;
  border-radius: 10px;
}
.main .icon-delete {
  font-size: 20px;
  position: absolute;
  top: 50%;
  right: -9.5px;
  transform: translateY(-50%);
  color: #5E8EB7;
  cursor: pointer;
  visibility: hidden;
}
.main:hover .icon-delete {
  visibility: visible;
}
.main .content-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid #ccd3db;
  min-height: 56px;
  height: auto;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 10px 18px 5px 16px;
}
.main .content-card-hover-removed:hover {
  border: 1px solid #ccd3db !important;
}
.main .content-card:hover {
  border: 1px dashed #929fb0;
}
.main .content-card .input-disabled-color input:disabled {
  color: black;
}
.main .content-card-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.main .content-card-REVIEW .body-regular {
  color: #161616 !important;
}
.main .content-card-REVIEW .bold-lith {
  color: #161616 !important;
}
.main .content-card-REVIEW .ant-input-number-suffix {
  color: #161616 !important;
}
.main .content-card-REVIEW .ant-picker-input input {
  color: #161616 !important;
}
.main .content-card-REVIEW .ant-form-item-no-colon {
  color: #161616 !important;
}
.main .content-card-REVIEW .ant-input-number-input-wrap {
  color: #161616 !important;
}
.main .content-card-REVIEW .ant-input-number-input-wrap input {
  font-weight: 500;
}
.main .content-card-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.main .content-card-APPROVED .body-regular {
  color: #404859 !important;
}
.main .content-card-APPROVED .bold-lith {
  color: #404859 !important;
}
.main .content-card-APPROVED .ant-input-number-suffix {
  color: #404859 !important;
}
.main .content-card-APPROVED .ant-picker-input input {
  color: #404859 !important;
}
.main .content-card-APPROVED .ant-form-item-no-colon {
  color: #404859 !important;
}
.main .content-card-APPROVED .ant-input-number-input-wrap {
  color: #404859 !important;
}
.main .content-card-APPROVED .ant-input-number-input-wrap input {
  font-weight: 500;
}
.main .content-card-APPROVED .file-name {
  color: #404859 !important;
}
.main .content-card-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: white;
}
.main .content-card-REQUEST_ERROR .body-regular {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .bold-lith {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .ant-form-item-no-colon {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .ant-picker-input input {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .ant-input-number-suffix {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .ant-input-number-input-wrap {
  color: #712220 !important;
}
.main .content-card-REQUEST_ERROR .ant-input-number-input-wrap input {
  font-weight: 500;
}
.main .content-card-REQUEST_ERROR .file-name {
  color: #712220 !important;
}
.main .content-card .card-ownership {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.main .content-card .card-ownership .section-1 {
  display: flex;
  width: 70%;
  flex-direction: column;
}
.main .content-card .card-ownership .section-1 .names {
  display: flex;
  gap: 30px;
}
.main .content-card .card-ownership .section-1 .names .name {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: auto;
  gap: 5px;
}
.main .content-card .card-ownership .section-1 .names .name span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
}
.main .content-card .card-ownership .section-1 .names .name label {
  font-size: 12px;
}
.main .content-card .card-ownership .section-1 .footer .approved {
  color: #587e5b;
}
.main .content-card .card-ownership .section-1 .footer .error {
  color: #404859;
}
.main .content-card .card-ownership .section-1 .footer button {
  color: #6e7889;
}
.main .content-card .card-ownership .section-1 .footer button .anticon {
  margin-inline-start: 4px;
}
.main .content-card .card-ownership .section-1 .footer button:hover {
  color: #6e7889;
}
.main .content-card .card-ownership .section-1 .footer span {
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
}
.main .content-card .card-ownership .section-2 {
  display: flex;
  flex-direction: column;
  align-items: end;
}
.main .content-card .card-ownership .section-2 .suffix-null input {
  margin-top: 18px;
  padding-right: 0 !important;
}
.main .content-card .card-ownership .section-2 input {
  width: 100px;
  text-align: end;
  padding-right: 13px !important;
}
.main .content-card .card-ownership .section-2 .guarantor {
  margin-top: 7px;
  font-size: 10px;
  color: #5E8EB7;
}
.main .content-card .card-ownership .section-2 .ant-input-number-suffix {
  margin-inline-end: 0px;
  color: black;
}
.main .content-card .form-edit {
  width: 100%;
  height: auto;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: grid;
  grid-template-columns: 45% 35% 20%;
  grid-template-areas: "ssn datebirth textedit" "phone email ." "address address address" "identification identification identification" "submit submit submit";
}
.main .content-card .form-edit .ant-input-status-error {
  color: #404859;
}
.main .content-card .form-edit .ant-form-item-row {
  display: block;
}
.main .content-card .form-edit .ant-form-item-label {
  text-align: start;
  height: 27px;
}
.main .content-card .form-edit .ant-form-item-label label {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14.52px;
  color: #6e7889;
}
.main .content-card .form-edit .ant-form-item-control-input {
  min-height: 20px;
}
.main .content-card .form-edit .ant-form-item {
  margin-bottom: 15px;
}
.main .content-card .form-edit .ssn {
  grid-area: ssn;
}
.main .content-card .form-edit .datebirth {
  grid-area: datebirth;
}
.main .content-card .form-edit .datebirth .ant-picker-input input::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-style: italic !important;
  font-weight: 400;
}
.main .content-card .form-edit .datebirth .ant-picker-input input:disabled {
  color: black;
}
.main .content-card .form-edit .textedit {
  grid-area: textedit;
  font-size: 11px;
  text-align: end;
  color: #5E8EB7;
  display: flex;
  align-items: start;
  gap: 6px;
  justify-content: end;
  margin-top: 5px;
}
.main .content-card .form-edit .phone {
  grid-area: phone;
}
.main .content-card .form-edit .email {
  grid-area: email;
}
.main .content-card .form-edit .address {
  grid-area: address;
}
.main .content-card .form-edit .identification {
  grid-area: identification;
}
.main .content-card .form-edit .identification label {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
}
.main .content-card .form-edit .submit {
  grid-area: submit;
}

.step-3 .blue-bold {
  font-size: 24px;
  font-style: normal;
  font-weight: 800;
  text-decoration: underline;
}
.step-3 .owner-REVIEW {
  color: #161616;
}
.step-3 .owner-APPROVED {
  color: #404859;
}
.step-3 .owner-REQUEST_ERROR {
  color: #404859;
}
.step-3 .content-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.step-3 .content-owner-new {
  display: flex;
  justify-content: space-between;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.step-3 .content-owner-new button {
  padding: 0;
}
.step-3 .content-owner-new .text-add {
  display: flex;
  gap: 5px;
  align-items: center;
}
.step-3 .content-owner-new .total {
  display: flex;
  gap: 15px;
  align-items: center;
}

.action-accept-reject {
  position: absolute;
  top: -10px;
  right: 15px;
  width: 60px;
  z-index: 99;
}
.action-accept-reject .content-actions {
  display: flex;
  justify-content: end;
  gap: 15px;
  width: 60px;
}
.action-accept-reject .circle-input {
  cursor: pointer;
}

.EntityDocs .task-footer .dropdown-blue-bold {
  height: 26px;
  display: unset;
  padding: 0 !important;
}
.EntityDocs .task-footer .dropdown-blue-bold span {
  font-weight: 600;
  text-decoration-line: underline;
}
.EntityDocs .task-footer .dropdown-review-bold {
  color: #AC78B3 !important;
  height: 26px;
  display: unset;
  padding: 0 !important;
}
.EntityDocs .task-footer .dropdown-review-bold span {
  font-weight: 600;
  text-decoration-line: underline;
}
.EntityDocs .task-footer .owners-tags {
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.EntityDocs .task-footer .owners-tags .circles-tags {
  display: flex;
  align-items: end;
  gap: 10px;
}
.EntityDocs .task-footer .owners-tags .circle {
  width: 20px;
  height: 20px;
}
.EntityDocs .task-footer .owners-tags .circle-APPROVED {
  background-color: #C2F0C5;
  border-color: #92c295;
}
.EntityDocs .task-footer .owners-tags .circle-REVIEW {
  background-color: #AC78B3;
  border-color: #AC78B3;
}
.EntityDocs .task-footer .owners-tags .circle-REQUEST_ERROR {
  background-color: #FFD4CF;
  border-color: #c94f4a;
}

.entity-docs-step-2 .section-1 span {
  font-size: 20px !important;
}
.entity-docs-step-2 .dropdown-blue-bold {
  display: unset;
  height: auto;
}
.entity-docs-step-2 .dropdown-review-bold {
  color: #AC78B3 !important;
  display: unset;
  padding: 0 !important;
}
.entity-docs-step-2 .dropdown-review-bold span {
  text-decoration-line: underline;
}
.entity-docs-step-2 .submits {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}
.entity-docs-step-2 .submits section {
  width: 100%;
}

.InvestmentExperienceVerification .card__generic-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.InvestmentExperienceVerification .card__generic-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: #FFFFFF;
}
.InvestmentExperienceVerification .card__generic-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.InvestmentExperienceVerification .card__generic .UploadDocs .input-content,
.InvestmentExperienceVerification .card__generic .UploadDocs .input-content input {
  height: 79px;
}
.InvestmentExperienceVerification .circle-review {
  background-color: #AC78B3;
  border-color: #AC78B3 !important;
}
.InvestmentExperienceVerification .circle-approved {
  border: 1px solid #92c295 !important;
  background-color: #C2F0C5;
}

.ConstructionBudget input::-webkit-outer-spin-button,
.ConstructionBudget input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.ConstructionBudget .h2 {
  margin-top: 30px !important;
}
.ConstructionBudget .UploadDocs .input-content,
.ConstructionBudget .UploadDocs .input-content input {
  height: 78px;
}
.ConstructionBudget .UploadDocs .input-content .empty-input .body-small,
.ConstructionBudget .UploadDocs .input-content input .empty-input .body-small {
  color: #2a2f3c;
}
.ConstructionBudget .card__generic .s-title .h4 {
  color: #404859;
}
.ConstructionBudget .card__generic .body-regular {
  margin-bottom: 20px;
}
.ConstructionBudget .link {
  color: #5e8eb7;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-decoration: none;
  line-height: 145%;
}
.ConstructionBudget .link .arrow {
  height: 10px;
  margin-left: 5px;
}

.title-company-step-1 {
  border-radius: 10px;
  border: 1px solid #ccd3db;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
  padding: 16px 24px 5px;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.title-company-step-1 .ant-form {
  margin-top: 15px;
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: 50% 5% 45%;
  grid-template-areas: "titleCompany titleCompany titleCompany" "name name ." "phone . email" "submit submit submit";
}
.title-company-step-1-REVIEW {
  border: 1px solid #AC78B3;
  background-color: #FDFCFF;
}
.title-company-step-1-REVIEW .h4 {
  color: #161616 !important;
}
.title-company-step-1-REVIEW .description {
  color: #161616 !important;
}
.title-company-step-1-REVIEW .link {
  color: #161616 !important;
}
.title-company-step-1-APPROVED {
  border: 1px solid #92c295;
  background-color: white;
}
.title-company-step-1-APPROVED .h4 {
  color: #404859 !important;
}
.title-company-step-1-APPROVED .description {
  color: #404859 !important;
}
.title-company-step-1-APPROVED .link {
  color: #404859 !important;
}
.title-company-step-1-REQUEST_ERROR {
  border: 1px solid #c94f4a;
  background-color: #FFFFFF;
}
.title-company-step-1-REQUEST_ERROR .h4 {
  color: #404859 !important;
}
.title-company-step-1-REQUEST_ERROR .description {
  color: #404859 !important;
}
.title-company-step-1-REQUEST_ERROR .link {
  color: #404859 !important;
}
.title-company-step-1 .ant-form-item-row {
  display: block;
}
.title-company-step-1 .ant-form-item-label {
  text-align: start;
  height: 27px;
}
.title-company-step-1 .ant-form-item-label label {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14.52px;
  color: #6e7889;
}
.title-company-step-1 .ant-form-item-control-input {
  min-height: 20px;
}
.title-company-step-1 .ant-form-item {
  margin-bottom: 15px;
}
.title-company-step-1 .titleCompany {
  grid-area: titleCompany;
}
.title-company-step-1 .titleCompany input {
  font-size: 16px !important;
}
.title-company-step-1 .name {
  grid-area: name;
}
.title-company-step-1 .phone {
  grid-area: phone;
}
.title-company-step-1 .email {
  grid-area: email;
}
.title-company-step-1 .submit {
  grid-area: submit;
}
.title-company-step-1 .submit button {
  border-radius: 6px;
}

.insurance-step-2 .ant-collapse-header-text {
  max-width: 335px;
  margin-inline-end: unset !important;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
}
.insurance-step-2 .ant-collapse-expand-icon {
  padding-inline-start: 0px !important;
}

.payoff-footer .dropdown-blue-bold {
  display: unset;
  padding: 0 !important;
  border: none !important;
}
.payoff-footer .dropdown-blue-bold span {
  background-color: white !important;
  color: #5E8EB7 !important;
  padding: 0 !important;
}
.payoff-footer .is-review {
  color: #AC78B3 !important;
}

.insurance-step-2 .ant-collapse-header-text {
  max-width: 335px;
  margin-inline-end: unset !important;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
}
.insurance-step-2 .ant-collapse-expand-icon {
  padding-inline-start: 0px !important;
}

.entities-list {
  padding: 24px 25px;
}
.entities-list .top-container {
  box-sizing: content-box;
  width: 100%;
  margin-bottom: 33px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
}
.entities-list .top-container .title {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.entities-list .top-container .title > span {
  cursor: pointer;
  color: var(--blue60, #5E8EB7);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
}
.entities-list .entities-container {
  padding: 16px 0px;
}
.entities-list .entities-container > * {
  margin-bottom: 16px;
}
.entities-list .entities-container > *:last-child {
  margin-bottom: 0px;
}
.entities-list .search-box {
  cursor: pointer;
  box-sizing: border-box;
  width: 384px;
  padding: 5px 18px 5px 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
  border: 1px solid var(--400-grey, #CCD3DB);
  background: var(--gray-100, #F9FAFB);
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}
.entities-list .search-box > input {
  all: unset;
  width: 100%;
  margin-left: 8px;
}

@keyframes horizontal-shaking {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-3px);
  }
  50% {
    transform: translateX(3px);
  }
  75% {
    transform: translateX(-1px);
  }
  100% {
    transform: translateX(1px);
  }
}
.Login {
  display: flex;
  justify-content: space-between;
  min-height: calc(100vh - 56px);
}
.Login-form,
.Login .rigth {
  width: 50%;
}
.Login-form {
  padding: 32px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}
.Login-form .coin {
  margin-bottom: 13px;
}
.Login-form .h1 {
  margin-bottom: 24px;
}
.Login-form .ant-form {
  width: 100%;
}
.Login-form .error-message {
  margin-top: 50px;
  color: #8f2f2c;
}
.Login-form .button {
  margin-top: 10px;
}
.Login-form .link:hover {
  color: #404859;
}
.Login-form .link .body-regular-bold {
  text-decoration: underline;
}
.Login-form .link-absolute {
  position: absolute;
  bottom: 30px;
  left: 32px;
  text-decoration: none;
}
.Login-form .link-absolute .body-regular-bold {
  text-decoration: underline;
}
.Login .rigth {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  padding-left: 60px;
  padding-top: 64px;
  background-color: #f9fafb;
}
.Login .rigth .bottom-flex {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  max-width: 700px;
}
.Login .rigth .h2 {
  margin-bottom: 12px;
  max-width: 520px;
}
.Login .rigth .body-regular {
  max-width: 520px;
  margin-bottom: 30px;
}
.Login .rigth .back {
  padding: 7px;
  padding-bottom: 0;
  padding-right: 0;
  background-color: #355c7d;
  border-top-left-radius: 10px;
  width: 100%;
}
.Login .rigth img {
  bottom: 0;
  width: 100%;
}
@media (min-height: 735px) {
  .Login .bottom-flex {
    height: 470px;
  }
  .Login .bottom-flex img {
    height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/main.scss","webpack://./src/sass/base/_generic.scss","webpack://./src/sass/utils/_variables.scss","webpack://./src/sass/base/_reset.scss","webpack://./src/sass/base/_typography.scss","webpack://./src/sass/base/_Buttons.scss","webpack://./src/sass/base/_Selects.scss","webpack://./src/sass/base/_Tags.scss","webpack://./src/components/Dropdowns/DropdownBasic/DropdownBasic.scss","webpack://./src/components/Atoms/Checkboxs/CheckboxBasic/CheckboxBasic.scss","webpack://./src/scenes/Public/components/Layout/Layout.scss","webpack://./src/components/ApprovalRejectSection/components/SelectSection/SelectSection.scss","webpack://./src/scenes/Private/LoanList/components/TaskItemList.scss","webpack://./src/scenes/Private/LoanList/LoanDetails/Progress/Progress.scss","webpack://./src/scenes/Private/Borrowers/Borrowers.scss","webpack://./src/components/RightScenes/RightScenes.scss","webpack://./src/scenes/Private/Borrowers/BorrowerDetail/BorrowerDetail.scss","webpack://./src/scenes/Private/LoanList/LoanDetails/LoanDetails.scss","webpack://./src/scenes/Private/LoanList/LoanDetails/LoanDocuments/LoanDocuments.scss","webpack://./src/scenes/Private/LoanList/LoanDetails/BorrowerCard/BorrowerCard.scss","webpack://./src/components/BorrowerTask/BorrowerTask.scss","webpack://./src/components/BorrowerTask/components/Organisms/Modals/ModalTask/ModalTask.scss","webpack://./src/components/BorrowerTask/components/Organisms/Modals/ModalTask/SectionRight/SectionRight.scss","webpack://./src/components/BorrowerTask/components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit.scss","webpack://./src/components/BorrowerTask/components/Organisms/QuestionBasic/QuestionBasic.scss","webpack://./src/components/Atoms/Loader/Spin.scss","webpack://./src/components/BorrowerTask/components/Atoms/ButtonTabsFilters/ButtonTabsFilters.scss","webpack://./src/components/BorrowerTask/components/Atoms/Cards/CardAlertError/CardAlertError.scss","webpack://./src/components/BorrowerTask/components/Atoms/Cards/CardDetailInformationBank/CardDetailInformationBank.scss","webpack://./src/components/BorrowerTask/components/Atoms/Cards/CardLoanTasks/CardLoanTasks.scss","webpack://./src/components/BorrowerTask/components/Atoms/Cards/CardSomeoneElse/CardSomeoneElse.scss","webpack://./src/components/BorrowerTask/components/Atoms/Cards/CardUploadResponse/CardUploadResponse.scss","webpack://./src/components/BorrowerTask/components/Atoms/Dropdown/DropdownBlue/DropdownBlue.scss","webpack://./src/components/BorrowerTask/components/Atoms/Inputs/InputAmount/InputAmount.scss","webpack://./src/components/BorrowerTask/components/Atoms/Inputs/InputBorderNone/InputBorderNone.scss","webpack://./src/components/BorrowerTask/components/Atoms/Inputs/InputUploadedFile/InputUploadedFile.scss","webpack://./src/components/BorrowerTask/components/Atoms/Progress/ProgressSteps/ProgressSteps.scss","webpack://./src/components/BorrowerTask/components/Atoms/Progress/TaskProgress/TaskProgress.scss","webpack://./src/components/BorrowerTask/components/Atoms/Selects/SelectPrimary/SelectPrimary.scss","webpack://./src/components/BorrowerTask/components/Atoms/Tags/StateTag/StateTag.scss","webpack://./src/components/BorrowerTask/components/Atoms/UploadDocs/UploadDocs.scss","webpack://./src/components/BorrowerTask/components/Atoms/Tags/CircleTag/CircleTag.scss","webpack://./src/components/BorrowerTask/MinimumLiquidity/MinimunLiquidity.scss","webpack://./src/components/BorrowerTask/MinimumLiquidity/Step2/CardStateAccount/CardStateAccount.scss","webpack://./src/components/BorrowerTask/MinimumLiquidity/Step2/SectionError/SectionError.scss","webpack://./src/components/BorrowerTask/MinimumLiquidity/Step2/SectionNewBank/SectionNewBank.scss","webpack://./src/components/BorrowerTask/DscrQuestionsAgreements/DscrQuestionsAgreements.scss","webpack://./src/components/BorrowerTask/DscrQuestionsAgreements/Step3/CardLeaseAgreements/CardLeaseAgreements.scss","webpack://./src/components/BorrowerTask/DscrQuestionsAgreements/Step3/CardMarketRent/CardMarketRent.scss","webpack://./src/components/BorrowerTask/DscrQuestionsAgreements/Step3/CardTotalUnits/CardTotalUnits.scss","webpack://./src/components/BorrowerTask/EntityGuarantorCreation/EntityGuarantorCreation.scss","webpack://./src/components/BorrowerTask/EntityGuarantorCreation/CardOwnership/CardOwnership.scss","webpack://./src/components/BorrowerTask/EntityGuarantorCreation/Step3/Step3.scss","webpack://./src/components/ActionAcceptAndReject/ActionAcceptAndReject.scss","webpack://./src/components/BorrowerTask/EntityDocs/EntityDocs.scss","webpack://./src/components/BorrowerTask/EntityDocs/Step2/Step2.scss","webpack://./src/components/BorrowerTask/InvestmentExperienceVerification/InvestmentExperienceVerification.scss","webpack://./src/components/BorrowerTask/ConstructionBudget/ConstructionBudget.scss","webpack://./src/components/BorrowerTask/TitleCompany/Step1/Step1.scss","webpack://./src/components/BorrowerTask/Insurance/Step2/Step2.scss","webpack://./src/components/BorrowerTask/Payoff/Payoff.scss","webpack://./src/components/BorrowerTask/Payoff/Step2/Step2.scss","webpack://./src/scenes/Private/EntitiesList/EntitiesList.scss","webpack://./src/sass/utils/_animations.scss","webpack://./src/scenes/Public/Login/Login.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,iBAAA;EACA,WAAA;ADIF;;ACDE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;ADIJ;ACFE;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;ADIJ;ACFE;EACE,YAAA;ADIJ;ACFI;EACE,YAAA;ADIN;;ACCE;EACE,mBAAA;EACA,yBAAA;EACA,kDAAA;EACA,WAAA;EACA,aAAA;ADEJ;;ACGI;;EAEE,eAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;ADAN;ACCM;;EACE,cCnCW;EDoCX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADER;;ACGA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kDAAA;ADAF;ACCE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;ADCJ;ACCE;EACE,cAAA;ADCJ;;ACEA;EACE,aAAA;EACA,8BAAA;ADCF;;ACCA;EACE,aAAA;EACA,yBAAA;ADEF;;ACAA;EACE,aAAA;EACA,2BAAA;ADGF;;ACDA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;ADIF;;ACDE;EACE,gBAAA;ADIJ;ACFE;EACE,gBAAA;ADIJ;ACFE;EACE,gBAAA;ADIJ;ACFE;EACE,gBAAA;ADIJ;ACFE;EACE,gBAAA;ADIJ;ACFE;EACE,gBAAA;ADIJ;ACFE;EACE,gBAAA;ADIJ;ACFE;EACE,eAAA;ADIJ;ACFE;EACE,eAAA;ADIJ;ACFE;EACE,gBAAA;ADIJ;ACFE;EACE,gBAAA;ADIJ;;ACDA;EACE,6BAAA;ADIF;;ACCE;EACE,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,UAAA;ADEJ;ACAE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;ADEJ;ACDI;EACE,YAAA;ADGN;ACFM;EACE,YAAA;ADIR;ACDI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ADGN;ACAM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ADER;ACGI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADDN;;ACME;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADHJ;ACMI;EACE,gBAAA;ADJN;;ACQA;EACE,eAAA;ADLF;;ACOA;EACE,eAAA;ADJF;;ACOA;EACE,oBAAA;ADJF;;AGtMA;;;CAAA;AAIA;EACE,sBAAA;AHyMF;;AGtMA;;;EAGE,SAAA;EACA,YAAA;AHyMF;;AGtMA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AHyMF;;AGtMA,yDAAA;AACA;EACE,UAAA;AHyMF;;AGtMA,gDAAA;AACA;;;;;;;;;;;EAWE,cAAA;AHyMF;;AGtMA;EACE,cAAA;AHyMF;;AGtMA;;EAEE,gBAAA;AHyMF;;AGtMA;;EAEE,YAAA;AHyMF;;AGtMA;;;;EAIE,WAAA;EACA,aAAA;AHyMF;;AGtMA;EACE,yBAAA;EACA,iBAAA;AHyMF;;AGtMA;;;;EAIE,wBAAA;EACA,qBAAA;AHyMF;;AGtMA;EACE,wBAAA;EACA,qBAAA;EAGA,uBAAA;AHyMF;;AGtMA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AHyMF;;AGtMA;;IAAA;AAIA;;;EAGE,qBAAA;GHwMA,eGvMA;GHwMA,OGvMA;EACA,eAAA;AHwMF;;AGrMA;;;IAAA;AAKA;EACE,aAAA;EACA,SAAA;AHuMF;;AGpMA;;;IAAA;AAKA;EACE,aAAA;AHsMF;;AGnMA;;;;;IAAA;AAOA;EACE,eAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;AHqMF;;AGlMA;;IAAA;AAIA;EACE,oBAAA;AHoMF;;AGjMA;;IAAA;AAIA;;EAEE,UAAA;AHmMF;;AGhMA;;;IAAA;AAKA;EACE,SAAA,EAAA,MAAA;EACA,+BAAA,EAAA,MAAA;AHkMF;;AG/LA;;IAAA;AAIA;EACE,SAAA;AHiMF;;AG9LA;;IAAA;AAIA;EACE,SAAA;AHgMF;;AG7LA;;IAAA;AAIA;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;AH+LF;;AG5LA;;;;IAAA;AAMA;EACE,SAAA,EAAA,MAAA;EACA,UAAA;EACA,mBAAA,EAAA,MAAA;GH8LA,iBG7LA,EAAA,MAAA;AH8LF;;AG3LA;;;;;IAAA;AAOA;;;;EAIE,eAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;EACA,wBAAA,EAAA,MAAA;GH6LA,sBG5LA,EAAA,MAAA;AH6LF;;AG1LA;;;IAAA;AAKA;;EAEE,mBAAA;AH4LF;;AGzLA;;;;;IAAA;AAOA;;EAEE,oBAAA;AH2LF;;AGxLA;;;;;;;;IAAA;AAUA;;;;EAIE,0BAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;GH0LA,iBGzLA,EAAA,MAAA;AH0LF;;AGvLA;;IAAA;AAIA;;EAEE,eAAA;AHyLF;;AGtLA;;;;;IAAA;AAOA;;EAEE,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;GHwLA,YGvLA,EAAA,MAAA;GHwLA,WGvLA,EAAA,MAAA;AHwLF;;AGrLA;;;;IAAA;AAMA;EACE,6BAAA,EAAA,MAAA,EAEA,MAAA;EACA,uBAAA;AHuLF;;AGpLA;;;IAAA;AAKA;;EAEE,wBAAA;AHsLF;;AGnLA;;IAAA;AAIA;;EAEE,SAAA;EACA,UAAA;AHqLF;;AGlLA;;;IAAA;AAKA;EACE,cAAA,EAAA,MAAA;EACA,mBAAA,EAAA,MAAA;AHoLF;;AGjLA;;IAAA;AAIA;EACE,yBAAA;EACA,iBAAA;AHmLF;;AGhLA;;;;;EAKE,WAAA;AHmLF;;AG3KA;EACE,mBAAA;EACA,iBAAA;AHmLF;;AGhLA;EACE,sBAAA;AHmLF;;AGhLA;EACE,SAAA;EACA,SAAA;EACA,UAAA;AHmLF;;AGhLA;EACE,gBAAA;AHmLF;;AGhLA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AHmLF;;AGhLA;EACE,SAAA;EACA,8JAAA;EAEA,mCAAA;EACA,kCAAA;AHkLF;;AG/KA;EACE,+EAAA;AHkLF;;AIpoBA;EACE,cFQW;EEPX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJuoBF;;AIroBA;EACE,cFKW;EEJX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJwoBF;AIvoBE;EACE,gBAAA;AJyoBJ;;AItoBA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJyoBF;;AIvoBA;EACE,cFdW;EEeX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJ0oBF;AIzoBE;EACE,0BAAA;AJ2oBJ;AIzoBE;EACE,gBAAA;AJ2oBJ;AIzoBE;EACE,gBAAA;AJ2oBJ;;AIxoBA;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cFnCgB;AF8qBlB;;AIzoBA;EACE,cF5CW;EE6CX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJ4oBF;AI3oBE;EACE,kBAAA;AJ6oBJ;AI3oBE;EACE,yBAAA;AJ6oBJ;AI3oBE;EAEE,gBAAA;AJ4oBJ;AI1oBE;EACE,gBAAA;AJ4oBJ;;AIxoBA;EACE,cFhEiB;EEiEjB,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJ2oBF;AI1oBE;EACE,gBAAA;AJ4oBJ;;AIzoBA;EACE,cFzEiB;EE0EjB,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AJ4oBF;;AI1oBA;EACE,cFvFW;EEwFX,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJ6oBF;AI5oBE;EACE,gBAAA;AJ8oBJ;AI5oBE;EACE,gBAAA;AJ8oBJ;AI5oBE;EACE,yBAAA;AJ8oBJ;;AI3oBA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJ8oBF;;AI5oBA;EACE,cFhHW;EEiHX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJ+oBF;AI9oBE;EACE,gBAAA;EACA,+BAAA;AJgpBJ;AI9oBE;EACE,gBAAA;AJgpBJ;AI9oBE;EACE,gBAAA;AJgpBJ;AI9oBE;EACE,gBAAA;AJgpBJ;;AI7oBA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJgpBF;AI/oBE;EACE,YAAA;EACA,gBAAA;AJipBJ;;AI7oBA;EACE,gBAAA;AJgpBF;;AI7oBA;EACE,gBAAA;AJgpBF;;AI7oBA;EACE,eAAA;AJgpBF;;AKpzBA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ALuzBF;AKtzBE;EACE,6BAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;ALwzBJ;AKvzBI;EACE,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;ALyzBN;AKtzBE;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;ALwzBJ;AKtzBE;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;ALwzBJ;AKtzBE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBH9CmB;EG+CnB,YAAA;ALwzBJ;AKvzBI;EACE,YAAA;EACA,yBAAA;ALyzBN;AKtzBE;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cHtDc;AF82BlB;AKtzBI;EACE,yBAAA;EACA,oCAAA;ALwzBN;AKrzBE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,WAAA;ALuzBJ;AKrzBE;EACE,UAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;ALuzBJ;AKtzBI;EACE,cAAA;ALwzBN;AKtzBI;EACE,yBAAA;ALwzBN;AKrzBE;EACE,UAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;ALuzBJ;AKtzBI;EACE,cAAA;ALwzBN;AKtzBI;EACE,yBAAA;ALwzBN;AKrzBE;EACE,WAAA;EACA,cHpGI;EGqGJ,yBAAA;ALuzBJ;AKtzBI;EACE,yBAAA;EACA,oCAAA;ALwzBN;AKrzBE;EACE,kBAAA;EACA,oCAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;ALuzBJ;AKrzBI;EACE,UAAA;EACA,uBAAA;EACA,wCAAA;ALuzBN;AKtzBM;EACE,2BAAA;EACA,oCAAA;ALwzBR;AKpzBI;EACE,oCAAA;EACA,gCAAA;ALszBN;AKpzBM;EACE,yBAAA;ALszBR;AKnzBM;EACE,oCAAA;EACA,gCAAA;ALqzBR;AKpzBQ;EACE,yBAAA;ALszBV;AKjzBI;EACE,oCAAA;EACA,gCAAA;ALmzBN;AKlzBM;EACE,yBAAA;ALozBR;AK/yBE;EACE,WAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,cHnKI;AFo9BR;AK/yBI;EACE,yBAAA;ALizBN;AK9yBI;EACE,yBAAA;ALgzBN;AK5yBE;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AL8yBJ;AK5yBI;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AL8yBN;AK1yBE;EACE,cAAA;AL4yBJ;AK3yBI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AL6yBN;AK1yBI;EACE,yBAAA;AL4yBN;AKxyBE;EACE,cAAA;AL0yBJ;AKzyBI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AL2yBN;AKxyBI;EACE,yBAAA;AL0yBN;AKtyBE;EACE,WAAA;ALwyBJ;AKtyBI;EACE,gCAAA;EACA,yBAAA;ALwyBN;AKryBI;EACE,qBH9NgB;EG+NhB,cH7Nc;AFogCpB;AKryBM;EACE,gCAAA;EACA,oCAAA;EACA,uBAAA;ALuyBR;;AMziCE;EACE,WAAA;EACA,YAAA;AN4iCJ;AM3iCI;EACE,uBAAA;EACA,4BAAA;EACA,8BAAA;EACA,oCAAA;AN6iCN;AM5iCM;EACE,uBAAA;AN8iCR;;AOxjCA;EACI,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AP2jCJ;AOzjCI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AP2jCR;;AOvjCA;EACI,2BAAA;EACA,qBAAA;AP0jCJ;AOxjCI;EACI,gBAAA;AP0jCR;AOvjCI;EACI,gBAAA;APyjCR;AOtjCI;EACI,oCAAA;APwjCR;AOrjCI;EACI,oCAAA;APujCR;AOpjCI;EACI,oCAAA;APsjCR;AOnjCI;EACI,oCAAA;APqjCR;;AQ5lCA;EACI,YAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;AR+lCJ;AQ7lCI;EACI,cAAA;EACA,kBAAA;AR+lCR;AQ3lCI;EACI,yBAAA;EACA,mBAAA;AR6lCR;AQ3lCQ;EACI,YAAA;EACA,YAAA;AR6lCZ;AQzlCY;EACI,oCAAA;AR2lChB;AQzlCgB;EACI,cA9BF;EA+BE,gBAAA;AR2lCpB;AQtlCQ;EACI,cAtCE;EAuCF,gBAAA;ARwlCZ;AQtlCY;EACI,cAzCE;EA0CF,gBAAA;ARwlChB;;ASjoCE;EACE,cAAA;ATooCJ;ASjoCM;EACE,oCAAA;ATmoCR;AS/nCQ;EACE,oCAAA;ATioCV;AS3nCE;;EAEE,YAAA;AT6nCJ;AS1nCM;;EACE,oCAAA;AT6nCR;ASznCQ;;EACE,oCAAA;AT4nCV;AStnCE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;ATwnCJ;ASpnCI;EACE,kBAAA;EACA,8BAAA;EACA,yBAAA;ATsnCN;AShnCM;EACE,oCAAA;ATknCR;AS9mCI;EACE,kBAAA;EACA,mBAAA;ATgnCN;;AU1qCA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AV6qCF;AU5qCE;EACE,WAAA;AV8qCJ;AU5qCE;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;AV8qCJ;AU7qCI;EACE,WAAA;AV+qCN;;AW1rCI;EACE,8BAAA;EACA,oCAAA;EACA,6BAAA;AX6rCN;AW3rCM;EACE,yBAAA;AX6rCR;AW1rCM;EACE,yBAAA;AX4rCR;AWvrCE;EACE,cAAA;EACA,YAAA;EACA,eAAA;AXyrCJ;AWvrCI;EACE,gBAAA;EACA,yBAAA;AXyrCN;;AWlrCE;EACE,cAAA;AXqrCJ;AWlrCE;EACE,aAAA;AXorCJ;AWjrCE;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;AXmrCJ;;AW/qCA;EACE,gBAAA;EACA,YAAA;AXkrCF;AWhrCE;EACE,kCAAA;AXkrCJ;;AW5qCI;EACE,yBAAA;AX+qCN;;AYzuCE;EACE,gBAAA;EACA,UAAA;AZ4uCJ;AY1uCI;EACE,gBAAA;AZ4uCN;AYzuCI;EACE,gBAAA;AZ2uCN;AYxuCI;EACE,yBV4BuB;AF8sC7B;AYvuCI;EACE,yBAAA;AZyuCN;AYtuCI;EACE,yBV6Be;AF2sCrB;AYruCI;EACE,yBVSe;AF8tCrB;AYnuCE;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;AZquCJ;AYluCE;EACE,WAAA;EACA,YAAA;AZouCJ;AYluCI;EACE,yBVnBa;EUoBb,qBVrBkB;AFyvCxB;AYluCM;EACE,yBVJqB;AFwuC7B;AYjuCM;EACE,yBVRqB;AF2uC7B;AY/tCI;EACE,yBVxBgB;EUyBhB,qBV3BS;AF4vCf;AY/tCM;EACE,yBVxBa;AFyvCrB;AY9tCM;EACE,yBV5Ba;AF4vCrB;AY5tCI;EACE,yBVZmB;EUanB,qBVlBe;AFgvCrB;AY5tCM;EACE,yBVrBa;AFmvCrB;AY3tCM;EACE,yBVzBa;AFsvCrB;AYztCI;EACE,yBAAA;EACA,yBAAA;AZ2tCN;AYztCM;EACE,yBAAA;AZ2tCR;AYxtCM;EACE,yBAAA;AZ0tCR;AYttCI;EACE,yBVhFO;EUiFP,yBAAA;AZwtCN;AYttCM;EACE,yBAAA;AZwtCR;AYrtCM;EACE,yBAAA;AZutCR;;Aa7zCA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;Abg0CF;Aa9zCE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;Abg0CJ;Aa9zCI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;Abg0CN;Aa7zCI;EACE,eAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,yBXVa;AFy0CnB;Aa3zCM;EACE,cAAA;Ab6zCR;Aa1zCM;EACE,cAAA;Ab4zCR;AazzCM;EACE,yBAAA;Ab2zCR;AazzCQ;EACE,yBAAA;Ab2zCV;AazzCU;EACE,oCAAA;Ab2zCZ;AavzCQ;EACE,yBAAA;AbyzCV;AavzCU;EACE,cAAA;AbyzCZ;AalzCM;EACE,cAAA;AbozCR;AajzCM;EACE,cAAA;AbmzCR;AahzCM;EACE,yBAAA;AbkzCR;AahzCQ;EACE,yBAAA;AbkzCV;AahzCU;EACE,oCAAA;AbkzCZ;Aa9yCQ;EACE,yBAAA;AbgzCV;Aa9yCU;EACE,cAAA;AbgzCZ;AazyCM;EACE,cAAA;Ab2yCR;AaxyCM;EACE,cAAA;Ab0yCR;AavyCM;EACE,yBAAA;AbyyCR;AavyCQ;EACE,yBAAA;AbyyCV;AavyCU;EACE,oCAAA;AbyyCZ;AaryCQ;EACE,yBAAA;AbuyCV;AaryCU;EACE,cAAA;AbuyCZ;Aa/xCM;EACE,cAAA;AbiyCR;Aa9xCM;EACE,cAAA;AbgyCR;Aa7xCM;EACE,yBAAA;Ab+xCR;Aa7xCQ;EACE,yBAAA;Ab+xCV;Aa7xCU;EACE,oCAAA;Ab+xCZ;Aa3xCQ;EACE,yBAAA;Ab6xCV;Aa3xCU;EACE,cAAA;Ab6xCZ;AatxCM;EACE,uBAAA;EACA,yBAAA;AbwxCR;AatxCQ;EACE,yBAAA;AbwxCV;AatxCU;EACE,oCAAA;AbwxCZ;AapxCQ;EACE,yBAAA;AbsxCV;AajxCI;EACE,kBAAA;EACA,yBAAA;EACA,wDAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;AbmxCN;AahxCQ;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AbkxCV;Aa/wCY;EACE,0BAAA;AbixCd;Aa7wCc;EACE,cAAA;Ab+wChB;Aa1wCU;EACE,6BAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;Ab4wCZ;Aa1wCY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;Ab4wCd;Aa1wCc;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;Ab4wChB;AatwCc;EACE,aAAA;AbwwChB;AarwCc;EACE,aAAA;AbuwChB;AalwCU;EACE,WAAA;AbowCZ;AajwCU;EACE,UAAA;AbmwCZ;AahwCU;EACE,UAAA;AbkwCZ;Aa/vCU;EACE,UAAA;AbiwCZ;Aa9vCU;EACE,UAAA;AbgwCZ;Aa7vCU;EACE,UAAA;Ab+vCZ;Aa3vCQ;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;Ab6vCV;Aa3vCU;EACE,mBAAA;EACA,6BAAA;Ab6vCZ;Aa3vCY;EACE,mBAAA;Ab6vCd;Aa3vCc;;EAEE,cAAA;Ab6vChB;AaxvCc;EACE,cAAA;Ab0vChB;AavvCc;EACE,yBAAA;AbyvChB;AarvCgB;EACE,cAAA;AbuvClB;AahvCU;EACE,mBAAA;EACA,6BAAA;AbkvCZ;AahvCY;EACE,mBAAA;AbkvCd;AahvCc;;EAEE,cAAA;AbkvChB;Aa7uCc;EACE,cAAA;Ab+uChB;Aa3uCgB;EACE,cAAA;Ab6uClB;AavuCU;EACE,mBAAA;EACA,6BAAA;AbyuCZ;AavuCY;EACE,mBAAA;AbyuCd;AavuCc;;EAEE,cAAA;AbyuChB;AapuCc;EACE,cAAA;AbsuChB;AaluCgB;EACE,cAAA;AbouClB;Aa9tCU;EACE,mBAAA;EACA,6BAAA;AbguCZ;Aa9tCY;EACE,mBAAA;AbguCd;Aa9tCc;;EAEE,cAAA;AbguChB;Aa3tCc;EACE,cAAA;Ab6tChB;AaztCgB;EACE,cAAA;Ab2tClB;AaptCY;EACE,yBAAA;AbstCd;AaltCU;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AbotCZ;AaltCY;EACE,eAAA;EACA,gBAAA;AbotCd;AajtCY;EACE,eAAA;EACA,gBAAA;AbmtCd;Aa/sCU;EACE,2BAAA;EACA,YAAA;AbitCZ;Aa9sCU;EACE,gBAAA;EACA,oBAAA;AbgtCZ;Aa9sCY;EACE,eAAA;EACA,gBAAA;AbgtCd;Aa7sCY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;Ab+sCd;Aa5sCY;EACE,YAAA;Ab8sCd;Aa5sCc;EACE,eAAA;EACA,gBAAA;Ab8sChB;Aa1sCY;EACE,YAAA;EACA,iBAAA;Ab4sCd;AazsCY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;Ab2sCd;AazsCc;EACE,kBAAA;EACA,eAAA;Ab2sChB;AaxsCc;EACE,kBAAA;EACA,gBAAA;Ab0sChB;AavsCc;EACE,2BAAA;AbysChB;AatsCc;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AbwsChB;AarsCc;EACE,yBAAA;AbusChB;AarsCgB;;;EAGE,cAAA;AbusClB;AansCc;EAEE,mBAAA;AbosChB;AalsCgB;;;;;EAGE,cAAA;AbssClB;AalsCc;EACE,mBAAA;AbosChB;AalsCgB;;;EAGE,cAAA;AbosClB;;AcvrDA;EACE,kBAAA;Ad0rDF;AcxrDE;EAME,yBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AdqrDJ;Ac7rDI;EACE,gBAAA;EACA,+BAAA;Ad+rDN;ActrDE;EACE,uBAAA;EACA,WAAA;EAEA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;AdsrDJ;AcprDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AdsrDN;AcprDM;EACE,eAAA;EAEA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AdqrDR;AchrDE;EACE,aAAA;AdkrDJ;Ac/qDE;EACE,iBAAA;AdirDJ;Ac/qDI;EACE,mBAAA;AdirDN;AchrDM;EACE,kBAAA;AdkrDR;;Ac5qDA;EACE,eAAA;EAEA,sBAAA;EACA,YAAA;EACA,yBAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;EAEA,mBAAA;EACA,0CAAA;EACA,oCAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;Ad2qDF;AczqDE;EACE,UAAA;EACA,WAAA;EACA,gBAAA;Ad2qDJ;;AcvqDA;EACE,eAAA;EAEA,iBAAA;EACA,oBAAA;EAEA,aAAA;EACA,mBAAA;EAEA,oCAAA;EAEA,kBAAA;AdsqDF;AcpqDE;EACE,iBAAA;EAEA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EAEA,mBAAA;AdoqDJ;AcjqDE;EACE,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AdmqDJ;AchqDE;EACE,mBAAA;AdkqDJ;AcjqDI;EACE,cAAA;AdmqDN;;Ac9pDA;EACE,eAAA;EAEA,sBAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EAGA,0BAAA;EAEA,mBAAA;EACA,0CAAA;EACA,8BAAA;Ad4pDF;Ac1pDE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;Ad4pDJ;Ac1pDI;EACE,WAAA;Ad4pDN;AczpDI;EACE,WAAA;Ad2pDN;AcvpDE;EACE,qBAAA;EAEA,mBAAA;EACA,wCAAA;EAEA,gBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AdspDJ;AclpDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EAEA,kBAAA;AdmpDN;AchpDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AdkpDN;Ac7oDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EAEA,kBAAA;Ad8oDN;Ac3oDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;Ad6oDN;AczoDE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;Ad2oDJ;AczoDI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EAEA,oBAAA;Ad0oDN;AcvoDI;EACE,aAAA;EACA,QAAA;AdyoDN;AcvoDM;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EAEA,iBAAA;EAEA,yBAAA;EACA,2BAAA;AduoDR;AcroDQ;EACE,yBAAA;EACA,aAAA;AduoDV;AcpoDQ;EACE,yBAAA;EACA,aAAA;AdsoDV;AchoDE;EACE,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,oBAAA;AdgoDJ;Ac7nDE;EACE,mBAAA;EACA,yCAAA;EACA,8BAAA;EACA,kDAAA;Ad+nDJ;Ac5nDM;EACE,yBAAA;Ad8nDR;Ac5nDM;EACE,yBAAA;Ad8nDR;AcznDM;EACE,yBAAA;Ad2nDR;AcznDM;EACE,8BAAA;Ad2nDR;ActnDM;EACE,yBAAA;AdwnDR;AcpnDI;EACE,yBAAA;EACA,gBAAA;AdsnDN;AcpnDM;EACE,yBAAA;EACA,gBAAA;AdsnDR;;Aet8DA;EACE,eAAA;EACA,kCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;Afy8DF;Aev8DE;EACE,kBAAA;EACA,wBAAA,EAAA,oCAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;Afy8DJ;Aet8DE;EACE;IACE,yCAAA;Efw8DJ;Eet8DE;IACE,wBAAA;Efw8DJ;AACF;Aer8DE;EACE,UAAA;EACA,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;Afu8DJ;Aer8DI;EAGE,oCAAA;EACA,gBAAA;EACA,YAAA;Afq8DN;;AgB/+DA;EACE,kBAAA;AhBk/DF;AgBh/DI;EACE,cduBc;EctBd,eAAA;EACA,gBAAA;EACA,QAAA;AhBk/DN;AgBh/DM;EACE,YAAA;AhBk/DR;AgBj/DQ;EACE,eAAA;AhBm/DV;AgB9+DE;;EAEE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AhBg/DJ;AgB9+DE;;EAEE,YAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AhBg/DJ;AgB9+DE;EACE,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;AhBg/DJ;AgB/+DI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AhBi/DN;AgB9+DE;EACE,QAAA;AhBg/DJ;AgB9+DE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AhBg/DJ;AgB/+DI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AhBi/DN;AgB/+DI;EACE,WAAA;EACA,gBAAA;AhBi/DN;AgBh/DM;EACE,aAAA;EACA,qCAAA;EACA,kBAAA;AhBk/DR;AgBj/DQ;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AhBm/DV;AgBh/DQ;EACE,aAAA;EACA,8BAAA;AhBk/DV;AgBj/DU;EACE,UAAA;AhBm/DZ;AgBl/DY;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AhBo/Dd;AgB7+DM;EACE,eAAA;AhB++DR;AgB5+DM;EACE,sBAAA;EACA,uBAAA;AhB8+DR;AgB1+DI;EACE,WAAA;AhB4+DN;AgBz+DI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AhB2+DN;AgB1+DM;EACE,gBAAA;AhB4+DR;AgBz+DI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AhB2+DN;AgBz+DI;;EAEE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AhB2+DN;AgBz+DI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AhB2+DN;AgBz+DI;;EAEE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AhB2+DN;AgB1+DM;;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AhB6+DR;AgB1+DI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AhB4+DN;AgB3+DM;EACE,WAAA;EACA,gBAAA;AhB6+DR;AgB1+DI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AhB4+DN;AgB3+DM;EACE,cAAA;AhB6+DR;AgBx+DE;EACE,kBAAA;AhB0+DJ;AgBv+DM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;AhBy+DR;AgBr+DI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AhBu+DN;AgBr+DM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AhBu+DR;AgBn+DI;EACE,aAAA;EACA,8BAAA;AhBq+DN;AgBl+DI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;AhBo+DN;AgBj+DI;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;AhBm+DN;AgB/9DM;EACE,eAAA;AhBi+DR;;AiBluEA;EACE,kBAAA;EAEA,gBAAA;AjBouEF;AiBluEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,mBAAA;EACA,gCAAA;EACA,mBAAA;AjBmuEJ;AiBjuEI;EACE,kBAAA;AjBmuEN;AiBjuEM;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EACA,yBAAA;AjBmuER;AiBhuEM;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AjBkuER;AiB9tEI;EACE,eAAA;EAEA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EACA,yBAAA;AjB+tEN;AiB3tEE;EACE,aAAA;EACA,8BAAA;EAEA,gCAAA;EACA,mBAAA;AjB4tEJ;AiB1tEI;EACE,SAAA;AjB4tEN;AiB1tEQ;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AjB4tEV;AiBztEQ;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AjB2tEV;AiBztEU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AjB2tEZ;AiBttEM;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjBwtER;AiBrtEM;EACE,mBAAA;AjButER;AiBrtEQ;EACE,aAAA;EACA,mBAAA;AjButEV;AiBrtEU;EACE,SAAA;EACA,iBAAA;AjButEZ;AiBptEU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,YAAA;AjBotEZ;AiB/sEM;EACE,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjBgtER;AiB9sEQ;EACE,eAAA;EAEA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjB+sEV;AiBzsEI;EACE,SAAA;AjB2sEN;AiBxsEI;EACE,SAAA;AjB0sEN;AiBtsEE;EACE,aAAA;AjBwsEJ;AiBtsEI;EACE,SAAA;EACA,sBAAA;AjBwsEN;AiBrsEI;EACE,mBAAA;AjBusEN;AiBrsEM;EACE,mBAAA;AjBusER;AiBrsEQ;EACE,kBAAA;AjBusEV;AiBnsEM;EACE,aAAA;EACA,8BAAA;AjBqsER;AiBnsEQ;EACE,SAAA;EAEA,mBAAA;EACA,0CAAA;EAEA,kBAAA;EAEA,kBAAA;AjBksEV;AiBhsEU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;AjBisEZ;AiB9rEU;EACE,YAAA;EAEA,mBAAA;EACA,wCAAA;EACA,8BAAA;EAEA,kBAAA;AjB8rEZ;AiB5rEY;EACE,0CAAA;EACA,oCAAA;AjB8rEd;AiB5rEc;EACE,yBAAA;EACA,gCAAA;AjB8rEhB;AiB3rEc;EACE,+BAAA;AjB6rEhB;AiBzrEY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EAEA,gCAAA;EAEA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AjBwrEd;AiBrrEY;EACE,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AjBqrEd;AiBjrEU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AjBmrEZ;AiBjrEY;EACE,gBAAA;EACA,cAAA;AjBmrEd;AiB9qEQ;EACE,SAAA;AjBgrEV;AiB3qEI;EACE,kBAAA;AjB6qEN;AiB1qEQ;EACE,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjB2qEV;AiBxqEQ;EACE,aAAA;EACA,mBAAA;AjB0qEV;AiBvqEQ;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AjByqEV;AiBvqEU;EACE,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EAMA,iBAAA;EAEA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AjBkqEZ;AiBhrEY;EACE,kBAAA;AjBkrEd;AiBjqEQ;EACE,mBAAA;AjBmqEV;AiB/pEM;EACE,qCAAA;EACA,+BAAA;EACA,kBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,mBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AjB+pER;AiB7pEQ;EACE,oCAAA;EACA,gCAAA;EAEA,yBAAA;AjB8pEV;AiBzpEQ;EACE,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjB0pEV;AiBlpEM;EACE,iBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,0CAAA;EACA,oCAAA;EAEA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AjBkpER;;AiB3oEE;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,kBAAA;AjB4oEJ;AiBzoEE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;AjB2oEJ;;AiBvoEA;EACE,mBAAA;EACA,0CAAA;EAEA,kBAAA;AjByoEF;AiBvoEE;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;AjBwoEJ;AiBroEE;EACE,8BAAA;EACA,gBAAA;EACA,kBAAA;AjBuoEJ;AiBroEI;EACE,kBAAA;AjBuoEN;AiBroEM;EACE,kBAAA;AjBuoER;AiBnoEI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;AjBooEN;AiBjoEQ;EACE,+BAAA;AjBmoEV;AiBhoEQ;EACE,eAAA;EAEA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AjBioEV;AiB7nEM;EACE,eAAA;EACA,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AjB8nER;AiB5nEQ;EACE,+BAAA;AjB8nEV;;AkBrnFA;EACE,eAAA;EAEA,aAAA;EACA,mBAAA;EAEA,QAAA;EAEA,kBAAA;EAEA,mBAAA;EACA,0CAAA;EACA,8BAAA;EA4HA,mBAAA;AlBy/EF;AkBnnFE;EACE,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,+CAAA;AlBqnFJ;AkBnnFI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AlBqnFN;AkBjnFM;EACE,eAAA;AlBmnFR;AkB/mFI;EACE,8BAAA;EACA,0BAAA;AlBinFN;AkB7mFE;EACE,mBAAA;EACA,oCAAA;EACA,8BAAA;EACA,+CAAA;AlB+mFJ;AkB7mFI;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AlB+mFN;AkB3mFM;EACE,0BAAA;AlB6mFR;AkBzmFI;EACE,mBAAA;EACA,0BAAA;AlB2mFN;AkBvmFE;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,+CAAA;AlBymFJ;AkBvmFI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AlBymFN;AkBrmFM;EACE,eAAA;AlBumFR;AkBnmFI;EACE,mBAAA;EACA,0BAAA;AlBqmFN;AkB9lFQ;EACE,eAAA;AlBgmFV;AkB3lFQ;EACE,eAAA;AlB6lFV;AkBxlFI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AlB0lFN;AkBvlFI;EACE,8BAAA;EACA,0BAAA;AlBylFN;AkBrlFE;EACE,YAAA;EACA,WAAA;EAEA,iBAAA;AlBslFJ;AkBplFI;EACE,iBAAA;AlBslFN;AkBhlFE;EACE,aAAA;EACA,QAAA;EACA,WAAA;AlBklFJ;AkBhlFI;EACE,YAAA;EACA,YAAA;AlBklFN;AkB9kFE;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AlBglFJ;AkB9kFI;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AlBglFN;AkB9kFM;EACE,yBAAA;AlBglFR;AkB7kFM;EACE,yBAAA;AlB+kFR;AkB1kFE;EACE,aAAA;EACA,kBAAA;AlB4kFJ;AkBzkFM;EACE,YAAA;EACA,YAAA;AlB2kFR;AkBvkFQ;EACE,aAAA;AlBykFV;AkBrkFU;EACE,eAAA;AlBukFZ;AkBhkFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,UAAA;AlBkkFJ;AkBhkFI;EACE,YAAA;EACA,aAAA;EACA,oBAAA;AlBkkFN;AkB7jFE;EACE,WAAA;AlB+jFJ;;AmBpxFA;EACE,aAAA;EACA,sBAAA;EAEA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,iBAAA;AnBsxFF;AmBpxFE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EAGA,kBAAA;EACA,WAAA;AnBoxFJ;AmBlxFI;EACE,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EAEA,kBAAA;AnBmxFN;AmBhxFI;EACE,gBAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AnBkxFN;AmB/wFI;EACE,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AnBixFN;AmB7wFE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,kBAAA;AnB6wFJ;AmB1wFE;EACE,WAAA;AnB4wFJ;AmB1wFI;EACE,iBAAA;AnB4wFN;AmBzwFI;EACE,WAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,YAAA;EACA,gBAAA;EAEA,kBAAA;EACA,qCAAA;EACA,+BAAA;AnBuwFN;AmBrwFM;EACE,qCAAA;AnBuwFR;AmBnwFI;EACE,0BAAA;EACA,gBAAA;AnBqwFN;;AoB72FA;EAEE,aAAA;EACA,sBAAA;EAEA,kBAAA;EAEA,mBAAA;EACA,0CAAA;EACA,8BAAA;EACA,mBAAA;ApB62FF;AoB32FE;EACE,aAAA;EACA,mBAAA;ApB62FJ;AoB32FI;EACE,WAAA;EACA,aAAA;EACA,QAAA;ApB62FN;AoB32FM;EACE,eAAA;ApB62FR;AoBz2FI;EACE,iBAAA;EACA,WAAA;ApB22FN;AoBx2FI;EACE,aAAA;EACA,WAAA;EACA,cAAA;ApB02FN;AoBx2FM;EACE,eAAA;ApB02FR;AoBt2FI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,UAAA;ApBw2FN;AoBt2FM;EACE,YAAA;EACA,aAAA;EACA,oBAAA;ApBw2FR;AoBp2FI;EACE,WAAA;ApBs2FN;AoBl2FE;EACE,YAAA;EACA,WAAA;EAEA,iBAAA;ApBm2FJ;AoBj2FI;EACE,iBAAA;ApBm2FN;AoB/1FM;EACE,eAAA;ApBi2FR;AoB51FE;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ApB81FJ;AoB31FE;EACE,8BAAA;ApB61FJ;AoB51FI;EACE,0BAAA;ApB81FN;AoBx1FM;EACE,eAAA;ApB01FR;AoBt1FI;EACE,oCAAA;EACA,8BAAA;ApBw1FN;AoBv1FM;EACE,0BAAA;ApBy1FR;AoBp1FE;EACE,oCAAA;EACA,8BAAA;ApBs1FJ;AoBp1FI;EACE,yBAAA;ApBs1FN;AoBl1FM;EACE,eAAA;ApBo1FR;AoBh1FI;EACE,8BAAA;ApBk1FN;AoBj1FM;EACE,0BAAA;ApBm1FR;AoB90FM;EACE,yBAAA;ApBg1FR;AoB70FM;EACE,cAAA;ApB+0FR;AoB30FI;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBlB3G0B;EkB4G1B,clB/Ge;EkBgHf,yBAAA;ApB60FN;AoB50FM;EACE,eAAA;EACA,gBAAA;ApB80FR;AoB50FM;EACE,eAAA;EACA,gBAAA;ApB80FR;AoB50FM;EACE,YAAA;EACA,YAAA;ApB80FR;AoB70FQ;EACE,0BAAA;EACA,clB9HW;EkB+HX,eAAA;ApB+0FV;AoB70FQ;EACE,WAAA;EACA,YAAA;ApB+0FV;AoB70FQ;EACE,wBAAA;ApB+0FV;AoB10FQ;EACE,gBAAA;EACA,qBAAA;ApB40FV;AoBt0FE;EACE,oCAAA;EACA,8BAAA;ApBw0FJ;AoBt0FI;EACE,yBAAA;ApBw0FN;AoBp0FM;EACE,eAAA;ApBs0FR;AoBl0FI;EACE,8BAAA;ApBo0FN;AoBn0FM;EACE,0BAAA;ApBq0FR;AoBh0FE;EACE,oCAAA;EACA,8BAAA;ApBk0FJ;AoBh0FI;EACE,yBAAA;ApBk0FN;AoB9zFM;EACE,eAAA;ApBg0FR;AoB5zFI;EACE,8BAAA;ApB8zFN;AoB7zFM;EACE,0BAAA;ApB+zFR;AoB1zFE;EACE,gBAAA;EACA,iBAAA;ApB4zFJ;AoB1zFI;EACE,gBAAA;EACA,eAAA;ApB4zFN;AoBzzFI;EACE,gBAAA;EACA,eAAA;ApB2zFN;;AqBxiGA;EACE,WAAA;ArB2iGF;;AqBxiGA;EACE,eAAA;EACA,kCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ArB2iGF;AqBziGE;EACE,gBAAA;ArB2iGJ;AqBxiGE;EACE,UAAA;EACA,sBAAA;EACA,YAAA;ArB0iGJ;AqBxiGE;EACE,UAAA;EACA,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;ArB0iGJ;AqBziGI;EAGE,oCAAA;EACA,gBAAA;EACA,YAAA;ArByiGN;AqBriGE;EAEE,iBAAA;ArBsiGJ;AqBriGI;EACE,WAAA;EACA,aAAA;EACA,iBAAA;ArBuiGN;AqBtiGM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;ArBwiGR;AqBtiGM;;;;EAIE,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,yBAAA;ArBwiGR;AqBtiGM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;ArBwiGR;AqBriGI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;ArBuiGN;AqBtiGM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,QAAA;ArBwiGR;AqBviGQ;EACE,UAAA;EACA,2BAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;ArByiGV;AqBxiGU;EACE,yBAAA;EACA,mBAAA;ArB0iGZ;AqBxiGU;EACE,YAAA;EACA,WAAA;EACA,0BAAA;ArB0iGZ;AqBxiGU;EACE,YAAA;EACA,WAAA;EACA,0BAAA;EACA,mBnB1Ec;AFonG1B;AqBtiGM;EACE,gBAAA;EACA,qBAAA;ArBwiGR;AqBviGQ;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;ArByiGV;AqBxiGU;EACE,kBAAA;EACA,iBAAA;ArB0iGZ;AqBtiGM;EACE,eAAA;ArBwiGR;AqBviGQ;EACE,gBAAA;ArByiGV;AqBxiGU;EACE,cnBvHC;AFiqGb;AqBriGM;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EAyDA,UAAA;EAKA,WAAA;EAMA,oBAAA;ArBs+FR;AqBziGQ;EACE,eAAA;EACA,aAAA;EACA,uBAAA;ArB2iGV;AqBziGQ;EACE,gBAAA;EACA,WAAA;EACA,oBAAA;ArB2iGV;AqBxiGQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;ArB0iGV;AqBziGU;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;ArB2iGZ;AqB1iGY;EACE,cAAA;ArB4iGd;AqBxiGQ;EACE,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;ArB0iGV;AqBxiGU;EACE,cAAA;ArB0iGZ;AqBviGQ;EACE,gBAAA;ArByiGV;AqBviGQ;EACE,cAAA;ArByiGV;AqBviGQ;EACE,UAAA;EACA,kBAAA;ArByiGV;AqBriGQ;EACE,mBAAA;ArBuiGV;AqBniGQ;EACE,gBAAA;EACA,kBAAA;ArBqiGV;AqBjiGQ;EACE,gBAAA;ArBmiGV;AqB9hGE;EACE,6BAAA;EACA,aAAA;ArBgiGJ;AqB9hGM;EACE,cAAA;ArBgiGR;AqB/hGQ;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;ArBiiGV;AqB5hGM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ArB8hGR;AqB3hGI;EACE,cAAA;ArB6hGN;AqB3hGI;EAIE,mBAAA;ArB0hGN;AqB7hGM;EACE,cAAA;ArB+hGR;AqB5hGM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;ArB8hGR;AqB7hGQ;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;ArB+hGV;AqB3hGI;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;ArB6hGN;AqB5hGM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;ArB8hGR;AqB5hGQ;EACE,cAAA;EACA,mBAAA;ArB8hGV;AqB7hGU;EACE,cAAA;ArB+hGZ;AqB5hGQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;ArB8hGV;AqB7hGU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;ArB+hGZ;AqB9hGY;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ArBgiGd;AqB/hGc;EACE,yBAAA;EACA,mBAAA;ArBiiGhB;AqBhiGgB;EACE,aAAA;ArBkiGlB;;AsBv1GA;EACE,UAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,4BAAA;AtB01GF;AsBx1GE;EACE,6BAAA;EACA,2BAAA;EACA,6BAAA;AtB01GJ;AsBv1GE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AtBy1GJ;AsBv1GI;EACE,uBAAA;AtBy1GN;;AuB92GA;EACE,mBAAA;EACA,4CAAA;EACA,sCAAA;EACA,+CAAA;EACA,UAAA;EACA,uBAAA;EACA,qBAAA;AvBi3GF;AuB/2GI;EACE,oCAAA;EACA,gCAAA;AvBi3GN;AuB92GE;EACE,eAAA;EACA,YAAA;AvBg3GJ;AuB92GE;EACE,WAAA;EACA,eAAA;AvBg3GJ;AuB92GE;EACE,6BAAA;EACA,aAAA;AvBg3GJ;AuB/2GI;EACE,gBAAA;EACA,kBAAA;AvBi3GN;AuB/2GI;EACE,cAAA;AvBi3GN;AuB/2GI;EACE,6BAAA;EACA,iBAAA;EACA,gBAAA;AvBi3GN;AuB/2GI;EACE,gBAAA;AvBi3GN;AuB/2GI;EACE,gBAAA;EACA,uBAAA;AvBi3GN;AuB/2GI;EACE,aAAA;AvBi3GN;AuB92GE;EACE,cAAA;AvBg3GJ;AuB92GE;EACE,gBAAA;AvBg3GJ;AuB/2GI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AvBi3GN;AuB92GE;EACE,gBAAA;EACA,kBAAA;AvBg3GJ;AuB/2GI;EACE,cAAA;AvBi3GN;AuB92GM;EACE,cAAA;AvBg3GR;AuB92GM;EACE,cAAA;AvBg3GR;AuB72GQ;EACE,oCAAA;EACA,8BAAA;EACA,yBAAA;AvB+2GV;AuB72GQ;EACE,oCAAA;EACA,2BAAA;EACA,yBAAA;AvB+2GV;AuB92GU;EACE,2BAAA;EACA,yBAAA;AvBg3GZ;AuB72GQ;EACE,oCAAA;EACA,8BAAA;EACA,yBAAA;EACA,2BAAA;AvB+2GV;;AwB58GE;EACE,cAAA;AxB+8GJ;AwB78GE;EACE,mBAAA;AxB+8GJ;AwB58GE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AxB88GJ;AwB58GI;EACE,aAAA;EACA,sBAAA;AxB88GN;AwB38GI;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AxB68GN;AwB58GM;EACE,yBAAA;AxB88GR;AwB58GM;EACE,2BAAA;AxB88GR;AwB58GM;EACE,aAAA;AxB88GR;AwB58GM;EAYE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kDAAA;AxBm8GR;AwBj9GQ;EACE,aAAA;EACA,QAAA;EACA,uBAAA;AxBm9GV;AwBl9GU;EACE,eAAA;AxBo9GZ;AwBl9GU;EACE,gBAAA;AxBo9GZ;AwB78GQ;EACE,yBAAA;AxB+8GV;AwB78GQ;EACE,cAAA;AxB+8GV;AwB78GQ;EACE,gBAAA;AxB+8GV;AwBz8GI;EACE,WAAA;AxB28GN;AwB18GM;EACE,YAAA;AxB48GR;AwB38GQ;EACE,yBAAA;AxB68GV;AwBz8GI;EACE,yBAAA;AxB28GN;AwBz8GI;EACE,yBAAA;EACA,eAAA;EACA,eAAA;AxB28GN;AwBx8GE;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AxB08GJ;AwBz8GI;EACE,cAAA;EACA,iBAAA;AxB28GN;;AyBnjHA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,0BAAA;AzBsjHF;;AyBnjHA;EACE,kBAAA;AzBsjHF;;AyBnjHA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;AzBsjHF;;AyBnjHA,0CAAA;AACA;EAA4B,wCAAA;AzBujH5B;;AyBtjHA;EAA4B,wCAAA;AzB0jH5B;;AyBzjHA;EAA4B,wCAAA;AzB6jH5B;;AyB5jHA;EAA4B,yCAAA;AzBgkH5B;;AyB/jHA;EAA4B,yCAAA;AzBmkH5B;;AyBlkHA;EAA4B,yCAAA;AzBskH5B;;AyBrkHA;EAA4B,yCAAA;AzBykH5B;;AyBxkHA;EAA4B,yCAAA;AzB4kH5B;;AyB3kHA;EAA4B,yCAAA;AzB+kH5B;;AyB9kHA;EAA6B,yCAAA;AzBklH7B;;AyBjlHA;EAA6B,yCAAA;AzBqlH7B;;AyBplHA;EAA6B,uCAAA;AzBwlH7B;;AyBtlHA,oDAAA;AACA;EACE;IACE,yBAAA;EzBylHF;EyBvlHA;IACE,yBAAA;EzBylHF;AACF;AyBtlHA,sCAAA;AACA;EAA4B,sBAAA;AzBylH5B;;AyBxlHA;EAA4B,oBAAA;AzB4lH5B;;AyB3lHA;EAA4B,sBAAA;AzB+lH5B;;AyB9lHA;EAA4B,sBAAA;AzBkmH5B;;AyBjmHA;EAA4B,sBAAA;AzBqmH5B;;AyBpmHA;EAA4B,sBAAA;AzBwmH5B;;AyBvmHA;EAA4B,sBAAA;AzB2mH5B;;AyB1mHA;EAA4B,sBAAA;AzB8mH5B;;AyB7mHA;EAA4B,sBAAA;AzBinH5B;;AyBhnHA;EAA6B,sBAAA;AzBonH7B;;AyBnnHA;EAA6B,sBAAA;AzBunH7B;;AyBtnHA;EAA6B,mBAAA;AzB0nH7B;;A0BrrHA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;A1BwrHF;A0BvrHE;EACE,oBAAA;EACA,mBxBSe;EwBRf,cxBCS;EwBAT,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;A1ByrHJ;A0BxrHI;EACE,gBAAA;EACA,gBAAA;A1B0rHN;A0BxrHI;EACE,8BAAA;EACA,uBAAA;A1B0rHN;A0BxrHI;EACE,yBlB1BY;EkB2BZ,cxBXE;AFqsHR;A0BzrHM;EACE,yBlB7BU;EkB8BV,yBAAA;A1B2rHR;;A2B1tHA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kDAAA;EACA,kBAAA;A3B6tHF;A2B5tHE;EACE,cAAA;EACA,kBAAA;A3B8tHJ;A2B5tHE;EACE,cAAA;EACA,mBAAA;A3B8tHJ;;A4B1uHA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;A5B6uHF;A4B5uHE;EACE,mBAAA;A5B8uHJ;A4B5uHE;EACE,cAAA;EACA,kBAAA;A5B8uHJ;A4B5uHE;EACE,cAAA;EACA,kBAAA;A5B8uHJ;A4B5uHE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;A5B8uHJ;A4B7uHI;EACE,UAAA;A5B+uHN;A4B5uHE;EACE,mBAAA;A5B8uHJ;A4B7uHI;EACE,gCAAA;EACA,oBAAA;A5B+uHN;;A6B3wHA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+CAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;A7B8wHF;A6B5wHE;EACE,c3BLS;E2BMT,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A7B8wHJ;A6B7wHI;EACE,gBAAA;A7B+wHN;A6B3wHE;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A7B6wHJ;A6B3wHE;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A7B6wHJ;A6B1wHI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;A7B4wHN;A6B3wHM;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,mBAAA;A7B6wHR;A6B5wHQ;EACE,YAAA;EACA,WAAA;EACA,UAAA;A7B8wHV;A6B3wHU;EACE,eAAA;A7B6wHZ;A6B5wHY;EACE,aAAA;A7B8wHd;A6BzwHU;EACE,eAAA;EACA,aAAA;A7B2wHZ;A6BtwHI;EACE,kBAAA;A7BwwHN;A6BtwHI;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;A7BwwHN;A6BtwHI;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;A7BwwHN;A6BpwHE;EACE,gBAAA;A7BswHJ;A6BlwHI;EACE,cAAA;EACA,kBAAA;A7BowHN;A6BjwHM;EACE,cAAA;A7BmwHR;A6B9vHE;EACE,SAAA;EACA,aAAA;EACA,8BAAA;A7BgwHJ;A6B7vHE;EACE,qBAAA;A7B+vHJ;A6B9vHI;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A7BgwHN;A6B/vHM;EACE,iBAAA;A7BiwHR;A6B/vHM;EACE,cAAA;A7BiwHR;A6B9vHI;EACE,cAAA;A7BgwHN;A6B9vHI;EACE,yBAAA;EACA,cAAA;A7BgwHN;A6B5vHQ;EACE,eAAA;A7B8vHV;A6B7vHU;EACE,aAAA;A7B+vHZ;A6B1vHQ;EACE,eAAA;EACA,aAAA;A7B4vHV;A6BzvHM;EACE,cAAA;A7B2vHR;A6BxvHI;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,+CAAA;A7B0vHN;A6BtvHE;EACE,qBAAA;EACA,mBAAA;A7BwvHJ;A6BtvHI;EACE,cAAA;EACA,mBAAA;A7BwvHN;A6BrvHI;EACE,yBAAA;A7BuvHN;A6BpvHI;EACE,cAAA;A7BsvHN;A6BnvHI;EACE,eAAA;EACA,aAAA;A7BqvHN;A6BnvHI;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;A7BqvHN;A6BpvHM;EACE,cAAA;A7BsvHR;A6BnvHI;EACE,cAAA;A7BqvHN;A6BnvHI;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gDAAA;A7BqvHN;A6BjvHE;EACE,qBAAA;A7BmvHJ;A6BlvHI;EACE,cAAA;A7BovHN;A6BjvHI;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;A7BmvHN;A6BlvHM;EACE,cAAA;A7BovHR;A6B/uHE;EACE,qBAAA;A7BivHJ;A6BhvHI;EACE,cAAA;A7BkvHN;A6BhvHI;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;A7BkvHN;A6BjvHM;EACE,cAAA;A7BmvHR;A6BhvHI;;EAEE,cAAA;A7BkvHN;A6BjvHM;;EACE,cAAA;A7BovHR;A6BjvHI;EACE,qBAAA;A7BmvHN;A6BhvHM;;EAEE,cAAA;A7BkvHR;A6B7uHQ;EACE,eAAA;A7B+uHV;A6B9uHU;EACE,aAAA;A7BgvHZ;A6B3uHQ;EACE,eAAA;EACA,aAAA;A7B6uHV;A6B1uHM;EACE,cAAA;A7B4uHR;A6BvuHI;EACE,sBAAA;A7ByuHN;;A8B7gIA;EACE,gBAAA;EACA,WAAA;A9BghIF;A8B/gIE;EACE,6BAAA;EACA,uBAAA;EACA,2BAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A9BihIJ;A8BhhII;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A9BkhIN;A8B/gIE;EACE,WAAA;EACA,mBAAA;A9BihIJ;A8B/gIE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;A9BihIJ;A8BhhII;EACE,WAAA;A9BkhIN;;A+BljIA;EACC,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;A/BqjID;A+BnjIC;EACC,mBAAA;A/BqjIF;A+BnjIE;EACC,WAAA;EACA,gBAAA;A/BqjIH;A+BljIE;EACC,UAAA;A/BojIH;A+BhjIC;EACC,aAAA;EACA,8BAAA;EACA,kBAAA;A/BkjIF;A+BhjIE;EACC,aAAA;EACA,mBAAA;A/BkjIH;A+B/iIE;EACC,UAAA;EACA,yBAAA;EACA,eAAA;A/BijIH;A+B/iIG;EACC,0BAAA;A/BijIJ;A+B9iIG;EACC,yBAAA;A/BgjIJ;A+B3iIC;EACC,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;A/B6iIF;A+B1iIC;EACC,yBAAA;EACA,yB7BlB8B;AF8jIhC;A+B1iIE;EACC,yBAAA;A/B4iIH;A+BziIE;EACC,yBAAA;A/B2iIH;A+BxiIE;EACC,yBAAA;A/B0iIH;A+BtiIC;EACC,yBAAA;EACA,uB7BzBgC;AFikIlC;A+BtiIE;EACC,yBAAA;A/BwiIH;A+BriIE;EACC,yBAAA;A/BuiIH;A+BpiIE;EACC,yBAAA;A/BsiIH;A+BliIC;EACC,yBAAA;EACA,yB7BjC6B;AFqkI/B;A+BliIE;EACC,yBAAA;A/BoiIH;A+BjiIE;EACC,yBAAA;A/BmiIH;A+BhiIE;EACC,yBAAA;A/BkiIH;;AgCvoIA;EACI,YAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AhC0oIJ;AgCxoII;EACI,oCAAA;EACA,uBAAA;AhC0oIR;AgCxoIQ;EACI,qCAAA;AhC0oIZ;AgCtoII;EACI,kCAAA;EACA,yBAAA;AhCwoIR;AgCtoIQ;EACI,0CAAA;AhCwoIZ;AgCpoII;EACI,yBAAA;EACA,mBAAA;AhCsoIR;AgCpoIQ;EACI,YAAA;AhCsoIZ;AgCloIY;EACI,oCAAA;AhCooIhB;AgCloIgB;EACI,cxBpCF;EwBqCE,gBAAA;AhCooIpB;AgC/nIQ;EACI,cxB5CE;EwB6CF,gBAAA;AhCioIZ;AgC/nIY;EACI,cxB/CE;EwBgDF,gBAAA;AhCioIhB;;AiClrIA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AjCqrIF;AiCprIE;EACE,cAAA;AjCsrIJ;AiCprIE;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AjCsrIJ;AiCrrII;EACE,cAAA;AjCurIN;AiCtrIM;EACE,aAAA;AjCwrIR;AiCprIM;EACE,cAAA;EACA,aAAA;AjCsrIR;AiCrrIQ;EACE,cAAA;EACA,cAAA;AjCurIV;AiClrIE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AjCorIJ;AiCnrII;EACE,cAAA;AjCqrIN;AiCnrII;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AjCqrIN;AiCnrII;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AjCqrIN;;AkCruIE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AlCwuIJ;AkCtuIE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AlCwuIJ;AkCtuIE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AlCwuIJ;AkCvuII;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AlCyuIN;AkCtuIE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AlCwuIJ;AkCtuIE;EACE,SAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;AlCwuIJ;AkCtuIM;EACE,eAAA;AlCwuIR;AkCnuIE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;AlCquIJ;AkCnuII;EACE,gBAAA;EACA,chCpDO;AFyxIb;AkCluII;EACE,gBAAA;EACA,chCzCU;AF6wIhB;AkCjuII;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AlCmuIN;;AmC3yIE;EACE,cAAA;AnC8yIJ;AmC7yII;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AnC+yIN;AmC9yIM;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AnCgzIR;AmC9yIQ;EACE,oCAAA;EACA,8BAAA;AnCgzIV;AmC7yIQ;EACE,oCAAA;EACA,8BAAA;AnC+yIV;AmC9yIU;;EAEE,yBAAA;AnCgzIZ;AmC7yIQ;EACE,oCAAA;EACA,8BAAA;AnC+yIV;AmC9yIU;;EAEE,yBAAA;AnCgzIZ;AmC3yIM;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AnC6yIR;AmC5yIQ;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;AnC8yIV;AmC5yIQ;EACE,eAAA;AnC8yIV;AmC3yIM;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AnC6yIR;AmC5yIQ;EACE,eAAA;AnC8yIV;AmC3yIM;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;AnC6yIR;AmC5yIQ;EACE,QAAA;AnC8yIV;AmC3yIM;EACE,gBAAA;AnC6yIR;AmC3yIM;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;AnC6yIR;AmC3yIM;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,mBAAA;AnC6yIR;AmC5yIQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AnC8yIV;;AoCh5IA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;ApCm5IF;AoCl5IE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ApCo5IJ;AoCn5II;EACE,WAAA;EACA,wBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,yBlCFa;AFu5InB;AoCl5IM;EACE,cAAA;ApCo5IR;AoCl5IM;EACE,yBlCFW;AFs5InB;AoC/4IQ;EACE,yBlCtBG;AFu6Ib;;AoCz4II;EACE,UAAA;ApC44IN;AoC14II;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;ApC44IN;AoC34IM;EACE,cAAA;ApC64IR;AoC54IQ;EACE,kBAAA;ApC84IV;AoC34IM;EACE,WAAA;EACA,WAAA;EACA,aAAA;ApC64IR;AoC34IM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;ApC64IR;AoC34IM;;EAEE,aAAA;EACA,WAAA;EACA,WAAA;ApC64IR;AoC34IM;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;ApC64IR;AoC34IQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;ApC64IV;AoC54IU;EACE,iBAAA;ApC84IZ;AoC34IQ;EACE,6BAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;ApC64IV;AoC54IU;EACE,gBAAA;EACA,WAAA;ApC84IZ;AoC14IM;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;ApC44IR;AoC34IQ;EACE,WAAA;EACA,YAAA;EACA,UAAA;ApC64IV;AoC34IQ;EACE,gBAAA;EACA,clCxFI;EkCyFJ,+BAAA;ApC64IV;AoC14IM;EAEE,yBAAA;ApC24IR;AoC14IQ;EACE,yBAAA;ApC44IV;AoC14IQ;EACE,cAAA;ApC44IV;AoCz4IU;EAGE,cAAA;ApCy4IZ;AoCt4IQ;EACE,YAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;ApCw4IV;AoCr4IM;EACE,yBlCtIK;EkCuIL,YAAA;ApCu4IR;AoCt4IQ;EACE,aAAA;ApCw4IV;AoCv4IU;EACE,cAAA;ApCy4IZ;AoCt4IY;EACE,eAAA;ApCw4Id;AoCp4IQ;EACE,YAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;ApCs4IV;AoCn4IM;EACE,yBAAA;EACA,YAAA;ApCq4IR;AoCp4IQ;EACE,clC5JF;AFkiJR;AoCp4IQ;EACE,aAAA;ApCs4IV;AoCn4IU;EACE,elCjKE;AFsiJd;AoCj4IU;EAGE,clC1KJ;AF2iJR;AoC93IQ;EACE,yBAAA;ApCg4IV;AoC93IQ;EACE,cAAA;ApCg4IV;AoC93IQ;EACE,YAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;ApCg4IV;AoC53IQ;EACE,cAAA;ApC83IV;;AqCllJE;EACE,WAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;ArCqlJJ;AqCplJI;EACE,8BAAA;EACA,2BAAA;ArCslJN;AqCplJI;EACE,+BAAA;EACA,4BAAA;ArCslJN;AqCplJI;EACE,WAAA;ArCslJN;AqCnlJE;EACE,yBAAA;EACA,oBAAA;ArCqlJJ;;AsCzmJE;EACE,cAAA;EACA,gBAAA;AtC4mJJ;AsC1mJE;EACE,WAAA;AtC4mJJ;;AuClnJA;EACI,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AvCqnJJ;AuCnnJI;EACI,iBAAA;AvCqnJR;AuClnJI;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AvConJR;AuCjnJI;EACI,qBrCyBoB;EqCxBpB,mBrCwBoB;AF2lJ5B;AuCjnJQ;EACI,yBAAA;AvCmnJZ;AuC/mJI;EACI,qBrCMkB;EqCLlB,mBrCKkB;AF4mJ1B;AuC/mJQ;EACI,yBAAA;AvCinJZ;AuC7mJI;EACI,qBrCgBiB;EqCfjB,mBrCeiB;AFgmJzB;AuC7mJQ;EACI,yBAAA;AvC+mJZ;AuC1mJQ;EACI,yBAAA;AvC4mJZ;;AwC9pJA;EACE,kBAAA;AxCiqJF;AwChqJE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AxCkqJJ;AwChqJE;EACE,YAAA;EACA,WAAA;EACA,0BAAA;AxCkqJJ;AwCjqJI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AxCmqJN;AwClqJM;EACE,eAAA;EACA,cAAA;AxCoqJR;AwChqJE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AxCkqJJ;AwCjqJI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AxCmqJN;AwClqJM;EACE,yBtCLc;EsCMd,qBtCRO;AF4qJf;AwClqJM;EACE,yBtCOoB;EsCNpB,qBAAA;AxCoqJR;AwChqJE;EACE,WAAA;EACA,mBAAA;AxCkqJJ;AwChqJE;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AxCkqJJ;AwCjqJI;EACE,6BAAA;EACA,uBAAA;EACA,2BAAA;AxCmqJN;AwC/pJI;EACE,cAAA;AxCiqJN;AwC9pJE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AxCgqJJ;AwC9pJE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AxCgqJJ;AwC/pJI;EACE,eAAA;AxCiqJN;AwC9pJE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AxCgqJJ;AwC7pJE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kCAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AxC+pJJ;AwC9pJI;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;AxCgqJN;AwC9pJI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;EAEA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,eAAA;AxC+pJN;AwC7pJI;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AxC+pJN;AwC9pJM;EACE,YAAA;AxCgqJR;AwC7pJI;EACE,+BAAA;EACA,kDAAA;EACA,iBAAA;AxC+pJN;AwC7pJI;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AxC+pJN;AwC5pJE;EACE,uBAAA;EACA,SAAA;AxC8pJJ;AwC7pJI;;EAEE,qBAAA;AxC+pJN;;AyC3zJE;EACE,WAAA;EACA,YAAA;AzC8zJJ;AyC5zJI;EACE,qBvCmCiB;EuClCjB,yBvCwCsB;AFsxJ5B;AyC5zJM;EACE,yBvCgCqB;AF8xJ7B;AyC1zJI;EACE,yBvCgBgB;EuCfhB,qBvCaS;AF+yJf;AyC1zJM;EACE,yBvCgBa;AF4yJrB;AyCxzJI;EACE,yBvCgCmB;EuC/BnB,qBvC0Be;AFgyJrB;AyCxzJM;EACE,yBvCuBa;AFmyJrB;;A0Ct1JA;EACE,oBAAA;A1Cy1JF;A0Cx1JE;EACE,yBAAA;A1C01JJ;A0Cx1JE;EACE,iBAAA;A1C01JJ;A0Cx1JE;EACE,yBAAA;EACA,kBAAA;A1C01JJ;A0Cx1JE;EACE,yBAAA;A1C01JJ;;A2Cv2JA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;A3C02JF;A2Cx2JE;EACE,oBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;A3C02JJ;A2Cz2JI;EACE,gBAAA;A3C22JN;A2Cx2JE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;A3C02JJ;A2Cv2JE;EAUE,uBAAA;A3Cg2JJ;A2Cz2JI;EACE,kBAAA;A3C22JN;A2Cz2JI;EACE,mBAAA;A3C22JN;A2Cz2JI;EACE,wBAAA;A3C22JN;A2Cr2JU;EACE,wBAAA;A3Cu2JZ;A2C/1JU;EACE,wBAAA;A3Ci2JZ;A2C31JE;EACE,6BAAA;EACA,gBAAA;A3C61JJ;A2C31JE;EACE,mBAAA;EACA,yBAAA;A3C61JJ;A2C51JI;EACE,mBAAA;A3C81JN;A2C71JM;EACE,cAAA;A3C+1JR;A2C31JM;EACE,cAAA;A3C61JR;A2C51JQ;EACE,cAAA;A3C81JV;A2C31JM;EACE,cAAA;A3C61JR;A2Cv1JU;EACE,yBAAA;A3Cy1JZ;A2Cv1JU;EACE,yBAAA;A3Cy1JZ;A2Cn1JE;EACE,yBAAA;A3Cq1JJ;A2Cn1JI;EACE,mBAAA;A3Cq1JN;A2Cp1JM;EACE,eAAA;A3Cs1JR;A2Cp1JM;EACE,cAAA;A3Cs1JR;A2Cl1JM;EACE,0BAAA;A3Co1JR;A2Cj1JI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;A3Cm1JN;A2Cl1JM;EACE,UAAA;A3Co1JR;A2Cn1JQ;EACE,kBAAA;A3Cq1JV;A2Cj1JI;EACE,gBAAA;EACA,6BAAA;EACA,gBAAA;A3Cm1JN;A2Ch1JE;EACE,yBAAA;A3Ck1JJ;A2Ch1JI;EACE,mBAAA;A3Ck1JN;A2Cj1JM;EACE,eAAA;A3Cm1JR;A2Cj1JM;EACE,cAAA;A3Cm1JR;A2C/0JM;EACE,0BAAA;A3Ci1JR;A2C90JI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;A3Cg1JN;A2C/0JM;EACE,UAAA;A3Ci1JR;A2Ch1JQ;EACE,kBAAA;A3Ck1JV;A2C90JI;EACE,gBAAA;EACA,6BAAA;EACA,gBAAA;A3Cg1JN;A2C50JQ;EACE,oCAAA;EACA,oCAAA;A3C80JV;A2C70JU;EACE,yBAAA;A3C+0JZ;A2C70JU;EACE,yBAAA;A3C+0JZ;A2Cv0JI;EACE,WAAA;A3Cy0JN;A2Cp0JM;EACE,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,8BAAA;EACA,6BAAA;A3Cs0JR;A2Cp0JM;EACE,aAAA;A3Cs0JR;;A4CxgKA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;A5C2gKF;A4CxgKI;EACE,YAAA;A5C0gKN;A4CtgKE;EACE,gBAAA;A5CwgKJ;A4CtgKI;EACE,oBAAA,EAAA,sDAAA;EACA,4BAAA,EAAA,yBAAA;EACA,qBAAA,EAAA,4BAAA;EACA,gBAAA,EAAA,sCAAA;A5CwgKN;A4CpgKE;EACE,kBAAA;A5CsgKJ;A4CpgKE;EACE,cAAA;A5CsgKJ;A4CpgKE;EACE,cAAA;A5CsgKJ;A4CpgKE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;A5CsgKJ;A4CpgKI;EACE,0BAAA;A5CsgKN;A4CpgKM;EACE,cAAA;A5CsgKR;A4ClgKI;EACE,cAAA;EACA,eAAA;A5CogKN;;A6CrjKE;;EAEE,kBAAA;EACA,cAAA;EACA,iBAAA;A7CwjKJ;A6CtjKE;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;A7CwjKJ;A6CrjKE;EACE,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A7CujKJ;;A6CnjKA;EACE,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;A7CsjKF;A6CpjKI;EACE,kBAAA;A7CsjKN;A6CnjKE;EACE,2BAAA;A7CqjKJ;A6CpjKI;EACE,YAAA;A7CsjKN;A6CjjKI;EACE,YAAA;A7CmjKN;A6ChjKE;EACE,yBAAA;A7CkjKJ;A6ChjKE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;A7CkjKJ;A6CjjKI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;A7CmjKN;A6ChjKM;EACE,aAAA;A7CkjKR;A6C9iKE;EACE,mBAAA;EACA,kBAAA;A7CgjKJ;A6C9iKI;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;A7CgjKN;A6C7iKE;EACE,6BAAA;A7C+iKJ;;A8C3nKI;EACE,eAAA;EACA,mBAAA;A9C8nKN;A8C7nKM;EACE,cAAA;EACA,gBAAA;EACA,+BAAA;EAEA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;A9C8nKR;A8C3nKI;EACE,YAAA;EACA,WAAA;EACA,eAAA;A9C6nKN;A8C5nKM;EACE,cAAA;A9C8nKR;A8C3nKI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A9C6nKN;A8C3nKI;EACE,gBAAA;A9C6nKN;A8C1nKM;EACE,aAAA;EACA,WAAA;A9C4nKR;A8C3nKQ;EACE,WAAA;A9C6nKV;A8C3nKQ;EACE,SAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;A9C6nKV;A8CxnKE;EACE,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;A9C0nKJ;A8CxnKI;EACE,aAAA;EACA,yBAAA;EACA,SAAA;A9C0nKN;A8CxnKM;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;A9C0nKR;A8CvnKM;EACE,UAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kCAAA;EACA,8BAAA;A9CynKR;A8CrnKI;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;A9CunKN;A8CrnKM;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;A9CunKR;A8CnnKQ;EACE,yBAAA;A9CqnKV;;A+C9tKA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;A/CiuKF;A+C/tKI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;A/CiuKN;A+ChuKM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;A/CkuKR;A+CjuKQ;EACE,yBAAA;A/CmuKV;A+C9tKE;EACE,yBAAA;EACF,yB7Ce8B;AFitKhC;A+C7tKE;EACE,yBAAA;EACA,uB7CoB8B;AF2sKlC;A+C7tKI;EACE,yBAAA;A/C+tKN;A+C5tKI;EACE,yBAAA;A/C8tKN;A+C3tKI;EACE,yBAAA;A/C6tKN;A+CztKE;EACE,yBAAA;EACA,yB7CY2B;AF+sK/B;A+CztKI;EACE,yBAAA;A/C2tKN;A+CxtKI;EACE,yBAAA;A/C0tKN;A+CvtKI;EACE,yBAAA;A/CytKN;;AgDjxKA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;AhDoxKF;AgDnxKE;EACE,cAAA;AhDqxKJ;AgDnxKE;EACE,6BAAA;AhDqxKJ;AgDnxKE;EACE,yBAAA;EACF,yB9C0B8B;AF2vKhC;AgDlxKE;EACE,yBAAA;EACA,uB9C+B8B;AFqvKlC;AgDlxKI;EACE,yBAAA;AhDoxKN;AgDjxKI;EACE,yBAAA;AhDmxKN;AgDhxKI;EACE,yBAAA;AhDkxKN;AgD9wKE;EACE,yBAAA;EACA,yB9CuB2B;AFyvK/B;AgD9wKI;EACE,yBAAA;AhDgxKN;AgD7wKI;EACE,yBAAA;AhD+wKN;AgD5wKI;EACE,yBAAA;AhD8wKN;AgD1wKE;EACE,UAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AhD4wKJ;AgD1wKI;EACE,UAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;AhD4wKN;AgD1wKM;EACE,2BAAA;EACA,yBAAA;AhD4wKR;AgDxwKI;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;AhD0wKN;AgDvwKI;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AhDywKN;AgDtwKI;EACE,sBAAA;AhDwwKN;;AiDh2KA;EAEE,yBAAA;EACA,kBAAA;AjDk2KF;AiDj2KE;EACE,cAAA;AjDm2KJ;AiDj2KE;EACE,8BAAA;AjDm2KJ;;AkDz2KI;EAME,YAAA;EACA,cAAA;EACA,qBAAA;AlDu2KN;AkD92KM;EACE,gBAAA;EACA,+BAAA;AlDg3KR;AkDx2KI;EAME,yBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AlDq2KN;AkD72KM;EACE,gBAAA;EACA,+BAAA;AlD+2KR;AkDt2KI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AlDw2KN;AkDt2KM;EACE,aAAA;EACA,gBAAA;EACA,SAAA;AlDw2KR;AkDr2KM;EACE,WAAA;EACA,YAAA;AlDu2KR;AkDp2KM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AlDs2KR;;AmDn5KA;EACE,kBAAA;EACA,mBAAA;AnDs5KF;AmDp5KE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AnDs5KJ;AmDl5KI;EACE,mBAAA;AnDo5KN;AmDh5KE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;AnDk5KJ;AmD/4KM;EACE,oCAAA;AnDi5KR;AmD74KI;EACE,0BAAA;AnD+4KN;AmD14KQ;EACE,YAAA;AnD44KV;AmDv4KI;EACE,yBAAA;EACA,yBjDlB0B;AF25KhC;AmDv4KM;EACE,yBAAA;AnDy4KR;AmDt4KM;EACE,yBAAA;AnDw4KR;AmDr4KM;EACE,yBAAA;AnDu4KR;AmDn4KQ;EACE,yBAAA;AnDq4KV;AmDj4KM;EACE,yBAAA;AnDm4KR;AmDh4KM;EACE,yBAAA;AnDk4KR;AmDh4KQ;EACE,gBAAA;AnDk4KV;AmD73KI;EACE,yBAAA;EACA,uBjD3C4B;AF06KlC;AmD73KM;EACE,yBAAA;AnD+3KR;AmD53KM;EACE,yBAAA;AnD83KR;AmD33KM;EACE,yBAAA;AnD63KR;AmDz3KQ;EACE,yBAAA;AnD23KV;AmDv3KM;EACE,yBAAA;AnDy3KR;AmDt3KM;EACE,yBAAA;AnDw3KR;AmDt3KQ;EACE,gBAAA;AnDw3KV;AmDp3KM;EACE,yBAAA;AnDs3KR;AmDl3KI;EACE,yBAAA;EACA,uBAAA;AnDo3KN;AmDl3KM;EACE,yBAAA;AnDo3KR;AmDj3KM;EACE,yBAAA;AnDm3KR;AmDh3KM;EACE,yBAAA;AnDk3KR;AmD92KQ;EACE,yBAAA;AnDg3KV;AmD52KM;EACE,yBAAA;AnD82KR;AmD32KM;EACE,yBAAA;AnD62KR;AmD32KQ;EACE,gBAAA;AnD62KV;AmDz2KM;EACE,yBAAA;AnD22KR;AmDv2KI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AnDy2KN;AmDv2KM;EACE,aAAA;EACA,UAAA;EACA,sBAAA;AnDy2KR;AmDv2KQ;EACE,aAAA;EACA,SAAA;AnDy2KV;AmDv2KU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,QAAA;AnDy2KZ;AmDv2KY;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AnDy2Kd;AmDt2KY;EACE,eAAA;AnDw2Kd;AmDj2KU;EACE,cjDxLY;AF2hLxB;AmDh2KU;EACE,cjD7JO;AF+/KnB;AmD/1KU;EACE,cjD5MG;AF6iLf;AmD/1KY;EACE,wBAAA;AnDi2Kd;AmD91KY;EACE,cjDnNC;AFmjLf;AmD51KU;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AnD81KZ;AmDz1KM;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AnD21KR;AmDx1KU;EACE,gBAAA;EACA,2BAAA;AnD01KZ;AmDt1KQ;EACE,YAAA;EACA,eAAA;EACA,8BAAA;AnDw1KV;AmDr1KQ;EACE,eAAA;EACA,eAAA;EACA,cAAA;AnDu1KV;AmDp1KQ;EACE,sBAAA;EACA,YAAA;AnDs1KV;AmDh1KI;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,aAAA;EACA,kCAAA;EACA,6JACE;AnD+0KR;AmDz0KM;EACE,cjD1OW;AFqjLnB;AmDx0KM;EACE,cAAA;AnD00KR;AmDv0KM;EACE,iBAAA;EACA,YAAA;AnDy0KR;AmDv0KQ;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cjDtSK;AF+mLf;AmDr0KM;EACE,gBAAA;AnDu0KR;AmDp0KM;EACE,mBAAA;AnDs0KR;AmDn0KM;EACE,cAAA;AnDq0KR;AmDl0KM;EACE,oBAAA;AnDo0KR;AmDh0KY;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AnDk0Kd;AmD/zKY;EACE,YAAA;AnDi0Kd;AmD3zKM;EACE,mBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,eAAA;AnD6zKR;AmD1zKM;EACE,gBAAA;AnD4zKR;AmDzzKM;EACE,gBAAA;AnD2zKR;AmDxzKM;EACE,kBAAA;AnD0zKR;AmDvzKM;EACE,yBAAA;AnDyzKR;AmDvzKQ;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AnDyzKV;AmDrzKM;EACE,iBAAA;AnDuzKR;;AoD9qLE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;ApDirLJ;AoD9qLE;EACE,clDwBgB;AFwpLpB;AoD7qLE;EACE,clDgCkB;AF+oLtB;AoD5qLE;EACE,clDoCe;AF0oLnB;AoD3qLE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ApD6qLJ;AoD1qLE;EACE,aAAA;EACA,8BAAA;EAEA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ApD2qLJ;AoDzqLI;EACE,UAAA;ApD2qLN;AoDxqLI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;ApD0qLN;AoDvqLI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ApDyqLN;;AqD1tLA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;ArD6tLF;AqD3tLE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;ArD6tLJ;AqD1tLE;EACE,eAAA;ArD4tLJ;;AsDzuLQ;EAMI,YAAA;EACA,cAAA;EACA,qBAAA;AtDuuLZ;AsD9uLY;EACI,gBAAA;EACA,+BAAA;AtDgvLhB;AsDxuLQ;EAMI,yBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AtDquLZ;AsD7uLY;EACI,gBAAA;EACA,+BAAA;AtD+uLhB;AsDtuLQ;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AtDwuLZ;AsDtuLY;EACI,aAAA;EACA,gBAAA;EACA,SAAA;AtDwuLhB;AsDruLY;EACI,WAAA;EACA,YAAA;AtDuuLhB;AsDruLgB;EACI,yBpDMQ;EoDLR,qBpDDG;AFwuLvB;AsDpuLgB;EACI,yBpDfE;EoDgBF,qBpDlBL;AFwvLf;AsDnuLgB;EACI,yBpDKK;EoDJL,qBpDDC;AFsuLrB;;AuDtxLQ;EACI,0BAAA;AvDyxLZ;AuDrxLI;EACI,cAAA;EACA,YAAA;AvDuxLR;AuDpxLI;EAKI,yBAAA;EACA,cAAA;EACA,qBAAA;AvDkxLR;AuDxxLQ;EACI,+BAAA;AvD0xLZ;AuDlxLI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AvDoxLR;AuDlxLQ;EACI,WAAA;AvDoxLZ;;AwD9yLI;EACE,yBAAA;EACF,yBtDiC4B;AFgxLhC;AwD9yLI;EACE,yBAAA;EACF,yBtD+C2B;AFiwL/B;AwD7yLI;EACE,yBAAA;EACF,uBtDiC8B;AF8wLlC;AwD3yLM;;EAEE,YAAA;AxD6yLR;AwDvyLI;EACE,yBtDGgB;EsDFhB,gCAAA;AxDyyLN;AwDtyLI;EACE,oCAAA;EACF,yBtDawB;AF2xL5B;;AyDx0LE;;EAEE,wBAAA;EACA,SAAA;AzD20LJ;AyDx0LE;EACE,2BAAA;AzD00LJ;AyDr0LI;;EAEE,YAAA;AzDu0LN;AyDp0LQ;;EACE,cAAA;AzDu0LV;AyD/zLM;EACE,cAAA;AzDi0LR;AyD7zLI;EACE,mBAAA;AzD+zLN;AyD3zLE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AzD6zLJ;AyD3zLI;EACE,YAAA;EACA,gBAAA;AzD6zLN;;A0D92LA;EACE,mBAAA;EACA,yBAAA;EACA,+CAAA;EACA,sBAAA;EAcA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A1Do2LF;A0Dp3LE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iCAAA;EACA,kHAAA;A1Ds3LJ;A0D12LE;EACE,yBAAA;EACA,yBxDY4B;AFg2LhC;A0D12LI;EACE,yBAAA;A1D42LN;A0Dz2LI;EACE,yBAAA;A1D22LN;A0Dx2LI;EACE,yBAAA;A1D02LN;A0Dt2LE;EACE,yBAAA;EACA,uBxDK8B;AFm2LlC;A0Dt2LI;EACE,yBAAA;A1Dw2LN;A0Dr2LI;EACE,yBAAA;A1Du2LN;A0Dp2LI;EACE,yBAAA;A1Ds2LN;A0Dl2LE;EACE,yBAAA;EACA,yBxDH2B;AFu2L/B;A0Dl2LI;EACE,yBAAA;A1Do2LN;A0Dj2LI;EACE,yBAAA;A1Dm2LN;A0Dh2LI;EACE,yBAAA;A1Dk2LN;A0D91LE;EACE,cAAA;A1Dg2LJ;A0D71LE;EACE,iBAAA;EACA,YAAA;A1D+1LJ;A0D71LI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cxD/ES;AF86Lf;A0D31LE;EACE,gBAAA;A1D61LJ;A0D11LE;EACE,mBAAA;A1D41LJ;A0Dz1LE;EAKE,uBAAA;A1Du1LJ;A0D31LI;EACE,0BAAA;A1D61LN;A0Dv1LE;EACE,eAAA;A1Dy1LJ;A0Dt1LE;EACE,gBAAA;A1Dw1LJ;A0Dr1LE;EACE,gBAAA;A1Du1LJ;A0Dp1LE;EACE,iBAAA;A1Ds1LJ;A0Dp1LI;EACE,kBAAA;A1Ds1LN;;A2Dl9LI;EACI,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;A3Dq9LR;A2Dl9LI;EACI,oCAAA;A3Do9LR;;A4D99LI;EACI,cAAA;EACA,qBAAA;EACA,uBAAA;A5Di+LR;A4Dh+LQ;EACI,kCAAA;EACA,yBAAA;EACA,qBAAA;A5Dk+LZ;A4D99LI;EACI,yBAAA;A5Dg+LR;;A6D5+LI;EACI,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;A7D++LR;A6D5+LI;EACI,oCAAA;A7D8+LR;;A8Dz/LA;EACE,kBAAA;A9D4/LF;A8D1/LE;EACE,uBAAA;EACA,WAAA;EAEA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;A9D0/LJ;A8Dx/LI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A9D0/LN;A8Dx/LM;EACE,eAAA;EAEA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;A9Dy/LR;A8Dp/LE;EACE,iBAAA;A9Ds/LJ;A8Dp/LI;EACE,mBAAA;A9Ds/LN;A8Dr/LM;EACE,kBAAA;A9Du/LR;A8Dl/LE;EACE,eAAA;EAEA,sBAAA;EACA,YAAA;EACA,yBAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;EAEA,mBAAA;EACA,0CAAA;EACA,oCAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;A9Dg/LJ;A8D9+LI;EACE,UAAA;EACA,WAAA;EACA,gBAAA;A9Dg/LN;;A+DxjMA;EACI;IAAK,wBAAA;E/D4jMP;E+D3jME;IAAM,2BAAA;E/D8jMR;E+D7jME;IAAM,0BAAA;E/DgkMR;E+D/jME;IAAM,2BAAA;E/DkkMR;E+DjkME;IAAO,0BAAA;E/DokMT;AACF;AgE1kMA;EACE,aAAA;EACA,8BAAA;EACA,8BAAA;AhE4kMF;AgE3kME;;EAEE,UAAA;AhE6kMJ;AgE3kME;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AhE6kMJ;AgE5kMI;EACE,mBAAA;AhE8kMN;AgE5kMI;EACE,mBAAA;AhE8kMN;AgE5kMI;EACE,WAAA;AhE8kMN;AgE5kMI;EACE,gBAAA;EACA,c9DNQ;AFolMd;AgE5kMI;EACE,gBAAA;AhE8kMN;AgE3kMM;EACE,cAAA;AhE6kMR;AgE3kMM;EACE,0BAAA;AhE6kMR;AgE1kMI;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;AhE4kMN;AgE3kMM;EACE,0BAAA;AhE6kMR;AgEzkME;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AhE2kMJ;AgE1kMI;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AhE4kMN;AgE1kMI;EACE,mBAAA;EACA,gBAAA;AhE4kMN;AgE1kMI;EACE,gBAAA;EACA,mBAAA;AhE4kMN;AgE1kMI;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EAIA,yBAAA;EACA,4BAAA;EACA,WAAA;AhEykMN;AgErkMI;EACE,SAAA;EACA,WAAA;AhEukMN;AgElkME;EACE;IACE,aAAA;EhEokMJ;EgEnkMI;IACE,YAAA;EhEqkMN;AACF","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n.container {\n  max-width: 1300px;\n  width: 100%;\n}\n\n.cards-step-2 .body-card {\n  color: #6e7889;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 4px;\n}\n.cards-step-2 iframe {\n  width: 100%;\n  height: 120px;\n  border: none;\n  background-color: transparent;\n}\n.cards-step-2 .UploadDocs .input-content {\n  height: 78px;\n}\n.cards-step-2 .UploadDocs .input-content input {\n  height: 78px;\n}\n\n.card__generic {\n  border-radius: 10px;\n  border: 1px solid #929fb0;\n  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);\n  width: 100%;\n  padding: 16px;\n}\n\n.form-item__input,\n.form-item .ant-input {\n  padding: 12px 0;\n  border: 0;\n  border-bottom: 1px solid #404859;\n  border-radius: 0;\n}\n.form-item__input::placeholder,\n.form-item .ant-input::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.card-upload {\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  padding: 12px 16px;\n  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);\n}\n.card-upload .link {\n  color: #6e7889;\n  text-align: right;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n}\n.card-upload p {\n  margin: 10px 0;\n}\n\n.flex-btw {\n  display: flex;\n  justify-content: space-between;\n}\n\n.flex-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.flex-col {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n}\n\n.mt-20 {\n  margin-top: 20px;\n}\n.mt-25 {\n  margin-top: 25px;\n}\n.mt-30 {\n  margin-top: 30px;\n}\n.mt-40 {\n  margin-top: 40px;\n}\n.mt-50 {\n  margin-top: 50px;\n}\n.mt-60 {\n  margin-top: 60px;\n}\n.mt-12 {\n  margin-top: 12px;\n}\n.mt-6 {\n  margin-top: 6px;\n}\n.mt-5 {\n  margin-top: 5px;\n}\n.mt-10 {\n  margin-top: 10px;\n}\n.mt-15 {\n  margin-top: 15px;\n}\n\n.divider-top {\n  border-top: 1px solid #afbdcc;\n}\n\n.input-transparent {\n  background-color: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0;\n}\n.input-number {\n  width: 100%;\n  height: 48px;\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  background: #fff;\n}\n.input-number .ant-input-number-input-wrap {\n  height: 45px;\n}\n.input-number .ant-input-number-input-wrap .ant-input-number-input {\n  height: 45px;\n}\n.input-number .ant-input-prefix {\n  color: #404859;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 400;\n}\n.input-number input::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 400;\n}\n.input-placeholder-bold::placeholder {\n  color: #9bbceb;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.body-placeholder::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 600;\n  line-height: normal;\n}\n.body-placeholder-w4::placeholder {\n  font-weight: 400;\n}\n\n.fz-14 {\n  font-size: 14px;\n}\n\n.fz-12 {\n  font-size: 12px;\n}\n\n.children {\n  padding-bottom: 20px;\n}\n\n/* http://meyerweb.com/eric/tools/css/reset/\n   v2.0-modified | 20110126\n   License: none (public domain)\n*/\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  margin: 0;\n  height: 100%;\n}\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n/* make sure to set some focus styles for accessibility */\n:focus {\n  outline: 0;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ninput[type=search]::-webkit-search-cancel-button,\ninput[type=search]::-webkit-search-decoration,\ninput[type=search]::-webkit-search-results-button,\ninput[type=search]::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\ninput[type=search] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\ntextarea {\n  overflow: auto;\n  vertical-align: top;\n  resize: vertical;\n}\n\n/**\n   * Correct `inline-block` display not defined in IE 6/7/8/9 and Firefox 3.\n   */\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n  *display: inline;\n  *zoom: 1;\n  max-width: 100%;\n}\n\n/**\n   * Prevent modern browsers from displaying `audio` without controls.\n   * Remove excess height in iOS 5 devices.\n   */\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n   * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.\n   * Known issue: no IE 6 support.\n   */\n[hidden] {\n  display: none;\n}\n\n/**\n   * 1. Correct text resizing oddly in IE 6/7 when body `font-size` is set using\n   *    `em` units.\n   * 2. Prevent iOS text size adjust after orientation change, without disabling\n   *    user zoom.\n   */\nhtml {\n  font-size: 100%; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -ms-text-size-adjust: 100%; /* 2 */\n}\n\n/**\n   * Address `outline` inconsistency between Chrome and other browsers.\n   */\na:focus {\n  outline: thin dotted;\n}\n\n/**\n   * Improve readability when focused and also mouse hovered in all browsers.\n   */\na:active,\na:hover {\n  outline: 0;\n}\n\n/**\n   * 1. Remove border when inside `a` element in IE 6/7/8/9 and Firefox 3.\n   * 2. Improve image quality when scaled in IE 7.\n   */\nimg {\n  border: 0; /* 1 */\n  -ms-interpolation-mode: bicubic; /* 2 */\n}\n\n/**\n   * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.\n   */\nfigure {\n  margin: 0;\n}\n\n/**\n   * Correct margin displayed oddly in IE 6/7.\n   */\nform {\n  margin: 0;\n}\n\n/**\n   * Define consistent border, margin, and padding.\n   */\nfieldset {\n  border: 0px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n   * 1. Correct color not being inherited in IE 6/7/8/9.\n   * 2. Correct text not wrapping in Firefox 3.\n   * 3. Correct alignment displayed oddly in IE 6/7.\n   */\nlegend {\n  border: 0; /* 1 */\n  padding: 0;\n  white-space: normal; /* 2 */\n  *margin-left: -7px; /* 3 */\n}\n\n/**\n   * 1. Correct font size not being inherited in all browsers.\n   * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,\n   *    and Chrome.\n   * 3. Improve appearance and consistency in all browsers.\n   */\nbutton,\ninput,\nselect,\ntextarea {\n  font-size: 100%; /* 1 */\n  margin: 0; /* 2 */\n  vertical-align: baseline; /* 3 */\n  *vertical-align: middle; /* 3 */\n}\n\n/**\n   * Address Firefox 3+ setting `line-height` on `input` using `!important` in\n   * the UA stylesheet.\n   */\nbutton,\ninput {\n  line-height: normal;\n}\n\n/**\n   * Address inconsistent `text-transform` inheritance for `button` and `select`.\n   * All other form control elements do not inherit `text-transform` values.\n   * Correct `button` style inheritance in Chrome, Safari 5+, and IE 6+.\n   * Correct `select` style inheritance in Firefox 4+ and Opera.\n   */\nbutton,\nselect {\n  text-transform: none;\n}\n\n/**\n   * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n   *    and `video` controls.\n   * 2. Correct inability to style clickable `input` types in iOS.\n   * 3. Improve usability and consistency of cursor style between image-type\n   *    `input` and others.\n   * 4. Remove inner spacing in IE 7 without affecting normal text inputs.\n   *    Known issue: inner spacing remains in IE 6.\n   */\nbutton,\nhtml input[type=button],\ninput[type=reset],\ninput[type=submit] {\n  -webkit-appearance: button; /* 2 */\n  cursor: pointer; /* 3 */\n  *overflow: visible; /* 4 */\n}\n\n/**\n   * Re-set default cursor for disabled elements.\n   */\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\n/**\n   * 1. Address box sizing set to content-box in IE 8/9.\n   * 2. Remove excess padding in IE 8/9.\n   * 3. Remove excess padding in IE 7.\n   *    Known issue: excess padding remains in IE 6.\n   */\ninput[type=checkbox],\ninput[type=radio] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n  *height: 13px; /* 3 */\n  *width: 13px; /* 3 */\n}\n\n/**\n   * 1. Address `appearance` set to `searchfield` in Safari 5 and Chrome.\n   * 2. Address `box-sizing` set to `border-box` in Safari 5 and Chrome\n   *    (include `-moz` to future-proof).\n   */\ninput[type=search] {\n  -webkit-appearance: textfield; /* 1 */\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box; /* 2 */\n  box-sizing: content-box;\n}\n\n/**\n   * Remove inner padding and search cancel button in Safari 5 and Chrome\n   * on OS X.\n   */\ninput[type=search]::-webkit-search-cancel-button,\ninput[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n   * Remove inner padding and border in Firefox 3+.\n   */\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n/**\n   * 1. Remove default vertical scrollbar in IE 6/7/8/9.\n   * 2. Improve readability and alignment in all browsers.\n   */\ntextarea {\n  overflow: auto; /* 1 */\n  vertical-align: top; /* 2 */\n}\n\n/**\n   * Remove most spacing between table cells.\n   */\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nhtml,\nbutton,\ninput,\nselect,\ntextarea {\n  color: #222;\n}\n\n::-moz-selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\n::selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\nimg {\n  vertical-align: middle;\n}\n\nfieldset {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\ntextarea {\n  resize: vertical;\n}\n\n.chromeframe {\n  margin: 0.2em 0;\n  background: #ccc;\n  color: #000;\n  padding: 0.2em 0;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n.h1 {\n  color: #404859;\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.h2 {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 120%;\n}\n.h2-w8 {\n  font-weight: 800;\n}\n\n.h3 {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 135%;\n}\n\n.h4 {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 115%;\n}\n.h4-cp {\n  text-transform: capitalize;\n}\n.h4-w4 {\n  font-weight: 400;\n}\n.h4-w5 {\n  font-weight: 500;\n}\n\n.title-blue-bold {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  color: #355c7d;\n}\n\n.body-regular {\n  color: #404859;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.body-regular-italic {\n  font-style: italic;\n}\n.body-regular-up {\n  text-transform: uppercase;\n}\n.body-regular-bold, .body-regular-w6 {\n  font-weight: 600;\n}\n.body-regular-w5 {\n  font-weight: 500;\n}\n\n.placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.placeholder-w6 {\n  font-weight: 600;\n}\n\n.button-txt-big {\n  color: #f5faff;\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n}\n\n.body-small {\n  color: #404859;\n  font-family: Inter;\n  font-size: 10px !important;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.body-small-w4 {\n  font-weight: 400;\n}\n.body-small-w6 {\n  font-weight: 600;\n}\n.body-small-up {\n  text-transform: uppercase;\n}\n\n.small-detail {\n  color: #6e7889;\n  font-family: Inter;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.body-card {\n  color: #404859;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n.body-card-bold-line {\n  font-weight: 700;\n  text-decoration-line: underline;\n}\n.body-card-w6 {\n  font-weight: 600;\n}\n.body-card-w7 {\n  font-weight: 700;\n}\n.body-card-w5 {\n  font-weight: 500;\n}\n\n.blue-bold {\n  color: #5e8eb7;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 145%;\n}\n.blue-bold img {\n  height: 10px;\n  margin-left: 5px;\n}\n\n.bold {\n  font-weight: 600;\n}\n\n.bold-little {\n  font-weight: 500;\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.button {\n  height: 32px;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.button-empty {\n  background-color: transparent;\n  padding: 0;\n  border: none;\n  box-shadow: none;\n}\n.button-empty span {\n  color: #404859 !important;\n  font-family: Inter;\n  font-size: 10px !important;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: 0.2px;\n}\n.button-modal-ok {\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid #ffc857 !important;\n  background: #ffc857 !important;\n  height: 40px;\n  color: #66564d !important;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.21px;\n}\n.button-modal-cancel {\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid #ddaa42 !important;\n  background: #fff9ee !important;\n  height: 40px;\n  color: #3c302a !important;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.21px;\n}\n.button-primary {\n  width: 100%;\n  height: 48px;\n  flex-shrink: 0;\n  border-radius: 6px;\n  border: 1px solid #162e43;\n  background: #162e43;\n  border: none;\n}\n.button-primary:hover {\n  border: none;\n  color: #f5faff !important;\n}\n.button-secondary {\n  width: 179px;\n  border-radius: 6px;\n  border: 1px solid #355c7d;\n  color: #355c7d;\n}\n.button-secondary:hover {\n  color: #355c7d !important;\n  border: 1px solid #355c7d !important;\n}\n.button-grey {\n  color: #6e7889 !important;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.18px;\n  border-radius: 6px;\n  border: 1px solid #eff3f5 !important;\n  background: #eff3f5;\n  width: 100%;\n}\n.button-transparent {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: #48759a;\n}\n.button-transparent .anticon {\n  color: #48759a;\n}\n.button-transparent:hover {\n  color: #48759a !important;\n}\n.button-gray {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: #afbdcc;\n}\n.button-gray .anticon {\n  color: #afbdcc;\n}\n.button-gray:hover {\n  color: #afbdcc !important;\n}\n.button-card {\n  width: 100%;\n  color: #000000;\n  border: 1px solid #ccd3db;\n}\n.button-card:hover {\n  color: #000000 !important;\n  border: 1px solid #ccd3db !important;\n}\n.button-submit {\n  border-radius: 6px;\n  border: 1px solid #122536 !important;\n  background: #122536 !important;\n  color: #fff !important;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.18px;\n  width: 100%;\n}\n.button-submit-delete {\n  all: unset;\n  border: none !important;\n  background-color: transparent !important;\n}\n.button-submit-delete:hover {\n  background: none !important;\n  border-color: transparent !important;\n}\n.button-submit:disabled {\n  background-color: #DFE4EB !important;\n  border-color: #DFE4EB !important;\n}\n.button-submit:disabled span {\n  color: #929FB0 !important;\n}\n.button-submit:disabled:hover {\n  background-color: #DFE4EB !important;\n  border-color: #DFE4EB !important;\n}\n.button-submit:disabled:hover span {\n  color: #929FB0 !important;\n}\n.button-submit:not(.button-submit-delete):hover {\n  background-color: #EBF6FF !important;\n  border-color: #EBF6FF !important;\n}\n.button-submit:not(.button-submit-delete):hover span {\n  color: #355D7D !important;\n}\n.button-link {\n  width: 100%;\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  font-weight: 400;\n  color: #000000;\n}\n.button-link:hover {\n  color: #000000 !important;\n}\n.button-link-REVIEW {\n  color: #161616 !important;\n}\n.button-link-border {\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid #162E43 !important;\n  background: none;\n  color: #3c302a !important;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.21px;\n}\n.button-link-border:disabled {\n  background-color: #DFE4EB !important;\n  border-color: #DFE4EB !important;\n  color: #929FB0 !important;\n}\n.button-link-blue {\n  color: #5E8EB7;\n}\n.button-link-blue span {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  text-decoration-line: underline;\n}\n.button-link-blue:hover {\n  color: #5E8EB7 !important;\n}\n.button-blue {\n  color: #5E8EB7;\n}\n.button-blue span {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.button-blue:hover {\n  color: #5E8EB7 !important;\n}\n.button-open-modal {\n  width: 100%;\n}\n.button-open-modal:hover {\n  border-color: #ccd3db !important;\n  color: #000000 !important;\n}\n.button-open-modal-REVIEW {\n  border-color: #AC78B3;\n  color: #161616;\n}\n.button-open-modal-REVIEW:hover {\n  border-color: #AC78B3 !important;\n  background-color: #693B6F !important;\n  color: white !important;\n}\n\n.select-primary {\n  width: 100%;\n  height: 40px;\n}\n.select-primary .ant-select-selector {\n  height: 40px !important;\n  padding: 2px 11px !important;\n  border-radius: 10px !important;\n  border: 1px solid #5e8eb7 !important;\n}\n.select-primary .ant-select-selector .ant-select-selection-search-input {\n  height: 40px !important;\n}\n\n.circle {\n  background-color: #fff;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid #2a2f3c;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.circle .upload {\n  width: auto;\n  height: 18px;\n  object-fit: cover;\n}\n\n.circle-state-tooltip {\n  padding: 6px 7px !important;\n  opacity: 1 !important;\n}\n.circle-state-tooltip b {\n  font-weight: 600;\n}\n.circle-state-tooltip span {\n  margin-top: 10px;\n}\n.circle-state-tooltip-APPROVED {\n  background-color: #549358 !important;\n}\n.circle-state-tooltip-DRAFT {\n  background-color: #404859 !important;\n}\n.circle-state-tooltip-REQUEST_ERROR {\n  background-color: #c94f4a !important;\n}\n.circle-state-tooltip-REVIEW {\n  background-color: #855791 !important;\n}\n\n.DrodownBasic {\n  height: 40px;\n  padding: 1px 3px !important;\n  display: flex;\n  align-items: center;\n  border: 1px solid #6E7889;\n  width: 100%;\n}\n.DrodownBasic span {\n  color: #6E7889;\n  padding-left: 16px;\n}\n.DrodownBasic-blue {\n  border: 1px solid #9BBCEB;\n  border-radius: 10px;\n}\n.DrodownBasic-blue .ant-dropdown-menu {\n  padding: 0px;\n  width: 160px;\n}\n.DrodownBasic-blue .ant-dropdown-menu-item:hover {\n  background-color: #EBF6FF !important;\n}\n.DrodownBasic-blue .ant-dropdown-menu-item:hover .ant-dropdown-menu-title-content {\n  color: #355c7d;\n  font-weight: 600;\n}\n.DrodownBasic-blue .ant-dropdown-menu-title-content {\n  color: #5E8EB7;\n  font-weight: 400;\n}\n.DrodownBasic-blue .ant-dropdown-menu-title-content:hover {\n  color: #355c7d;\n  font-weight: 600;\n}\n\n.checkbox-basic .ant-checkbox-wrapper {\n  color: #244560;\n}\n.checkbox-basic .ant-checkbox-wrapper:hover .ant-checkbox-inner {\n  border: 1px solid #5E8EB7 !important;\n}\n.checkbox-basic .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #5E8EB7 !important;\n}\n.checkbox-basic .ant-checkbox,\n.checkbox-basic .ant-checkbox-input {\n  border: none;\n}\n.checkbox-basic .ant-checkbox:hover .ant-checkbox-inner,\n.checkbox-basic .ant-checkbox-input:hover .ant-checkbox-inner {\n  border: 1px solid #5E8EB7 !important;\n}\n.checkbox-basic .ant-checkbox:hover .ant-checkbox-checked .ant-checkbox-inner,\n.checkbox-basic .ant-checkbox-input:hover .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #5E8EB7 !important;\n}\n.checkbox-basic .ant-checkbox-inner {\n  width: 18px;\n  height: 18px;\n  border: 1px solid #5E8EB7;\n}\n.checkbox-basic .ant-checkbox-disabled .ant-checkbox-inner {\n  border-radius: 2px;\n  background: #DFE4EB !important;\n  border: 1px solid #DFE4EB;\n}\n.checkbox-basic .ant-checkbox-checked:hover .ant-checkbox-inner {\n  background-color: #5E8EB7 !important;\n}\n.checkbox-basic .ant-checkbox-checked .ant-checkbox-inner {\n  border-radius: 2px;\n  background: #5E8EB7;\n}\n\n.Layout {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.Layout .content {\n  width: 100%;\n}\n.Layout .BarLogin {\n  padding: 16px;\n  background-color: #eff3f5;\n  width: 64px;\n  height: 100vh;\n  border-right: 1px solid #dfe4eb;\n}\n.Layout .BarLogin .logo {\n  width: 32px;\n}\n\n.select-section-selected .ant-select-selector {\n  background: #F5FAFF !important;\n  border: 1px solid #5E8EB7 !important;\n  padding-left: 10px !important;\n}\n.select-section-selected .ant-select-selector .ant-select-selection-item {\n  color: #355C7D !important;\n}\n.select-section-selected .ant-select-selector .ant-select-selection-item-content {\n  color: #5E8EB7 !important;\n}\n.select-section .ant-select {\n  display: block;\n  height: 40px;\n  margin-top: 6px;\n}\n.select-section .ant-select .ant-select-selection-placeholder {\n  margin-bottom: 0;\n  color: #6E7889 !important;\n}\n\n.ant-select-dropdown div {\n  color: #6E7889;\n}\n.ant-select-dropdown .anticon {\n  display: none;\n}\n.ant-select-dropdown .circle {\n  width: 14px !important;\n  height: 14px !important;\n  border-color: #CCD3DB;\n}\n\n.ant-select-outlined.ant-select-multiple .ant-select-selection-item {\n  background: none;\n  border: none;\n}\n.ant-select-outlined.ant-select-multiple .ant-select-selection-item span {\n  color: rgb(53, 92, 125) !important;\n}\n\n.ant-select-item-option-selected .ant-select-item-option-content div {\n  color: #48759A !important;\n}\n\n.task-item-list .circle-state-tooltip {\n  padding: 6px 7px;\n  opacity: 1;\n}\n.task-item-list .circle-state-tooltip b {\n  font-weight: 600;\n}\n.task-item-list .circle-state-tooltip span {\n  margin-top: 10px;\n}\n.task-item-list .circle-state-tooltip-APPROVED {\n  background-color: #549358;\n}\n.task-item-list .circle-state-tooltip-DRAFT {\n  background-color: #c0cad7;\n}\n.task-item-list .circle-state-tooltip-REQUEST_ERROR {\n  background-color: #c94f4a;\n}\n.task-item-list .circle-state-tooltip-REVIEW {\n  background-color: #855791;\n}\n.task-item-list .circles-tags {\n  display: flex;\n  align-items: end;\n  gap: 20px;\n  margin-top: 5px;\n}\n.task-item-list .circle {\n  width: 16px;\n  height: 16px;\n}\n.task-item-list .circle-APPROVED {\n  background-color: #6eac72;\n  border-color: #587e5b;\n}\n.task-item-list .circle-APPROVED:hover {\n  background-color: #549358;\n}\n.task-item-list .circle-APPROVED-active {\n  background-color: #549358;\n}\n.task-item-list .circle-REVIEW {\n  background-color: #AC78B3;\n  border-color: #AC78B3;\n}\n.task-item-list .circle-REVIEW:hover {\n  background-color: #855791;\n}\n.task-item-list .circle-REVIEW-active {\n  background-color: #855791;\n}\n.task-item-list .circle-REQUEST_ERROR {\n  background-color: #FFD4CF;\n  border-color: #c94f4a;\n}\n.task-item-list .circle-REQUEST_ERROR:hover {\n  background-color: #c94f4a;\n}\n.task-item-list .circle-REQUEST_ERROR-active {\n  background-color: #c94f4a;\n}\n.task-item-list .circle-DRAFT {\n  background-color: #DFE4EB;\n  border: 1px solid #CCD3DB;\n}\n.task-item-list .circle-DRAFT:hover {\n  background-color: #cfd7e1;\n}\n.task-item-list .circle-DRAFT-active {\n  background-color: #cfd7e1;\n}\n.task-item-list .circle-INCOMPLETE {\n  background-color: #2a2f3c;\n  border: 1px solid #2a2f3c;\n}\n.task-item-list .circle-INCOMPLETE:hover {\n  background-color: #20232d;\n}\n.task-item-list .circle-INCOMPLETE-active {\n  background-color: #20232d;\n}\n\n.LoanProgress {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n}\n.LoanProgress .tab {\n  margin: 0 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.LoanProgress .tab .popover-label {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.LoanProgress .tab .bar-status {\n  cursor: pointer;\n  width: 100%;\n  width: calc(100% + 20px);\n  height: 8px;\n  border-radius: 16px;\n  margin-top: 6px;\n  background-color: #dfe4eb;\n}\n.LoanProgress .tab-complete .text-status {\n  color: #141F15;\n}\n.LoanProgress .tab-complete .body-small {\n  color: #2D7032;\n}\n.LoanProgress .tab-complete .bar-status {\n  background-color: #4CA852;\n}\n.LoanProgress .tab-complete .bar-status-selected {\n  background-color: #2D7032;\n}\n.LoanProgress .tab-complete .bar-status-selected:hover {\n  background-color: #2D7032 !important;\n}\n.LoanProgress .tab-complete .bar-status:hover {\n  background-color: #3F9545;\n}\n.LoanProgress .tab-complete .bar-status:hover .body-small {\n  color: #2D7032;\n}\n.LoanProgress .tab-blocked .body-small {\n  color: #8A130F;\n}\n.LoanProgress .tab-blocked .text-status {\n  color: #610805;\n}\n.LoanProgress .tab-blocked .bar-status {\n  background-color: #C13934;\n}\n.LoanProgress .tab-blocked .bar-status-selected {\n  background-color: #8A130F;\n}\n.LoanProgress .tab-blocked .bar-status-selected:hover {\n  background-color: #8A130F !important;\n}\n.LoanProgress .tab-blocked .bar-status:hover {\n  background-color: #A31C17;\n}\n.LoanProgress .tab-blocked .bar-status:hover .body-small {\n  color: #8A130F;\n}\n.LoanProgress .tab-error .body-small {\n  color: #8A130F;\n}\n.LoanProgress .tab-error .text-status {\n  color: #610805;\n}\n.LoanProgress .tab-error .bar-status {\n  background-color: #FFDAD6;\n}\n.LoanProgress .tab-error .bar-status-selected {\n  background-color: #8A130F;\n}\n.LoanProgress .tab-error .bar-status-selected:hover {\n  background-color: #8A130F !important;\n}\n.LoanProgress .tab-error .bar-status:hover {\n  background-color: #C13934;\n}\n.LoanProgress .tab-error .bar-status:hover .body-small {\n  color: #8A130F;\n}\n.LoanProgress .tab-progress .text-status {\n  color: #122536;\n}\n.LoanProgress .tab-progress .body-small {\n  color: #404859;\n}\n.LoanProgress .tab-progress .bar-status {\n  background-color: #5E8EB7;\n}\n.LoanProgress .tab-progress .bar-status-selected {\n  background-color: #355C7D;\n}\n.LoanProgress .tab-progress .bar-status-selected:hover {\n  background-color: #355C7D !important;\n}\n.LoanProgress .tab-progress .bar-status:hover {\n  background-color: #48759A;\n}\n.LoanProgress .tab-progress .bar-status:hover .body-small {\n  color: #404859;\n}\n.LoanProgress .tab-not-started .bar-status {\n  background-color: white;\n  border: 1px solid #404859;\n}\n.LoanProgress .tab-not-started .bar-status-selected {\n  background-color: #404859;\n}\n.LoanProgress .tab-not-started .bar-status-selected:hover {\n  background-color: #404859 !important;\n}\n.LoanProgress .tab-not-started .bar-status:hover {\n  background-color: #929FB0;\n}\n.LoanProgress .tab-open-content {\n  position: absolute;\n  border: 1px solid #929FB0;\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.1019607843);\n  height: auto;\n  min-height: 253px;\n  width: 825px;\n  background: white;\n  top: 150px;\n  border-radius: 10px;\n  z-index: 99;\n}\n.LoanProgress .tab-open-content .content-bar-status {\n  width: 823px;\n  height: 68px;\n  background: white;\n  border-radius: 10px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: start;\n  gap: 8px;\n  padding-left: 8px;\n  padding-top: 3px;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab .body-small {\n  font-size: 12px !important;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab-error span {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-bar-status .bar-status {\n  width: -webkit-fill-available;\n  height: 16px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.LoanProgress .tab-open-content .content-bar-status .bar-status .text-status {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n}\n.LoanProgress .tab-open-content .content-bar-status .bar-status .text-status span {\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 600;\n}\n.LoanProgress .tab-open-content .content-bar-status .bar-status:hover span {\n  display: none;\n}\n.LoanProgress .tab-open-content .content-bar-status .bar-status:hover .text-status {\n  display: none;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab {\n  margin: 0 0;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(1) {\n  width: 10%;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(2) {\n  width: 22%;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(3) {\n  width: 38%;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(4) {\n  width: 14%;\n}\n.LoanProgress .tab-open-content .content-bar-status .tab:nth-child(5) {\n  width: 11%;\n}\n.LoanProgress .tab-open-content .content-phase-select {\n  width: 823px;\n  height: auto;\n  min-height: 183px;\n  border-radius: 10px;\n  background: #F9FAFB;\n  border-top: 1px solid #DFE4EB;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete {\n  background: #F8FFF8;\n  border-top: 1px solid #C2F0C5;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete .tag-state {\n  background: #C2F0C5;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete .tag-state b,\n.LoanProgress .tab-open-content .content-phase-select-complete .tag-state span {\n  color: #141F15;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete .content-phase b {\n  color: #1F4222;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete .content-phase p {\n  color: #1F4222 !important;\n}\n.LoanProgress .tab-open-content .content-phase-select-complete .content-phase-first b {\n  color: #2D7032;\n}\n.LoanProgress .tab-open-content .content-phase-select-blocked {\n  background: #FCF8F7;\n  border-top: 1px solid #FFC6BF;\n}\n.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state {\n  background: #FFD4CF;\n}\n.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state b,\n.LoanProgress .tab-open-content .content-phase-select-blocked .tag-state span {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-phase-select-blocked .content-phase b {\n  color: #2A2F3C;\n}\n.LoanProgress .tab-open-content .content-phase-select-blocked .content-phase-first b {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-phase-select-error {\n  background: #FCF8F7;\n  border-top: 1px solid #FFC6BF;\n}\n.LoanProgress .tab-open-content .content-phase-select-error .tag-state {\n  background: #FFD4CF;\n}\n.LoanProgress .tab-open-content .content-phase-select-error .tag-state b,\n.LoanProgress .tab-open-content .content-phase-select-error .tag-state span {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-phase-select-error .content-phase b {\n  color: #2A2F3C;\n}\n.LoanProgress .tab-open-content .content-phase-select-error .content-phase-first b {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-phase-select-progress {\n  background: #F5FAFF;\n  border-top: 1px solid #B6DCFC;\n}\n.LoanProgress .tab-open-content .content-phase-select-progress .tag-state {\n  background: #B6DCFC;\n}\n.LoanProgress .tab-open-content .content-phase-select-progress .tag-state b,\n.LoanProgress .tab-open-content .content-phase-select-progress .tag-state span {\n  color: #122536;\n}\n.LoanProgress .tab-open-content .content-phase-select-progress .content-phase b {\n  color: #2A2F3C;\n}\n.LoanProgress .tab-open-content .content-phase-select-progress .content-phase-first b {\n  color: #244560;\n}\n.LoanProgress .tab-open-content .content-phase-select-not-started .tag-state {\n  border: 1px solid #404859;\n}\n.LoanProgress .tab-open-content .content-phase-select .tag-state {\n  height: 16px;\n  width: max-content;\n  display: flex;\n  align-items: center;\n  gap: 3.5px;\n  border-radius: 10px;\n  padding: 3px 7px;\n  margin: 16px 23px;\n}\n.LoanProgress .tab-open-content .content-phase-select .tag-state b {\n  font-size: 10px;\n  font-weight: 600;\n}\n.LoanProgress .tab-open-content .content-phase-select .tag-state span {\n  font-size: 10px;\n  font-weight: 400;\n}\n.LoanProgress .tab-open-content .content-phase-select .divider {\n  border: 0.7px solid #929FB0;\n  height: auto;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase {\n  margin: 0px 24px;\n  padding-bottom: 23px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase b {\n  font-size: 12px;\n  font-weight: 600;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase p {\n  font-size: 12px;\n  font-weight: 400;\n  color: #2A2F3C;\n  margin-top: 6px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase-first {\n  width: 270px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase-first b {\n  font-size: 16px;\n  font-weight: 600;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase-second {\n  width: 240px;\n  margin-left: 20px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 4px;\n  width: max-content;\n  border-radius: 4px;\n  padding: 2px 3px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item span {\n  font-family: Inter;\n  font-size: 12px;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item b {\n  font-family: Inter;\n  font-weight: 500;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item .bold {\n  font-weight: 600 !important;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item .circle {\n  width: 12px;\n  height: 12px;\n  border: 1px solid #6E7889;\n  border-radius: 50%;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED {\n  background-color: #D5F7E2;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED span,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED b,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED strong {\n  color: #2D7032;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR, .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED {\n  background: #FFC6BF;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR span,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR b,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR strong, .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED span,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED b,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED strong {\n  color: #610805;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW {\n  background: #F7EDFC;\n}\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW span,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW b,\n.LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW strong {\n  color: #855791;\n}\n\n.borrowers {\n  padding: 24px 25px;\n}\n.borrowers .dropdown-review-bold {\n  color: #AC78B3 !important;\n  height: 26px;\n  display: unset;\n  padding: 0 !important;\n}\n.borrowers .dropdown-review-bold span {\n  font-weight: 600;\n  text-decoration-line: underline;\n}\n.borrowers .top-container {\n  box-sizing: content-box;\n  width: 100%;\n  margin-bottom: 33px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: space-between;\n}\n.borrowers .top-container .title {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.borrowers .top-container .title > span {\n  cursor: pointer;\n  color: var(--blue60, #5E8EB7);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-decoration-line: underline;\n}\n.borrowers .badges-container {\n  display: flex;\n}\n.borrowers-container {\n  padding: 16px 0px;\n}\n.borrowers-container > * {\n  margin-bottom: 16px;\n}\n.borrowers-container > *:last-child {\n  margin-bottom: 0px;\n}\n\n.search-box {\n  cursor: pointer;\n  box-sizing: border-box;\n  width: 384px;\n  padding: 5px 18px 5px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--gray-100, #F9FAFB);\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 120%;\n}\n.search-box > input {\n  all: unset;\n  width: 100%;\n  margin-left: 8px;\n}\n\n.status-badge {\n  cursor: pointer;\n  padding: 4px 12px;\n  border-radius: 100px;\n  display: flex;\n  align-items: center;\n  background: var(--300-grey, #DFE4EB);\n  margin-right: 12px;\n}\n.status-badge .title {\n  margin-right: 4px;\n  color: var(--800-grey, #404859);\n  text-align: right;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px; /* 133.333% */\n  white-space: nowrap;\n}\n.status-badge .count {\n  color: var(--800-grey, #404859);\n  text-align: right;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px; /* 133.333% */\n}\n.status-badge.selected {\n  background: #355C7D;\n}\n.status-badge.selected .title, .status-badge.selected .count {\n  color: #FFFFFF;\n}\n\n.borrower-list-item {\n  cursor: pointer;\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 8px 24px 8px 16px;\n  border-radius: 10px;\n  border: 1px solid var(--600-grey, #929FB0);\n  background: var(--white, #FFF);\n}\n.borrower-list-item > * {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.borrower-list-item > *.loan-status-badge-container {\n  flex: 0.8;\n}\n.borrower-list-item > *.borrower-summary-container {\n  flex: 0.5;\n}\n.borrower-list-item .loan-status-badge {\n  display: inline-block;\n  border-radius: 76px;\n  border: 1px solid var(--blue60, #5E8EB7);\n  padding: 4px 7px;\n  color: var(--70, #48759A);\n  text-align: center;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.2px;\n  text-transform: uppercase;\n}\n.borrower-list-item .borrower-summary .caption {\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 115%;\n  text-transform: capitalize;\n  margin-bottom: 2px;\n}\n.borrower-list-item .borrower-summary .borrower-name {\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 115%;\n  text-transform: capitalize;\n}\n.borrower-list-item .entities-summary .caption {\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 115%;\n  text-transform: capitalize;\n  margin-bottom: 2px;\n}\n.borrower-list-item .entities-summary .content {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 115%;\n  text-transform: capitalize;\n  white-space: nowrap;\n  display: flex;\n  gap: 3px;\n  align-items: center;\n}\n.borrower-list-item .task-summary {\n  padding-left: 10px;\n  display: flex;\n  flex-direction: column;\n}\n.borrower-list-item .task-summary .caption {\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 115%;\n  text-transform: capitalize;\n  margin-bottom: 2.5px;\n}\n.borrower-list-item .task-summary .task-item-container {\n  display: flex;\n  gap: 9px;\n}\n.borrower-list-item .task-summary .task-item-container .task-item {\n  box-sizing: border-box;\n  height: 15px;\n  width: 15px;\n  border-radius: 100px;\n  margin-right: 8px;\n  background-color: #DFE4EB;\n  border: 1.5px solid #CCD3DB;\n}\n.borrower-list-item .task-summary .task-item-container .task-item.completed {\n  background-color: #4CA852;\n  border: unset;\n}\n.borrower-list-item .task-summary .task-item-container .task-item.review {\n  background-color: #855791;\n  border: unset;\n}\n.borrower-list-item .action-container {\n  color: var(--blue60, #5E8EB7);\n  text-align: right;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  white-space: nowrap;\n  align-self: flex-end;\n}\n.borrower-list-item:hover {\n  border-radius: 10px;\n  border: 1px solid var(--blue-40, #97BCF0);\n  background: var(--10, #F5FAFF);\n  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n}\n.borrower-list-item:hover .borrower-summary .caption {\n  color: var(--70, #48759A);\n}\n.borrower-list-item:hover .borrower-summary .borrower-name {\n  color: var(--90, #244560);\n}\n.borrower-list-item:hover .address-summary .caption {\n  color: var(--70, #48759A);\n}\n.borrower-list-item:hover .address-summary .address {\n  color: var(--blue-80, #355C7D);\n}\n.borrower-list-item:hover .task-summary .caption {\n  color: var(--70, #48759A);\n}\n.borrower-list-item:hover .action-container {\n  color: var(--70, #48759A);\n  font-weight: 600;\n}\n.borrower-list-item:hover .action-container:hover {\n  color: var(--90, #244560);\n  font-weight: 700;\n}\n\n.right-scenes {\n  position: fixed;\n  background: rgba(42, 47, 60, 0.55);\n  backdrop-filter: blur(2px);\n  top: 0;\n  left: 70px;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.right-scenes-content {\n  position: relative;\n  width: calc(100% - 70px); /* Ancho de la pantalla menos 70px */\n  background-color: #fff;\n  height: 100%;\n  animation: slideIn 1s forwards;\n}\n@keyframes slideIn {\n  from {\n    transform: translateX(calc(-100% + 70px));\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n.right-scenes .button-close-mask {\n  width: 30%;\n  height: 100%;\n  background-color: rgba(255, 0, 0, 0);\n  box-shadow: none;\n  border: none;\n}\n.right-scenes .button-close-mask:hover, .right-scenes .button-close-mask:active, .right-scenes .button-close-mask:focus {\n  background-color: rgba(255, 0, 0, 0);\n  box-shadow: none;\n  border: none;\n}\n\n.view-borrower-detail {\n  padding: 50px 15px;\n}\n.view-borrower-detail-header .title {\n  color: #404859;\n  font-size: 32px;\n  font-weight: 600;\n  gap: 5px;\n}\n.view-borrower-detail-header .title button {\n  height: 32px;\n}\n.view-borrower-detail-header .title button span {\n  font-size: 32px;\n}\n.view-borrower-detail .button-r,\n.view-borrower-detail .button-r:hover {\n  width: 58px;\n  height: 20px;\n  border: 1px solid #bb8d2f;\n  color: #bb8d2f;\n  border-radius: 76px;\n  padding: 0;\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 12.1px;\n  margin: 0 15px;\n}\n.view-borrower-detail .button-delete,\n.view-borrower-detail .button-delete:hover {\n  height: 20px;\n  border: none;\n  color: #c94f4a;\n  padding: 0;\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 12.1px;\n  margin: 0 15px;\n}\n.view-borrower-detail .flex-2-col {\n  display: flex;\n  margin-top: 20px;\n  justify-content: space-between;\n  width: 100%;\n  gap: 30px;\n}\n.view-borrower-detail .flex-2-col .box {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 50%;\n}\n.view-borrower-detail .gap-3 {\n  gap: 6px;\n}\n.view-borrower-detail .card-profile-generic {\n  border: 1px solid #afbdcc;\n  border-radius: 10px;\n  padding: 15px;\n  width: 100%;\n}\n.view-borrower-detail .card-profile-generic .card-title {\n  font-family: Inter;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 29.05px;\n  text-align: left;\n}\n.view-borrower-detail .card-profile-generic .table {\n  width: 100%;\n  margin-top: 10px;\n}\n.view-borrower-detail .card-profile-generic .table-row {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  margin-bottom: 7px;\n}\n.view-borrower-detail .card-profile-generic .table-row .title {\n  font-family: Inter;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14.52px;\n  text-align: left;\n  color: #6e7889;\n}\n.view-borrower-detail .card-profile-generic .table-row .flex {\n  display: flex;\n  justify-content: space-between;\n}\n.view-borrower-detail .card-profile-generic .table-row .flex .col {\n  width: 50%;\n}\n.view-borrower-detail .card-profile-generic .table-row .flex .col .italic {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 16.94px;\n  text-align: left;\n  color: #929fb0;\n}\n.view-borrower-detail .card-profile-generic .avatar .ant-avatar-string {\n  font-size: 25px;\n}\n.view-borrower-detail .card-profile-generic .avatar .ant-upload {\n  width: 68px !important;\n  height: 68px !important;\n}\n.view-borrower-detail .card-profile-generic .ant-upload-wrapper.ant-upload-picture-circle-wrapper {\n  width: auto;\n}\n.view-borrower-detail .card-profile-generic .title-bold {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16.94px;\n  text-align: left;\n  color: #404859;\n}\n.view-borrower-detail .card-profile-generic .title-bold .bold {\n  font-weight: 600;\n}\n.view-borrower-detail .card-profile-generic .body-bold {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16.94px;\n  text-align: right;\n}\n.view-borrower-detail .card-profile-generic .button-transparent,\n.view-borrower-detail .card-profile-generic .button-transparent:hover {\n  padding: 0;\n  height: 20px;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16.94px;\n  text-align: left;\n  color: #8a130f;\n}\n.view-borrower-detail .card-profile-generic .button-round {\n  width: 75px;\n  height: 20px;\n  padding: 0;\n  border-radius: 76px;\n  border: 2px solid #404859;\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 600;\n}\n.view-borrower-detail .card-profile-generic .button-edit,\n.view-borrower-detail .card-profile-generic .button-edit:hover {\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  text-align: left;\n  color: #5e8eb7;\n}\n.view-borrower-detail .card-profile-generic .button-edit .edit,\n.view-borrower-detail .card-profile-generic .button-edit:hover .edit {\n  width: 10px;\n  height: 10px;\n  margin-right: 3px;\n}\n.view-borrower-detail .card-profile-generic .link {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16.94px;\n  text-align: left;\n  color: #5e8eb7;\n  text-decoration: none;\n}\n.view-borrower-detail .card-profile-generic .link .arrow {\n  width: 15px;\n  margin-left: 5px;\n}\n.view-borrower-detail .card-profile-generic .text-footer {\n  font-family: Inter;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14.52px;\n  text-align: left;\n  color: #6e7889;\n  margin-top: 14px;\n}\n.view-borrower-detail .card-profile-generic .text-footer span {\n  color: #4e8aff;\n}\n.view-borrower-detail .card-report {\n  position: relative;\n}\n.view-borrower-detail .card-report .button span {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 19.36px;\n  letter-spacing: 0.015em;\n  text-align: center;\n}\n.view-borrower-detail .card-report .button-edit {\n  position: absolute;\n  top: 8px;\n  right: 15px;\n}\n.view-borrower-detail .card-report .button-edit span {\n  font-family: Inter;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  text-align: left;\n  color: #5e8eb7;\n}\n.view-borrower-detail .card-report-head {\n  display: flex;\n  justify-content: space-between;\n}\n.view-borrower-detail .card-report .date-expires {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 16.94px;\n  text-align: right;\n  color: #6E7889;\n}\n.view-borrower-detail .card-report .upload-report-span {\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16.94px;\n  text-align: right;\n  color: #5E8EB7;\n  text-decoration: underline;\n}\n.view-borrower-detail .card-report .credit-score-input input {\n  text-align: end;\n}\n\n.loan-details {\n  padding: 43px 40px;\n  overflow: hidden;\n}\n.loan-details .loan-details-top-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #929FB0;\n  margin-bottom: 22px;\n}\n.loan-details .loan-details-top-bar .loan-info {\n  margin-bottom: 2px;\n}\n.loan-details .loan-details-top-bar .loan-info .loan-borrower-name {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px; /* 133.333% */\n  letter-spacing: 0.24px;\n  text-transform: uppercase;\n}\n.loan-details .loan-details-top-bar .loan-info .loan-address {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 16px;\n  letter-spacing: 0.24px;\n  text-transform: uppercase;\n}\n.loan-details .loan-details-top-bar .close-button-container {\n  cursor: pointer;\n  color: var(--800-grey, #404859);\n  text-align: right;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px; /* 133.333% */\n  letter-spacing: 0.24px;\n  text-transform: uppercase;\n}\n.loan-details .loan-details-first-row {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: solid 1px #CCD3DB;\n  margin-bottom: 16px;\n}\n.loan-details .loan-details-first-row .loan-progress {\n  flex: 6;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-info .loan-status {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: 0.36px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: 0.36px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date b {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.36px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-address {\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 40px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-progress-section {\n  margin-bottom: 20px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container {\n  display: flex;\n  flex-direction: row;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container > * {\n  flex: 1;\n  margin-right: 8px;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container .loan-progress-item-caption {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  white-space: nowrap;\n  margin-bottom: 6px;\n  flex: 0.13;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-values-summary {\n  margin-bottom: 8px;\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 115%;\n}\n.loan-details .loan-details-first-row .loan-progress .loan-values-summary span {\n  cursor: pointer;\n  color: var(--blue60, #5E8EB7);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 115%;\n}\n.loan-details .loan-details-first-row .placeholder {\n  flex: 3;\n}\n.loan-details .loan-details-first-row .borrower-card {\n  flex: 1;\n}\n.loan-details .loan-details-main {\n  display: flex;\n}\n.loan-details .loan-details-main > * {\n  flex: 1;\n  box-sizing: border-box;\n}\n.loan-details .loan-details-main .left-column {\n  padding-right: 15px;\n}\n.loan-details .loan-details-main .left-column > * {\n  margin-bottom: 16px;\n}\n.loan-details .loan-details-main .left-column > *:last-of-type {\n  margin-bottom: 0px;\n}\n.loan-details .loan-details-main .left-column .loan-summary {\n  display: flex;\n  justify-content: space-between;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing {\n  flex: 1;\n  border-radius: 10px;\n  border: 1px solid var(--500-grey, #AFBDCC);\n  padding: 16px 20px;\n  margin-right: 16px;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .label {\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 18px;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar {\n  width: 128px;\n  border-radius: 10px;\n  border: 1px solid var(--blue60, #5E8EB7);\n  background: var(--10, #F5FAFF);\n  margin-bottom: 8px;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled {\n  border: 1px solid var(--600-grey, #929FB0);\n  background: var(--200-grey, #EFF3F5);\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .date {\n  color: var(--70, #48759A);\n  border-bottom: 1px solid #929FB0;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .day {\n  color: var(--300-grey, #DFE4EB);\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar .date {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 26px;\n  border-bottom: 1px solid #5E8EB7;\n  color: var(--70, #48759A);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px; /* 114.286% */\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .calendar .day {\n  height: 68px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--blue-80, #355C7D);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .caption {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.loan-details .loan-details-main .left-column .loan-summary .closing .caption b {\n  font-weight: 600;\n  color: #404859;\n}\n.loan-details .loan-details-main .left-column .loan-summary .content-box {\n  flex: 5;\n}\n.loan-details .loan-details-main .right-column {\n  padding-left: 15px;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks > .title {\n  margin-bottom: 8px;\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 40px;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-status-container {\n  display: flex;\n  margin-bottom: 16px;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 7px;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  margin-left: 16px;\n  color: var(--700-grey, #6E7889);\n  text-align: right;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n  text-transform: uppercase;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div svg {\n  position: relative;\n}\n.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-list {\n  margin-bottom: 17px;\n}\n.loan-details .loan-details-main .right-column .action-button {\n  border: 1px solid var(--100, #162E43);\n  background: var(--100, #162E43);\n  text-align: center;\n  border-radius: 6px;\n  padding: 14px 0px;\n  margin-bottom: 30px;\n  color: var(--10, #F5FAFF);\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n}\n.loan-details .loan-details-main .right-column .action-button:hover {\n  background-color: #EBF6FF !important;\n  border-color: #EBF6FF !important;\n  color: #355D7D !important;\n}\n.loan-details .loan-details-main .right-column .loan-documents > .title {\n  margin-bottom: 8px;\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 40px;\n}\n.loan-details .loan-details-main .right-column .approve-loan {\n  padding: 14px 0px;\n  text-align: center;\n  border-radius: 6px;\n  border: 1px solid var(--300-grey, #DFE4EB);\n  background: var(--300-grey, #DFE4EB);\n  color: var(--600-grey, #929FB0);\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n}\n\n.loan-progress-item .caption {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  white-space: nowrap;\n  text-align: center;\n  margin-bottom: 4px;\n}\n.loan-progress-item .loan-progress-bar {\n  width: 100%;\n  height: 6px;\n  border-radius: 16px;\n  background: var(--300-grey, #DFE4EB);\n}\n\n.content-box {\n  border-radius: 10px;\n  border: 1px solid var(--500-grey, #AFBDCC);\n  padding: 16px 20px;\n}\n.content-box .label {\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 10px;\n}\n.content-box .content {\n  border-left: 1px solid #97BCF0;\n  padding: 2px 0px;\n  padding-left: 12px;\n}\n.content-box .content .item {\n  margin-bottom: 8px;\n}\n.content-box .content .item:last-of-type {\n  margin-bottom: 0px;\n}\n.content-box .content .item-row {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.content-box .content .item-row .value i {\n  color: var(--700-grey, #6E7889);\n}\n.content-box .content .item-row .value span {\n  cursor: pointer;\n  color: var(--blue60, #5E8EB7);\n  text-align: right;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.content-box .content .item-row.extra {\n  margin-top: 8px;\n  padding-left: 16px;\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: normal;\n}\n.content-box .content .item-row.extra .value {\n  color: var(--700-grey, #6E7889);\n}\n\n.document-item {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 11px 16px;\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--white, #FFF);\n  margin-bottom: 12px;\n}\n.document-item-COMPLETE {\n  border-radius: 10px;\n  border: 1px solid var(--green-60, #4CA852);\n  background: #FAFCFC;\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n}\n.document-item-COMPLETE .label {\n  color: var(--green-90, #1F4222);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.document-item-COMPLETE svg:not(.trash) path {\n  stroke: #1F4222;\n}\n.document-item-COMPLETE .status-badge {\n  background: var(--30, #C2F0C5);\n  color: var(--100, #141F15);\n}\n.document-item-VERIFY\\/UPDATE {\n  border-radius: 10px;\n  border: 1px solid var(--60, #C59ED5);\n  background: var(--10, #FAF9FC);\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n}\n.document-item-VERIFY\\/UPDATE .label {\n  color: var(--90, #653B6F);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.document-item-VERIFY\\/UPDATE svg:not(.trash) path {\n  stroke: var(--90, #653B6F);\n}\n.document-item-VERIFY\\/UPDATE .status-badge {\n  background: #EAD6FF;\n  color: var(--100, #141F15);\n}\n.document-item-UPLOAD {\n  border-radius: 10px;\n  border: 1px solid #C13934;\n  background: #FAFCFC;\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n}\n.document-item-UPLOAD .label {\n  color: #610805;\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.document-item-UPLOAD svg:not(.trash) path {\n  stroke: #610805;\n}\n.document-item-UPLOAD .status-badge {\n  background: #FFC6BF;\n  color: var(--100, #141F15);\n}\n.document-item-DRAFT svg:not(.trash) path {\n  stroke: #929FB0;\n}\n.document-item-DRAFT svg.trash path {\n  stroke: #FFC6BF;\n}\n.document-item-DRAFT .label {\n  color: var(--600-grey, #929FB0);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.document-item-DRAFT .status-badge {\n  background: var(--30, #EFF3F5);\n  color: var(--100, #404859);\n}\n.document-item svg {\n  height: 16px;\n  width: 16px;\n  margin-right: 8px;\n}\n.document-item svg:last-of-type {\n  margin-right: 0px;\n}\n.document-item .actions-container {\n  display: flex;\n  gap: 8px;\n  width: 40px;\n}\n.document-item .actions-container .disabled {\n  opacity: 0.3;\n  cursor: auto;\n}\n.document-item .label {\n  width: 20em;\n  font-size: 22px;\n  display: flex;\n  align-items: center;\n}\n.document-item .label .expires-label {\n  margin-left: 24px;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 400;\n  text-align: left;\n}\n.document-item .label .expires-label-error {\n  color: #E56A5C !important;\n}\n.document-item .label .expires-label-approved {\n  color: #3F9545 !important;\n}\n.document-item .feedback-actions-container {\n  display: flex;\n  align-items: start;\n}\n.document-item .feedback-actions-container .action-blocked-disabled {\n  opacity: 0.3;\n  cursor: auto;\n}\n.document-item .feedback-actions-container .action-blocked-blocked svg {\n  fill: #FFC6BF;\n}\n.document-item .feedback-actions-container .action-blocked-blocked svg:not(.trash) path {\n  stroke: #610805;\n}\n.document-item .content-right {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  justify-content: end;\n  width: 50%;\n}\n.document-item .content-right .document-state {\n  width: 200px;\n  display: flex;\n  justify-content: end;\n}\n.document-item .expand {\n  flex: 0.2;\n}\n\n.borrower-card {\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  background: var(--gray-100, #F9FAFB);\n  height: 112px;\n  padding: 7px 14px;\n}\n.borrower-card .borrower-summary {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 256px;\n  position: relative;\n  bottom: 8px;\n}\n.borrower-card .borrower-summary .photo-container {\n  position: absolute;\n  top: -8px;\n  border-radius: 24px;\n  background: lightgray 50%;\n  margin-bottom: 4px;\n}\n.borrower-card .borrower-summary .borrower-caption {\n  margin-top: 22px;\n  color: var(--700-grey, #6E7889);\n  text-align: center;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-transform: uppercase;\n}\n.borrower-card .borrower-summary .borrower-name {\n  color: var(--900-grey, #2A2F3C);\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.borrower-card .contact-info-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 8px;\n}\n.borrower-card .buttons-container {\n  width: 100%;\n}\n.borrower-card .buttons-container > *:first-child {\n  margin-right: 8px;\n}\n.borrower-card .buttons-container .button-blue {\n  width: 100%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--100, #122536);\n  text-align: center;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.15px;\n  height: 24px;\n  padding: 0px 6px;\n  border-radius: 6px;\n  border: 1px solid var(--100, #162E43);\n  background: var(--100, #122536);\n}\n.borrower-card .buttons-container .button-blue:hover {\n  color: var(--100, #122536) !important;\n}\n.borrower-card .buttons-container .button-blue.outlined {\n  color: var(--100, #122536);\n  background: #FFF;\n}\n\n.borrower-task-item {\n  display: flex;\n  flex-direction: column;\n  padding: 11px 16px;\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--white, #FFF);\n  margin-bottom: 12px;\n}\n.borrower-task-item .row-1 {\n  display: flex;\n  align-items: center;\n}\n.borrower-task-item .row-1 .actions-container {\n  width: 40px;\n  display: flex;\n  gap: 8px;\n}\n.borrower-task-item .row-1 .actions-container img, .borrower-task-item .row-1 .actions-container svg {\n  cursor: pointer;\n}\n.borrower-task-item .row-1 .label {\n  margin-left: 10px;\n  width: 20em;\n}\n.borrower-task-item .row-1 .feedback-actions-container {\n  display: flex;\n  width: 20px;\n  max-width: 5em;\n}\n.borrower-task-item .row-1 .feedback-actions-container svg {\n  cursor: pointer;\n}\n.borrower-task-item .row-1 .content-right {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  justify-content: end;\n  width: 50%;\n}\n.borrower-task-item .row-1 .content-right .content-status {\n  width: 150px;\n  display: flex;\n  justify-content: end;\n}\n.borrower-task-item .row-1 .expand {\n  width: 20px;\n}\n.borrower-task-item svg {\n  height: 16px;\n  width: 16px;\n  margin-right: 8px;\n}\n.borrower-task-item svg:last-of-type {\n  margin-right: 0px;\n}\n.borrower-task-item svg:not(.trash) path {\n  stroke: #2A2F3C;\n}\n.borrower-task-item .label {\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.borrower-task-item .status-badge {\n  background: var(--30, #404859);\n}\n.borrower-task-item .status-badge .title {\n  color: var(--100, #FFFFFF);\n}\n.borrower-task-item.DRAFT svg:not(.trash) path {\n  stroke: #404859;\n}\n.borrower-task-item.DRAFT .status-badge {\n  border: 1px solid var(--60, #404859);\n  background: var(--30, #FFFFFF);\n}\n.borrower-task-item.DRAFT .status-badge .title {\n  color: var(--100, #404859);\n}\n.borrower-task-item.REVIEW {\n  border: 1px solid var(--60, #C59ED5);\n  background: var(--10, #FAF9FC);\n}\n.borrower-task-item.REVIEW .label {\n  color: var(--90, #653B6F);\n}\n.borrower-task-item.REVIEW svg:not(.trash) path {\n  stroke: #653B6F;\n}\n.borrower-task-item.REVIEW .status-badge {\n  background: var(--30, #EAD6FF);\n}\n.borrower-task-item.REVIEW .status-badge .title {\n  color: var(--100, #241226);\n}\n.borrower-task-item.REVIEW .liquidity-info .title {\n  color: #653B6F !important;\n}\n.borrower-task-item.REVIEW .liquidity-info .max {\n  color: #653B6F;\n}\n.borrower-task-item.REVIEW .box-message-state-review {\n  margin-top: 10px;\n  margin-left: 60px;\n  margin-right: 28px;\n  padding: 5px 8px;\n  background-color: #FDFCFF;\n  color: #855791;\n  border: 1px solid #D7B8E5;\n}\n.borrower-task-item.REVIEW .box-message-state-review span {\n  font-size: 12px;\n  font-weight: 400;\n}\n.borrower-task-item.REVIEW .box-message-state-review b {\n  font-size: 12px;\n  font-weight: 700;\n}\n.borrower-task-item.REVIEW .box-message-state-review button {\n  height: auto;\n  padding: 0px;\n}\n.borrower-task-item.REVIEW .box-message-state-review button span {\n  text-decoration: underline;\n  color: #855791;\n  font-size: 12px;\n}\n.borrower-task-item.REVIEW .box-message-state-review button svg {\n  width: 12px;\n  height: 12px;\n}\n.borrower-task-item.REVIEW .box-message-state-review button .anticon {\n  margin-inline-start: 5px;\n}\n.borrower-task-item.REVIEW .box-message-state-review .button-bold span {\n  font-weight: 600;\n  text-decoration: none;\n}\n.borrower-task-item.REQUEST_ERROR {\n  border: 1px solid var(--60, #C13934);\n  background: var(--10, #FFFFFF);\n}\n.borrower-task-item.REQUEST_ERROR .label {\n  color: var(--90, #610805);\n}\n.borrower-task-item.REQUEST_ERROR svg:not(.trash) path {\n  stroke: #610805;\n}\n.borrower-task-item.REQUEST_ERROR .status-badge {\n  background: var(--30, #FFC6BF);\n}\n.borrower-task-item.REQUEST_ERROR .status-badge .title {\n  color: var(--100, #241226);\n}\n.borrower-task-item.APPROVED {\n  border: 1px solid var(--60, #4CA852);\n  background: var(--10, #FAFCFC);\n}\n.borrower-task-item.APPROVED .label {\n  color: var(--90, #1F4222);\n}\n.borrower-task-item.APPROVED svg:not(.trash) path {\n  stroke: #1F4222;\n}\n.borrower-task-item.APPROVED .status-badge {\n  background: var(--30, #C2F0C5);\n}\n.borrower-task-item.APPROVED .status-badge .title {\n  color: var(--100, #241226);\n}\n.borrower-task-item .liquidity-info {\n  margin-top: 10px;\n  margin-left: 55px;\n}\n.borrower-task-item .liquidity-info .label {\n  font-weight: 500;\n  font-size: 12px;\n}\n.borrower-task-item .liquidity-info .max {\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.cont-modal {\n  width: 100%;\n}\n\n.ModalTask {\n  position: fixed;\n  background: rgba(42, 47, 60, 0.55);\n  backdrop-filter: blur(2px);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 300;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ModalTask .content-add {\n  margin-top: 50px;\n}\n.ModalTask-content {\n  width: 70%;\n  background-color: #fff;\n  height: 100%;\n}\n.ModalTask .button-close-mask {\n  width: 30%;\n  height: 100%;\n  background-color: rgba(255, 0, 0, 0);\n  box-shadow: none;\n  border: none;\n}\n.ModalTask .button-close-mask:hover, .ModalTask .button-close-mask:active, .ModalTask .button-close-mask:focus {\n  background-color: rgba(255, 0, 0, 0);\n  box-shadow: none;\n  border: none;\n}\n.ModalTask .content-modal {\n  padding-bottom: 0;\n}\n.ModalTask .content-modal .modal-title {\n  width: 100%;\n  padding: 40px;\n  padding-bottom: 0;\n}\n.ModalTask .content-modal .modal-title .flex-btw {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  border-bottom: 1px solid #929fb0;\n}\n.ModalTask .content-modal .modal-title button,\n.ModalTask .content-modal .modal-title button:hover,\n.ModalTask .content-modal .modal-title button:active,\n.ModalTask .content-modal .modal-title button:focus {\n  background-color: transparent;\n  border: none !important;\n  padding: 0 !important;\n  box-shadow: none !important;\n  color: #404859 !important;\n}\n.ModalTask .content-modal .modal-title .body-card {\n  color: #404859;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px; /* 133.333% */\n  letter-spacing: 0.24px;\n}\n.ModalTask .content-modal .modal-container {\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  height: calc(100vh - 180px);\n}\n.ModalTask .content-modal .modal-container .dots {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 45%;\n  left: 30px;\n  gap: 9px;\n}\n.ModalTask .content-modal .modal-container .dots-button {\n  padding: 0;\n  border: 1.5px solid #6e7889;\n  background: #fff;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n.ModalTask .content-modal .modal-container .dots-button-success {\n  border: 1px solid #6EAC72;\n  background: #C5F0C8;\n}\n.ModalTask .content-modal .modal-container .dots-button-active {\n  height: 25px;\n  width: 25px;\n  border: 2px dotted #ddaa42;\n}\n.ModalTask .content-modal .modal-container .dots-button-review-active {\n  height: 25px;\n  width: 25px;\n  border: 2px dotted #ddaa42;\n  background: #e3ddf0;\n}\n.ModalTask .content-modal .modal-container .modal-title {\n  border-bottom: 0;\n  align-items: flex-end;\n}\n.ModalTask .content-modal .modal-container .modal-title button {\n  height: 18px;\n  text-transform: uppercase;\n  color: #8a5791 !important;\n}\n.ModalTask .content-modal .modal-container .modal-title button img {\n  margin-top: -0.9px;\n  margin-right: 3px;\n}\n.ModalTask .content-modal .modal-container .text {\n  margin-top: 5px;\n}\n.ModalTask .content-modal .modal-container .text a {\n  margin-left: 6px;\n}\n.ModalTask .content-modal .modal-container .text a:hover {\n  color: #2a2f3c;\n}\n.ModalTask .content-modal .modal-container .modal-cards {\n  width: 100%;\n  height: 100%;\n  padding-bottom: 20px;\n  padding-top: 64px;\n  overflow: auto;\n  padding-right: 10px;\n  max-width: 576px;\n  /* Track */\n  /* Handle */\n  /* Handle on hover */\n}\n.ModalTask .content-modal .modal-container .modal-cards--full {\n  max-width: none;\n  display: flex;\n  justify-content: center;\n}\n.ModalTask .content-modal .modal-container .modal-cards-mx-w {\n  max-width: 576px;\n  width: 100%;\n  padding-bottom: 20px;\n}\n.ModalTask .content-modal .modal-container .modal-cards .flex-btw {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 12px;\n}\n.ModalTask .content-modal .modal-container .modal-cards .flex-btw .button {\n  text-transform: uppercase;\n  color: #404859;\n  text-align: right;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 120%;\n  text-transform: uppercase;\n}\n.ModalTask .content-modal .modal-container .modal-cards .flex-btw .button .anticon {\n  color: #404859;\n}\n.ModalTask .content-modal .modal-container .modal-cards .title {\n  background: #e3ddf0;\n  border-radius: 140px;\n  display: flex;\n  padding: 5px 12px 5px 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.ModalTask .content-modal .modal-container .modal-cards .title .body-regular {\n  color: #48244d;\n}\n.ModalTask .content-modal .modal-container .modal-cards .h2 {\n  margin-top: 12px;\n}\n.ModalTask .content-modal .modal-container .modal-cards .h2-w8 {\n  color: #ac78b3;\n}\n.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar {\n  width: 8px;\n  border-radius: 5px;\n}\n.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 5px;\n}\n.ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n.ModalTask .modal-review-task__footer {\n  border-top: 1px solid #dfe4eb;\n  height: 180px;\n}\n.ModalTask .modal-review-task__footer .text-footer .placeholder {\n  color: #6e7889;\n}\n.ModalTask .modal-review-task__footer .text-footer .placeholder span {\n  color: #f5faff;\n  font-weight: 600;\n  background-color: #5e8eb7;\n  padding: 0 5px;\n  border-radius: 3px;\n}\n.ModalTask .modal-review-task__footer .footer-grey .h4 {\n  color: #6e7889;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 170%;\n}\n.ModalTask .modal-review-task__footer .body-regular {\n  color: #6e7889;\n}\n.ModalTask .modal-review-task__footer .footer_dost {\n  align-items: center;\n}\n.ModalTask .modal-review-task__footer .footer_dost .body-regular {\n  color: #404859;\n}\n.ModalTask .modal-review-task__footer .footer_dost .circles {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n}\n.ModalTask .modal-review-task__footer .footer_dost .circles .circle {\n  border-radius: 64px;\n  border: 1px solid #404859;\n  width: 20px;\n  height: 20px;\n}\n.ModalTask .modal-review-task__footer .modal-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  height: 100%;\n  padding-right: 15px;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards {\n  width: 100%;\n  height: 100%;\n  max-width: 576px;\n  padding: 14px 0;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .h4-w4 {\n  color: #ac78b3;\n  margin-bottom: 10px;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .h4-w4 .h4 {\n  color: #6e7889;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle {\n  border-radius: 100%;\n  border: 1px solid #8a5791;\n  background: #dfb8e5;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle-active {\n  border: 1px solid #587e5b;\n  background: #6eac72;\n}\n.ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle-active img {\n  display: none;\n}\n\n.ModalTask-content-right {\n  width: 35%;\n  background-color: #fff;\n  height: 100%;\n  border-left: 1px solid #ccd3db;\n  overflow: scroll;\n  padding: 60px 45px 25px 30px;\n}\n.ModalTask-content-right .w-md-editor .title {\n  line-height: unset !important;\n  font-size: unset !important;\n  font-weight: unset !important;\n}\n.ModalTask-content-right .button-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  color: black;\n}\n.ModalTask-content-right .button-close:hover {\n  color: black !important;\n}\n\n.modal-end-submit {\n  border-radius: 10px;\n  border: 1px solid var(--yellow-400, #ffd47d);\n  background: var(--yellow-100, #fff9ee);\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n  padding: 0;\n  width: 556px !important;\n  top: 202px !important;\n}\n.modal-end-submit .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #162e43 !important;\n  border-color: #162e43 !important;\n}\n.modal-end-submit .coin {\n  width: 49.334px;\n  height: 34px;\n}\n.modal-end-submit .tag {\n  width: 53px;\n  height: 47.06px;\n}\n.modal-end-submit .ant-modal-content {\n  background-color: transparent;\n  padding: 32px;\n}\n.modal-end-submit .ant-modal-content .h2 {\n  margin-top: 15px;\n  margin-bottom: 5px;\n}\n.modal-end-submit .ant-modal-content .h4 {\n  color: #66564d;\n}\n.modal-end-submit .ant-modal-content .divider {\n  border-top: 1px solid #ddaa42;\n  padding-top: 20px;\n  margin-top: 26px;\n}\n.modal-end-submit .ant-modal-content .buttons {\n  margin-top: 35px;\n}\n.modal-end-submit .ant-modal-content .button {\n  margin-top: 16px;\n  height: 40px !important;\n}\n.modal-end-submit .ant-modal-content .ant-modal-footer {\n  display: none;\n}\n.modal-end-submit .anticon {\n  color: #997120;\n}\n.modal-end-submit .ant-checkbox-wrapper {\n  margin-top: 10px;\n}\n.modal-end-submit .ant-checkbox-wrapper span {\n  color: #244560;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.18px;\n}\n.modal-end-submit--white {\n  background: #fff;\n  border-color: #fff;\n}\n.modal-end-submit--white .anticon {\n  color: #6e7889;\n}\n.modal-end-submit--white .ant-modal-content .h2 {\n  color: #162e43;\n}\n.modal-end-submit--white .ant-modal-content .h4 {\n  color: #48759a;\n}\n.modal-end-submit--white .ant-modal-content .buttons .button-modal-ok {\n  border: 1px solid #162e43 !important;\n  background: #162e43 !important;\n  color: #ffffff !important;\n}\n.modal-end-submit--white .ant-modal-content .buttons .button-modal-cancel {\n  border: 1px solid #162e43 !important;\n  background: #fff !important;\n  color: #162e43 !important;\n}\n.modal-end-submit--white .ant-modal-content .buttons .button-modal-cancel-delete {\n  font-weight: 600 !important;\n  color: #122536 !important;\n}\n.modal-end-submit--white .ant-modal-content .buttons .button-modal-delete {\n  border: 1px solid #A31C17 !important;\n  background: #A31C17 !important;\n  color: #F5FAFF !important;\n  font-weight: 600 !important;\n}\n\n.QuestionBasic .body-regular {\n  color: #6e7889;\n}\n.QuestionBasic .h3 {\n  margin-bottom: 40px;\n}\n.QuestionBasic .options {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 18px;\n  margin-top: 25px;\n}\n.QuestionBasic .options .content-left {\n  display: flex;\n  flex-direction: column;\n}\n.QuestionBasic .options .Button-option {\n  cursor: pointer;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  background: #f9fafb;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);\n  min-height: 56px;\n  height: auto;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 19px 24px;\n}\n.QuestionBasic .options .Button-option-text {\n  color: #2a2f3c !important;\n}\n.QuestionBasic .options .Button-option .flex-btw {\n  margin-bottom: 0 !important;\n}\n.QuestionBasic .options .Button-option .flex-start {\n  display: none;\n}\n.QuestionBasic .options .Button-option-active {\n  border-radius: 10px;\n  border: 1px solid #9bbceb;\n  background: #ebf6ff;\n  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n}\n.QuestionBasic .options .Button-option-active .flex-start {\n  display: flex;\n  gap: 6px;\n  align-items: flex-start;\n}\n.QuestionBasic .options .Button-option-active .flex-start img {\n  margin-top: 3px;\n}\n.QuestionBasic .options .Button-option-active .flex-start .body-regular {\n  max-width: 300px;\n}\n.QuestionBasic .options .Button-option-active-text {\n  color: #355c7d !important;\n}\n.QuestionBasic .options .Button-option-active .body-regular {\n  color: #5e8eb7;\n}\n.QuestionBasic .options .Button-option-active .sub-title {\n  font-weight: 500;\n}\n.QuestionBasic .Button-option-active .ModalEndSubmit {\n  width: 100%;\n}\n.QuestionBasic .Button-option-active .ModalEndSubmit .button {\n  height: 36px;\n}\n.QuestionBasic .Button-option-active .ModalEndSubmit .button span {\n  color: #f5faff !important;\n}\n.QuestionBasic .Button-option-active .Button-option-text {\n  color: #355c7d !important;\n}\n.QuestionBasic .Button-option-active-description {\n  color: #5E8EB7 !important;\n  font-size: 14px;\n  margin-top: 5px;\n}\n.QuestionBasic .list {\n  list-style-type: disc;\n  list-style: disc;\n  padding-left: 25px;\n  margin-top: 15px;\n}\n.QuestionBasic .list .h4 {\n  color: #404859;\n  line-height: 145%;\n}\n\n.spinner-container {\n  position: relative;\n  width: auto;\n  height: 120px;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  overflow: hidden; /* Evita desbordamientos */\n}\n\n.spinner {\n  position: relative;\n}\n\n.spinner div {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background-color: #c4cdd5;\n  border-radius: 50%;\n  animation: spin 1.2s linear infinite;\n}\n\n/* Colocación inicial de los 12 círculos */\n.spinner div:nth-child(1) {\n  transform: rotate(30deg) translate(40px);\n}\n\n.spinner div:nth-child(2) {\n  transform: rotate(60deg) translate(40px);\n}\n\n.spinner div:nth-child(3) {\n  transform: rotate(90deg) translate(40px);\n}\n\n.spinner div:nth-child(4) {\n  transform: rotate(120deg) translate(40px);\n}\n\n.spinner div:nth-child(5) {\n  transform: rotate(150deg) translate(40px);\n}\n\n.spinner div:nth-child(6) {\n  transform: rotate(180deg) translate(40px);\n}\n\n.spinner div:nth-child(7) {\n  transform: rotate(210deg) translate(40px);\n}\n\n.spinner div:nth-child(8) {\n  transform: rotate(240deg) translate(40px);\n}\n\n.spinner div:nth-child(9) {\n  transform: rotate(270deg) translate(40px);\n}\n\n.spinner div:nth-child(10) {\n  transform: rotate(300deg) translate(40px);\n}\n\n.spinner div:nth-child(11) {\n  transform: rotate(330deg) translate(40px);\n}\n\n.spinner div:nth-child(12) {\n  transform: rotate(0deg) translate(40px);\n}\n\n/* Animación para cambiar el color de los círculos */\n@keyframes spin {\n  0%, 100% {\n    background-color: #c4cdd5;\n  }\n  8.3% {\n    background-color: #4e8de6;\n  }\n}\n/* Cambia el retardo de cada círculo */\n.spinner div:nth-child(1) {\n  animation-delay: -1.1s;\n}\n\n.spinner div:nth-child(2) {\n  animation-delay: -1s;\n}\n\n.spinner div:nth-child(3) {\n  animation-delay: -0.9s;\n}\n\n.spinner div:nth-child(4) {\n  animation-delay: -0.8s;\n}\n\n.spinner div:nth-child(5) {\n  animation-delay: -0.7s;\n}\n\n.spinner div:nth-child(6) {\n  animation-delay: -0.6s;\n}\n\n.spinner div:nth-child(7) {\n  animation-delay: -0.5s;\n}\n\n.spinner div:nth-child(8) {\n  animation-delay: -0.4s;\n}\n\n.spinner div:nth-child(9) {\n  animation-delay: -0.3s;\n}\n\n.spinner div:nth-child(10) {\n  animation-delay: -0.2s;\n}\n\n.spinner div:nth-child(11) {\n  animation-delay: -0.1s;\n}\n\n.spinner div:nth-child(12) {\n  animation-delay: 0s;\n}\n\n.ButtonTabsFilters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n}\n.ButtonTabsFilters .tab {\n  border-radius: 100px;\n  background: #dfe4eb;\n  color: #404859;\n  text-align: right;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  border: none;\n  box-shadow: none;\n  height: 24px;\n}\n.ButtonTabsFilters .tab .number {\n  font-weight: 400;\n  margin-left: 3px;\n}\n.ButtonTabsFilters .tab:hover {\n  background: #5E8EB7 !important;\n  color: white !important;\n}\n.ButtonTabsFilters .tab-active {\n  background-color: #355c7d;\n  color: #ffffff;\n}\n.ButtonTabsFilters .tab-active:hover {\n  background-color: #355c7d;\n  color: #ffffff !important;\n}\n\n.CardAlertError {\n  border-radius: 10px;\n  border: 1px solid #d7b8e5;\n  background: #f7edfc;\n  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n  padding: 18px 24px;\n}\n.CardAlertError .h4-w5 {\n  color: #241226;\n  margin-bottom: 5px;\n}\n.CardAlertError .h4-w4 {\n  color: #653b6f;\n  margin-bottom: 30px;\n}\n\n.CardDetailInformationBank {\n  border-radius: 10px;\n  border: 1px solid #929fb0;\n  background: #fff;\n  padding: 20px 16px;\n}\n.CardDetailInformationBank .h4 {\n  margin-bottom: 24px;\n}\n.CardDetailInformationBank .label {\n  color: #6e7889;\n  margin-bottom: 4px;\n}\n.CardDetailInformationBank .info {\n  color: #929fb0;\n  font-style: italic;\n}\n.CardDetailInformationBank .row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.CardDetailInformationBank .row .column {\n  width: 50%;\n}\n.CardDetailInformationBank .column {\n  margin-bottom: 20px;\n}\n.CardDetailInformationBank .column-line {\n  border-bottom: 1px solid #dfe4eb;\n  padding-bottom: 16px;\n}\n\n.CardLoanTasks {\n  width: 396px;\n  height: 192px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  border: 1px solid #6e7889;\n  background: #fafcfc;\n  padding: 12px 19px;\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.CardLoanTasks .state-name {\n  color: #404859;\n  font-family: Inter;\n  font-size: 10px !important;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.CardLoanTasks .state-name-w6 {\n  font-weight: 600;\n}\n.CardLoanTasks .withBorder {\n  width: 100%;\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  background: #fff;\n  color: #000;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.CardLoanTasks .withOutBorder {\n  width: 100%;\n  border-radius: 10px;\n  border: none;\n  background: none;\n  box-shadow: none;\n  color: #000;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.CardLoanTasks__top__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n}\n.CardLoanTasks__top__head .flex-end {\n  display: flex;\n  justify-content: flex-end;\n  gap: 4px;\n  align-items: center;\n}\n.CardLoanTasks__top__head .flex-end .svg-grid {\n  height: 12px;\n  width: 12px;\n  fill: none;\n}\n.CardLoanTasks__top__head .flex-end .quick-task path {\n  stroke: #6e7889;\n}\n.CardLoanTasks__top__head .flex-end .quick-task path:first-child {\n  fill: #6e7889;\n}\n.CardLoanTasks__top__head .flex-end .major-task path {\n  stroke: #6e7889;\n  fill: #6e7889;\n}\n.CardLoanTasks__top .h4 {\n  margin-bottom: 4px;\n}\n.CardLoanTasks__top .text {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.CardLoanTasks__top .body-card-full {\n  margin-left: 5px;\n  padding: 0 5px;\n  font-weight: 700;\n  border-radius: 2px;\n}\n.CardLoanTasks .TaskProgress {\n  margin-top: 10px;\n}\n.CardLoanTasks__bottom .body-small-up {\n  color: #587e5b;\n  margin-bottom: 8px;\n}\n.CardLoanTasks__bottom .flex-betwen .body-card {\n  color: #587e5b;\n}\n.CardLoanTasks-buttons-actions {\n  gap: 10px;\n  display: flex;\n  justify-content: space-between;\n}\n.CardLoanTasks-APPROVED {\n  border-color: #6eac72;\n}\n.CardLoanTasks-APPROVED .state {\n  border-radius: 76px;\n  background: #c5f0c8;\n  padding: 4px 8px 4px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.CardLoanTasks-APPROVED .state .check {\n  margin-right: 2px;\n}\n.CardLoanTasks-APPROVED .state .state-name {\n  color: #355137;\n}\n.CardLoanTasks-APPROVED .h4 {\n  color: #466849;\n}\n.CardLoanTasks-APPROVED .body-card-full {\n  background-color: #c5f0c8;\n  color: #466849;\n}\n.CardLoanTasks-APPROVED .flex-end .svg-grid path {\n  stroke: #6eac72;\n}\n.CardLoanTasks-APPROVED .flex-end .svg-grid path:first-child {\n  fill: #6eac72;\n}\n.CardLoanTasks-APPROVED .flex-end .major-task path {\n  stroke: #6eac72;\n  fill: #6eac72;\n}\n.CardLoanTasks-APPROVED .flex-end .state-name {\n  color: #6eac72;\n}\n.CardLoanTasks-APPROVED .button-card {\n  border: 1px solid #6eac72;\n  background: #fafcfc;\n  color: #466849;\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n}\n.CardLoanTasks-REVIEW {\n  border-color: #ac78b3;\n  background: #FEFAFF;\n}\n.CardLoanTasks-REVIEW .body-card-full {\n  color: #48244d;\n  background: #e3ddf0;\n}\n.CardLoanTasks-REVIEW .body-card--green {\n  background-color: #e3ddf0;\n}\n.CardLoanTasks-REVIEW .state-name {\n  color: #8a5791;\n}\n.CardLoanTasks-REVIEW .CardLoanTasks__top__head .flex-end .major-task path {\n  stroke: #ac78b3;\n  fill: #ac78b3;\n}\n.CardLoanTasks-REVIEW .state {\n  border-radius: 76px;\n  background: #e3ddf0;\n  padding: 4px 8px 4px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.CardLoanTasks-REVIEW .state .state-name {\n  color: #48244d;\n}\n.CardLoanTasks-REVIEW .body-card {\n  color: #48244d;\n}\n.CardLoanTasks-REVIEW .button-card {\n  color: #693b6f;\n  border-radius: 6px;\n  border: 1px solid #ac78b3;\n  background: #fdfcff;\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.03);\n}\n.CardLoanTasks-DRAFT {\n  border-color: #929fb0;\n}\n.CardLoanTasks-DRAFT .body-card-w5 {\n  color: #48244d;\n}\n.CardLoanTasks-DRAFT .state {\n  border-radius: 76px;\n  background: #404859;\n  padding: 4px 8px 4px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.CardLoanTasks-DRAFT .state .state-name {\n  color: #f9fafb;\n}\n.CardLoanTasks-REQUEST_ERROR {\n  border-color: #c94f4a;\n}\n.CardLoanTasks-REQUEST_ERROR .body-card-w5 {\n  color: #ac3e3a;\n}\n.CardLoanTasks-REQUEST_ERROR .state {\n  border-radius: 76px;\n  background: #ffd4cf;\n  padding: 4px 8px 4px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.CardLoanTasks-REQUEST_ERROR .state .state-name {\n  color: #712220;\n}\n.CardLoanTasks-REQUEST_ERROR .h4,\n.CardLoanTasks-REQUEST_ERROR .body-card {\n  color: #712220;\n}\n.CardLoanTasks-REQUEST_ERROR .h4-text-2,\n.CardLoanTasks-REQUEST_ERROR .body-card-text-2 {\n  color: #ac3e3a;\n}\n.CardLoanTasks-REQUEST_ERROR .button-card {\n  border-color: #c94f4a;\n}\n.CardLoanTasks-REQUEST_ERROR .flex-betwen .button,\n.CardLoanTasks-REQUEST_ERROR .flex-betwen .button-link {\n  color: #712220;\n}\n.CardLoanTasks-REQUEST_ERROR .flex-end .svg-grid path {\n  stroke: #c94f4a;\n}\n.CardLoanTasks-REQUEST_ERROR .flex-end .svg-grid path:first-child {\n  fill: #c94f4a;\n}\n.CardLoanTasks-REQUEST_ERROR .flex-end .major-task path {\n  stroke: #c94f4a;\n  fill: #c94f4a;\n}\n.CardLoanTasks-REQUEST_ERROR .flex-end .state-name {\n  color: #c94f4a;\n}\n.CardLoanTasks-beginTask .ModalCardState {\n  width: 100% !important;\n}\n\n.CardSomeoneElse {\n  margin-top: 10px;\n  width: 100%;\n}\n.CardSomeoneElse input {\n  background-color: transparent;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0;\n  color: #48759a;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.CardSomeoneElse input::placeholder {\n  color: #9bbceb;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 500;\n  line-height: normal;\n}\n.CardSomeoneElse .ant-form-item {\n  width: 100%;\n  margin-bottom: 15px;\n}\n.CardSomeoneElse .row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.CardSomeoneElse .row .ant-form-item {\n  width: 100%;\n}\n\n.card-upload-response {\n  position: relative;\n  border-radius: 10px;\n  border: 1px solid #2A2F3C;\n  padding: 10px 16px;\n}\n.card-upload-response .template {\n  margin-bottom: 10px;\n}\n.card-upload-response .template .arrow-right {\n  width: 14px;\n  margin-left: 5px;\n}\n.card-upload-response .template button {\n  padding: 0;\n}\n.card-upload-response .header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n.card-upload-response .header .h4 {\n  display: flex;\n  align-items: center;\n}\n.card-upload-response .header .link {\n  padding: 0;\n  color: rgb(110, 120, 137);\n  font-size: 12px;\n}\n.card-upload-response .header .link span {\n  text-decoration: underline;\n}\n.card-upload-response .header .link:hover {\n  color: rgb(110, 120, 137);\n}\n.card-upload-response .description {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0em;\n  text-align: left;\n  margin-bottom: 12px;\n}\n.card-upload-response-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.card-upload-response-REVIEW .h4 {\n  color: #161616 !important;\n}\n.card-upload-response-REVIEW .description {\n  color: #161616 !important;\n}\n.card-upload-response-REVIEW .link {\n  color: #161616 !important;\n}\n.card-upload-response-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.card-upload-response-APPROVED .h4 {\n  color: #404859 !important;\n}\n.card-upload-response-APPROVED .description {\n  color: #404859 !important;\n}\n.card-upload-response-APPROVED .link {\n  color: #404859 !important;\n}\n.card-upload-response-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: #FFFFFF;\n}\n.card-upload-response-REQUEST_ERROR .h4 {\n  color: #404859 !important;\n}\n.card-upload-response-REQUEST_ERROR .description {\n  color: #404859 !important;\n}\n.card-upload-response-REQUEST_ERROR .link {\n  color: #404859 !important;\n}\n\n.DrodownBlue {\n  height: 20px;\n  padding: 1px 3px !important;\n  display: flex;\n  align-items: center;\n}\n.DrodownBlue:hover {\n  background-color: #5E8EB7 !important;\n  color: white !important;\n}\n.DrodownBlue:hover span {\n  text-decoration-line: none !important;\n}\n.DrodownBlue:disabled {\n  background-color: white !important;\n  color: #5E8EB7 !important;\n}\n.DrodownBlue:disabled span {\n  text-decoration-line: underline !important;\n}\n.DrodownBlue-blue {\n  border: 1px solid #9BBCEB;\n  border-radius: 10px;\n}\n.DrodownBlue-blue .ant-dropdown-menu {\n  padding: 0px;\n}\n.DrodownBlue-blue .ant-dropdown-menu-item:hover {\n  background-color: #EBF6FF !important;\n}\n.DrodownBlue-blue .ant-dropdown-menu-item:hover .ant-dropdown-menu-title-content {\n  color: #355c7d;\n  font-weight: 600;\n}\n.DrodownBlue-blue .ant-dropdown-menu-title-content {\n  color: #5E8EB7;\n  font-weight: 400;\n}\n.DrodownBlue-blue .ant-dropdown-menu-title-content:hover {\n  color: #355c7d;\n  font-weight: 600;\n}\n\n.InputAmount {\n  border-radius: 10px;\n  border: 1px solid #929fb0;\n  background: #fff;\n  padding: 13px 16px;\n}\n.InputAmount .h4 {\n  color: #404859;\n}\n.InputAmount .button-operation {\n  padding: 0;\n  height: 23px;\n  border: 0;\n  background: none;\n  box-shadow: none;\n}\n.InputAmount .button-operation .anticon {\n  color: #5e8eb7;\n}\n.InputAmount .button-operation .anticon-full {\n  display: none;\n}\n.InputAmount .button-operation:hover .anticon {\n  color: #5e8eb7;\n  display: none;\n}\n.InputAmount .button-operation:hover .anticon-full {\n  display: block;\n  margin-left: 0;\n}\n.InputAmount .flex {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n}\n.InputAmount .flex .h4 {\n  color: #929fb0;\n}\n.InputAmount .flex span {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: normal;\n}\n.InputAmount .flex .text-bold {\n  color: #5e8eb7;\n  font-weight: 600;\n  font-style: normal;\n}\n\n.InputBorderNone .input {\n  color: #775614;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.InputBorderNone .body-placeholder-w4 {\n  color: #775614;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.InputBorderNone .bold-lith {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n}\n.InputBorderNone .bold-lith::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 145%;\n}\n.InputBorderNone .bold {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n}\n.InputBorderNone .percentage-bottom {\n  border: 0;\n  display: flex;\n  justify-content: space-between;\n  border-top: 1px solid #afbdcc;\n  padding-top: 1px;\n  margin-bottom: 10px !important;\n  width: 90% !important;\n}\n.InputBorderNone .percentage-bottom .body-regular span {\n  font-size: 12px;\n}\n.InputBorderNone .ant-input-number-input {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  line-height: normal;\n  padding: 5px 0px !important;\n}\n.InputBorderNone .ant-input-number-input .default {\n  font-weight: 400;\n  color: #404859;\n}\n.InputBorderNone .ant-input-number-input .warning {\n  font-weight: 600;\n  color: #775614;\n}\n.InputBorderNone .ant-input-number-input::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-style: italic !important;\n  font-weight: 400;\n}\n\n.InputUploadedFile .file-ok {\n  margin: 10px 0;\n}\n.InputUploadedFile .file-ok .file {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f9fafb;\n  position: relative;\n}\n.InputUploadedFile .file-ok .file-content {\n  height: 28px;\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  background-color: #f9fafb;\n  width: 100%;\n  padding: 0 20px;\n  padding-right: 12px;\n}\n.InputUploadedFile .file-ok .file-content-approved {\n  border: 1px solid #92c295 !important;\n  background: #f5faf7 !important;\n}\n.InputUploadedFile .file-ok .file-content-request_error {\n  border: 1px solid #c94f4a !important;\n  background: #fff4f3 !important;\n}\n.InputUploadedFile .file-ok .file-content-request_error .name,\n.InputUploadedFile .file-ok .file-content-request_error .anticon {\n  color: #712220 !important;\n}\n.InputUploadedFile .file-ok .file-content-review {\n  border: 1px solid #AC78B3 !important;\n  background: #e3ddf0 !important;\n}\n.InputUploadedFile .file-ok .file-content-review .name,\n.InputUploadedFile .file-ok .file-content-review .anticon {\n  color: #693B6F !important;\n}\n.InputUploadedFile .file-ok .file .file-name {\n  width: 80%;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 7px;\n}\n.InputUploadedFile .file-ok .file .file-name .name {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.InputUploadedFile .file-ok .file .file-name .anticon {\n  font-size: 15px;\n}\n.InputUploadedFile .file-ok .file .content-buttons {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  gap: 7px;\n}\n.InputUploadedFile .file-ok .file .content-buttons .anticon {\n  font-size: 15px;\n}\n.InputUploadedFile .file-ok .file .flex {\n  width: 80%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  gap: 12px;\n}\n.InputUploadedFile .file-ok .file .flex:first-child {\n  gap: 4px;\n}\n.InputUploadedFile .file-ok .file .upload {\n  margin-bottom: 0;\n}\n.InputUploadedFile .file-ok .file .flex-btw {\n  margin-bottom: 0;\n  height: 100%;\n  border-bottom: none;\n}\n.InputUploadedFile .file-ok .file .circle-input {\n  background-color: #fff;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid #2a2f3c;\n  display: flex;\n  position: absolute;\n  left: 0;\n  justify-content: center;\n  align-items: center;\n}\n.InputUploadedFile .file-ok .file .circle-input .upload {\n  width: auto;\n  height: 18px;\n  object-fit: cover;\n}\n\n.ProgressSteps {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n}\n.ProgressSteps .tab {\n  margin: 0 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.ProgressSteps .tab .bar-status {\n  width: 100%;\n  width: calc(100% + 20px);\n  height: 6px;\n  border-radius: 16px;\n  margin-top: 6px;\n  background-color: #dfe4eb;\n}\n.ProgressSteps .tab-complete .body-small {\n  color: #587e5b;\n}\n.ProgressSteps .tab-complete .bar-status {\n  background-color: #6eac72;\n}\n.ProgressSteps .tab-started:hover .bar-status {\n  background-color: #404859;\n}\n\n.ant-popover-content .ant-popover-inner {\n  padding: 0;\n}\n.ant-popover-content .popover-content {\n  padding: 10px 8px;\n  border-radius: 10px;\n  width: 240px;\n  position: relative;\n}\n.ant-popover-content .popover-content .body-small {\n  color: #fafcfa;\n}\n.ant-popover-content .popover-content .body-small-w6 {\n  margin-bottom: 6px;\n}\n.ant-popover-content .popover-content .divider {\n  height: 1px;\n  width: 100%;\n  margin: 8px 0;\n}\n.ant-popover-content .popover-content .button {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n.ant-popover-content .popover-content .flecha-darck,\n.ant-popover-content .popover-content .flecha {\n  display: none;\n  width: 16px;\n  height: 8px;\n}\n.ant-popover-content .popover-content .felx-between {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n}\n.ant-popover-content .popover-content .felx-between .flex {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ant-popover-content .popover-content .felx-between .flex img {\n  margin-right: 5px;\n}\n.ant-popover-content .popover-content .felx-between .button {\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  height: 20px;\n  box-shadow: none;\n}\n.ant-popover-content .popover-content .felx-between .button .flecha {\n  margin-left: 5px;\n  width: 12px;\n}\n.ant-popover-content .popover-content .warning {\n  display: none;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 5px;\n  margin-top: 10px;\n}\n.ant-popover-content .popover-content .warning svg {\n  width: 10px;\n  height: 11px;\n  fill: none;\n}\n.ant-popover-content .popover-content .warning .body-small {\n  margin-bottom: 0;\n  color: #8f2f2c;\n  text-decoration-line: underline;\n}\n.ant-popover-content .popover-content-complete, .ant-popover-content .popover-content-started {\n  background-color: #587e5b;\n}\n.ant-popover-content .popover-content-complete .divider, .ant-popover-content .popover-content-started .divider {\n  background-color: #fafcfa;\n}\n.ant-popover-content .popover-content-complete .flecha, .ant-popover-content .popover-content-started .flecha {\n  display: block;\n}\n.ant-popover-content .popover-content-complete .button:hover, .ant-popover-content .popover-content-complete .button:active, .ant-popover-content .popover-content-complete .button:focus, .ant-popover-content .popover-content-started .button:hover, .ant-popover-content .popover-content-started .button:active, .ant-popover-content .popover-content-started .button:focus {\n  color: #fafcfa;\n}\n.ant-popover-content .popover-content-complete::after, .ant-popover-content .popover-content-started::after {\n  content: \"*\";\n  font-size: 0;\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 11px solid #587e5b;\n  position: absolute;\n  left: 46%;\n  top: -10px;\n  z-index: 3;\n}\n.ant-popover-content .popover-content-started {\n  background-color: #404859;\n  width: 270px;\n}\n.ant-popover-content .popover-content-started .warning {\n  display: flex;\n}\n.ant-popover-content .popover-content-started .warning .body-small {\n  color: #ffd4cf;\n}\n.ant-popover-content .popover-content-started .warning svg path {\n  stroke: #ffd4cf;\n}\n.ant-popover-content .popover-content-started::after {\n  content: \"*\";\n  font-size: 0;\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 11px solid #404859;\n  position: absolute;\n  left: 46%;\n  top: -10px;\n  z-index: 3;\n}\n.ant-popover-content .popover-content-not-started {\n  background-color: #ccd3db;\n  width: 270px;\n}\n.ant-popover-content .popover-content-not-started .body-small {\n  color: #000000;\n}\n.ant-popover-content .popover-content-not-started .warning {\n  display: flex;\n}\n.ant-popover-content .popover-content-not-started svg path {\n  stroke: #8f2f2c;\n}\n.ant-popover-content .popover-content-not-started .button:hover, .ant-popover-content .popover-content-not-started .button:active, .ant-popover-content .popover-content-not-started .button:focus {\n  color: #000000;\n}\n.ant-popover-content .popover-content-not-started .divider {\n  background-color: #404859;\n}\n.ant-popover-content .popover-content-not-started .flecha-darck {\n  display: block;\n}\n.ant-popover-content .popover-content-not-started::after {\n  content: \"*\";\n  font-size: 0;\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 11px solid #ccd3db;\n  position: absolute;\n  left: 46%;\n  top: -10px;\n  z-index: 3;\n}\n.ant-popover-content .popover-content .green-all .body-small {\n  color: #c5f0c8;\n}\n\n.TaskProgress .bar {\n  width: 100%;\n  background-color: #dfe4eb;\n  height: 8px;\n  border-radius: 8px;\n  display: flex;\n}\n.TaskProgress .bar :first-child {\n  border-bottom-left-radius: 8px;\n  border-top-left-radius: 8px;\n}\n.TaskProgress .bar :last-child {\n  border-bottom-right-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.TaskProgress .bar-percentage {\n  height: 8px;\n}\n.TaskProgress .h4 {\n  color: #404859 !important;\n  text-transform: none;\n}\n\n.SelectPrimary .body-regular {\n  color: #2a2f3c;\n  font-weight: 500;\n}\n.SelectPrimary .ant-space-item {\n  width: 100%;\n}\n\n.state-tag {\n  width: max-content;\n  border-radius: 76px;\n  padding: 4px 8px 4px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.state-tag .check {\n  margin-right: 2px;\n}\n.state-tag .state-name {\n  font-weight: 600;\n  font-family: Inter;\n  line-height: 11px;\n  letter-spacing: 0.02em;\n  font-size: 10px;\n}\n.state-tag-APPROVED {\n  border-color: #C2F0C5;\n  background: #C2F0C5;\n}\n.state-tag-APPROVED .state-name {\n  color: #404859 !important;\n}\n.state-tag-REVIEW {\n  border-color: #e3ddf0;\n  background: #e3ddf0;\n}\n.state-tag-REVIEW .state-name {\n  color: #161616 !important;\n}\n.state-tag-REQUEST_ERROR {\n  border-color: #FFD4CF;\n  background: #FFD4CF;\n}\n.state-tag-REQUEST_ERROR .state-name {\n  color: #404859 !important;\n}\n.state-tag-DRAFT .state-name {\n  color: #2a2f3c !important;\n}\n\n.UploadDocs {\n  position: relative;\n}\n.UploadDocs .modal-see-file {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: red;\n}\n.UploadDocs .button-upload {\n  height: 78px;\n  width: 100%;\n  border: 1px dashed #6e7889;\n}\n.UploadDocs .button-upload p {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.UploadDocs .button-upload p span {\n  font-size: 10px;\n  color: #4e8aff;\n}\n.UploadDocs .circles {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n}\n.UploadDocs .circles .circle {\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  border: 1px solid #404859;\n}\n.UploadDocs .circles .circle-review {\n  background-color: #AC78B3;\n  border-color: #AC78B3;\n}\n.UploadDocs .circles .circle-approved {\n  background-color: #C2F0C5;\n  border-color: #92c295;\n}\n.UploadDocs .ant-upload {\n  width: 100%;\n  margin-bottom: 12px;\n}\n.UploadDocs .button {\n  border-radius: 6px;\n  border: #122536;\n  background: #122536;\n  width: 100%;\n  height: 32px;\n  color: #fff;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.18px;\n}\n.UploadDocs .button-transparent {\n  background-color: transparent;\n  border: none !important;\n  box-shadow: none !important;\n}\n.UploadDocs .body-small .blue {\n  color: #4e8aff;\n}\n.UploadDocs .upload {\n  width: 20px;\n  height: 20px;\n  margin-bottom: 7px;\n}\n.UploadDocs .empty-input {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.UploadDocs .empty-input .small-detail {\n  margin-top: 4px;\n}\n.UploadDocs--container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 12px;\n}\n.UploadDocs .input-content {\n  position: relative;\n  height: 128px;\n  width: 100%;\n  border-radius: 10px;\n  background: var(--colors-gradient);\n  padding: 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px dashed #6e7889;\n}\n.UploadDocs .input-content .white {\n  background-color: #fff;\n  height: 10px;\n  width: 20px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  border-top-left-radius: 5px;\n  z-index: 200;\n}\n.UploadDocs .input-content input {\n  height: 126px;\n  width: 100%;\n  border-radius: 10px;\n  background-color: rgba(255, 0, 0, 0);\n  font-size: 0 !important;\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  cursor: pointer;\n}\n.UploadDocs .input-content .cont-img {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n}\n.UploadDocs .input-content .cont-img img {\n  width: 100px;\n}\n.UploadDocs .input-content-wh {\n  background: var(--colors-white);\n  box-shadow: -3px 1px 10px -7px var(--colors-black);\n  margin: 30px 40px;\n}\n.UploadDocs .input-content .edit {\n  position: absolute;\n  bottom: 0;\n  height: auto;\n  width: 99px;\n  border-radius: 0;\n}\n.UploadDocs .content-flex {\n  align-items: flex-start;\n  gap: 16px;\n}\n.UploadDocs .content-flex .input-content,\n.UploadDocs .content-flex .file-ok {\n  width: 50% !important;\n}\n\n.circle-tag .circle {\n  width: 20px;\n  height: 20px;\n}\n.circle-tag .circle-APPROVED {\n  border-color: #92c295;\n  background-color: #C2F0C5;\n}\n.circle-tag .circle-APPROVED:hover {\n  background-color: #549358;\n}\n.circle-tag .circle-REVIEW {\n  background-color: #AC78B3;\n  border-color: #AC78B3;\n}\n.circle-tag .circle-REVIEW:hover {\n  background-color: #855791;\n}\n.circle-tag .circle-REQUEST_ERROR {\n  background-color: #FFD4CF;\n  border-color: #c94f4a;\n}\n.circle-tag .circle-REQUEST_ERROR:hover {\n  background-color: #c94f4a;\n}\n\n.MinimumLiquidity {\n  padding-bottom: 30px;\n}\n.MinimumLiquidity .h4 {\n  color: #404859 !important;\n}\n.MinimumLiquidity .divider-top {\n  padding-top: 10px;\n}\n.MinimumLiquidity .h4-error {\n  color: #712220 !important;\n  margin-bottom: 7px;\n}\n.MinimumLiquidity .h2-w8 {\n  color: #2a2f3c !important;\n}\n\n.CardStateAccount {\n  border-radius: 10px;\n  border: 1px solid #7b7b7b;\n  padding: 12px 16px;\n  position: relative;\n}\n.CardStateAccount .label {\n  border-radius: 100px;\n  min-width: 81px;\n  width: auto;\n  max-width: 95px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 3px 4px;\n  gap: 4px;\n  margin-bottom: 8px;\n  background: #969696;\n}\n.CardStateAccount .label .body-small {\n  margin-bottom: 0;\n}\n.CardStateAccount_head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n.CardStateAccount .box {\n  width: 300px !important;\n}\n.CardStateAccount .box .body-card {\n  margin-bottom: 6px;\n}\n.CardStateAccount .box .body-regular {\n  margin-bottom: 16px;\n}\n.CardStateAccount .box .file-ok {\n  margin-top: 0 !important;\n}\n.CardStateAccount .box-error .flex .button:last-child {\n  display: none !important;\n}\n.CardStateAccount .box-success .flex .button:last-child {\n  display: none !important;\n}\n.CardStateAccount .divider {\n  border-top: 1px solid #afbdcc;\n  margin-top: 20px;\n}\n.CardStateAccount--inReview {\n  background: #fdfcff;\n  border: 1px solid #ac78b3;\n}\n.CardStateAccount--inReview .label {\n  background: #e3ddf0;\n}\n.CardStateAccount--inReview .label .body-small {\n  color: #48244d;\n}\n.CardStateAccount--inReview .box .body-card {\n  color: #48244d;\n}\n.CardStateAccount--inReview .box .body-card-dark {\n  color: #2a2f3c;\n}\n.CardStateAccount--inReview .box .body-regular {\n  color: #48244d;\n}\n.CardStateAccount--inReview .file-ok .file-content .name {\n  color: #693b6f !important;\n}\n.CardStateAccount--inReview .file-ok .file-content .anticon {\n  color: #693b6f !important;\n}\n.CardStateAccount--error {\n  border: 1px solid #c94f4a;\n}\n.CardStateAccount--error .label {\n  background: #ffd4cf;\n}\n.CardStateAccount--error .label img {\n  margin-top: 1px;\n}\n.CardStateAccount--error .label .body-small {\n  color: #712220;\n}\n.CardStateAccount--error .UploadDocs .input-content {\n  border: 1px dashed #e67f73;\n}\n.CardStateAccount--error .row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.CardStateAccount--error .row .box {\n  width: 40%;\n}\n.CardStateAccount--error .row .box .body-card {\n  margin-bottom: 4px;\n}\n.CardStateAccount--error .divider {\n  margin-top: 20px;\n  border-top: 1px solid #ffd4cf;\n  padding-top: 8px;\n}\n.CardStateAccount--approved {\n  border: 1px solid #3F9545;\n}\n.CardStateAccount--approved .label {\n  background: #C5F0C8;\n}\n.CardStateAccount--approved .label img {\n  margin-top: 1px;\n}\n.CardStateAccount--approved .label .body-small {\n  color: #355137;\n}\n.CardStateAccount--approved .UploadDocs .input-content {\n  border: 1px dashed #C5F0C8;\n}\n.CardStateAccount--approved .row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.CardStateAccount--approved .row .box {\n  width: 40%;\n}\n.CardStateAccount--approved .row .box .body-card {\n  margin-bottom: 4px;\n}\n.CardStateAccount--approved .divider {\n  margin-top: 20px;\n  border-top: 1px solid #C5F0C8;\n  padding-top: 8px;\n}\n.CardStateAccount--approved .file-ok .file-content {\n  border: 1px solid #75C27A !important;\n  background-color: #C5F0C8 !important;\n}\n.CardStateAccount--approved .file-ok .file-content .name {\n  color: #355137 !important;\n}\n.CardStateAccount--approved .file-ok .file-content .anticon {\n  color: #355137 !important;\n}\n.CardStateAccount .row-btw .box {\n  width: 100%;\n}\n.CardStateAccount .section-upload .UploadDocs .file-content {\n  height: 28px !important;\n  border-radius: 10px;\n  border: 1px solid #eff3f5 !important;\n  background: #eff3f5 !important;\n  padding-left: 12px !important;\n}\n.CardStateAccount .section-upload .UploadDocs .InputUploadedFile .file-ok .file .circle {\n  display: none;\n}\n\n.SectionError {\n  border-radius: 10px;\n  border: 1px solid #c94f4a;\n  padding: 12px 15px;\n}\n.SectionError .flex-end button {\n  height: 30px;\n}\n.SectionError .description {\n  overflow: hidden;\n}\n.SectionError .description .body-regular {\n  display: -webkit-box; /* Utiliza el modelo de caja flexible de tipo webkit */\n  -webkit-box-orient: vertical; /* Orientación vertical */\n  -webkit-line-clamp: 2; /* Número máximo de líneas */\n  overflow: hidden; /* Oculta el contenido que sobresale */\n}\n.SectionError .flex-btw {\n  margin-bottom: 5px;\n}\n.SectionError .body-regular {\n  color: #c94f4a;\n}\n.SectionError .body-regular-w6 {\n  color: #712220;\n}\n.SectionError .button {\n  color: #712220;\n  text-align: right;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 140%;\n}\n.SectionError .button span {\n  text-decoration: underline;\n}\n.SectionError .button span:hover {\n  color: #712220;\n}\n.SectionError .button .anticon {\n  color: #712220;\n  margin-top: 2px;\n}\n\n.SectionNewBank .h4,\n.SectionNewBank .body-regular {\n  margin-bottom: 8px;\n  color: #2a2f3c;\n  line-height: 145%;\n}\n.SectionNewBank .button {\n  width: auto !important;\n  font-size: 20px;\n  font-weight: 600;\n}\n.SectionNewBank .button-block {\n  width: 100% !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.card-add-account {\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  padding: 16px;\n  margin-top: 16px;\n}\n.card-add-account .ModalEndSubmit .button {\n  margin-bottom: 5px;\n}\n.card-add-account .flex-btw {\n  margin-bottom: 0 !important;\n}\n.card-add-account .flex-btw .box {\n  height: 100%;\n}\n.card-add-account .UploadDocs .flex-btw {\n  border: none;\n}\n.card-add-account .body-card {\n  color: #404859 !important;\n}\n.card-add-account .box {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.card-add-account .box .h4 {\n  color: #929fb0;\n  font-style: italic;\n  margin-bottom: 16px;\n}\n.card-add-account .box .ModalEndSubmit .button {\n  display: none;\n}\n.card-add-account .button-submit {\n  margin-bottom: 20px;\n  border-radius: 6px;\n}\n.card-add-account .button-submit span {\n  color: #fff;\n  text-align: center;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.18px;\n}\n.card-add-account .top-InfoExpand {\n  border-top: 1px solid #afbdcc;\n}\n\n.DscrQuestionsAgreements .Step3 .h2 {\n  margin-top: 4px;\n  margin-bottom: 10px;\n}\n.DscrQuestionsAgreements .Step3 .h2 .blue-bold {\n  color: #5e8eb7;\n  font-weight: 800;\n  text-decoration-line: underline;\n  color: #2A2F3C;\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 135%;\n  text-decoration-line: unset;\n}\n.DscrQuestionsAgreements .Step3 .rent-input {\n  border: none;\n  width: auto;\n  display: inline;\n}\n.DscrQuestionsAgreements .Step3 .rent-input.touched {\n  color: #404859;\n}\n.DscrQuestionsAgreements .Step3 .month {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.DscrQuestionsAgreements .Step3 #rent-button {\n  margin-top: 16px;\n}\n.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex {\n  display: flex;\n  width: 100%;\n}\n.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex .cont-files {\n  width: 100%;\n}\n.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex .UploadDocs--container {\n  gap: 20px;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: row;\n  width: 100%;\n}\n.DscrQuestionsAgreements .InputAmount-edit {\n  margin-bottom: 0px !important;\n  border: none !important;\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n.DscrQuestionsAgreements .InputAmount-edit .flex {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n}\n.DscrQuestionsAgreements .InputAmount-edit .flex .text-bold {\n  color: #5e8eb7;\n  font-weight: 600;\n  font-style: normal;\n}\n.DscrQuestionsAgreements .InputAmount-edit .flex .input-edit {\n  all: unset;\n  color: #6E7889;\n  animation: none;\n  cursor: pointer;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 19.36px;\n  text-align: right;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n.DscrQuestionsAgreements .InputAmount-edit .button-edit {\n  all: unset;\n  border: none;\n  color: #5E8EB7;\n  animation: none;\n  cursor: pointer;\n  margin-left: 10px;\n}\n.DscrQuestionsAgreements .InputAmount-edit .button-edit span {\n  margin-left: 5px;\n  font-weight: 500;\n  color: #5E8EB7;\n  font-family: Inter;\n  font-style: normal;\n}\n.DscrQuestionsAgreements .InputAmount-edit .button-edit-disabled span {\n  color: #6E7889 !important;\n}\n\n.CardLeaseAgreements {\n  padding: 16px;\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n}\n.CardLeaseAgreements .flex-btw .flex {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 28px;\n}\n.CardLeaseAgreements .flex-btw .flex .circle {\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  border: 1px solid #404859;\n}\n.CardLeaseAgreements .flex-btw .flex .circle--active {\n  background-color: #404859;\n}\n.CardLeaseAgreements-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.CardLeaseAgreements-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.CardLeaseAgreements-APPROVED .h4 {\n  color: #404859 !important;\n}\n.CardLeaseAgreements-APPROVED .description {\n  color: #404859 !important;\n}\n.CardLeaseAgreements-APPROVED .link {\n  color: #404859 !important;\n}\n.CardLeaseAgreements-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: #FFFFFF;\n}\n.CardLeaseAgreements-REQUEST_ERROR .h4 {\n  color: #404859 !important;\n}\n.CardLeaseAgreements-REQUEST_ERROR .description {\n  color: #404859 !important;\n}\n.CardLeaseAgreements-REQUEST_ERROR .link {\n  color: #404859 !important;\n}\n\n.CardMarketRent {\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n  padding: 12px 16px;\n}\n.CardMarketRent .body-regular-italic {\n  color: #929fb0;\n}\n.CardMarketRent .flex-btw {\n  margin-bottom: 9px !important;\n}\n.CardMarketRent-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.CardMarketRent-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.CardMarketRent-APPROVED .h4 {\n  color: #404859 !important;\n}\n.CardMarketRent-APPROVED .description {\n  color: #404859 !important;\n}\n.CardMarketRent-APPROVED .link {\n  color: #404859 !important;\n}\n.CardMarketRent-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: #FFFFFF;\n}\n.CardMarketRent-REQUEST_ERROR .h4 {\n  color: #404859 !important;\n}\n.CardMarketRent-REQUEST_ERROR .description {\n  color: #404859 !important;\n}\n.CardMarketRent-REQUEST_ERROR .link {\n  color: #404859 !important;\n}\n.CardMarketRent .ant-form {\n  all: unset;\n  margin-top: 10px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.CardMarketRent .ant-form .form-row {\n  all: unset;\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  max-height: 35px;\n}\n.CardMarketRent .ant-form .form-row .bold {\n  font-weight: 600 !important;\n  color: #404859 !important;\n}\n.CardMarketRent .ant-form .rent-container {\n  display: flex;\n  align-items: baseline;\n  position: relative;\n}\n.CardMarketRent .ant-form .rent-input {\n  width: auto;\n  min-width: 56px;\n  max-width: 58px;\n  text-align: right;\n  font-weight: 600;\n  color: #404859;\n  border: none;\n  outline: none;\n  background: transparent;\n}\n.CardMarketRent .ant-form .unit-input {\n  width: 25px !important;\n}\n\n.CardTotalUnits {\n  border: 1px solid #929fb0;\n  padding: 12px 16px;\n}\n.CardTotalUnits .body-regular-italic {\n  color: #929fb0;\n}\n.CardTotalUnits .flex-btw {\n  margin-bottom: 16px !important;\n}\n\n.EntityGuarantorCreation .task-footer .dropdown-blue-bold {\n  height: 26px;\n  display: unset;\n  padding: 0 !important;\n}\n.EntityGuarantorCreation .task-footer .dropdown-blue-bold span {\n  font-weight: 600;\n  text-decoration-line: underline;\n}\n.EntityGuarantorCreation .task-footer .dropdown-review-bold {\n  color: #AC78B3 !important;\n  height: 26px;\n  display: unset;\n  padding: 0 !important;\n}\n.EntityGuarantorCreation .task-footer .dropdown-review-bold span {\n  font-weight: 600;\n  text-decoration-line: underline;\n}\n.EntityGuarantorCreation .task-footer .owners-tags {\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n}\n.EntityGuarantorCreation .task-footer .owners-tags .circles-tags {\n  display: flex;\n  align-items: end;\n  gap: 10px;\n}\n.EntityGuarantorCreation .task-footer .owners-tags .circle {\n  width: 20px;\n  height: 20px;\n}\n.EntityGuarantorCreation .task-footer .owners-tags .circle-step3 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n}\n\n.main {\n  position: relative;\n  border-radius: 10px;\n}\n.main .icon-delete {\n  font-size: 20px;\n  position: absolute;\n  top: 50%;\n  right: -9.5px;\n  transform: translateY(-50%);\n  color: #5E8EB7;\n  cursor: pointer;\n  visibility: hidden;\n}\n.main:hover .icon-delete {\n  visibility: visible;\n}\n.main .content-card {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  min-height: 56px;\n  height: auto;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 10px 18px 5px 16px;\n}\n.main .content-card-hover-removed:hover {\n  border: 1px solid #ccd3db !important;\n}\n.main .content-card:hover {\n  border: 1px dashed #929fb0;\n}\n.main .content-card .input-disabled-color input:disabled {\n  color: black;\n}\n.main .content-card-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.main .content-card-REVIEW .body-regular {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .bold-lith {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .ant-input-number-suffix {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .ant-picker-input input {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .ant-form-item-no-colon {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .ant-input-number-input-wrap {\n  color: #161616 !important;\n}\n.main .content-card-REVIEW .ant-input-number-input-wrap input {\n  font-weight: 500;\n}\n.main .content-card-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.main .content-card-APPROVED .body-regular {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .bold-lith {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .ant-input-number-suffix {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .ant-picker-input input {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .ant-form-item-no-colon {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .ant-input-number-input-wrap {\n  color: #404859 !important;\n}\n.main .content-card-APPROVED .ant-input-number-input-wrap input {\n  font-weight: 500;\n}\n.main .content-card-APPROVED .file-name {\n  color: #404859 !important;\n}\n.main .content-card-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: white;\n}\n.main .content-card-REQUEST_ERROR .body-regular {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .bold-lith {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .ant-form-item-no-colon {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .ant-picker-input input {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .ant-input-number-suffix {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .ant-input-number-input-wrap {\n  color: #712220 !important;\n}\n.main .content-card-REQUEST_ERROR .ant-input-number-input-wrap input {\n  font-weight: 500;\n}\n.main .content-card-REQUEST_ERROR .file-name {\n  color: #712220 !important;\n}\n.main .content-card .card-ownership {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.main .content-card .card-ownership .section-1 {\n  display: flex;\n  width: 70%;\n  flex-direction: column;\n}\n.main .content-card .card-ownership .section-1 .names {\n  display: flex;\n  gap: 30px;\n}\n.main .content-card .card-ownership .section-1 .names .name {\n  display: flex;\n  flex-direction: column;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: auto;\n  gap: 5px;\n}\n.main .content-card .card-ownership .section-1 .names .name span {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: 16px;\n}\n.main .content-card .card-ownership .section-1 .names .name label {\n  font-size: 12px;\n}\n.main .content-card .card-ownership .section-1 .footer .approved {\n  color: #587e5b;\n}\n.main .content-card .card-ownership .section-1 .footer .error {\n  color: #404859;\n}\n.main .content-card .card-ownership .section-1 .footer button {\n  color: #6e7889;\n}\n.main .content-card .card-ownership .section-1 .footer button .anticon {\n  margin-inline-start: 4px;\n}\n.main .content-card .card-ownership .section-1 .footer button:hover {\n  color: #6e7889;\n}\n.main .content-card .card-ownership .section-1 .footer span {\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 15px;\n}\n.main .content-card .card-ownership .section-2 {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n}\n.main .content-card .card-ownership .section-2 .suffix-null input {\n  margin-top: 18px;\n  padding-right: 0 !important;\n}\n.main .content-card .card-ownership .section-2 input {\n  width: 100px;\n  text-align: end;\n  padding-right: 13px !important;\n}\n.main .content-card .card-ownership .section-2 .guarantor {\n  margin-top: 7px;\n  font-size: 10px;\n  color: #5E8EB7;\n}\n.main .content-card .card-ownership .section-2 .ant-input-number-suffix {\n  margin-inline-end: 0px;\n  color: black;\n}\n.main .content-card .form-edit {\n  width: 100%;\n  height: auto;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  display: grid;\n  grid-template-columns: 45% 35% 20%;\n  grid-template-areas: \"ssn datebirth textedit\" \"phone email .\" \"address address address\" \"identification identification identification\" \"submit submit submit\";\n}\n.main .content-card .form-edit .ant-input-status-error {\n  color: #404859;\n}\n.main .content-card .form-edit .ant-form-item-row {\n  display: block;\n}\n.main .content-card .form-edit .ant-form-item-label {\n  text-align: start;\n  height: 27px;\n}\n.main .content-card .form-edit .ant-form-item-label label {\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14.52px;\n  color: #6e7889;\n}\n.main .content-card .form-edit .ant-form-item-control-input {\n  min-height: 20px;\n}\n.main .content-card .form-edit .ant-form-item {\n  margin-bottom: 15px;\n}\n.main .content-card .form-edit .ssn {\n  grid-area: ssn;\n}\n.main .content-card .form-edit .datebirth {\n  grid-area: datebirth;\n}\n.main .content-card .form-edit .datebirth .ant-picker-input input::placeholder {\n  color: #929fb0;\n  font-family: Inter;\n  font-style: italic !important;\n  font-weight: 400;\n}\n.main .content-card .form-edit .datebirth .ant-picker-input input:disabled {\n  color: black;\n}\n.main .content-card .form-edit .textedit {\n  grid-area: textedit;\n  font-size: 11px;\n  text-align: end;\n  color: #5E8EB7;\n  display: flex;\n  align-items: start;\n  gap: 6px;\n  justify-content: end;\n  margin-top: 5px;\n}\n.main .content-card .form-edit .phone {\n  grid-area: phone;\n}\n.main .content-card .form-edit .email {\n  grid-area: email;\n}\n.main .content-card .form-edit .address {\n  grid-area: address;\n}\n.main .content-card .form-edit .identification {\n  grid-area: identification;\n}\n.main .content-card .form-edit .identification label {\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 15px;\n}\n.main .content-card .form-edit .submit {\n  grid-area: submit;\n}\n\n.step-3 .blue-bold {\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 800;\n  text-decoration: underline;\n}\n.step-3 .owner-REVIEW {\n  color: #161616;\n}\n.step-3 .owner-APPROVED {\n  color: #404859;\n}\n.step-3 .owner-REQUEST_ERROR {\n  color: #404859;\n}\n.step-3 .content-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.step-3 .content-owner-new {\n  display: flex;\n  justify-content: space-between;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.step-3 .content-owner-new button {\n  padding: 0;\n}\n.step-3 .content-owner-new .text-add {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n.step-3 .content-owner-new .total {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n.action-accept-reject {\n  position: absolute;\n  top: -10px;\n  right: 15px;\n  width: 60px;\n  z-index: 99;\n}\n.action-accept-reject .content-actions {\n  display: flex;\n  justify-content: end;\n  gap: 15px;\n  width: 60px;\n}\n.action-accept-reject .circle-input {\n  cursor: pointer;\n}\n\n.EntityDocs .task-footer .dropdown-blue-bold {\n  height: 26px;\n  display: unset;\n  padding: 0 !important;\n}\n.EntityDocs .task-footer .dropdown-blue-bold span {\n  font-weight: 600;\n  text-decoration-line: underline;\n}\n.EntityDocs .task-footer .dropdown-review-bold {\n  color: #AC78B3 !important;\n  height: 26px;\n  display: unset;\n  padding: 0 !important;\n}\n.EntityDocs .task-footer .dropdown-review-bold span {\n  font-weight: 600;\n  text-decoration-line: underline;\n}\n.EntityDocs .task-footer .owners-tags {\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n}\n.EntityDocs .task-footer .owners-tags .circles-tags {\n  display: flex;\n  align-items: end;\n  gap: 10px;\n}\n.EntityDocs .task-footer .owners-tags .circle {\n  width: 20px;\n  height: 20px;\n}\n.EntityDocs .task-footer .owners-tags .circle-APPROVED {\n  background-color: #C2F0C5;\n  border-color: #92c295;\n}\n.EntityDocs .task-footer .owners-tags .circle-REVIEW {\n  background-color: #AC78B3;\n  border-color: #AC78B3;\n}\n.EntityDocs .task-footer .owners-tags .circle-REQUEST_ERROR {\n  background-color: #FFD4CF;\n  border-color: #c94f4a;\n}\n\n.entity-docs-step-2 .section-1 span {\n  font-size: 20px !important;\n}\n.entity-docs-step-2 .dropdown-blue-bold {\n  display: unset;\n  height: auto;\n}\n.entity-docs-step-2 .dropdown-review-bold {\n  color: #AC78B3 !important;\n  display: unset;\n  padding: 0 !important;\n}\n.entity-docs-step-2 .dropdown-review-bold span {\n  text-decoration-line: underline;\n}\n.entity-docs-step-2 .submits {\n  display: flex;\n  justify-content: space-between;\n  gap: 15px;\n}\n.entity-docs-step-2 .submits section {\n  width: 100%;\n}\n\n.InvestmentExperienceVerification .card__generic-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.InvestmentExperienceVerification .card__generic-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: #FFFFFF;\n}\n.InvestmentExperienceVerification .card__generic-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.InvestmentExperienceVerification .card__generic .UploadDocs .input-content,\n.InvestmentExperienceVerification .card__generic .UploadDocs .input-content input {\n  height: 79px;\n}\n.InvestmentExperienceVerification .circle-review {\n  background-color: #AC78B3;\n  border-color: #AC78B3 !important;\n}\n.InvestmentExperienceVerification .circle-approved {\n  border: 1px solid #92c295 !important;\n  background-color: #C2F0C5;\n}\n\n.ConstructionBudget input::-webkit-outer-spin-button,\n.ConstructionBudget input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.ConstructionBudget .h2 {\n  margin-top: 30px !important;\n}\n.ConstructionBudget .UploadDocs .input-content,\n.ConstructionBudget .UploadDocs .input-content input {\n  height: 78px;\n}\n.ConstructionBudget .UploadDocs .input-content .empty-input .body-small,\n.ConstructionBudget .UploadDocs .input-content input .empty-input .body-small {\n  color: #2a2f3c;\n}\n.ConstructionBudget .card__generic .s-title .h4 {\n  color: #404859;\n}\n.ConstructionBudget .card__generic .body-regular {\n  margin-bottom: 20px;\n}\n.ConstructionBudget .link {\n  color: #5e8eb7;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  text-decoration: none;\n  line-height: 145%;\n}\n.ConstructionBudget .link .arrow {\n  height: 10px;\n  margin-left: 5px;\n}\n\n.title-company-step-1 {\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);\n  padding: 16px 24px 5px;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.title-company-step-1 .ant-form {\n  margin-top: 15px;\n  width: 100%;\n  height: auto;\n  display: grid;\n  grid-template-columns: 50% 5% 45%;\n  grid-template-areas: \"titleCompany titleCompany titleCompany\" \"name name .\" \"phone . email\" \"submit submit submit\";\n}\n.title-company-step-1-REVIEW {\n  border: 1px solid #AC78B3;\n  background-color: #FDFCFF;\n}\n.title-company-step-1-REVIEW .h4 {\n  color: #161616 !important;\n}\n.title-company-step-1-REVIEW .description {\n  color: #161616 !important;\n}\n.title-company-step-1-REVIEW .link {\n  color: #161616 !important;\n}\n.title-company-step-1-APPROVED {\n  border: 1px solid #92c295;\n  background-color: white;\n}\n.title-company-step-1-APPROVED .h4 {\n  color: #404859 !important;\n}\n.title-company-step-1-APPROVED .description {\n  color: #404859 !important;\n}\n.title-company-step-1-APPROVED .link {\n  color: #404859 !important;\n}\n.title-company-step-1-REQUEST_ERROR {\n  border: 1px solid #c94f4a;\n  background-color: #FFFFFF;\n}\n.title-company-step-1-REQUEST_ERROR .h4 {\n  color: #404859 !important;\n}\n.title-company-step-1-REQUEST_ERROR .description {\n  color: #404859 !important;\n}\n.title-company-step-1-REQUEST_ERROR .link {\n  color: #404859 !important;\n}\n.title-company-step-1 .ant-form-item-row {\n  display: block;\n}\n.title-company-step-1 .ant-form-item-label {\n  text-align: start;\n  height: 27px;\n}\n.title-company-step-1 .ant-form-item-label label {\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14.52px;\n  color: #6e7889;\n}\n.title-company-step-1 .ant-form-item-control-input {\n  min-height: 20px;\n}\n.title-company-step-1 .ant-form-item {\n  margin-bottom: 15px;\n}\n.title-company-step-1 .titleCompany {\n  grid-area: titleCompany;\n}\n.title-company-step-1 .titleCompany input {\n  font-size: 16px !important;\n}\n.title-company-step-1 .name {\n  grid-area: name;\n}\n.title-company-step-1 .phone {\n  grid-area: phone;\n}\n.title-company-step-1 .email {\n  grid-area: email;\n}\n.title-company-step-1 .submit {\n  grid-area: submit;\n}\n.title-company-step-1 .submit button {\n  border-radius: 6px;\n}\n\n.insurance-step-2 .ant-collapse-header-text {\n  max-width: 335px;\n  margin-inline-end: unset !important;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n}\n.insurance-step-2 .ant-collapse-expand-icon {\n  padding-inline-start: 0px !important;\n}\n\n.payoff-footer .dropdown-blue-bold {\n  display: unset;\n  padding: 0 !important;\n  border: none !important;\n}\n.payoff-footer .dropdown-blue-bold span {\n  background-color: white !important;\n  color: #5E8EB7 !important;\n  padding: 0 !important;\n}\n.payoff-footer .is-review {\n  color: #AC78B3 !important;\n}\n\n.insurance-step-2 .ant-collapse-header-text {\n  max-width: 335px;\n  margin-inline-end: unset !important;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n}\n.insurance-step-2 .ant-collapse-expand-icon {\n  padding-inline-start: 0px !important;\n}\n\n.entities-list {\n  padding: 24px 25px;\n}\n.entities-list .top-container {\n  box-sizing: content-box;\n  width: 100%;\n  margin-bottom: 33px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: space-between;\n}\n.entities-list .top-container .title {\n  color: var(--800-grey, #404859);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.entities-list .top-container .title > span {\n  cursor: pointer;\n  color: var(--blue60, #5E8EB7);\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-decoration-line: underline;\n}\n.entities-list .entities-container {\n  padding: 16px 0px;\n}\n.entities-list .entities-container > * {\n  margin-bottom: 16px;\n}\n.entities-list .entities-container > *:last-child {\n  margin-bottom: 0px;\n}\n.entities-list .search-box {\n  cursor: pointer;\n  box-sizing: border-box;\n  width: 384px;\n  padding: 5px 18px 5px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--gray-100, #F9FAFB);\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 120%;\n}\n.entities-list .search-box > input {\n  all: unset;\n  width: 100%;\n  margin-left: 8px;\n}\n\n@keyframes horizontal-shaking {\n  0% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(-3px);\n  }\n  50% {\n    transform: translateX(3px);\n  }\n  75% {\n    transform: translateX(-1px);\n  }\n  100% {\n    transform: translateX(1px);\n  }\n}\n.Login {\n  display: flex;\n  justify-content: space-between;\n  min-height: calc(100vh - 56px);\n}\n.Login-form,\n.Login .rigth {\n  width: 50%;\n}\n.Login-form {\n  padding: 32px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: flex-start;\n  position: relative;\n}\n.Login-form .coin {\n  margin-bottom: 13px;\n}\n.Login-form .h1 {\n  margin-bottom: 24px;\n}\n.Login-form .ant-form {\n  width: 100%;\n}\n.Login-form .error-message {\n  margin-top: 50px;\n  color: #8f2f2c;\n}\n.Login-form .button {\n  margin-top: 10px;\n}\n.Login-form .link:hover {\n  color: #404859;\n}\n.Login-form .link .body-regular-bold {\n  text-decoration: underline;\n}\n.Login-form .link-absolute {\n  position: absolute;\n  bottom: 30px;\n  left: 32px;\n  text-decoration: none;\n}\n.Login-form .link-absolute .body-regular-bold {\n  text-decoration: underline;\n}\n.Login .rigth {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: flex-start;\n  position: relative;\n  padding-left: 60px;\n  padding-top: 64px;\n  background-color: #f9fafb;\n}\n.Login .rigth .bottom-flex {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  max-width: 700px;\n}\n.Login .rigth .h2 {\n  margin-bottom: 12px;\n  max-width: 520px;\n}\n.Login .rigth .body-regular {\n  max-width: 520px;\n  margin-bottom: 30px;\n}\n.Login .rigth .back {\n  padding: 7px;\n  padding-bottom: 0;\n  padding-right: 0;\n  background-color: #355c7d;\n  border-top-left-radius: 10px;\n  width: 100%;\n}\n.Login .rigth img {\n  bottom: 0;\n  width: 100%;\n}\n@media (min-height: 735px) {\n  .Login .bottom-flex {\n    height: 470px;\n  }\n  .Login .bottom-flex img {\n    height: 100%;\n  }\n}",".container {\n  max-width: 1300px;\n  width: 100%;\n}\n.cards-step-2 {\n  .body-card {\n    color: #6e7889;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-bottom: 4px;\n  }\n  iframe {\n    width: 100%;\n    height: 120px;\n    border: none;\n    background-color: transparent;\n  }\n  .UploadDocs .input-content {\n    height: 78px;\n\n    input {\n      height: 78px;\n    }\n  }\n}\n.card {\n  &__generic {\n    border-radius: 10px;\n    border: 1px solid #929fb0;\n    box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);\n    width: 100%;\n    padding: 16px;\n  }\n}\n.form {\n  &-item {\n    &__input,\n    .ant-input {\n      padding: 12px 0;\n      border: 0;\n      border-bottom: 1px solid $grey-title;\n      border-radius: 0;\n      &::placeholder {\n        color: $grey-placeholder;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n    }\n  }\n}\n.card-upload {\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  padding: 12px 16px;\n  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);\n  .link {\n    color: #6e7889;\n    text-align: right;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-decoration-line: underline;\n  }\n  p {\n    margin: 10px 0;\n  }\n}\n.flex-btw {\n  display: flex;\n  justify-content: space-between;\n}\n.flex-end {\n  display: flex;\n  justify-content: flex-end;\n}\n.flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n.flex-col {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n}\n.mt {\n  &-20 {\n    margin-top: 20px;\n  }\n  &-25 {\n    margin-top: 25px;\n  }\n  &-30 {\n    margin-top: 30px;\n  }\n  &-40 {\n    margin-top: 40px;\n  }\n  &-50 {\n    margin-top: 50px;\n  }\n  &-60 {\n    margin-top: 60px;\n  }\n  &-12 {\n    margin-top: 12px;\n  }\n  &-6 {\n    margin-top: 6px;\n  }\n  &-5 {\n    margin-top: 5px;\n  }\n  &-10 {\n    margin-top: 10px;\n  }\n  &-15 {\n    margin-top: 15px;\n  }\n}\n.divider-top {\n  border-top: 1px solid #afbdcc;\n}\n\n// inputs ******************************************** inputs\n.input {\n  &-transparent {\n    background-color: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n    padding: 0;\n  }\n  &-number {\n    width: 100%;\n    height: 48px;\n    border-radius: 10px;\n    border: 1px solid #2a2f3c;\n    background: #fff;\n    .ant-input-number-input-wrap {\n      height: 45px;\n      .ant-input-number-input {\n        height: 45px;\n      }\n    }\n    .ant-input-prefix {\n      color: #404859;\n      font-family: Inter;\n      font-size: 16px;\n      font-weight: 400;\n    }\n    input {\n      &::placeholder {\n        color: #929fb0;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: italic;\n        font-weight: 400;\n      }\n    }\n  }\n  &-placeholder-bold {\n    &::placeholder {\n      color: #9bbceb;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n}\n.body-placeholder {\n  &::placeholder {\n    color: #929fb0;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: italic;\n    font-weight: 600;\n    line-height: normal;\n  }\n  &-w4 {\n    &::placeholder {\n      font-weight: 400;\n    }\n  }\n}\n.fz-14 {\n  font-size: 14px;\n}\n.fz-12 {\n  font-size: 12px;\n}\n\n.children {\n  padding-bottom: 20px;\n}\n","//sizes\n$small: 440px;\n$s-medium: 570px;\n$medium: 761px;\n$large: 960px;\n$x-large: 1060px;\n$xx-large: 1250px;\n\n//colors\n$grey-title: #404859;\n$grey-text-op: #6e7889;\n$grey-placeholder: #929fb0;\n$color-primary-button: #162e43;\n$white-button-txt: #f5faff;\n$black-text: #2a2f3c;\n$blue-button-tab: #355c7d;\n$white-button-tab: #dfe4eb;\n$white: #ffffff;\n$black: #000000;\n$red-title: #c94f4a;\n$red-warning: #8f2f2c;\n$grey-border: #ccd3db;\n$green-tab-active-text: #587e5b;\n$green-tab-active: #6eac72;\n\n$state-warning: #775614;\n\n$state-draft-hover: #404859;\n\n$state-review: #AC78B3;\n$state-review-dark: #693B6F;\n$state-review-border: #AC78B3;\n$state-review-border-2: #D7B8E5;\n$state-review-text: #161616;\n$state-review-text-dark: #241226;\n$state-review-label: #855791;\n$state-review-tag: #48244D;\n$state-review-background: #e3ddf0;\n$state-review-background-ligth: #FDFCFF;\n\n$state-approved: #f5faf7;\n$state-approved-border:#92c295;\n$state-approved-border-dark: darken($green-tab-active, 10%); \n$state-approved-title-dark: #3F9545; \n$state-approved-icon: #466849; \n$state-approved-text: #404859;\n$state-approved-text-dark: #1F4222;\n$state-approved-background: #C2F0C5;\n$state-approved-background-ligth: white;\n\n$state-error: #fff4f3;\n$state-error-border: #c94f4a;\n$state-error-icon: #712220;\n$state-error-text: #404859;\n$state-error-text-dark: #8A130F;\n$state-error-dark: #C13934;\n$state-error-background: #FFD4CF;\n$state-error-background-ligth: #FFFFFF;\n\n$state-tag-incomplete: #404859;\n\n$button-disbaled-background: #DFE4EB;\n$button-disbaled-border: #DFE4EB;\n$button-color: #929FB0;\n$button-blue: #5E8EB7;\n","/* http://meyerweb.com/eric/tools/css/reset/\n   v2.0-modified | 20110126\n   License: none (public domain)\n*/\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  margin: 0;\n  height: 100%;\n}\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n/* make sure to set some focus styles for accessibility */\n:focus {\n  outline: 0;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration,\ninput[type=\"search\"]::-webkit-search-results-button,\ninput[type=\"search\"]::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\ninput[type=\"search\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\ntextarea {\n  overflow: auto;\n  vertical-align: top;\n  resize: vertical;\n}\n\n/**\n   * Correct `inline-block` display not defined in IE 6/7/8/9 and Firefox 3.\n   */\n\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n  *display: inline;\n  *zoom: 1;\n  max-width: 100%;\n}\n\n/**\n   * Prevent modern browsers from displaying `audio` without controls.\n   * Remove excess height in iOS 5 devices.\n   */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n   * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.\n   * Known issue: no IE 6 support.\n   */\n\n[hidden] {\n  display: none;\n}\n\n/**\n   * 1. Correct text resizing oddly in IE 6/7 when body `font-size` is set using\n   *    `em` units.\n   * 2. Prevent iOS text size adjust after orientation change, without disabling\n   *    user zoom.\n   */\n\nhtml {\n  font-size: 100%; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -ms-text-size-adjust: 100%; /* 2 */\n}\n\n/**\n   * Address `outline` inconsistency between Chrome and other browsers.\n   */\n\na:focus {\n  outline: thin dotted;\n}\n\n/**\n   * Improve readability when focused and also mouse hovered in all browsers.\n   */\n\na:active,\na:hover {\n  outline: 0;\n}\n\n/**\n   * 1. Remove border when inside `a` element in IE 6/7/8/9 and Firefox 3.\n   * 2. Improve image quality when scaled in IE 7.\n   */\n\nimg {\n  border: 0; /* 1 */\n  -ms-interpolation-mode: bicubic; /* 2 */\n}\n\n/**\n   * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.\n   */\n\nfigure {\n  margin: 0;\n}\n\n/**\n   * Correct margin displayed oddly in IE 6/7.\n   */\n\nform {\n  margin: 0;\n}\n\n/**\n   * Define consistent border, margin, and padding.\n   */\n\nfieldset {\n  border: 0px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n   * 1. Correct color not being inherited in IE 6/7/8/9.\n   * 2. Correct text not wrapping in Firefox 3.\n   * 3. Correct alignment displayed oddly in IE 6/7.\n   */\n\nlegend {\n  border: 0; /* 1 */\n  padding: 0;\n  white-space: normal; /* 2 */\n  *margin-left: -7px; /* 3 */\n}\n\n/**\n   * 1. Correct font size not being inherited in all browsers.\n   * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,\n   *    and Chrome.\n   * 3. Improve appearance and consistency in all browsers.\n   */\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-size: 100%; /* 1 */\n  margin: 0; /* 2 */\n  vertical-align: baseline; /* 3 */\n  *vertical-align: middle; /* 3 */\n}\n\n/**\n   * Address Firefox 3+ setting `line-height` on `input` using `!important` in\n   * the UA stylesheet.\n   */\n\nbutton,\ninput {\n  line-height: normal;\n}\n\n/**\n   * Address inconsistent `text-transform` inheritance for `button` and `select`.\n   * All other form control elements do not inherit `text-transform` values.\n   * Correct `button` style inheritance in Chrome, Safari 5+, and IE 6+.\n   * Correct `select` style inheritance in Firefox 4+ and Opera.\n   */\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/**\n   * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n   *    and `video` controls.\n   * 2. Correct inability to style clickable `input` types in iOS.\n   * 3. Improve usability and consistency of cursor style between image-type\n   *    `input` and others.\n   * 4. Remove inner spacing in IE 7 without affecting normal text inputs.\n   *    Known issue: inner spacing remains in IE 6.\n   */\n\nbutton,\n  html input[type=\"button\"], /* 1 */\n  input[type=\"reset\"],\n  input[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n  cursor: pointer; /* 3 */\n  *overflow: visible; /* 4 */\n}\n\n/**\n   * Re-set default cursor for disabled elements.\n   */\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\n/**\n   * 1. Address box sizing set to content-box in IE 8/9.\n   * 2. Remove excess padding in IE 8/9.\n   * 3. Remove excess padding in IE 7.\n   *    Known issue: excess padding remains in IE 6.\n   */\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n  *height: 13px; /* 3 */\n  *width: 13px; /* 3 */\n}\n\n/**\n   * 1. Address `appearance` set to `searchfield` in Safari 5 and Chrome.\n   * 2. Address `box-sizing` set to `border-box` in Safari 5 and Chrome\n   *    (include `-moz` to future-proof).\n   */\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box; /* 2 */\n  box-sizing: content-box;\n}\n\n/**\n   * Remove inner padding and search cancel button in Safari 5 and Chrome\n   * on OS X.\n   */\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n   * Remove inner padding and border in Firefox 3+.\n   */\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n/**\n   * 1. Remove default vertical scrollbar in IE 6/7/8/9.\n   * 2. Improve readability and alignment in all browsers.\n   */\n\ntextarea {\n  overflow: auto; /* 1 */\n  vertical-align: top; /* 2 */\n}\n\n/**\n   * Remove most spacing between table cells.\n   */\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nhtml,\nbutton,\ninput,\nselect,\ntextarea {\n  color: #222;\n}\n\n::-moz-selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\n::selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\nimg {\n  vertical-align: middle;\n}\n\nfieldset {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\ntextarea {\n  resize: vertical;\n}\n\n.chromeframe {\n  margin: 0.2em 0;\n  background: #ccc;\n  color: #000;\n  padding: 0.2em 0;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\",\n    \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n",".h1 {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.h2 {\n  color: $black-text;\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 120%;\n  &-w8 {\n    font-weight: 800;\n  }\n}\n.h3 {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 135%;\n}\n.h4 {\n  color: $black-text;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 115%;\n  &-cp {\n    text-transform: capitalize;\n  }\n  &-w4 {\n    font-weight: 400;\n  }\n  &-w5 {\n    font-weight: 500;\n  }\n}\n.title-blue-bold {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  color: $blue-button-tab;\n}\n.body-regular {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  &-italic {\n    font-style: italic;\n  }\n  &-up {\n    text-transform: uppercase;\n  }\n  &-bold,\n  &-w6 {\n    font-weight: 600;\n  }\n  &-w5 {\n    font-weight: 500;\n  }\n}\n\n.placeholder {\n  color: $grey-placeholder;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  &-w6 {\n    font-weight: 600;\n  }\n}\n.button-txt-big {\n  color: $white-button-txt;\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n}\n.body-small {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 10px !important;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  &-w4 {\n    font-weight: 400;\n  }\n  &-w6 {\n    font-weight: 600;\n  }\n  &-up {\n    text-transform: uppercase;\n  }\n}\n.small-detail {\n  color: #6e7889;\n  font-family: Inter;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.body-card {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  &-bold-line {\n    font-weight: 700;\n    text-decoration-line: underline;\n  }\n  &-w6 {\n    font-weight: 600;\n  }\n  &-w7 {\n    font-weight: 700;\n  }\n  &-w5 {\n    font-weight: 500;\n  }\n}\n.blue-bold {\n  color: #5e8eb7;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 145%;\n  img {\n    height: 10px;\n    margin-left: 5px;\n  }\n}\n\n.bold {\n  font-weight: 600;\n}\n\n.bold-little {\n  font-weight: 500;\n}\n\n.cursor {\n  cursor: pointer;\n}\n",".button {\n  height: 32px;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  &-empty {\n    background-color: transparent;\n    padding: 0;\n    border: none;\n    box-shadow: none;\n    span {\n      color: #404859 !important;\n      font-family: Inter;\n      font-size: 10px !important;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 16px;\n      letter-spacing: 0.2px;\n    }\n  }\n  &-modal-ok {\n    width: 100%;\n    border-radius: 6px;\n    border: 1px solid #ffc857 !important;\n    background: #ffc857 !important;\n    height: 40px;\n    color: #66564d !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.21px;\n  }\n  &-modal-cancel {\n    width: 100%;\n    border-radius: 6px;\n    border: 1px solid #ddaa42 !important;\n    background: #fff9ee !important;\n    height: 40px;\n    color: #3c302a !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: 0.21px;\n  }\n  &-primary {\n    width: 100%;\n    height: 48px;\n    flex-shrink: 0;\n    border-radius: 6px;\n    border: 1px solid $color-primary-button;\n    background: $color-primary-button;\n    border: none;\n    &:hover {\n      border: none;\n      color: $white-button-txt !important;\n    }\n  }\n  &-secondary {\n    width: 179px;\n    border-radius: 6px;\n    border: 1px solid $blue-button-tab;\n    color: $blue-button-tab;\n\n    &:hover {\n      color: $blue-button-tab !important;\n      border: 1px solid $blue-button-tab !important;\n    }\n  }\n  &-grey {\n    color: #6e7889 !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.18px;\n    border-radius: 6px;\n    border: 1px solid #eff3f5 !important;\n    background: #eff3f5;\n    width: 100%;\n  }\n  &-transparent {\n    padding: 0;\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    color: #48759a;\n    .anticon {\n      color: #48759a;\n    }\n    &:hover {\n      color: #48759a !important;\n    }\n  }\n  &-gray {\n    padding: 0;\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    color: #afbdcc;\n    .anticon {\n      color: #afbdcc;\n    }\n    &:hover {\n      color: #afbdcc !important;\n    }\n  }\n  &-card {\n    width: 100%;\n    color: $black;\n    border: 1px solid $grey-border;\n    &:hover {\n      color: $black !important;\n      border: 1px solid $grey-border !important;\n    }\n  }\n  &-submit {\n    border-radius: 6px;\n    border: 1px solid #122536 !important;\n    background: #122536 !important;\n    color: #fff !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.18px;\n    width: 100%;\n\n    &-delete {\n      all: unset;\n      border: none !important;\n      background-color: transparent !important;\n      &:hover {\n        background: none !important;\n        border-color: transparent !important;\n      }\n    }\n\n    &:disabled {\n      background-color: $button-disbaled-background !important;\n      border-color: $button-disbaled-border !important;\n\n      span {\n        color: $button-color !important;\n      }\n\n      &:hover {\n        background-color: $button-disbaled-background !important;\n        border-color: $button-disbaled-border !important;\n        span {\n          color: $button-color !important;\n        }\n      }\n    }\n\n    &:not(&-delete):hover {\n      background-color: #EBF6FF !important;\n      border-color: #EBF6FF !important;\n      span {\n        color: #355D7D !important;\n      }\n    }\n  }\n\n  &-link {\n    width: 100%;\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    font-weight: 400;\n    color: $black;\n\n    &:hover {\n      color: $black !important;\n    }\n\n    &-REVIEW {\n      color: $state-review-text !important;\n    }\n  }\n\n  &-link-border {\n    width: 100%;\n    border-radius: 6px;\n    border: 1px solid #162E43 !important;\n    background: none;\n    color: #3c302a !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: 0.21px;\n\n    &:disabled {\n      background-color: $button-disbaled-background !important;\n      border-color: $button-disbaled-border !important;\n      color: $button-color !important;\n    }\n  }\n\n  &-link-blue {\n    color: #5E8EB7;\n    span {\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      text-decoration-line: underline;\n    }\n\n    &:hover {\n      color: #5E8EB7 !important;\n    }\n  }\n\n  &-blue {\n    color: #5E8EB7;\n    span {\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n    }\n\n    &:hover {\n      color: #5E8EB7 !important;\n    }\n  }\n\n  &-open-modal {\n    width: 100%;\n\n    &:hover {\n      border-color: $grey-border !important;\n      color: $black !important;\n    }\n\n    &-REVIEW {\n      border-color: $state-review-border;\n      color: $state-review-text;\n  \n      &:hover {\n        border-color: $state-review-border !important;\n        background-color: $state-review-dark !important;\n        color: white !important;\n      }\n    }\n  }\n}\n",".select {\n  &-primary {\n    width: 100%;\n    height: 40px;\n    .ant-select-selector {\n      height: 40px !important;\n      padding: 2px 11px !important;\n      border-radius: 10px !important;\n      border: 1px solid #5e8eb7 !important;\n      .ant-select-selection-search-input {\n        height: 40px !important;\n      }\n    }\n  }\n}\n",".circle {\n    background-color: #fff;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: 1px solid #2a2f3c;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .upload {\n        width: auto;\n        height: 18px;\n        object-fit: cover;\n    }\n}\n\n.circle-state-tooltip {\n    padding: 6px 7px !important;\n    opacity: 1 !important;\n\n    b {\n        font-weight: 600;\n    }\n\n    span {\n        margin-top: 10px;\n    }\n\n    &-APPROVED {\n        background-color: $state-approved-border-dark !important;\n    }\n\n    &-DRAFT {\n        background-color: $state-draft-hover !important;\n    }\n\n    &-REQUEST_ERROR {\n        background-color: $state-error-border !important;\n    }\n\n    &-REVIEW {\n        background-color: $state-review-label !important;\n    }\n}","$button-blue: #5E8EB7;\n$blue-button-tab: #355c7d;\n\n.DrodownBasic {\n    height: 40px;\n    padding: 1px 3px !important;\n    display: flex;\n    align-items: center;\n    border: 1px solid #6E7889;\n    width: 100%;\n\n    span {\n        color: #6E7889;\n        padding-left: 16px;\n    }\n\n\n    &-blue {\n        border: 1px solid #9BBCEB;\n        border-radius: 10px;\n\n        .ant-dropdown-menu {\n            padding: 0px;\n            width: 160px;\n        }\n\n        .ant-dropdown-menu-item {\n            &:hover {\n                background-color: #EBF6FF !important;\n\n                .ant-dropdown-menu-title-content {\n                    color: $blue-button-tab;\n                    font-weight: 600;\n                }\n            }\n        }\n\n        .ant-dropdown-menu-title-content {\n            color: $button-blue;\n            font-weight: 400;\n\n            &:hover {\n                color: $blue-button-tab;\n                font-weight: 600;\n            }\n        }\n    }\n}",".checkbox-basic {\n\n  .ant-checkbox-wrapper {\n    color: #244560;\n    \n    &:hover {\n      .ant-checkbox-inner {\n        border: 1px solid #5E8EB7 !important;\n      }\n\n      .ant-checkbox-checked {\n        .ant-checkbox-inner {\n          background-color: #5E8EB7 !important;\n        }\n      }\n    }\n  }\n\n  .ant-checkbox,\n  .ant-checkbox-input {\n    border: none;\n\n    &:hover {\n      .ant-checkbox-inner {\n        border: 1px solid #5E8EB7 !important;\n      }\n\n      .ant-checkbox-checked {\n        .ant-checkbox-inner {\n          background-color: #5E8EB7 !important;\n        }\n      }\n    }\n  }\n\n  .ant-checkbox-inner {\n    width: 18px;\n    height: 18px;\n    border: 1px solid #5E8EB7;\n  }\n\n  .ant-checkbox-disabled {\n    .ant-checkbox-inner {\n      border-radius: 2px;\n      background: #DFE4EB !important;\n      border: 1px solid #DFE4EB;\n    }\n  }\n\n  .ant-checkbox-checked {\n    &:hover {\n      .ant-checkbox-inner {\n        background-color: #5E8EB7 !important;\n      }\n    }\n\n    .ant-checkbox-inner {\n      border-radius: 2px;\n      background: #5E8EB7;\n    }\n  }\n}",".Layout {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  .content {\n    width: 100%;\n  }\n  .BarLogin {\n    padding: 16px;\n    background-color: #eff3f5;\n    width: 64px;\n    height: 100vh;\n    border-right: 1px solid #dfe4eb;\n    .logo {\n      width: 32px;\n    }\n  }\n}\n",".select-section {\n\n  &-selected {\n    .ant-select-selector {\n      background: #F5FAFF !important;\n      border: 1px solid #5E8EB7 !important;\n      padding-left: 10px !important;\n\n      .ant-select-selection-item {\n        color: #355C7D !important;\n      }\n\n      .ant-select-selection-item-content {\n        color: #5E8EB7 !important;\n      }\n    }\n  }\n\n  .ant-select {\n    display: block;\n    height: 40px;\n    margin-top: 6px;\n\n    .ant-select-selection-placeholder {\n      margin-bottom: 0;\n      color: #6E7889 !important;\n    }\n  }\n}\n\n.ant-select-dropdown {\n\n  div {\n    color: #6E7889;\n  }\n\n  .anticon {\n    display: none;\n  }\n\n  .circle {\n    width: 14px !important;\n    height: 14px !important;\n    border-color: #CCD3DB;\n  }\n}\n\n.ant-select-outlined.ant-select-multiple .ant-select-selection-item {\n  background: none;\n  border: none;\n  \n  span {\n    color: rgb(53, 92, 125) !important;\n  }\n}\n\n.ant-select-item-option-selected {\n  .ant-select-item-option-content {\n    div {\n      color: #48759A !important;\n    }\n\n  }\n}",".task-item-list {\n  .circle-state-tooltip {\n    padding: 6px 7px;\n    opacity: 1;\n\n    b {\n      font-weight: 600;\n    }\n\n    span {\n      margin-top: 10px;\n    }\n\n    &-APPROVED {\n      background-color: $state-approved-border-dark;\n    }\n\n    &-DRAFT {\n      background-color: darken(#DFE4EB, 10%);\n    }\n\n    &-REQUEST_ERROR {\n      background-color: $state-error-border;\n    }\n\n    &-REVIEW {\n      background-color: $state-review-label;\n    }\n  }\n\n  .circles-tags {\n    display: flex;\n    align-items: end;\n    gap: 20px;\n    margin-top: 5px;\n  }\n\n  .circle {\n    width: 16px;\n    height: 16px;\n\n    &-APPROVED {\n      background-color: $green-tab-active;\n      border-color: $green-tab-active-text;\n\n      &:hover {\n        background-color: $state-approved-border-dark;\n      }\n\n      &-active {\n        background-color: $state-approved-border-dark;\n      }\n    }\n\n    &-REVIEW {\n      background-color: $state-review-border;\n      border-color: $state-review;\n\n      &:hover {\n        background-color: $state-review-label;\n      }\n\n      &-active {\n        background-color: $state-review-label;\n      }\n    }\n\n    &-REQUEST_ERROR {\n      background-color: $state-error-background;\n      border-color: $state-error-border;\n\n      &:hover {\n        background-color: $state-error-border;\n      }\n\n      &-active {\n        background-color: $state-error-border;\n      }\n    }\n\n    &-DRAFT {\n      background-color: #DFE4EB;\n      border: 1px solid #CCD3DB;\n\n      &:hover {\n        background-color: darken(#DFE4EB, 5%);\n      }\n\n      &-active {\n        background-color: darken(#DFE4EB, 5%);\n      }\n    }\n\n    &-INCOMPLETE {\n      background-color: $black-text;\n      border: 1px solid $black-text;\n\n      &:hover {\n        background-color: darken($black-text, 5%);\n      }\n\n      &-active {\n        background-color: darken($black-text, 5%);\n      }\n    }\n  }\n}",".LoanProgress {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n\n  .tab {\n    margin: 0 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    .popover-label {\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n    }\n\n    .bar-status {\n      cursor: pointer;\n      width: 100%;\n      width: calc(100% + 20px);\n      height: 8px;\n      border-radius: 16px;\n      margin-top: 6px;\n      background-color: $white-button-tab;\n    }\n\n    &-complete {\n      .text-status {\n        color: #141F15;\n      }\n\n      .body-small {\n        color: #2D7032;\n      }\n\n      .bar-status {\n        background-color: #4CA852;\n\n        &-selected {\n          background-color: #2D7032;\n\n          &:hover {\n            background-color: #2D7032 !important;\n          }\n        }\n\n        &:hover {\n          background-color: #3F9545;\n\n          .body-small {\n            color: #2D7032;\n          }\n        }\n      }\n    }\n\n    &-blocked {\n      .body-small {\n        color: #8A130F;\n      }\n\n      .text-status {\n        color: #610805;\n      }\n\n      .bar-status {\n        background-color: #C13934;\n\n        &-selected {\n          background-color: #8A130F;\n\n          &:hover {\n            background-color: #8A130F !important;\n          }\n        }\n\n        &:hover {\n          background-color: #A31C17;\n\n          .body-small {\n            color: #8A130F;\n          }\n        }\n      }\n    }\n\n    &-error {\n      .body-small {\n        color: #8A130F;\n      }\n\n      .text-status {\n        color: #610805;\n      }\n\n      .bar-status {\n        background-color: #FFDAD6;\n\n        &-selected {\n          background-color: #8A130F;\n\n          &:hover {\n            background-color: #8A130F !important;\n          }\n        }\n\n        &:hover {\n          background-color: #C13934;\n\n          .body-small {\n            color: #8A130F;\n          }\n        }\n      }\n    }\n\n    &-progress {\n\n      .text-status {\n        color: #122536;\n      }\n\n      .body-small {\n        color: #404859;\n      }\n\n      .bar-status {\n        background-color: #5E8EB7;\n\n        &-selected {\n          background-color: #355C7D;\n\n          &:hover {\n            background-color: #355C7D !important;\n          }\n        }\n\n        &:hover {\n          background-color: #48759A;\n\n          .body-small {\n            color: #404859;\n          }\n        }\n      }\n    }\n\n    &-not-started {\n      .bar-status {\n        background-color: white;\n        border: 1px solid #404859;\n\n        &-selected {\n          background-color: #404859;\n\n          &:hover {\n            background-color: #404859 !important;\n          }\n        }\n\n        &:hover {\n          background-color: #929FB0;\n        }\n      }\n    }\n\n    &-open-content {\n      position: absolute;\n      border: 1px solid #929FB0;\n      box-shadow: 2px 2px 10px 0px #0000001A;\n      height: auto;\n      min-height: 253px;\n      width: 825px;\n      background: white;\n      top: 150px;\n      border-radius: 10px;\n      z-index: 99;\n\n      .content {\n        &-bar-status {\n          width: 823px;\n          height: 68px;\n          background: white;\n          border-radius: 10px;\n          display: flex;\n          justify-content: flex-start;\n          align-items: start;\n          gap: 8px;\n          padding-left: 8px;\n          padding-top: 3px;\n\n          .tab {\n            .body-small {\n              font-size: 12px !important;\n            }\n\n            &-error {\n              span {\n                color: #610805;\n              }\n            }\n          }\n\n          .bar-status {\n            width: -webkit-fill-available;\n            height: 16px;\n            border-radius: 16px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            .text-status {\n              display: flex;\n              align-items: center;\n              gap: 3px;\n\n              span {\n                font-family: Inter;\n                font-size: 10px;\n                font-weight: 600;\n              }\n            }\n\n\n            &:hover {\n              span {\n                display: none;\n              }\n\n              .text-status {\n                display: none;\n              }\n            }\n          }\n\n          .tab {\n            margin: 0 0;\n          }\n\n          .tab:nth-child(1) {\n            width: 10%;\n          }\n\n          .tab:nth-child(2) {\n            width: 22%;\n          }\n\n          .tab:nth-child(3) {\n            width: 38%;\n          }\n\n          .tab:nth-child(4) {\n            width: 14%;\n          }\n\n          .tab:nth-child(5) {\n            width: 11%;\n          }\n        }\n\n        &-phase-select {\n          width: 823px;\n          height: auto;\n          min-height: 183px;\n          border-radius: 10px;\n          background: #F9FAFB;\n          border-top: 1px solid #DFE4EB;\n\n          &-complete {\n            background: #F8FFF8;\n            border-top: 1px solid #C2F0C5;\n\n            .tag-state {\n              background: #C2F0C5;\n\n              b,\n              span {\n                color: #141F15;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #1F4222;\n              }\n\n              p {\n                color: #1F4222 !important;\n              }\n\n              &-first {\n                b {\n                  color: #2D7032;\n                }\n              }\n\n            }\n          }\n\n          &-blocked {\n            background: #FCF8F7;\n            border-top: 1px solid #FFC6BF;\n\n            .tag-state {\n              background: #FFD4CF;\n\n              b,\n              span {\n                color: #610805;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #2A2F3C;\n              }\n\n              &-first {\n                b {\n                  color: #610805;\n                }\n              }\n            }\n          }\n\n          &-error {\n            background: #FCF8F7;\n            border-top: 1px solid #FFC6BF;\n\n            .tag-state {\n              background: #FFD4CF;\n\n              b,\n              span {\n                color: #610805;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #2A2F3C;\n              }\n\n              &-first {\n                b {\n                  color: #610805;\n                }\n              }\n            }\n          }\n\n          &-progress {\n            background: #F5FAFF;\n            border-top: 1px solid #B6DCFC;\n\n            .tag-state {\n              background: #B6DCFC;\n\n              b,\n              span {\n                color: #122536;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #2A2F3C;\n              }\n\n              &-first {\n                b {\n                  color: #244560;\n                }\n              }\n            }\n          }\n\n          &-not-started {\n            .tag-state {\n              border: 1px solid #404859;\n            }\n          }\n\n          .tag-state {\n            height: 16px;\n            width: max-content;\n            display: flex;\n            align-items: center;\n            gap: 3.5px;\n            border-radius: 10px;\n            padding: 3px 7px;\n            margin: 16px 23px;\n\n            b {\n              font-size: 10px;\n              font-weight: 600;\n            }\n\n            span {\n              font-size: 10px;\n              font-weight: 400;\n            }\n          }\n\n          .divider {\n            border: 0.7px solid #929FB0;\n            height: auto;\n          }\n\n          .content-phase {\n            margin: 0px 24px;\n            padding-bottom: 23px;\n\n            b {\n              font-size: 12px;\n              font-weight: 600;\n            }\n\n            p {\n              font-size: 12px;\n              font-weight: 400;\n              color: #2A2F3C;\n              margin-top: 6px;\n            }\n\n            &-first {\n              width: 270px;\n\n              b {\n                font-size: 16px;\n                font-weight: 600;\n              }\n            }\n\n            &-second {\n              width: 240px;\n              margin-left: 20px;\n            }\n\n            .task-item {\n              display: flex;\n              align-items: center;\n              gap: 5px;\n              margin-top: 4px;\n              width: max-content;\n              border-radius: 4px;\n              padding: 2px 3px;\n\n              span {\n                font-family: Inter;\n                font-size: 12px;\n              }\n\n              b {\n                font-family: Inter;\n                font-weight: 500;\n              }\n\n              .bold {\n                font-weight: 600 !important;\n              }\n\n              .circle {\n                width: 12px;\n                height: 12px;\n                border: 1px solid #6E7889;\n                border-radius: 50%;\n              }\n\n              &-APPROVED {\n                background-color: #D5F7E2;\n\n                span,\n                b,\n                strong {\n                  color: #2D7032;\n                }\n              }\n\n              &-REQUEST_ERROR,\n              &-BLOCKED {\n                background: #FFC6BF;\n\n                span,\n                b,\n                strong {\n                  color: #610805;\n                }\n              }\n\n              &-REVIEW {\n                background: #F7EDFC;\n\n                span,\n                b,\n                strong  {\n                  color: #855791;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}",".borrowers {\n  padding: 24px 25px;\n\n  .dropdown-review-bold {\n    span {\n      font-weight: 600;\n      text-decoration-line: underline;\n    }\n\n    color: $state-review !important;\n    height: 26px;\n    display: unset;\n    padding: 0 !important;\n  }\n\n  .top-container {\n    box-sizing: content-box;\n    width: 100%;\n\n    margin-bottom: 33px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: space-between;\n\n    .title {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 32px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n\n      >span {\n        cursor: pointer;\n\n        color: var(--blue60, #5E8EB7);\n        font-family: Inter;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        text-decoration-line: underline;\n      }\n    }\n  }\n\n  .badges-container {\n    display: flex;\n  }\n\n  &-container {\n    padding: 16px 0px;\n\n    >* {\n      margin-bottom: 16px;\n      &:last-child {\n        margin-bottom: 0px;\n      }\n    }\n  }\n}\n\n.search-box {\n  cursor: pointer;\n\n  box-sizing: border-box;\n  width: 384px;\n  padding: 5px 18px 5px 8px;\n\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--gray-100, #F9FAFB);\n\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 120%;\n\n  >input {\n    all: unset;\n    width: 100%;\n    margin-left: 8px;\n  }\n}\n\n.status-badge {\n  cursor: pointer;\n\n  padding: 4px 12px;\n  border-radius: 100px;\n\n  display: flex;\n  align-items: center;\n\n  background: var(--300-grey, #DFE4EB);\n\n  margin-right: 12px;\n\n  .title {\n    margin-right: 4px;\n\n    color: var(--800-grey, #404859);\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 16px; /* 133.333% */\n\n    white-space: nowrap;\n  }\n\n  .count {\n    color: var(--800-grey, #404859);\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px; /* 133.333% */\n  }\n\n  &.selected {\n    background: #355C7D;\n    .title, .count {\n      color: #FFFFFF;\n    }\n  }\n}\n\n.borrower-list-item {\n  cursor: pointer;\n\n  box-sizing: border-box;\n  width: 100%;\n\n  display: flex;\n  align-items: center;\n\n\n  padding: 8px 24px 8px 16px;\n\n  border-radius: 10px;\n  border: 1px solid var(--600-grey, #929FB0);\n  background: var(--white, #FFF);\n\n  >* {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n\n    &.loan-status-badge-container {\n      flex: 0.8\n    }\n    \n    &.borrower-summary-container {\n      flex: 0.5;\n    }\n  }\n\n  .loan-status-badge {\n    display: inline-block;\n\n    border-radius: 76px;\n    border: 1px solid var(--blue60, #5E8EB7);\n\n    padding: 4px 7px;\n\n    color: var(--70, #48759A);\n    text-align: center;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.2px;\n    text-transform: uppercase;\n  }\n\n  .borrower-summary {\n    .caption {\n      color: var(--700-grey, #6E7889);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n\n      margin-bottom: 2px;\n    }\n\n    .borrower-name {\n      color: var(--900-grey, #2A2F3C);\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 115%;\n      text-transform: capitalize;\n    }\n  }\n\n  .entities-summary {\n    .caption {\n      color: var(--700-grey, #6E7889);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n\n      margin-bottom: 2px;\n    }\n\n    .content {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n      white-space: nowrap;\n      display: flex;\n      gap: 3px;\n      align-items: center;\n    }\n  }\n\n  .task-summary {\n    padding-left: 10px;\n    display: flex;\n    flex-direction: column;\n\n    .caption {\n      color: var(--700-grey, #6E7889);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n\n      margin-bottom: 2.5px;\n    }\n\n    .task-item-container {\n      display: flex;\n      gap: 9px;\n\n      .task-item {\n        box-sizing: border-box;\n        height: 15px;\n        width: 15px;\n        border-radius: 100px;\n        \n        margin-right: 8px;\n\n        background-color: #DFE4EB;\n        border: 1.5px solid #CCD3DB;\n\n        &.completed {\n          background-color: #4CA852;\n          border: unset;\n        }\n\n        &.review {\n          background-color: #855791;\n          border: unset;\n        }\n      }\n    }\n  }\n\n  .action-container {\n    color: var(--blue60, #5E8EB7);\n    text-align: right;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n\n    white-space: nowrap;\n\n    align-self: flex-end;\n  }\n\n  &:hover {\n    border-radius: 10px;\n    border: 1px solid var(--blue-40, #97BCF0);\n    background: var(--10, #F5FAFF);\n    box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.10);\n\n    .borrower-summary {\n      .caption {\n        color: var(--70, #48759A);\n      }\n      .borrower-name {\n        color: var(--90, #244560);\n      }\n    }\n\n    .address-summary {\n      .caption {\n        color: var(--70, #48759A);\n      }\n      .address {\n        color: var(--blue-80, #355C7D);\n      }\n    }\n\n    .task-summary {\n      .caption {\n        color: var(--70, #48759A);\n      }\n    }\n\n    .action-container {\n      color: var(--70, #48759A);\n      font-weight: 600;\n\n      &:hover {\n        color: var(--90, #244560);\n        font-weight: 700;\n      }\n    }\n  }\n}",".right-scenes{\n  position: fixed;\n  background: rgba(42, 47, 60, 0.55);\n  backdrop-filter: blur(2px);\n  top: 0;\n  left: 70px;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &-content {\n    position: relative;\n    width: calc(100% - 70px); /* Ancho de la pantalla menos 70px */\n    background-color: #fff;\n    height: 100%;\n    animation: slideIn 1s forwards;\n  }\n\n  @keyframes slideIn {\n    from {\n      transform: translateX(calc(-100% + 70px));\n    }\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  .button-close-mask {\n    width: 30%;\n    height: 100%;\n    background-color: rgba(255, 0, 0, 0);\n    box-shadow: none;\n    border: none;\n\n    &:hover,\n    &:active,\n    &:focus {\n      background-color: rgba(255, 0, 0, 0);\n      box-shadow: none;\n      border: none;\n    }\n  }\n}",".view-borrower-detail {\n  padding: 50px 15px;\n  &-header {\n    .title {\n      color: $state-draft-hover;\n      font-size: 32px;\n      font-weight: 600;\n      gap: 5px;\n\n      button {\n        height: 32px;\n        span {\n          font-size: 32px;\n        }\n      }\n    }\n  }\n  .button-r,\n  .button-r:hover {\n    width: 58px;\n    height: 20px;\n    border: 1px solid #bb8d2f;\n    color: #bb8d2f;\n    border-radius: 76px;\n    padding: 0;\n    font-family: Inter;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 12.1px;\n    margin: 0 15px;\n  }\n  .button-delete,\n  .button-delete:hover {\n    height: 20px;\n    border: none;\n    color: #c94f4a;\n    padding: 0;\n    font-family: Inter;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 12.1px;\n    margin: 0 15px;\n  }\n  .flex-2-col {\n    display: flex;\n    margin-top: 20px;\n    justify-content: space-between;\n    width: 100%;\n    gap: 30px;\n    .box {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n      width: 50%;\n    }\n  }\n  .gap-3 {\n    gap: 6px;\n  }\n  .card-profile-generic {\n    border: 1px solid #afbdcc;\n    border-radius: 10px;\n    padding: 15px;\n    width: 100%;\n    .card-title {\n      font-family: Inter;\n      font-size: 24px;\n      font-weight: 400;\n      line-height: 29.05px;\n      text-align: left;\n    }\n    .table {\n      width: 100%;\n      margin-top: 10px;\n      &-row {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        margin-bottom: 7px;\n        .title {\n          font-family: Inter;\n          font-size: 12px;\n          font-weight: 400;\n          line-height: 14.52px;\n          text-align: left;\n          color: #6e7889;\n        }\n\n        .flex {\n          display: flex;\n          justify-content: space-between;\n          .col {\n            width: 50%;\n            .italic {\n              font-family: Inter;\n              font-size: 14px;\n              font-style: italic;\n              font-weight: 400;\n              line-height: 16.94px;\n              text-align: left;\n              color: #929fb0;\n            }\n          }\n        }\n      }\n    }\n    .avatar {\n      .ant-avatar-string {\n        font-size: 25px;\n      }\n\n      .ant-upload {\n        width: 68px !important;\n        height: 68px !important;\n      }\n    }\n\n    .ant-upload-wrapper.ant-upload-picture-circle-wrapper {\n      width: auto;\n    }\n\n    .title-bold {\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 16.94px;\n      text-align: left;\n      color: #404859;\n      .bold {\n        font-weight: 600;\n      }\n    }\n    .body-bold {\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 16.94px;\n      text-align: right;\n    }\n    .button-transparent,\n    .button-transparent:hover {\n      padding: 0;\n      height: 20px;\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 16.94px;\n      text-align: left;\n      color: #8a130f;\n    }\n    .button-round {\n      width: 75px;\n      height: 20px;\n      padding: 0;\n      border-radius: 76px;\n      border: 2px solid #404859;\n      font-family: Inter;\n      font-size: 10px;\n      font-weight: 600;\n    }\n    .button-edit,\n    .button-edit:hover {\n      font-family: Inter;\n      font-size: 10px;\n      font-weight: 500;\n      line-height: 12px;\n      text-align: left;\n      color: #5e8eb7;\n      .edit {\n        width: 10px;\n        height: 10px;\n        margin-right: 3px;\n      }\n    }\n    .link {\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 16.94px;\n      text-align: left;\n      color: #5e8eb7;\n      text-decoration: none;\n      .arrow {\n        width: 15px;\n        margin-left: 5px;\n      }\n    }\n    .text-footer {\n      font-family: Inter;\n      font-size: 12px;\n      font-weight: 400;\n      line-height: 14.52px;\n      text-align: left;\n      color: #6e7889;\n      margin-top: 14px;\n      span {\n        color: #4e8aff;\n      }\n    }\n  }\n  \n  .card-report {\n    position: relative;\n\n    .button {\n      span {\n        font-family: Inter;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 19.36px;\n        letter-spacing: 0.015em;\n        text-align: center;\n      }\n    }\n\n    .button-edit {\n      position: absolute;\n      top: 8px;\n      right: 15px;\n\n      span {\n        font-family: Inter;\n        font-size: 10px;\n        font-weight: 500;\n        line-height: 12px;\n        text-align: left;\n        color: #5e8eb7;\n      }\n    }\n\n    &-head {\n      display: flex;\n      justify-content: space-between;\n    }\n\n    .date-expires {\n      font-family: Inter;\n      font-size: 14px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: 16.94px;\n      text-align: right;\n      color: #6E7889;\n    }\n\n    .upload-report-span {\n      cursor: pointer;\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 16.94px;\n      text-align: right;\n      color: #5E8EB7;\n      text-decoration: underline;\n    }\n\n    .credit-score-input {\n      input {\n        text-align: end;\n      }\n    }\n  }\n}\n",".loan-details {\n  padding: 43px 40px;\n\n  overflow: hidden;\n\n  .loan-details-top-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    padding-bottom: 8px;\n    border-bottom: 1px solid #929FB0;\n    margin-bottom: 22px;\n\n    .loan-info {\n      margin-bottom: 2px;\n      \n      .loan-borrower-name {\n        color: var(--800-grey, #404859);\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 16px; /* 133.333% */\n        letter-spacing: 0.24px;\n        text-transform: uppercase;\n      }\n\n      .loan-address {\n        color: var(--800-grey, #404859);\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 16px;\n        letter-spacing: 0.24px;\n        text-transform: uppercase;\n      }\n    }\n\n    .close-button-container {\n      cursor: pointer;\n\n      color: var(--800-grey, #404859);\n      text-align: right;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 16px; /* 133.333% */\n      letter-spacing: 0.24px;\n      text-transform: uppercase;\n    }\n  }\n\n  .loan-details-first-row {\n    display: flex;\n    justify-content: space-between;\n\n    border-bottom: solid 1px #CCD3DB;\n    margin-bottom: 16px;\n\n    .loan-progress {\n      flex: 6;\n      .loan-info {\n        .loan-status {\n          color: var(--800-grey, #404859);\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 16px;\n          letter-spacing: 0.36px;\n        }\n\n        .loan-closing-date {\n          color: var(--800-grey, #404859);\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 16px;\n          letter-spacing: 0.36px;\n\n          b {\n            color: var(--800-grey, #404859);\n            font-family: Inter;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 16px;\n            letter-spacing: 0.36px;\n          }\n        }\n      }\n\n      .loan-address {\n        color: var(--900-grey, #2A2F3C);\n        font-family: Inter;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 40px;\n      }\n\n      .loan-progress-section {\n        margin-bottom: 20px;\n\n        .loan-progress-items-container {\n          display: flex;\n          flex-direction: row;\n\n          >* {\n            flex: 1;\n            margin-right: 8px;\n          }\n\n          .loan-progress-item-caption {\n            color: var(--800-grey, #404859);\n            font-family: Inter;\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n\n            white-space: nowrap;\n            margin-bottom: 6px;\n\n            flex: 0.13;\n          }\n        }\n      }\n\n      .loan-values-summary {\n        margin-bottom: 8px;\n\n        color: var(--800-grey, #404859);\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 115%;\n\n        span {\n          cursor: pointer;\n\n          color: var(--blue60, #5E8EB7);\n          font-family: Inter;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 115%;\n        }\n      }\n  \n    }\n\n    .placeholder {\n      flex: 3;\n    }\n\n    .borrower-card {\n      flex: 1;\n    }\n  }\n\n  .loan-details-main {\n    display: flex;\n\n    >* {\n      flex: 1;\n      box-sizing: border-box;\n    }\n\n    .left-column {\n      padding-right: 15px;\n\n      >* {\n        margin-bottom: 16px;\n\n        &:last-of-type {\n          margin-bottom: 0px;\n        }\n      }\n\n      .loan-summary {\n        display: flex;\n        justify-content: space-between;\n\n        .closing {\n          flex: 1;\n\n          border-radius: 10px;\n          border: 1px solid var(--500-grey, #AFBDCC);\n          \n          padding: 16px 20px;\n\n          margin-right: 16px;\n\n          .label {\n            color: var(--900-grey, #2A2F3C);\n            font-family: Inter;\n            font-size: 22px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n\n            margin-bottom: 18px;\n          }\n\n          .calendar {\n            width: 128px;\n\n            border-radius: 10px;\n            border: 1px solid var(--blue60, #5E8EB7);\n            background: var(--10, #F5FAFF);\n\n            margin-bottom: 8px;\n\n            &.disabled {\n              border: 1px solid var(--600-grey, #929FB0);\n              background: var(--200-grey, #EFF3F5);\n\n              .date {\n                color: var(--70, #48759A);\n                border-bottom: 1px solid #929FB0;\n              }\n\n              .day {\n                color: var(--300-grey, #DFE4EB);\n              }\n            }\n\n            .date {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n\n              padding: 6px 26px;\n\n              border-bottom: 1px solid #5E8EB7;\n\n              color: var(--70, #48759A);\n              font-family: Inter;\n              font-size: 14px;\n              font-style: normal;\n              font-weight: 600;\n              line-height: 16px; /* 114.286% */\n            }\n\n            .day {\n              height: 68px;\n\n              display: flex;\n              align-items: center;\n              justify-content: center;\n\n              color: var(--blue-80, #355C7D);\n              font-family: Inter;\n              font-size: 32px;\n              font-style: normal;\n              font-weight: 600;\n              line-height: normal;\n            }\n          }\n          \n          .caption {\n            color: var(--800-grey, #404859);\n            font-family: Inter;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 18px; /* 128.571% */\n\n            b {\n              font-weight: 600;\n              color: #404859;\n            }\n          }\n        }\n\n        .content-box {\n          flex: 5;\n        }\n      }\n    }\n\n    .right-column {\n      padding-left: 15px;\n\n      .borrower-tasks {\n        >.title {\n          margin-bottom: 8px;\n\n          color: var(--900-grey, #2A2F3C);\n          font-family: Inter;\n          font-size: 32px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 40px;\n        }\n\n        .borrower-tasks-status-container {\n          display: flex;\n          margin-bottom: 16px;\n        }\n\n        .borrower-tasks-actions {\n          display: flex;\n          align-items: center;\n          justify-content: flex-end;\n          margin-bottom: 7px;\n\n          >div {\n            cursor: pointer;\n\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 3px;\n\n            svg {\n              position: relative;\n            }\n\n            margin-left: 16px;\n\n            color: var(--700-grey, #6E7889);\n            text-align: right;\n            font-family: Inter;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            letter-spacing: 0.24px;\n            text-transform: uppercase;\n          }\n        }\n\n        .borrower-tasks-list {\n          margin-bottom: 17px;\n        }\n      }\n\n      .action-button {\n        border: 1px solid var(--100, #162E43);\n        background: var(--100, #162E43);\n        text-align: center;\n\n        border-radius: 6px;\n        padding: 14px 0px;\n        margin-bottom: 30px;\n\n        color: var(--10, #F5FAFF);\n        text-align: center;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        letter-spacing: 0.24px;\n\n        &:hover {\n          background-color: #EBF6FF !important;\n          border-color: #EBF6FF !important;\n    \n          color: #355D7D !important;\n        }\n      }\n\n      .loan-documents {\n        >.title {\n          margin-bottom: 8px;\n\n          color: var(--900-grey, #2A2F3C);\n          font-family: Inter;\n          font-size: 32px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 40px;\n        }\n\n        .loan-documents-list {\n          \n        }\n      }\n\n      .approve-loan {\n        padding: 14px 0px;\n        text-align: center;\n\n        border-radius: 6px;\n        border: 1px solid var(--300-grey, #DFE4EB);\n        background: var(--300-grey, #DFE4EB);\n\n        color: var(--600-grey, #929FB0);\n        text-align: center;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        letter-spacing: 0.24px;\n      }\n    }\n  }\n}\n\n.loan-progress-item {\n  .caption {\n    color: var(--800-grey, #404859);\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    white-space: nowrap;\n    text-align: center;\n\n    margin-bottom: 4px;\n  }\n\n  .loan-progress-bar {\n    width: 100%;\n    height: 6px;\n    border-radius: 16px;\n    background: var(--300-grey, #DFE4EB);\n  }\n}\n\n.content-box {\n  border-radius: 10px;\n  border: 1px solid var(--500-grey, #AFBDCC);\n\n  padding: 16px 20px;\n\n  .label {\n    color: var(--900-grey, #2A2F3C);\n    font-family: Inter;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    margin-bottom: 10px;\n  }\n\n  .content {\n    border-left: 1px solid #97BCF0;\n    padding: 2px 0px;\n    padding-left: 12px;\n\n    .item {\n      margin-bottom: 8px;\n      \n      &:last-of-type {\n        margin-bottom: 0px;\n      }\n    }\n\n    .item-row {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    \n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .value {\n        i {\n          color: var(--700-grey, #6E7889);\n        }\n\n        span {\n          cursor: pointer;\n          \n          color: var(--blue60, #5E8EB7);\n          text-align: right;\n          font-family: Inter;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: normal;\n        }\n      }\n\n      &.extra {\n        margin-top: 8px;\n        padding-left: 16px;\n\n        color: var(--900-grey, #2A2F3C);\n        font-family: Inter;\n        font-size: 14px;\n        font-style: italic;\n        font-weight: 400;\n        line-height: normal;\n\n        .value {\n          color: var(--700-grey, #6E7889);\n        }\n      }\n    }\n  }\n}\n",".document-item {\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n\n  gap: 8px;\n\n  padding: 11px 16px;\n\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--white, #FFF);\n\n  &-COMPLETE {\n    border-radius: 10px;\n    border: 1px solid var(--green-60, #4CA852);\n    background: #FAFCFC;\n    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n\n    .label {\n      color: var(--green-90, #1F4222);\n      font-family: Inter;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: #1F4222;\n      }\n    }\n\n    .status-badge {\n      background: var(--30, #C2F0C5);\n      color: var(--100, #141F15);\n    }\n  }\n\n  &-VERIFY\\/UPDATE {\n    border-radius: 10px;\n    border: 1px solid var(--60, #C59ED5);\n    background: var(--10, #FAF9FC);\n    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n\n    .label {\n      color: var(--90, #653B6F);\n      font-family: Inter;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: var(--90, #653B6F);\n      }\n    }\n\n    .status-badge {\n      background: #EAD6FF;\n      color: var(--100, #141F15);\n    }\n  }\n\n  &-UPLOAD {\n    border-radius: 10px;\n    border: 1px solid #C13934;\n    background: #FAFCFC;\n    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n\n    .label {\n      color: #610805;\n      font-family: Inter;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: #610805;\n      }\n    }\n\n    .status-badge {\n      background: #FFC6BF;\n      color: var(--100, #141F15);\n    }\n  }\n\n  &-DRAFT { \n    svg {\n      &:not(.trash) {\n        path {\n          stroke: #929FB0;\n        }\n      }\n  \n      &.trash {\n        path {\n          stroke: #FFC6BF;\n        }\n      }\n    }\n  \n    .label {\n      color: var(--600-grey, #929FB0);\n      font-family: Inter;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n  \n    .status-badge {\n      background: var(--30, #EFF3F5);\n      color: var(--100, #404859);\n    } \n  }\n\n  svg {\n    height: 16px;\n    width: 16px;\n\n    margin-right: 8px;\n\n    &:last-of-type {\n      margin-right: 0px;\n    }\n  }\n\n  margin-bottom: 12px;\n\n  .actions-container {\n    display: flex;\n    gap: 8px;\n    width: 40px;\n\n    .disabled {\n      opacity: 0.3;\n      cursor: auto;\n    }\n  }\n\n  .label {\n    width: 20em;\n    font-size: 22px;\n    display: flex;\n    align-items: center;\n\n    .expires-label {\n      margin-left: 24px;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: italic;\n      font-weight: 400;\n      text-align: left;\n\n      &-error {\n        color: #E56A5C !important;\n      }\n\n      &-approved {\n        color: #3F9545 !important;\n      }\n    }\n  }\n\n  .feedback-actions-container {\n    display: flex;\n    align-items: start;\n\n    .action-blocked {\n      &-disabled {\n        opacity: 0.3;\n        cursor: auto;\n      }\n\n      &-blocked {\n        svg {\n          fill: #FFC6BF;\n        }\n\n        svg:not(.trash) {\n          path {\n            stroke: #610805;\n          }\n        }\n      }\n    }\n  }\n\n  .content-right {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    justify-content: end;\n    width: 50%;\n\n    .document-state {\n      width: 200px;\n      display: flex;\n      justify-content: end;\n    }\n  }\n\n\n  .expand { \n    flex: 0.2;\n  }\n}",".borrower-card {\n  display: flex;\n  flex-direction: column;\n\n  border-radius: 10px;\n  background: var(--gray-100, #F9FAFB);\n  height: 112px;\n  padding: 7px 14px;\n\n  .borrower-summary {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 256px;\n    \n\n    position: relative;\n    bottom: 8px;\n\n    .photo-container {\n      position: absolute; \n      top: -8px;\n      border-radius: 24px;\n      background: lightgray 50%;\n\n      margin-bottom: 4px;\n    }\n\n    .borrower-caption {\n      margin-top: 22px;\n      color: var(--700-grey, #6E7889);\n      text-align: center;\n      font-family: Inter;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      text-transform: uppercase;\n    }\n\n    .borrower-name {\n      color: var(--900-grey, #2A2F3C);\n      text-align: center;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n    }\n  }\n\n  .contact-info-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    color: var(--800-grey, #404859);\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    margin-bottom: 8px;\n  }\n\n  .buttons-container {\n    width: 100%;\n\n    >*:first-child {\n      margin-right: 8px;\n    }\n\n    .button-blue {\n      width: 100%;\n      cursor: pointer;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      color: var(--100, #122536);\n      text-align: center;\n      font-family: Inter;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      letter-spacing: 0.15px;\n\n      height: 24px;\n      padding: 0px 6px;\n\n      border-radius: 6px;\n      border: 1px solid var(--100, #162E43);\n      background: var(--100, #122536);\n\n      &:hover {\n        color: var(--100, #122536) !important;\n      }\n    }\n\n    .button-blue.outlined {\n      color: var(--100, #122536);\n      background: #FFF;\n    }\n  }\n}",".borrower-task-item {\n  \n  display: flex;\n  flex-direction: column;\n  \n  padding: 11px 16px;\n  \n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--white, #FFF);\n  margin-bottom: 12px;\n  \n  .row-1 {\n    display: flex;\n    align-items: center;\n  \n    .actions-container {\n      width: 40px;\n      display: flex;\n      gap: 8px;\n\n      img,svg {\n        cursor: pointer;\n      }\n    }\n  \n    .label {\n      margin-left: 10px;\n      width: 20em;\n    }\n  \n    .feedback-actions-container {\n      display: flex;\n      width: 20px;\n      max-width: 5em;\n\n      svg {\n        cursor: pointer;\n      }\n    }\n\n    .content-right {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      justify-content: end;\n      width: 50%;\n\n      .content-status {\n        width: 150px;\n        display: flex;\n        justify-content: end;\n      }\n    }\n\n    .expand { \n      width: 20px;\n    }\n  }\n\n  svg {\n    height: 16px;\n    width: 16px;\n\n    margin-right: 8px;\n\n    &:last-of-type {\n      margin-right: 0px;\n    }\n\n    &:not(.trash) {\n      path {\n        stroke: #2A2F3C;\n      }\n    }\n  }\n\n  .label {\n    color: var(--900-grey, #2A2F3C);\n    font-family: Inter;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n\n  .status-badge {\n    background: var(--30, #404859);\n    .title {\n      color: var(--100, #FFFFFF);\n    }\n  } \n\n  &.DRAFT {\n    svg:not(.trash) {\n      path {\n        stroke: #404859;\n      }\n    }\n\n    .status-badge {\n      border: 1px solid var(--60, #404859);\n      background: var(--30, #FFFFFF);\n      .title {\n        color: var(--100, #404859);\n      }\n    }\n  }\n\n  &.REVIEW {\n    border: 1px solid var(--60, #C59ED5);\n    background: var(--10, #FAF9FC);\n\n    .label {\n      color: var(--90, #653B6F);\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: #653B6F;\n      }\n    }\n\n    .status-badge {\n      background: var(--30, #EAD6FF);\n      .title {\n        color: var(--100, #241226);\n      }\n    }\n\n    .liquidity-info {\n      .title {\n        color: #653B6F !important;\n      }\n\n      .max {\n        color: #653B6F;\n      }\n    }\n\n    .box-message-state-review {\n      margin-top: 10px;\n      margin-left: 60px;\n      margin-right: 28px;\n      padding: 5px 8px;\n      background-color: $state-review-background-ligth;\n      color: $state-review-label;\n      border: 1px solid $state-review-border-2;\n      span {\n        font-size: 12px;\n        font-weight: 400;\n      }\n      b {\n        font-size: 12px;\n        font-weight: 700;\n      }\n      button {\n        height: auto;\n        padding: 0px;\n        span {\n          text-decoration: underline;\n          color: $state-review-label;\n          font-size: 12px;\n        }\n        svg {\n          width: 12px;\n          height: 12px;\n        }\n        .anticon {\n          margin-inline-start: 5px;\n        }\n      }\n\n      .button-bold {\n        span {\n          font-weight: 600;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n  \n  &.REQUEST_ERROR {\n    border: 1px solid var(--60, #C13934);\n    background: var(--10, #FFFFFF);\n\n    .label {\n      color: var(--90, #610805);\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: #610805;\n      }\n    }\n\n    .status-badge {\n      background: var(--30, #FFC6BF);\n      .title {\n        color: var(--100, #241226);\n      }\n    }\n  }\n\n  &.APPROVED {\n    border: 1px solid var(--60, #4CA852);\n    background: var(--10, #FAFCFC);\n\n    .label {\n      color: var(--90, #1F4222);\n    }\n\n    svg:not(.trash) {\n      path {\n        stroke: #1F4222;\n      }\n    }\n\n    .status-badge {\n      background: var(--30, #C2F0C5);\n      .title {\n        color: var(--100, #241226);\n      }\n    }\n  }\n\n  .liquidity-info {\n    margin-top: 10px;\n    margin-left: 55px;\n\n    .label {\n      font-weight: 500;\n      font-size: 12px;\n    }\n\n    .max {\n      font-weight: 600;\n      font-size: 12px;\n    }\n  }\n\n}",".cont-modal {\n  width: 100%;\n}\n\n.ModalTask {\n  position: fixed;\n  background: rgba(42, 47, 60, 0.55);\n  backdrop-filter: blur(2px);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 300;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .content-add {\n    margin-top: 50px;\n  }\n  \n  &-content {\n    width: 70%;\n    background-color: #fff;\n    height: 100%;\n  }\n  .button-close-mask {\n    width: 30%;\n    height: 100%;\n    background-color: rgba(255, 0, 0, 0);\n    box-shadow: none;\n    border: none;\n    &:hover,\n    &:active,\n    &:focus {\n      background-color: rgba(255, 0, 0, 0);\n      box-shadow: none;\n      border: none;\n    }\n  }\n\n  .content-modal {\n    // padding: 40px;\n    padding-bottom: 0;\n    .modal-title {\n      width: 100%;\n      padding: 40px;\n      padding-bottom: 0;\n      .flex-btw {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        border-bottom: 1px solid $grey-placeholder;\n      }\n      button,\n      button:hover,\n      button:active,\n      button:focus {\n        background-color: transparent;\n        border: none !important;\n        padding: 0 !important;\n        box-shadow: none !important;\n        color: $grey-title !important;\n      }\n      .body-card {\n        color: #404859;\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 16px; /* 133.333% */\n        letter-spacing: 0.24px;\n      }\n    }\n    .modal-container {\n      position: relative;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: flex-start;\n      height: calc(100vh - 180px);\n      .dots {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        position: absolute;\n        top: 45%;\n        left: 30px;\n        gap: 9px;\n        &-button {\n          padding: 0;\n          border: 1.5px solid #6e7889;\n          background: #fff;\n          width: 8px;\n          height: 8px;\n          border-radius: 50%;\n          &-success {\n            border: 1px solid #6EAC72;\n            background: #C5F0C8;\n          }\n          &-active {\n            height: 25px;\n            width: 25px;\n            border: 2px dotted #ddaa42;\n          }\n          &-review-active {\n            height: 25px;\n            width: 25px;\n            border: 2px dotted #ddaa42;\n            background: $state-review-background;\n          }\n        }\n      }\n      .modal-title {\n        border-bottom: 0;\n        align-items: flex-end;\n        button {\n          height: 18px;\n          text-transform: uppercase;\n          color: #8a5791 !important;\n          img {\n            margin-top: -0.9px;\n            margin-right: 3px;\n          }\n        }\n      }\n      .text {\n        margin-top: 5px;\n        a {\n          margin-left: 6px;\n          &:hover {\n            color: $black-text;\n          }\n        }\n      }\n\n      .modal-cards {\n        width: 100%;\n        height: 100%;\n        padding-bottom: 20px;\n        padding-top: 64px;\n        overflow: auto;\n        padding-right: 10px;\n        max-width: 576px;\n        &--full {\n          max-width: none;\n          display: flex;\n          justify-content: center;\n        }\n        &-mx-w {\n          max-width: 576px;\n          width: 100%;\n          padding-bottom: 20px;\n        }\n\n        .flex-btw {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          width: 100%;\n          margin-bottom: 12px;\n          .button {\n            text-transform: uppercase;\n            color: #404859;\n            text-align: right;\n            font-family: Inter;\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 120%;\n            text-transform: uppercase;\n            .anticon {\n              color: #404859;\n            }\n          }\n        }\n        .title {\n          background: #e3ddf0;\n          border-radius: 140px;\n          display: flex;\n          padding: 5px 12px 5px 10px;\n          justify-content: center;\n          align-items: center;\n          gap: 4px;\n\n          .body-regular {\n            color: #48244d;\n          }\n        }\n        .h2 {\n          margin-top: 12px;\n        }\n        .h2-w8 {\n          color: #ac78b3;\n        }\n        &::-webkit-scrollbar {\n          width: 8px;\n          border-radius: 5px;\n        }\n\n        /* Track */\n        &::-webkit-scrollbar-track {\n          background: #f1f1f1;\n        }\n\n        /* Handle */\n        &::-webkit-scrollbar-thumb {\n          background: #888;\n          border-radius: 5px;\n        }\n\n        /* Handle on hover */\n        &::-webkit-scrollbar-thumb:hover {\n          background: #555;\n        }\n      }\n    }\n  }\n  .modal-review-task__footer {\n    border-top: 1px solid #dfe4eb;\n    height: 180px;\n    .text-footer {\n      .placeholder {\n        color: #6e7889;\n        span {\n          color: #f5faff;\n          font-weight: 600;\n          background-color: #5e8eb7;\n          padding: 0 5px;\n          border-radius: 3px;\n        }\n      }\n    }\n    .footer-grey {\n      .h4 {\n        color: #6e7889;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 170%;\n      }\n    }\n    .body-regular {\n      color: #6e7889;\n    }\n    .footer_dost {\n      .body-regular {\n        color: #404859;\n      }\n      align-items: center;\n      .circles {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 24px;\n        .circle {\n          border-radius: 64px;\n          border: 1px solid #404859;\n          width: 20px;\n          height: 20px;\n        }\n      }\n    }\n    .modal-container {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: flex-start;\n      height: 100%;\n      padding-right: 15px;\n      .modal-cards {\n        width: 100%;\n        height: 100%;\n        max-width: 576px;\n        padding: 14px 0;\n\n        .h4-w4 {\n          color: #ac78b3;\n          margin-bottom: 10px;\n          .h4 {\n            color: #6e7889;\n          }\n        }\n        .flex {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          width: 100%;\n          .circles {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            gap: 24px;\n            .circle {\n              border-radius: 100%;\n              border: 1px solid #8a5791;\n              background: #dfb8e5;\n              width: 20px;\n              height: 20px;\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              &-active {\n                border: 1px solid #587e5b;\n                background: #6eac72;\n                img {\n                  display: none;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".ModalTask-content-right {\n  width: 35%;\n  background-color: #fff;\n  height: 100%;\n  border-left: 1px solid #ccd3db;\n  overflow: scroll;\n  padding: 60px 45px 25px 30px;\n\n  .w-md-editor .title {\n    line-height: unset !important;\n    font-size: unset !important;\n    font-weight: unset !important;\n  }\n\n  .button-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    color: black;\n\n    &:hover {\n      color: black !important;\n    }\n  }\n}",".modal-end-submit {\n  border-radius: 10px;\n  border: 1px solid var(--yellow-400, #ffd47d);\n  background: var(--yellow-100, #fff9ee);\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n  padding: 0;\n  width: 556px !important;\n  top: 202px !important;\n  .ant-checkbox-checked {\n    .ant-checkbox-inner {\n      background-color: #162e43 !important;\n      border-color: #162e43 !important;\n    }\n  }\n  .coin {\n    width: 49.334px;\n    height: 34px;\n  }\n  .tag {\n    width: 53px;\n    height: 47.06px;\n  }\n  .ant-modal-content {\n    background-color: transparent;\n    padding: 32px;\n    .h2 {\n      margin-top: 15px;\n      margin-bottom: 5px;\n    }\n    .h4 {\n      color: #66564d;\n    }\n    .divider {\n      border-top: 1px solid #ddaa42;\n      padding-top: 20px;\n      margin-top: 26px;\n    }\n    .buttons {\n      margin-top: 35px;\n    }\n    .button {\n      margin-top: 16px;\n      height: 40px !important;\n    }\n    .ant-modal-footer {\n      display: none;\n    }\n  }\n  .anticon {\n    color: #997120;\n  }\n  .ant-checkbox-wrapper {\n    margin-top: 10px;\n    span {\n      color: #244560;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      letter-spacing: 0.18px;\n    }\n  }\n  &--white {\n    background: #fff;\n    border-color: #fff;\n    .anticon {\n      color: #6e7889;\n    }\n    .ant-modal-content {\n      .h2 {\n        color: #162e43;\n      }\n      .h4 {\n        color: #48759a;\n      }\n      .buttons {\n        .button-modal-ok {\n          border: 1px solid #162e43 !important;\n          background: #162e43 !important;\n          color: #ffffff !important;\n        }\n        .button-modal-cancel {\n          border: 1px solid #162e43 !important;\n          background: #fff !important;\n          color: #162e43 !important;\n          &-delete {\n            font-weight: 600 !important;\n            color: #122536 !important;\n          }\n        }\n        .button-modal-delete {\n          border: 1px solid #A31C17 !important;\n          background: #A31C17 !important;\n          color: #F5FAFF !important;\n          font-weight: 600 !important;\n        }\n      }\n    }\n  }\n}\n",".QuestionBasic {\n\n  .body-regular {\n    color: #6e7889;\n  }\n  .h3 {\n    margin-bottom: 40px;\n  }\n  \n  .options {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 18px;\n    margin-top: 25px;\n\n    .content-left {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .Button-option {\n      cursor: pointer;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: flex-start;\n      flex-direction: column;\n      border-radius: 10px;\n      border: 1px solid #ccd3db;\n      background: #f9fafb;\n      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);\n      min-height: 56px;\n      height: auto;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      padding: 19px 24px;\n      &-text {\n        color: #2a2f3c !important;\n      }\n      .flex-btw {\n        margin-bottom: 0 !important;\n      }\n      .flex-start {\n        display: none;\n      }\n      &-active {\n        .flex-start {\n          display: flex;\n          gap: 6px;\n          align-items: flex-start;\n          img {\n            margin-top: 3px;\n          }\n          .body-regular {\n            max-width: 300px;\n          }\n        }\n        border-radius: 10px;\n        border: 1px solid #9bbceb;\n        background: #ebf6ff;\n        box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n        &-text {\n          color: #355c7d !important;\n        }\n        .body-regular {\n          color: #5e8eb7;\n        }\n        .sub-title {\n          font-weight: 500;\n        }\n      }\n    }\n  }\n  .Button-option-active {\n    .ModalEndSubmit {\n      width: 100%;\n      .button {\n        height: 36px;\n        span {\n          color: #f5faff !important;\n        }\n      }\n    }\n    .Button-option-text {\n      color: $blue-button-tab !important;\n    }\n    &-description {\n      color: #5E8EB7 !important;\n      font-size: 14px;\n      margin-top: 5px;\n    }\n  }\n  .list {\n    list-style-type: disc;\n    list-style: disc;\n    padding-left: 25px;\n    margin-top: 15px;\n    .h4 {\n      color: #404859;\n      line-height: 145%;\n    }\n  }\n}\n",".spinner-container {\n  position: relative;\n  width: auto;\n  height: 120px;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  overflow: hidden; /* Evita desbordamientos */\n}\n\n.spinner {\n  position: relative;\n}\n\n.spinner div {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background-color: #c4cdd5;\n  border-radius: 50%;\n  animation: spin 1.2s linear infinite;\n}\n\n/* Colocación inicial de los 12 círculos */\n.spinner div:nth-child(1) { transform: rotate(30deg) translate(40px); }\n.spinner div:nth-child(2) { transform: rotate(60deg) translate(40px); }\n.spinner div:nth-child(3) { transform: rotate(90deg) translate(40px); }\n.spinner div:nth-child(4) { transform: rotate(120deg) translate(40px); }\n.spinner div:nth-child(5) { transform: rotate(150deg) translate(40px); }\n.spinner div:nth-child(6) { transform: rotate(180deg) translate(40px); }\n.spinner div:nth-child(7) { transform: rotate(210deg) translate(40px); }\n.spinner div:nth-child(8) { transform: rotate(240deg) translate(40px); }\n.spinner div:nth-child(9) { transform: rotate(270deg) translate(40px); }\n.spinner div:nth-child(10) { transform: rotate(300deg) translate(40px); }\n.spinner div:nth-child(11) { transform: rotate(330deg) translate(40px); }\n.spinner div:nth-child(12) { transform: rotate(0deg) translate(40px); }\n\n/* Animación para cambiar el color de los círculos */\n@keyframes spin {\n  0%, 100% {\n    background-color: #c4cdd5;\n  }\n  8.3% {\n    background-color: #4e8de6;\n  }\n}\n\n/* Cambia el retardo de cada círculo */\n.spinner div:nth-child(1) { animation-delay: -1.1s; }\n.spinner div:nth-child(2) { animation-delay: -1s; }\n.spinner div:nth-child(3) { animation-delay: -0.9s; }\n.spinner div:nth-child(4) { animation-delay: -0.8s; }\n.spinner div:nth-child(5) { animation-delay: -0.7s; }\n.spinner div:nth-child(6) { animation-delay: -0.6s; }\n.spinner div:nth-child(7) { animation-delay: -0.5s; }\n.spinner div:nth-child(8) { animation-delay: -0.4s; }\n.spinner div:nth-child(9) { animation-delay: -0.3s; }\n.spinner div:nth-child(10) { animation-delay: -0.2s; }\n.spinner div:nth-child(11) { animation-delay: -0.1s; }\n.spinner div:nth-child(12) { animation-delay: 0s; }",".ButtonTabsFilters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  .tab {\n    border-radius: 100px;\n    background: $white-button-tab;\n    color: $grey-title;\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 16px;\n    border: none;\n    box-shadow: none;\n    height: 24px;\n    .number {\n      font-weight: 400;\n      margin-left: 3px;\n    }\n    &:hover {\n      background: #5E8EB7 !important;\n      color: white !important;\n    }\n    &-active {\n      background-color: $blue-button-tab;\n      color: $white;\n      &:hover {\n        background-color: $blue-button-tab;\n        color: $white !important;\n      }\n    }\n  }\n}\n",".CardAlertError {\n  border-radius: 10px;\n  border: 1px solid #d7b8e5;\n  background: #f7edfc;\n  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n  padding: 18px 24px;\n  .h4-w5 {\n    color: #241226;\n    margin-bottom: 5px;\n  }\n  .h4-w4 {\n    color: #653b6f;\n    margin-bottom: 30px;\n  }\n}\n",".CardDetailInformationBank {\n  border-radius: 10px;\n  border: 1px solid #929fb0;\n  background: #fff;\n  padding: 20px 16px;\n  .h4 {\n    margin-bottom: 24px;\n  }\n  .label {\n    color: #6e7889;\n    margin-bottom: 4px;\n  }\n  .info {\n    color: #929fb0;\n    font-style: italic;\n  }\n  .row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .column {\n      width: 50%;\n    }\n  }\n  .column {\n    margin-bottom: 20px;\n    &-line {\n      border-bottom: 1px solid #dfe4eb;\n      padding-bottom: 16px;\n    }\n  }\n}\n",".CardLoanTasks {\n  width: 396px;\n  height: 192px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  border: 1px solid #6e7889;\n  background: #fafcfc;\n  padding: 12px 19px;\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .state-name {\n    color: $grey-title;\n    font-family: Inter;\n    font-size: 10px !important;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    &-w6 {\n      font-weight: 600;\n    }\n  }\n\n  .withBorder {\n    width: 100%;\n    border-radius: 10px;\n    border: 1px solid #ccd3db;\n    background: #fff;\n    color: #000;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .withOutBorder {\n    width: 100%;\n    border-radius: 10px;\n    border: none;\n    background: none;\n    box-shadow: none;\n    color: #000;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  &__top {\n    &__head {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 5px;\n      .flex-end {\n        display: flex;\n        justify-content: flex-end;\n        gap: 4px;\n        align-items: center;\n        .svg-grid {\n          height: 12px;\n          width: 12px;\n          fill: none;\n        }\n        .quick-task {\n          path {\n            stroke: #6e7889;\n            &:first-child {\n              fill: #6e7889;\n            }\n          }\n        }\n        .major-task {\n          path {\n            stroke: #6e7889;\n            fill: #6e7889;\n          }\n        }\n      }\n    }\n    .h4 {\n      margin-bottom: 4px;\n    }\n    .text {\n      display: flex;\n      justify-content: flex-start;\n      align-items: flex-start;\n    }\n    .body-card-full {\n      margin-left: 5px;\n      padding: 0 5px;\n      font-weight: 700;\n      border-radius: 2px;\n    }\n  }\n\n  .TaskProgress {\n    margin-top: 10px;\n  }\n  \n  &__bottom {\n    .body-small-up {\n      color: #587e5b;\n      margin-bottom: 8px;\n    }\n    .flex-betwen {\n      .body-card {\n        color: #587e5b;\n      }\n    }\n  }\n\n  &-buttons-actions {\n    gap: 10px;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &-APPROVED {\n    border-color: #6eac72;\n    .state {\n      border-radius: 76px;\n      background: #c5f0c8;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      .check {\n        margin-right: 2px;\n      }\n      .state-name {\n        color: #355137;\n      }\n    }\n    .h4 {\n      color: #466849;\n    }\n    .body-card-full {\n      background-color: #c5f0c8;\n      color: #466849;\n    }\n    .flex-end {\n      .svg-grid {\n        path {\n          stroke: #6eac72;\n          &:first-child {\n            fill: #6eac72;\n          }\n        }\n      }\n      .major-task {\n        path {\n          stroke: #6eac72;\n          fill: #6eac72;\n        }\n      }\n      .state-name {\n        color: #6eac72;\n      }\n    }\n    .button-card {\n      border: 1px solid #6eac72;\n      background: #fafcfc;\n      color: #466849;\n      box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n    }\n  }\n\n  &-REVIEW {\n    border-color: #ac78b3;\n    background: #FEFAFF;\n\n    .body-card-full {\n      color: #48244d;\n      background: #e3ddf0;\n    }\n\n    .body-card--green {\n      background-color: #e3ddf0;\n    }\n\n    .state-name {\n      color: #8a5791;\n    }\n\n    .CardLoanTasks__top__head .flex-end .major-task path {\n      stroke: #ac78b3;\n      fill: #ac78b3;\n    }\n    .state {\n      border-radius: 76px;\n      background: #e3ddf0;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n      .state-name {\n        color: #48244d;\n      }\n    }\n    .body-card {\n      color: #48244d;\n    }\n    .button-card {\n      color: #693b6f;\n      border-radius: 6px;\n      border: 1px solid #ac78b3;\n      background: #fdfcff;\n      box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.03);\n    }\n  }\n\n  &-DRAFT {\n    border-color: #929fb0;\n    .body-card-w5 {\n      color: #48244d;\n    }\n\n    .state {\n      border-radius: 76px;\n      background: #404859;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n      .state-name {\n        color: #f9fafb;\n      }\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border-color: #c94f4a;\n    .body-card-w5 {\n      color: #ac3e3a;\n    }\n    .state {\n      border-radius: 76px;\n      background: #ffd4cf;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n      .state-name {\n        color: #712220;\n      }\n    }\n    .h4,\n    .body-card {\n      color: #712220;\n      &-text-2 {\n        color: #ac3e3a;\n      }\n    }\n    .button-card {\n      border-color: #c94f4a;\n    }\n    .flex-betwen {\n      .button,\n      .button-link {\n        color: #712220;\n      }\n    }\n    .flex-end {\n      .svg-grid {\n        path {\n          stroke: #c94f4a;\n          &:first-child {\n            fill: #c94f4a;\n          }\n        }\n      }\n      .major-task {\n        path {\n          stroke: #c94f4a;\n          fill: #c94f4a;\n        }\n      }\n      .state-name {\n        color: #c94f4a;\n      }\n    }\n  }\n  &-beginTask {\n    .ModalCardState {\n      width: 100% !important;\n    }\n  }\n}\n",".CardSomeoneElse {\n  margin-top: 10px;\n  width: 100%;\n  input {\n    background-color: transparent;\n    border: none !important;\n    box-shadow: none !important;\n    padding: 0;\n    color: #48759a;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    &::placeholder {\n      color: #9bbceb;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n  .ant-form-item {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n  .row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .ant-form-item {\n      width: 100%;\n    }\n  }\n}\n",".card-upload-response {\n\tposition: relative;\n\tborder-radius: 10px;\n\tborder: 1px solid #2A2F3C;\n\tpadding: 10px 16px;\n\n\t.template {\n\t\tmargin-bottom: 10px;\n\n\t\t.arrow-right {\n\t\t\twidth: 14px;\n\t\t\tmargin-left: 5px;\n\t\t}\n\n\t\tbutton {\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\n\t.header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 6px;\n\n\t\t.h4 {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\n\t\t.link {\n\t\t\tpadding: 0;\n\t\t\tcolor: rgba(110, 120, 137, 1);\n\t\t\tfont-size: 12px;\n\n\t\t\tspan {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tcolor: rgba(110, 120, 137, 1);\n\t\t\t}\n\t\t}\n\t}\n\n\t.description {\n\t\tfont-family: Inter;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 20px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t&-REVIEW {\n\t\tborder: 1px solid $state-review-border;\n\t\tbackground-color: $state-review-background-ligth;\n\n\t\t.h4 {\n\t\t\tcolor: $state-review-text !important;\n\t\t}\n\n\t\t.description {\n\t\t\tcolor: $state-review-text !important;\n\t\t}\n\n\t\t.link {\n\t\t\tcolor: $state-review-text !important;\n\t\t}\n\t}\n\n\t&-APPROVED {\n\t\tborder: 1px solid $state-approved-border;\n\t\tbackground-color: $state-approved-background-ligth;\n\n\t\t.h4 {\n\t\t\tcolor: $state-approved-text !important;\n\t\t}\n\n\t\t.description {\n\t\t\tcolor: $state-approved-text !important;\n\t\t}\n\n\t\t.link {\n\t\t\tcolor: $state-approved-text !important;\n\t\t}\n\t}\n\n\t&-REQUEST_ERROR {\n\t\tborder: 1px solid $state-error-border;\n\t\tbackground-color: $state-error-background-ligth;\n\n\t\t.h4 {\n\t\t\tcolor: $state-error-text !important;\n\t\t}\n\n\t\t.description {\n\t\t\tcolor: $state-error-text !important;\n\t\t}\n\n\t\t.link {\n\t\t\tcolor: $state-error-text !important;\n\t\t}\n\t}\n}",".DrodownBlue {\n    height: 20px;\n    padding: 1px 3px !important;\n    display: flex;\n    align-items: center;\n\n    &:hover {\n        background-color: $button-blue !important;\n        color: white !important;\n\n        span {\n            text-decoration-line: none !important;\n        }\n    }\n\n    &:disabled {\n        background-color: white !important;\n        color: $button-blue !important;\n\n        span {\n            text-decoration-line: underline !important;\n        }\n    }\n\n    &-blue {\n        border: 1px solid #9BBCEB;\n        border-radius: 10px;\n\n        .ant-dropdown-menu {\n            padding: 0px;\n        }\n\n        .ant-dropdown-menu-item {\n            &:hover {\n                background-color: #EBF6FF !important;\n\n                .ant-dropdown-menu-title-content {\n                    color: $blue-button-tab;\n                    font-weight: 600;\n                }\n            }\n        }\n\n        .ant-dropdown-menu-title-content {\n            color: $button-blue;\n            font-weight: 400;\n\n            &:hover {\n                color: $blue-button-tab;\n                font-weight: 600;\n            }\n        }\n    }\n}",".InputAmount {\n  border-radius: 10px;\n  border: 1px solid #929fb0;\n  background: #fff;\n  padding: 13px 16px;\n  .h4 {\n    color: #404859;\n  }\n  .button-operation {\n    padding: 0;\n    height: 23px;\n    border: 0;\n    background: none;\n    box-shadow: none;\n    .anticon {\n      color: #5e8eb7;\n      &-full {\n        display: none;\n      }\n    }\n    &:hover {\n      .anticon {\n        color: #5e8eb7;\n        display: none;\n        &-full {\n          display: block;\n          margin-left: 0;\n        }\n      }\n    }\n  }\n  .flex {\n    display: flex;\n    justify-content: flex-end;\n    gap: 16px;\n    .h4 {\n      color: #929fb0;\n    }\n    span {\n      color: #929fb0;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: normal;\n    }\n    .text-bold {\n      color: #5e8eb7;\n      font-weight: 600;\n      font-style: normal;\n    }\n  }\n}\n",".InputBorderNone {\n  .input {\n    color: #775614;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n  .body-placeholder-w4 {\n    color: #775614;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  .bold-lith {\n    color: #2a2f3c;\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 400;\n    &::placeholder {\n      color: #929fb0;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: 145%;\n    }\n  }\n  .bold {\n    color: #2a2f3c;\n    font-family: Inter;\n    font-size: 16px;\n    font-weight: 600;\n  }\n  .percentage-bottom {\n    border: 0;\n    display: flex;\n    justify-content: space-between;\n    border-top: 1px solid #afbdcc;\n    padding-top: 1px;\n    margin-bottom: 10px !important;\n    width: 90% !important;\n    .body-regular {\n      span {\n        font-size: 12px;\n      }\n    }\n  }\n\n  .ant-input-number-input {\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    line-height: normal;\n    padding: 5px 0px !important;\n\n    .default {\n      font-weight: 400;\n      color: $grey-title;\n    }\n\n    .warning {\n      font-weight: 600;\n      color: $state-warning;\n    }\n\n    &::placeholder {\n      color: #929fb0;\n      font-family: Inter;\n      font-style: italic !important;\n      font-weight: 400;\n    }\n  }\n}\n",".InputUploadedFile {\n  .file-ok {\n    margin: 10px 0;\n    .file {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: #f9fafb;\n      position: relative;\n      &-content {\n        height: 28px;\n        border-radius: 10px;\n        border: 1px solid #2a2f3c;\n        background-color: #f9fafb;\n        width: 100%;\n        padding: 0 20px;\n        padding-right: 12px;\n\n        &-approved {\n          border: 1px solid $state-approved-border !important;\n          background: $state-approved !important;\n        }\n\n        &-request_error {\n          border: 1px solid $state-error-border !important;\n          background: $state-error !important;\n          .name,\n          .anticon {\n            color: $state-error-icon !important;\n          }\n        }\n        &-review {\n          border: 1px solid $state-review-border !important;\n          background: $state-review-background !important;\n          .name,\n          .anticon {\n            color: $state-review-dark !important;\n          }\n        }\n      }\n      \n      .file-name {\n        width: 80%;\n        display: flex;\n        justify-content: start;\n        align-items: center;\n        gap: 7px;\n        .name {\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          overflow: hidden;\n        }\n        .anticon {\n          font-size: 15px;\n        }\n      }\n      .content-buttons {\n        display: flex;\n        justify-content: end;\n        align-items: center;\n        gap: 7px;\n        .anticon {\n          font-size: 15px;\n        }\n      }\n      .flex {\n        width: 80%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 100%;\n        gap: 12px;\n        &:first-child {\n          gap: 4px;\n        }\n      }\n      .upload {\n        margin-bottom: 0;\n      }\n      .flex-btw {\n        margin-bottom: 0;\n        height: 100%;\n        border-bottom: none;\n      }\n      .circle-input {\n        background-color: #fff;\n        width: 18px;\n        height: 18px;\n        border-radius: 50%;\n        border: 1px solid #2a2f3c;\n        display: flex;\n        position: absolute;\n        left: 0;\n        justify-content: center;\n        align-items: center;\n        .upload {\n          width: auto;\n          height: 18px;\n          object-fit: cover;\n        }\n      }\n    }\n  }\n}\n",".ProgressSteps {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n  .tab {\n    margin: 0 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    .bar-status {\n      width: 100%;\n      width: calc(100% + 20px);\n      height: 6px;\n      border-radius: 16px;\n      margin-top: 6px;\n      background-color: $white-button-tab;\n    }\n    &-complete {\n      .body-small {\n        color: $green-tab-active-text;\n      }\n      .bar-status {\n        background-color: $green-tab-active;\n      }\n    }\n    &-started {\n      &:hover {\n        .bar-status {\n          background-color: $grey-title;\n        }\n      }\n    }\n  }\n}\n.ant-popover {\n  &-content {\n    .ant-popover-inner {\n      padding: 0;\n    }\n    .popover-content {\n      padding: 10px 8px;\n      border-radius: 10px;\n      width: 240px;\n      position: relative;\n      .body-small {\n        color: #fafcfa;\n        &-w6 {\n          margin-bottom: 6px;\n        }\n      }\n      .divider {\n        height: 1px;\n        width: 100%;\n        margin: 8px 0;\n      }\n      .button {\n        display: flex;\n        gap: 4px;\n        align-items: center;\n      }\n      .flecha-darck,\n      .flecha {\n        display: none;\n        width: 16px;\n        height: 8px;\n      }\n      .felx-between {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        align-items: center;\n\n        .flex {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          img {\n            margin-right: 5px;\n          }\n        }\n        .button {\n          background-color: transparent;\n          border: none;\n          padding: 0;\n          height: 20px;\n          box-shadow: none;\n          .flecha {\n            margin-left: 5px;\n            width: 12px;\n          }\n        }\n      }\n      .warning {\n        display: none;\n        justify-content: flex-start;\n        align-items: center;\n        gap: 5px;\n        margin-top: 10px;\n        svg {\n          width: 10px;\n          height: 11px;\n          fill: none;\n        }\n        .body-small {\n          margin-bottom: 0;\n          color: $red-warning;\n          text-decoration-line: underline;\n        }\n      }\n      &-complete,\n      &-started {\n        background-color: #587e5b;\n        .divider {\n          background-color: #fafcfa;\n        }\n        .flecha {\n          display: block;\n        }\n        .button {\n          &:hover,\n          &:active,\n          &:focus {\n            color: #fafcfa;\n          }\n        }\n        &::after {\n          content: '*';\n          font-size: 0;\n          width: 0;\n          height: 0;\n          border-left: 10px solid transparent;\n          border-right: 10px solid transparent;\n          border-bottom: 11px solid #587e5b;\n          position: absolute;\n          left: 46%;\n          top: -10px;\n          z-index: 3;\n        }\n      }\n      &-started {\n        background-color: $grey-title;\n        width: 270px;\n        .warning {\n          display: flex;\n          .body-small {\n            color: #ffd4cf;\n          }\n          svg {\n            path {\n              stroke: #ffd4cf;\n            }\n          }\n        }\n        &::after {\n          content: '*';\n          font-size: 0;\n          width: 0;\n          height: 0;\n          border-left: 10px solid transparent;\n          border-right: 10px solid transparent;\n          border-bottom: 11px solid $grey-title;\n          position: absolute;\n          left: 46%;\n          top: -10px;\n          z-index: 3;\n        }\n      }\n      &-not-started {\n        background-color: #ccd3db;\n        width: 270px;\n        .body-small {\n          color: $black;\n        }\n        .warning {\n          display: flex;\n        }\n        svg {\n          path {\n            stroke: $red-warning;\n          }\n        }\n        .button {\n          &:hover,\n          &:active,\n          &:focus {\n            color: $black;\n          }\n        }\n        .divider {\n          background-color: #404859;\n        }\n        .flecha-darck {\n          display: block;\n        }\n        &::after {\n          content: '*';\n          font-size: 0;\n          width: 0;\n          height: 0;\n          border-left: 10px solid transparent;\n          border-right: 10px solid transparent;\n          border-bottom: 11px solid #ccd3db;\n          position: absolute;\n          left: 46%;\n          top: -10px;\n          z-index: 3;\n        }\n      }\n      .green-all {\n        .body-small {\n          color: #c5f0c8;\n        }\n      }\n    }\n  }\n}\n",".TaskProgress {\n  .bar {\n    width: 100%;\n    background-color: #dfe4eb;\n    height: 8px;\n    border-radius: 8px;\n    display: flex;\n    :first-child{\n      border-bottom-left-radius: 8px;\n      border-top-left-radius: 8px;\n    }\n    :last-child{ \n      border-bottom-right-radius: 8px;\n      border-top-right-radius: 8px;\n    }\n    &-percentage {\n      height: 8px;\n    }\n  }\n  .h4 {\n    color: #404859 !important;\n    text-transform: none;\n  }\n}\n",".SelectPrimary {\n  .body-regular {\n    color: #2a2f3c;\n    font-weight: 500;\n  }\n  .ant-space-item {\n    width: 100%;\n  }\n}\n",".state-tag {\n    width: max-content;\n    border-radius: 76px;\n    padding: 4px 8px 4px 7px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n\n    .check {\n        margin-right: 2px;\n    }\n\n    .state-name {\n        font-weight: 600;\n        font-family: Inter;\n        line-height: 11px;\n        letter-spacing: 0.02em;\n        font-size: 10px;\n    }\n\n    &-APPROVED {\n        border-color: $state-approved-background;\n        background: $state-approved-background;\n\n        .state-name {\n            color: $state-approved-text !important;\n        }\n    }\n\n    &-REVIEW {\n        border-color: $state-review-background;\n        background: $state-review-background;\n\n        .state-name {\n            color: $state-review-text !important;\n        }\n    }\n\n    &-REQUEST_ERROR {\n        border-color: $state-error-background;\n        background: $state-error-background;\n\n        .state-name {\n            color: $state-error-text !important;\n        }\n    }\n\n    &-DRAFT {\n        .state-name {\n            color: $black-text !important;\n        }\n    }\n}",".UploadDocs {\n  position: relative;\n  .modal-see-file {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: red;\n  }\n  .button-upload {\n    height: 78px;\n    width: 100%;\n    border: 1px dashed #6e7889;\n    p {\n      color: #2a2f3c;\n      font-family: Inter;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      span {\n        font-size: 10px;\n        color: #4e8aff;\n      }\n    }\n  }\n  .circles {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n    .circle {\n      border-radius: 50%;\n      width: 16px;\n      height: 16px;\n      border: 1px solid #404859;\n      &-review {\n        background-color: $state-review-border;\n        border-color: $state-review;\n      }\n      &-approved {\n        background-color: $state-approved-background;\n        border-color: $state-approved-border;\n      }\n    }\n  }\n  .ant-upload {\n    width: 100%;\n    margin-bottom: 12px;\n  }\n  .button {\n    border-radius: 6px;\n    border: #122536;\n    background: #122536;\n    width: 100%;\n    height: 32px;\n    color: #fff;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.18px;\n    &-transparent {\n      background-color: transparent;\n      border: none !important;\n      box-shadow: none !important;\n    }\n  }\n  .body-small {\n    .blue {\n      color: #4e8aff;\n    }\n  }\n  .upload {\n    width: 20px;\n    height: 20px;\n    margin-bottom: 7px;\n  }\n  .empty-input {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    .small-detail {\n      margin-top: 4px;\n    }\n  }\n  &--container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 12px;\n  }\n\n  .input-content {\n    position: relative;\n    height: 128px;\n    width: 100%;\n    border-radius: 10px;\n    background: var(--colors-gradient);\n    padding: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px dashed #6e7889;\n    .white {\n      background-color: #fff;\n      height: 10px;\n      width: 20px;\n      position: absolute;\n      left: 0px;\n      top: 0px;\n      border-top-left-radius: 5px;\n      z-index: 200;\n    }\n    input {\n      height: 126px;\n      width: 100%;\n      border-radius: 10px;\n      background-color: rgba(255, 0, 0, 0);\n      // background-color: red;\n      font-size: 0 !important;\n      position: absolute;\n      z-index: 2;\n      top: 0;\n      cursor: pointer;\n    }\n    .cont-img {\n      height: 100%;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: #fff;\n      img {\n        width: 100px;\n      }\n    }\n    &-wh {\n      background: var(--colors-white);\n      box-shadow: -3px 1px 10px -7px var(--colors-black);\n      margin: 30px 40px;\n    }\n    .edit {\n      position: absolute;\n      bottom: 0;\n      height: auto;\n      width: 99px;\n      border-radius: 0;\n    }\n  }\n  .content-flex {\n    align-items: flex-start;\n    gap: 16px;\n    .input-content,\n    .file-ok {\n      width: 50% !important;\n    }\n  }\n}\n",".circle-tag {\n  .circle {\n    width: 20px;\n    height: 20px;\n  \n    &-APPROVED {\n      border-color: $state-approved-border;\n      background-color: $state-approved-background;\n\n      &:hover {\n        background-color: $state-approved-border-dark;\n      }\n    }\n  \n    &-REVIEW {\n      background-color: $state-review-border;\n      border-color: $state-review;\n\n      &:hover {\n        background-color: $state-review-label;\n      }\n    }\n  \n    &-REQUEST_ERROR {\n      background-color: $state-error-background;\n      border-color: $state-error-border;\n\n      &:hover {\n        background-color: $state-error-border;\n      }\n    }\n  }\n}",".MinimumLiquidity {\n  padding-bottom: 30px;\n  .h4 {\n    color: #404859 !important;\n  }\n  .divider-top {\n    padding-top: 10px;\n  }\n  .h4-error {\n    color: #712220 !important;\n    margin-bottom: 7px;\n  }\n  .h2-w8 {\n    color: $black-text !important;\n  }\n}\n",".CardStateAccount {\n  border-radius: 10px;\n  border: 1px solid #7b7b7b;\n  padding: 12px 16px;\n  position: relative;\n\n  .label {\n    border-radius: 100px;\n    min-width: 81px;\n    width: auto;\n    max-width: 95px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 3px 4px;\n    gap: 4px;\n    margin-bottom: 8px;\n    background: #969696;\n    .body-small {\n      margin-bottom: 0;\n    }\n  }\n  &_head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 100%;\n  }\n\n  .box {\n    .body-card {\n      margin-bottom: 6px;\n    }\n    .body-regular {\n      margin-bottom: 16px;\n    }\n    .file-ok {\n      margin-top: 0 !important;\n    }\n    width: 300px !important;\n    &-error {\n      .flex {\n        .button {\n          &:last-child {\n            display: none !important;\n          }\n        }\n      }\n    }\n    &-success {\n      .flex {\n        .button {\n          &:last-child {\n            display: none !important;\n          }\n        }\n      }\n    }\n  }\n  .divider {\n    border-top: 1px solid #afbdcc;\n    margin-top: 20px;\n  }\n  &--inReview {\n    background: #fdfcff;\n    border: 1px solid #ac78b3;\n    .label {\n      background: #e3ddf0;\n      .body-small {\n        color: #48244d;\n      }\n    }\n    .box {\n      .body-card {\n        color: #48244d;\n        &-dark {\n          color: #2a2f3c;\n        }\n      }\n      .body-regular {\n        color: #48244d;\n      }\n    }\n    .file-ok {\n      .file {\n        &-content {\n          .name {\n            color: #693b6f !important;\n          }\n          .anticon {\n            color: #693b6f !important;\n          }\n        }\n      }\n    }\n  }\n  &--error {\n    border: 1px solid #c94f4a;\n\n    .label {\n      background: #ffd4cf;\n      img {\n        margin-top: 1px;\n      }\n      .body-small {\n        color: #712220;\n      }\n    }\n    .UploadDocs {\n      .input-content {\n        border: 1px dashed #e67f73;\n      }\n    }\n    .row {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 10px;\n      .box {\n        width: 40%;\n        .body-card {\n          margin-bottom: 4px;\n        }\n      }\n    }\n    .divider {\n      margin-top: 20px;\n      border-top: 1px solid #ffd4cf;\n      padding-top: 8px;\n    }\n  }\n  &--approved {\n    border: 1px solid #3F9545;\n\n    .label {\n      background: #C5F0C8;\n      img {\n        margin-top: 1px;\n      }\n      .body-small {\n        color: #355137;\n      }\n    }\n    .UploadDocs {\n      .input-content {\n        border: 1px dashed #C5F0C8;\n      }\n    }\n    .row {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 10px;\n      .box {\n        width: 40%;\n        .body-card {\n          margin-bottom: 4px;\n        }\n      }\n    }\n    .divider {\n      margin-top: 20px;\n      border-top: 1px solid #C5F0C8;\n      padding-top: 8px;\n    }\n    .file-ok {\n      .file {\n        &-content {\n          border: 1px solid #75C27A !important;\n          background-color: #C5F0C8 !important;\n          .name {\n            color: #355137 !important;\n          }\n          .anticon {\n            color: #355137 !important;\n          }\n        }\n      }\n    }\n    \n  }\n  .row-btw {\n    .box {\n      width: 100%;\n    }\n  }\n  .section-upload {\n    .UploadDocs {\n      .file-content {\n        height: 28px !important;\n        border-radius: 10px;\n        border: 1px solid #eff3f5 !important;\n        background: #eff3f5 !important;\n        padding-left: 12px !important;\n      }\n      .InputUploadedFile .file-ok .file .circle {\n        display: none;\n      }\n    }\n  }\n}\n",".SectionError {\n  border-radius: 10px;\n  border: 1px solid #c94f4a;\n  padding: 12px 15px;\n\n  .flex-end {\n    button {\n      height: 30px;\n    }\n  }\n\n  .description{\n    overflow: hidden;\n\n    .body-regular {\n      display: -webkit-box; /* Utiliza el modelo de caja flexible de tipo webkit */\n      -webkit-box-orient: vertical; /* Orientación vertical */\n      -webkit-line-clamp: 2; /* Número máximo de líneas */\n      overflow: hidden; /* Oculta el contenido que sobresale */  \n    }\n  }\n\n  .flex-btw {\n    margin-bottom: 5px;\n  }\n  .body-regular {\n    color: #c94f4a;\n  }\n  .body-regular-w6 {\n    color: #712220;\n  }\n  .button {\n    color: #712220;\n    text-align: right;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 140%;\n\n    span {\n      text-decoration: underline;\n\n      &:hover {\n        color: #712220;\n      }\n    } \n\n    .anticon {\n      color: #712220;\n      margin-top: 2px;\n    }\n  }\n}\n",".SectionNewBank {\n  .h4,\n  .body-regular {\n    margin-bottom: 8px;\n    color: #2a2f3c;\n    line-height: 145%;\n  }\n  .button {\n    width: auto !important;\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  .button-block {\n    width: 100% !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.card-add-account {\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  padding: 16px;\n  margin-top: 16px;\n  .ModalEndSubmit {\n    .button {\n      margin-bottom: 5px;\n    }\n  }\n  .flex-btw {\n    margin-bottom: 0 !important;\n    .box {\n      height: 100%;\n    }\n  }\n\n  .UploadDocs {\n    .flex-btw {\n      border: none;\n    }\n  }\n  .body-card {\n    color: #404859 !important;\n  }\n  .box {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    .h4 {\n      color: #929fb0;\n      font-style: italic;\n      margin-bottom: 16px;\n    }\n    .ModalEndSubmit {\n      .button {\n        display: none;\n      }\n    }\n  }\n  .button-submit {\n    margin-bottom: 20px;\n    border-radius: 6px;\n\n    span {\n      color: #fff;\n      text-align: center;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      letter-spacing: 0.18px;\n    }\n  }\n  .top-InfoExpand {\n    border-top: 1px solid #afbdcc;\n  }\n  // .item {\n  //   .flex-btw {\n  //     border: 0;\n  //     border-top: 1px solid #afbdcc;\n  //     padding-top: 1px;\n  //     margin-top: -15px;\n  //     margin-bottom: 16px !important;\n  //     align-items: flex-end !important;\n  //     width: 90% !important;\n  //     .body-regular {\n  //       margin-bottom: 0;\n  //       span {\n  //         font-size: 12px;\n  //       }\n  //     }\n  //   }\n  // }\n}\n",".DscrQuestionsAgreements {\n  .Step3 {\n    .h2 {\n      margin-top: 4px;\n      margin-bottom: 10px;\n      .blue-bold {\n        color: #5e8eb7;\n        font-weight: 800;\n        text-decoration-line: underline;\n\n        color: #2A2F3C;\n        font-family: Inter;\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 800;\n        line-height: 135%;\n        text-decoration-line: unset;\n      }\n    }\n    .rent-input {\n      border: none;\n      width: auto;\n      display: inline;\n      &.touched {\n        color: #404859;\n      }\n    }\n    .month {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n    #rent-button {\n      margin-top: 16px;\n    }\n    .UploadDocs {\n      .contenedor-flex {\n        display: flex;\n        width: 100%;\n        .cont-files {\n          width: 100%;\n        }\n        .UploadDocs--container {\n          gap: 20px;\n          justify-content: center;\n          align-items: flex-start;\n          flex-direction: row;\n          width: 100%;\n        }\n      }\n    }\n  }\n  .InputAmount-edit {\n    margin-bottom: 0px !important;\n    border: none !important;\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n\n    .flex {\n      display: flex;\n      justify-content: flex-end;\n      gap: 16px;\n\n      .text-bold {\n        color: #5e8eb7;\n        font-weight: 600;\n        font-style: normal;\n      }\n      \n      .input-edit {\n        all: unset;\n        color: #6E7889;\n        animation: none;\n        cursor: pointer;\n        font-style: italic;\n        font-weight: 400;\n        line-height: 19.36px;\n        text-align: right;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n      }\n\n    }\n    .button-edit {\n      all: unset;\n      border: none;\n      color: #5E8EB7;\n      animation: none;\n      cursor: pointer;\n      margin-left: 10px;\n  \n      span {\n        margin-left: 5px;\n        font-weight: 500;\n        color: #5E8EB7;\n        font-family: Inter;\n        font-style: normal;\n      }\n\n      &-disabled {\n        span {\n          color: #6E7889 !important;\n        }\n      }\n    }\n  }\n}\n",".CardLeaseAgreements {\n  padding: 16px;\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n  .flex-btw {\n    .flex {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 28px;\n      .circle {\n        border-radius: 50%;\n        width: 16px;\n        height: 16px;\n        border: 1px solid #404859;\n        &--active {\n          background-color: #404859;\n        }\n      }\n    }\n  }\n  &-REVIEW {\n    border: 1px solid $state-review-border;\n\t\tbackground-color: $state-review-background-ligth;\n  }\n\n  &-APPROVED {\n    border: 1px solid $state-approved-border;\n    background-color: $state-approved-background-ligth;\n\n    .h4 {\n      color: $state-approved-text !important;\n    }\n\n    .description {\n      color: $state-approved-text !important;\n    }\n\n    .link {\n      color: $state-approved-text !important;\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border: 1px solid $state-error-border;\n    background-color: $state-error-background-ligth;\n\n    .h4 {\n      color: $state-error-text !important;\n    }\n\n    .description {\n      color: $state-error-text !important;\n    }\n\n    .link {\n      color: $state-error-text !important;\n    }\n  }\n}\n",".CardMarketRent {\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n  padding: 12px 16px;\n  .body-regular-italic {\n    color: #929fb0;\n  }\n  .flex-btw {\n    margin-bottom: 9px !important;\n  }\n  &-REVIEW {\n    border: 1px solid $state-review-border;\n\t\tbackground-color: $state-review-background-ligth;\n  }\n\n  &-APPROVED {\n    border: 1px solid $state-approved-border;\n    background-color: $state-approved-background-ligth;\n\n    .h4 {\n      color: $state-approved-text !important;\n    }\n\n    .description {\n      color: $state-approved-text !important;\n    }\n\n    .link {\n      color: $state-approved-text !important;\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border: 1px solid $state-error-border;\n    background-color: $state-error-background-ligth;\n\n    .h4 {\n      color: $state-error-text !important;\n    }\n\n    .description {\n      color: $state-error-text !important;\n    }\n\n    .link {\n      color: $state-error-text !important;\n    }\n  }\n\n  .ant-form {\n    all: unset;\n    margin-top: 10px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n\n    .form-row {\n      all: unset;\n      display: flex;\n      align-items: baseline;\n      gap: 5px;\n      max-height: 35px;\n\n      .bold {\n        font-weight: 600 !important;\n        color: #404859 !important;\n      }\n    }\n\n    .rent-container {\n      display: flex;\n      align-items: baseline;\n      position: relative;\n    }\n\n    .rent-input {\n      width: auto;\n      min-width: 56px;\n      max-width: 58px;\n      text-align: right;\n      font-weight: 600;\n      color: #404859;\n      border: none;\n      outline: none;\n      background: transparent;\n    }\n\n    .unit-input {\n      width: 25px !important;\n    }\n  }\n  \n}\n",".CardTotalUnits {\n  // border-radius: 4px;\n  border: 1px solid #929fb0;\n  padding: 12px 16px;\n  .body-regular-italic {\n    color: #929fb0;\n  }\n  .flex-btw {\n    margin-bottom: 16px !important;\n  }\n}\n",".EntityGuarantorCreation {\n  .task-footer {\n    .dropdown-blue-bold {\n      span {\n        font-weight: 600;\n        text-decoration-line: underline;\n      }\n\n      height: 26px;\n      display: unset;\n      padding: 0 !important;\n    }\n\n    .dropdown-review-bold {\n      span {\n        font-weight: 600;\n        text-decoration-line: underline;\n      }\n\n      color: $state-review !important;\n      height: 26px;\n      display: unset;\n      padding: 0 !important;\n    }\n\n    .owners-tags {\n      display: flex;\n      justify-content: space-between;\n      align-items: end;\n\n      .circles-tags {\n        display: flex;\n        align-items: end;\n        gap: 10px;\n      }\n\n      .circle {\n        width: 20px;\n        height: 20px;\n      }\n\n      .circle-step3 {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 5px;\n      }\n    }\n  }\n}",".main {\n  position: relative;\n  border-radius: 10px;\n\n  .icon-delete {\n    font-size: 20px;\n    position: absolute;\n    top: 50%;\n    right: -9.5px;\n    transform: translateY(-50%);\n    color: #5E8EB7;\n    cursor: pointer;\n    visibility: hidden;\n  }\n\n  &:hover {\n    .icon-delete {\n      visibility: visible;\n    }\n  }\n\n  .content-card {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border-radius: 10px;\n    border: 1px solid #ccd3db;\n    min-height: 56px;\n    height: auto;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    padding: 10px 18px 5px 16px;\n\n    &-hover-removed {\n      &:hover {\n        border: 1px solid #ccd3db !important\n      }\n    }\n\n    &:hover {\n      border: 1px dashed $grey-placeholder;\n    }\n\n    .input-disabled-color {\n      input {\n        &:disabled {\n          color: black;\n        }\n      }\n    }\n\n    &-REVIEW {\n      border: 1px solid $state-review-border;\n      background-color: $state-review-background-ligth;\n\n      .body-regular {\n        color: $state-review-text !important;\n      }\n\n      .bold-lith {\n        color: $state-review-text !important;\n      }\n\n      .ant-input-number-suffix {\n        color: $state-review-text !important;\n      }\n\n      .ant-picker-input {\n        input {\n          color: $state-review-text !important;\n        }\n      }\n\n      .ant-form-item-no-colon {\n        color: $state-review-text !important;\n      }\n\n      .ant-input-number-input-wrap {\n        color: $state-review-text !important;\n\n        input {\n          font-weight: 500;\n        }\n      }\n    }\n\n    &-APPROVED {\n      border: 1px solid $state-approved-border;\n      background-color: $state-approved-background-ligth;\n\n      .body-regular {\n        color: $state-approved-text !important;\n      }\n\n      .bold-lith {\n        color: $state-approved-text !important;\n      }\n\n      .ant-input-number-suffix {\n        color: $state-approved-text !important;\n      }\n\n      .ant-picker-input {\n        input {\n          color: $state-approved-text !important;\n        }\n      }\n\n      .ant-form-item-no-colon {\n        color: $state-approved-text !important;\n      }\n\n      .ant-input-number-input-wrap {\n        color: $state-approved-text !important;\n\n        input {\n          font-weight: 500;\n        }\n      }\n\n      .file-name {\n        color: $state-approved-text !important;\n      }\n    }\n\n    &-REQUEST_ERROR {\n      border: 1px solid $state-error-border;\n      background-color: white;\n\n      .body-regular {\n        color: $state-error-icon !important;\n      }\n\n      .bold-lith {\n        color: $state-error-icon !important;\n      }\n\n      .ant-form-item-no-colon {\n        color: $state-error-icon !important;\n      }\n\n      .ant-picker-input {\n        input {\n          color: $state-error-icon !important;\n        }\n      }\n\n      .ant-input-number-suffix {\n        color: $state-error-icon !important;\n      }\n\n      .ant-input-number-input-wrap {\n        color: $state-error-icon !important;\n\n        input {\n          font-weight: 500;\n        }\n      }\n\n      .file-name {\n        color: $state-error-icon !important;\n      }\n    }\n\n    .card-ownership {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n\n      .section-1 {\n        display: flex;\n        width: 70%;\n        flex-direction: column;\n\n        .names {\n          display: flex;\n          gap: 30px;\n\n          .name {\n            display: flex;\n            flex-direction: column;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            width: auto;\n            gap: 5px;\n\n            span {\n              white-space: nowrap;\n              text-overflow: ellipsis;\n              overflow: hidden;\n              font-size: 16px;\n            }\n\n            label {\n              font-size: 12px;\n            }\n          }\n        }\n\n        .footer {\n\n          .approved {\n            color: $green-tab-active-text;\n          }\n\n          .error {\n            color: $state-error-text;\n          }\n\n          button {\n            color: $grey-text-op;\n\n            .anticon {\n              margin-inline-start: 4px;\n            }\n\n            &:hover {\n              color: $grey-text-op;\n            }\n          }\n\n          span {\n            font-family: Inter;\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 15px;\n          }\n        }\n      }\n\n      .section-2 {\n        display: flex;\n        flex-direction: column;\n        align-items: end;\n\n        .suffix-null {\n          input {\n            margin-top: 18px;\n            padding-right: 0 !important;\n          }  \n        }\n\n        input {\n          width: 100px;\n          text-align: end;\n          padding-right: 13px !important;\n        }\n\n        .guarantor {\n          margin-top: 7px;\n          font-size: 10px;\n          color: #5E8EB7;\n        }\n\n        .ant-input-number-suffix {\n          margin-inline-end: 0px;\n          color: black;\n        }\n\n      }\n    }\n\n    .form-edit {\n      width: 100%;\n      height: auto;\n\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n\n      display: grid;\n      grid-template-columns: 45% 35% 20%;\n      grid-template-areas:\n        'ssn datebirth textedit'\n        'phone email .'\n        'address address address'\n        'identification identification identification'\n        'submit submit submit';\n\n      .ant-input-status-error {\n        color: $state-error-text;\n      }\n\n      .ant-form-item-row {\n        display: block;\n      }\n\n      .ant-form-item-label {\n        text-align: start;\n        height: 27px;\n\n        label {\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 14.52px;\n          color: $grey-text-op;\n        }\n      }\n\n      .ant-form-item-control-input {\n        min-height: 20px;\n      }\n\n      .ant-form-item {\n        margin-bottom: 15px;\n      }\n\n      .ssn {\n        grid-area: ssn;\n      }\n\n      .datebirth {\n        grid-area: datebirth;\n\n        .ant-picker-input {\n          input {\n            &::placeholder {\n              color: #929fb0;\n              font-family: Inter;\n              font-style: italic !important;\n              font-weight: 400;\n            }\n\n            &:disabled {\n              color: black;\n            }\n          }\n        }\n      }\n\n      .textedit {\n        grid-area: textedit;\n        font-size: 11px;\n        text-align: end;\n        color: #5E8EB7;\n        display: flex;\n        align-items: start;\n        gap: 6px;\n        justify-content: end;\n        margin-top: 5px;\n      }\n\n      .phone {\n        grid-area: phone;\n      }\n\n      .email {\n        grid-area: email;\n      }\n\n      .address {\n        grid-area: address;\n      }\n\n      .identification {\n        grid-area: identification;\n\n        label {\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 15px;\n        }\n      }\n\n      .submit {\n        grid-area: submit;\n      }\n    }\n  }\n}",".step-3 {\n  .blue-bold {\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 800;\n    text-decoration: underline;\n  }\n\n  .owner-REVIEW {\n    color: $state-review-text;\n  }\n\n  .owner-APPROVED {\n    color: $state-approved-text;\n  }\n\n  .owner-REQUEST_ERROR {\n    color: $state-error-text;\n  }\n    \n  .content-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .content-owner-new {\n    display: flex;\n    justify-content: space-between;\n\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n\n    button {\n      padding: 0;\n    }\n\n    .text-add {\n      display: flex;\n      gap: 5px;\n      align-items: center;\n    }\n\n    .total{\n      display: flex;\n      gap: 15px;\n      align-items: center;\n    }\n  }\n}",".action-accept-reject {\n  position: absolute;\n  top: -10px;\n  right: 15px;\n  width: 60px;\n  z-index: 99;\n  \n  .content-actions {\n    display: flex;\n    justify-content: end;\n    gap: 15px;\n    width: 60px;\n  }\n\n  .circle-input {\n    cursor: pointer;\n  }\n}",".EntityDocs {\n    .task-footer {\n        .dropdown-blue-bold {\n            span {\n                font-weight: 600;\n                text-decoration-line: underline;\n            }\n\n            height: 26px;\n            display: unset;\n            padding: 0 !important;\n        }\n\n        .dropdown-review-bold {\n            span {\n                font-weight: 600;\n                text-decoration-line: underline;\n            }\n\n            color: $state-review !important;\n            height: 26px;\n            display: unset;\n            padding: 0 !important;\n        }\n\n        .owners-tags {\n            display: flex;\n            justify-content: space-between;\n            align-items: end;\n\n            .circles-tags {\n                display: flex;\n                align-items: end;\n                gap: 10px;\n            }\n\n            .circle {\n                width: 20px;\n                height: 20px;\n\n                &-APPROVED {\n                    background-color: $state-approved-background;\n                    border-color: $state-approved-border;\n                }\n\n                &-REVIEW {\n                    background-color: $state-review-border;\n                    border-color: $state-review;\n                }\n\n                &-REQUEST_ERROR {\n                    background-color: $state-error-background;\n                    border-color: $state-error-border;\n                }\n            }\n        }\n    }\n}",".entity-docs-step-2 {\n\n    .section-1 {\n        span {\n            font-size: 20px !important;\n        }\n    }\n\n    .dropdown-blue-bold {\n        display: unset;\n        height: auto;\n    }\n\n    .dropdown-review-bold {\n        span {\n            text-decoration-line: underline;\n        }\n\n        color: $state-review !important;\n        display: unset;\n        padding: 0 !important;\n    }\n\n    .submits {\n        display: flex;\n        justify-content: space-between;\n        gap: 15px;\n\n        section {\n            width: 100%;\n        }\n    }\n}",".InvestmentExperienceVerification {\n  .card__generic {\n\n    &-REVIEW {\n      border: 1px solid $state-review-border;\n\t\t  background-color: $state-review-background-ligth;\n    }\n\n    &-REQUEST_ERROR {\n      border: 1px solid $state-error-border;\n\t\t  background-color: $state-error-background-ligth;\n    }\n\n    &-APPROVED {\n      border: 1px solid $state-approved-border;\n\t\t  background-color: $state-approved-background-ligth;\n    }\n\n    .UploadDocs {\n      .input-content,\n      .input-content input {\n        height: 79px;\n      }\n    }\n  }\n\n  .circle {\n    &-review {\n      background-color: $state-review-border;\n      border-color: $state-review !important;\n    }\n\n    &-approved {\n      border: 1px solid $state-approved-border !important;\n\t\t  background-color: $state-approved-background;\n    }\n  }\n}\n",".ConstructionBudget {\n\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  .h2 {\n    margin-top: 30px !important;\n  }\n\n  .UploadDocs {\n\n    .input-content,\n    .input-content input {\n      height: 78px;\n\n      .empty-input {\n        .body-small {\n          color: #2a2f3c;\n        }\n      }\n    }\n  }\n\n  .card__generic {\n    .s-title {\n      .h4 {\n        color: #404859;\n      }\n    }\n\n    .body-regular {\n      margin-bottom: 20px;\n    }\n  }\n\n  .link {\n    color: #5e8eb7;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    text-decoration: none;\n    line-height: 145%;\n\n    .arrow {\n      height: 10px;\n      margin-left: 5px;\n    }\n  }\n}",".title-company-step-1 {\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);\n  padding: 16px 24px 5px;\n  \n  .ant-form {\n    margin-top: 15px;\n    width: 100%;\n    height: auto;\n    display: grid;\n    grid-template-columns: 50% 5% 45%;\n    grid-template-areas: 'titleCompany titleCompany titleCompany'\n    'name name .'\n    'phone . email'\n    'submit submit submit';\n  }\n\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n\n  &-REVIEW {\n    border: 1px solid $state-review-border;\n    background-color: $state-review-background-ligth;\n\n    .h4 {\n      color: $state-review-text !important;\n    }\n\n    .description {\n      color: $state-review-text !important;\n    }\n\n    .link {\n      color: $state-review-text !important;\n    }\n  }\n\n  &-APPROVED {\n    border: 1px solid $state-approved-border;\n    background-color: $state-approved-background-ligth;\n\n    .h4 {\n      color: $state-approved-text !important;\n    }\n\n    .description {\n      color: $state-approved-text !important;\n    }\n\n    .link {\n      color: $state-approved-text !important;\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border: 1px solid $state-error-border;\n    background-color: $state-error-background-ligth;\n\n    .h4 {\n      color: $state-error-text !important;\n    }\n\n    .description {\n      color: $state-error-text !important;\n    }\n\n    .link {\n      color: $state-error-text !important;\n    }\n  }\n\n  .ant-form-item-row {\n    display: block;\n  }\n\n  .ant-form-item-label {\n    text-align: start;\n    height: 27px;\n\n    label {\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 14.52px;\n      color: $grey-text-op;\n    }\n  }\n\n  .ant-form-item-control-input {\n    min-height: 20px;\n  }\n\n  .ant-form-item {\n    margin-bottom: 15px;\n  }\n\n  .titleCompany {\n    input {\n      font-size: 16px !important;\n    }\n\n    grid-area: titleCompany;\n  }\n\n  .name {\n    grid-area: name;\n  }\n\n  .phone {\n    grid-area: phone;\n  }\n\n  .email {\n    grid-area: email;\n  }\n\n  .submit {\n    grid-area: submit;\n\n    button {\n      border-radius: 6px;\n    }\n  }\n}",".insurance-step-2 {\n    .ant-collapse-header-text {\n        max-width: 335px;\n        margin-inline-end: unset !important;\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n    }\n\n    .ant-collapse-expand-icon {\n        padding-inline-start: 0px !important;\n    }\n}",".payoff-footer {\n    .dropdown-blue-bold {\n        display: unset;\n        padding: 0 !important;\n        border: none !important;\n        span {\n            background-color: white !important;\n            color: $button-blue !important;\n            padding: 0 !important;\n        }\n    }\n\n    .is-review {\n        color: $state-review !important;\n      }\n}",".insurance-step-2 {\n    .ant-collapse-header-text {\n        max-width: 335px;\n        margin-inline-end: unset !important;\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n    }\n\n    .ant-collapse-expand-icon {\n        padding-inline-start: 0px !important;\n    }\n}",".entities-list {\n  padding: 24px 25px;\n\n  .top-container {\n    box-sizing: content-box;\n    width: 100%;\n\n    margin-bottom: 33px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: space-between;\n\n    .title {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 32px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n\n      >span {\n        cursor: pointer;\n\n        color: var(--blue60, #5E8EB7);\n        font-family: Inter;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        text-decoration-line: underline;\n      }\n    }\n  }\n\n  .entities-container {\n    padding: 16px 0px;\n\n    >* {\n      margin-bottom: 16px;\n      &:last-child {\n        margin-bottom: 0px;\n      }\n    }\n  }\n\n  .search-box {\n    cursor: pointer;\n  \n    box-sizing: border-box;\n    width: 384px;\n    padding: 5px 18px 5px 8px;\n  \n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  \n    border-radius: 10px;\n    border: 1px solid var(--400-grey, #CCD3DB);\n    background: var(--gray-100, #F9FAFB);\n  \n    color: var(--700-grey, #6E7889);\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%;\n  \n    >input {\n      all: unset;\n      width: 100%;\n      margin-left: 8px;\n    }\n  }\n}","@keyframes horizontal-shaking {\n    0% { transform: translateX(0); }\n    25% { transform: translateX(-3px); }\n    50% { transform: translateX(3px); }\n    75% { transform: translateX(-1px); }\n    100% { transform: translateX(1px); }\n  }\n  ",".Login {\n  display: flex;\n  justify-content: space-between;\n  min-height: calc(100vh - 56px);\n  &-form,\n  .rigth {\n    width: 50%;\n  }\n  &-form {\n    padding: 32px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: flex-start;\n    position: relative;\n    .coin {\n      margin-bottom: 13px;\n    }\n    .h1 {\n      margin-bottom: 24px;\n    }\n    .ant-form {\n      width: 100%;\n    }\n    .error-message {\n      margin-top: 50px;\n      color: $red-warning;\n    }\n    .button {\n      margin-top: 10px;\n    }\n    .link {\n      &:hover {\n        color: #404859;\n      }\n      .body-regular-bold {\n        text-decoration: underline;\n      }\n    }\n    .link-absolute {\n      position: absolute;\n      bottom: 30px;\n      left: 32px;\n      text-decoration: none;\n      .body-regular-bold {\n        text-decoration: underline;\n      }\n    }\n  }\n  .rigth {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    align-items: flex-start;\n    position: relative;\n    padding-left: 60px;\n    padding-top: 64px;\n    background-color: #f9fafb;\n    .bottom-flex {\n      display: flex;\n      justify-content: flex-end;\n      width: 100%;\n      max-width: 700px;\n    }\n    .h2 {\n      margin-bottom: 12px;\n      max-width: 520px;\n    }\n    .body-regular {\n      max-width: 520px;\n      margin-bottom: 30px;\n    }\n    .back {\n      padding: 7px;\n      padding-bottom: 0;\n      padding-right: 0;\n      // position: absolute;\n      // bottom: 0;\n      // right: 0;\n      background-color: #355c7d;\n      border-top-left-radius: 10px;\n      width: 100%;\n      // max-height: 450px;\n      // max-width: 600px;\n    }\n    img {\n      bottom: 0;\n      width: 100%;\n      // max-height: 441px;\n    }\n  }\n\n  @media (min-height: 735px) {\n    .bottom-flex {\n      height: 470px;\n      img {\n        height: 100%;\n        // object-fit: cover;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
